/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * Spanish resource file
 */

import {
    ArcTimeLineValidationTypes,
    ArcTimelineGroups,
    Entity,
    GAComponentDocumentStatus,
    GALinkStatus,
    GARoleTypeId,
    TaskListTypes,
    actionTypes,
    activityType,
    assignmentTypes,
    bulkAssignment,
    bulkAssignmentConstants,
    clientRequestNoteTab,
    confidentialityTypes,
    filters,
    financialStatementType,
    gaRecommendationType,
    gaScopes,
    groupSummaryTabs,
    independenceActionIds,
    instructionStatus,
    instructionType,
    ipFilterType,
    ipInputType,
    linkType,
    milestoneBuildTaskIds,
    notesFilter,
    reviewNoteRoutes,
    rnhFilterTypeQuery,
    rnhQuickFilter,
    snapshotComparisonIds,
    syncStatus,
    todoListTimeframeOptions,
    trialBalanceType,
    uiViews,
    receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

    //Review notes tile 2

    reviewNoteTileGraphHeader: "Notas de revisión abiertas por fecha de vencimiento",
    reviewNoteTileGraphHeaderAssignedToMe: "Abrir notas de revisión asignadas a mí, por fecha de vencimiento",
    reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
    reviewNoteYAxisLabel: "Notas de revisión",
    overDueCatFirst: "Atrasado >90",
    overDueCatSecond: "Atrasado 31-90",
    overDueCatThird: "Atrasado 10-30",
    overDueCatFourth: "Atrasado <10",
    catFifth: '<10',
    catSixth: '10-30',
    catSeventh: '31-90',
    catEighth: '>90',
    noNotesAvailable: "No hay notas disponibles",


    //ReviewNoteTiles
    totalOpen: "Total abierto",
    totalCleared: "Total aclarado",
    changeDueDate: "Cambiar la fecha de vencimiento",
    reviewNoteHashValue: '#',

    //Rejected PSPs
    rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',


    //CRA Build Step 2 Labels
    inherentRiskTypeId: "Evaluación del riesgo inherente",
    controlRiskTypeId: "Evaluación del riesgo de control",
    viewUnRelatedWCGWs: "Ver WCGW no relacionados",
    unrelatedWCGWsInstruction: "Los WCGW que se enumeran a continuación no están relacionados con ninguna afirmación. Deben estar relacionados con al menos una aserción o eliminarse. Para encontrar fácilmente estos WCGW en el modal 'Relacionar WCGW con aserciones', seleccione \'WCGW no relacionados'\ en el menú desplegable SCOT. Si el WCGW ya no es relevante o necesita ser editado, haga clic en el enlace \'Identificar WCGW y controles'\ en la página subyacente para realizar esos cambios.",
    relatedWCGWsInstruction: "Relacione los WCGW con la aserción seleccionada. Seleccione un SCOT para relacionar las WCGW de una SCOT específica, o seleccione una opción de Todas las SCOT. Para obtener una lista de WCGW que deben relacionarse con una aserción, seleccione \'WCGW no relacionadas'\.",
    allScots: " Todos los SCOTs",
    allWCGWs: "Todos los WCGW",
    unRelatedWCGWs: " WCGW no relacionadas",
    //CRA Build Step 4 Header Label
    craValue: "CRA",
    incompleteCraValue: "CRA incompleto",
    // Panel Headers
    taskCategories: "Navegación de tareas",
    taskCategoryExecution: "Ejecución",
    taskList: "Lista de tareas",
    taskDetails: "Detalles de la tarea",
    fullScreen: "Fullscreen",
    exitFullScreen: "Salir a pantalla completa",
    defaultDropdown: "Menú desplegable",
    status: "Estado",
    language: "Idioma",
    channel: "Canal",
    header: "Encabezado",
    headerName: "Nombre del encabezado",
    sectionCustomLabelLabel: "Etiqueta personalizada",
    sectionNamePlaceHolder: "Ingrese el título de la sección",
    showRelatedObjectLabel: "Mostrar objetos relacionados",
    errorBanner: "{0} Error(es)",
    customize: "Personalizar",
    customized: "Personalizado",
    custom: "Personalizar",
    description: "Descripción",
    seeDescription: "Ver descripción",
    section: "Sección",
    entities: "Entidades",
    edit: "Editar",
    delete: "Eliminar",
    collapse: "Colapsar",
    collapseAll: "Colapsar todo",
    expand: "Ampliar",
    expandAll: "Expandir todo",
    incompleteResponse: "Respuesta incompleta",
    unresolvedComments: "Comentarios no resueltos",
    saving: "Guardando",
    tasks: "Tareas",
    requests: "Solicitudes",

    //BodyType Placeholder
    numericValuePlaceholder: "Introducir importe",

    //Modal
    addButton: "Botón Añadir",
    evidence: "Evidencia",
    temporary: "Temporal",
    temporaryFiles: "Archivos temporales",
    priorPeriod: "Período anterior",
    externaldocuments: "Documentos externos",
    eydocuments: "Documentos de EY",
    clientRequestClientAnalytics: "Nombre del análisis",
    groupdocuments: "Documentos de grupo",
    name: "Nombre",
    reason: "Razón",
    browse: "Navegador",
    uploadFile: "Cargar archivos",
    uploadDocument: "Cargar documento",
    duplicateDocumentHeader: "Uno o más documentos con el mismo nombre ya existen en este compromiso (ya sea como archivos de prueba o temporales).",
    duplicateDocumentInstruction: "Seleccione 'Sobreescribir' para cargar el documento y reemplace el archivo existente o 'Descartar' para cancelar. Si este archivo existente está en Evidencia, el documento se cargará en Evidencia. Si el archivo existente está en Archivos temporales, el documento se cargará en Archivos temporales.",
    overwriteLabel: "Sobrescribir",
    discardLabel: "Descartar",
    discardChangesLabel: "Descartar los cambios",
    note: "Nota",
    notes: "Notas",
    signOffs: "Firmas",
    related: "relacionado",
    attributes: "Atributos",
    approveChanges: "Aprobar cambios",
    nodocumentsAdded: "No hay documentos disponibles",
    noEntitiesAvailable: "No hay entidades disponibles",
    noDocumentsUpload: "No se están cargando documentos",
    noSections: "No hay secciones disponibles",
    noRequestMessage: "No hay solicitudes ni tareas externas en este compromiso",
    noResultFound: "No se han encontrado resultados.",
    noRequestsFound: "No se encontraron solicitudes",
    noTimePhasesFound: "No hay fases de tiempo disponibles",
    noEntitiesFound: "Sin resultados",
    relatedEntities: "Entidades vinculadas",
    noClickableRelatedEntities: "Las entidades relacionadas no se pueden editar para esta tarea",
    taskByEntityLabel: "Tareas por entidad",
    relEntityLabel: "Entidad",
    singleEntity: "{0} entidad",
    multipleEntity: "{0} entidades",
    engagementDeliveryLabel: "Tareas por compromiso",
    onlyShowRelEntities: "Mostrar solo entidades relacionadas",
    engDeliveryDescription: "Esta tarea está asociada a todas las entidades del compromiso",
    relEntitiesDescription: "Ver entidades relacionadas con la tarea. Las entidades relacionadas solo se pueden editar para tareas OSP y OST.",
    relEntitiesPSTorPSPDesc: "Ver entidades relacionadas con la tarea. Las entidades relacionadas no se pueden editar para tareas PST y PSP.",
    warningRelMsg: "La tarea debe estar relacionada con una o más entidades. Para que la interacción de la tarea sea para toda la tarea, cambie el botón de alternancia Tarea por entidad.",
    reldetailDescription: "De forma predeterminada, las tareas de OSP y OST abarcan toda la interacción y están relacionadas con todas las entidades. Las tareas se pueden relacionar con una o varias entidades habilitando Tareas por entidad.",
    results: "Resultados",
    searchPlaceholder: "Búsqueda",
    searchDocPlaceholder: "Documento de búsqueda",
    searchCanvasForms: "Buscar formularios Canvas",
    searchControlForms: "Buscar SCOTs",
    canvasFormListDescription: "Seleccione un formulario Canvas de la lista siguiente para ver los informes de formulario Canvas relacionados.",
    controlFormListDescription: "Seleccione un SCOT para ver sus formularios de control relacionados.",
    object: "Objeto",
    relateCollaboration: "Relacionar la colaboración",
    reviewNote: "Notas de revisión",
    reviewNoteSingle: "Nota de revisión",
    documentReviewNotes: "Notas del documento",
    noEvidenceFilesAssociated: "No hay archivos de evidencia asociados a esta tarea",
    taskReviewNoteWithParenthesess: "Nota(s) de la(s) tarea(s)",
    taskNotes: "Notas de tareas",
    documentsNotes: "Notas del documento",
    addNewDocumentNote: "Agregar nota de documento",
    selectDocument: "Seleccione un documento",
    taskReviewNotes: "Nota de tarea",
    showCleared: "Mostrar aclarados",
    Replied: "Respondido",
    showClosed: "Mostrar cerrado",
    allNotes: "Todas las notas",
    myNotes: "Mis notas",
    noTasksAvailable: "No hay tareas disponibles",
    noWCGWAvailableForTask: "No hay ROMM disponible",
    noSubstantiveTasksAvailable: "No hay tareas sustantivas relacionadas",
    noNotesAssociatedWithDocument: "No hay notas asociadas a este documento",
    noNotesAssociatedWithTak: "No hay notas asociadas a esta tarea",
    otherEngagementNotes: "Otras notas de compromiso",
    to: "Para",
    deleteReviewNote: "Eliminar",
    missingToUserError: "Obligatorio",
    missingReviewNoteTextError: "Se requiere revisar el texto de la nota",
    invalidReviewNoteTextError: "El texto introducido supera el límite",
    dueDateRequiredTextError: "Se requiere la fecha de vencimiento",
    saveNoteTextError: "Guardar o cancelar para continuar",
    engagementName: "Nombre del compromiso:",
    assignmentsCountLabel: "Asignaciones",
    AssignmentsDays: "Días",
    closedOnTime: "Cerrado a tiempo",
    daysToPrepare: "Días para prepararse",
    daysToReview: "Días para revisar",
    totalAssignments: "Total <br> asignaciones",
    currentlyAssigned: "Actualmente <br>asignado",
    UpcomingAssignments: "Próximos",
    authoredByMe: "Escrito por mí",
    commentsLabel: "Notas de revisión",
    clearedOnTime: "Aclarado a tiempo",
    daysToClear: "Días para aclarar",
    daysToClose: "Días para cerrar",
    totalLabel: "Notas totales",

    criticalAndHighRn: "Notas críticas y altas",
    criticalAndHighComments: "Notas críticas y altas",
    lowAndMediumComments: "Notas medias y bajas",
    metricsInstructionalText: "Vea las métricas de rendimiento de sus tareas y notas a continuación. <br>Seleccione un miembro del equipo para ver sus métricas o elija <b>la vista Compromiso</b> para ver un resumen general.",
    metricsNewInstructionalText: "Seleccione un miembro del equipo para ver sus notas de revisión y tareas o elija <b>Vista de compromiso</b> para ver un resumen general.",
    switchToViewPlaceholder: "No hay datos que mostrar. <br>Seleccione a otro miembro del equipo o cambie a la vista <b>vista del compromiso.</b>",
    tasksClosedOnTime: "Tareas cerradas a tiempo.",
    daysDetailReview: "Días para detallar la revisión",
    daysGeneralReview: "Días a la revisión general",
    totalDaysReview: "Total de días para revisar",
    metricsInstructionalTextconfiguration: "Vea un resumen general de las métricas de rendimiento de las asignaciones y notas a continuación.",

    //document download
    docSizeMB: "MB",
    docSizeKB: "Kb",
    labelForExpiredPackage: "El paquete ha caducado.",
    headerForDocumentDownload: "Haga clic en el nombre del archivo para descargar",
    labelForNoFiles: "No había archivos en las categorías seleccionadas.",
    labelForProcessing: "Los archivos se están procesando.",

    //create dropdown texts
    create: "Crear",
    addRequestText: "Petición",
    addExternalTaskText: "Tarea externa",
    addFindingText: "Encontrar",
    show: "Mostrar:",
    riskTypeHeader: "Tipo de riesgo",
    wcgwHeader: "WCGW",
    hasNotes: "notas abiertas",
    hasNote: "nota abierta",
    noNotes: "(0 notas abiertas)",
    addTemporaryFiles: "Añadir archivos temporales",
    addPriorPeriodEvidence: "Agregar período anterior",
    addExternalDocuments: "Añadir documentos externos",
    //Nav
    navHeaderTasks: "Tareas",
    quickFilterAllCompletedTasks: "Todas las tareas completadas",
    quickFilterMyCompletedAssignmnets: "Mis tareas completadas",
    quickFilterMyUpcomingAssignments: "Mis próximas tareas",
    navHeaderTaskCategory: "Categorías de tareas",
    navFilterBy: "Opciones de filtro",
    navHeaderDocuments: "Documentos",
    navHeaderCollaboration: "Colaboración",
    navHeaderAssignments: "Asignaciones",
    navHeaderAutomation: "Automatización",
    navHeaderMore: "Más",
    navDashboard: "Tablero",
    navReviewnotes: "Notas de revisión",
    navHeaderManageteam: "Administrar equipo",
    navHeaderMangeteamNew: "Gestionar equipo - Nuevo",
    mangeteam: "Gestionar equipo",
    postArchive: "Archivado posterior",
    addmember: "Añadir miembro",
    addnewmember: "Agregar nuevo usuario",
    addPriorPeriodMembers: "Agregar miembros inactivos",
    addPriorPeriodUsers: "Agregar miembros inactivos",
    createPackage: "Crear paquete",
    engagementrole: "Rol del compromiso",
    noPendingPriorPeriodUsers: "No hay miembros inactivos a los que invitar",
    sendPriorPeriodUserInvitesWithCount: "Enviadas (0) invitaciones",
    sendPriorPeriodUserInvitesWithoutCount: "Enviar invitaciones",
    priorPeriodMembersModalHeaderMessage: "Seleccione los miembros inactivos que desea agregar al compromiso. Los miembros recibirán los permisos que tenían anteriormente dentro del compromiso tras la reactivación.",
    priorPeriodIndependenceModalHeaderMessage: "Seleccione los miembros inactivos de solo independencia que le gustaría agregar a su compromiso.",
    disabledPriorPeriodMembersButtonToolTip: "Derechos insuficientes para agregar miembros anteriores. Hable con un miembro del equipo de compromiso con los derechos apropiados para tomar esta acción.",
    disabledNewMembersButtonToolTip: "Derechos insuficientes para añadir nuevos miembros. Hable con un miembro del equipo de compromiso con los derechos apropiados para tomar esta acción.",
    disabledNewMembersButtonToolTipThirdpartyuser: "Derechos insuficientes para añadir nuevos miembros de terceros. Hable con un miembro del equipo de compromiso con los derechos apropiados para tomar esta acción.",
    rbacNoRightsForContentUpdateToolTip: "Permisos insuficientes para desarrollar la actualizacion de contenido. Contacte al administrador de su compromiso y solicite los permisos para iniciar la actualizacion del contenido.",
    deactivateInternalUsersWithCount: "{0} miembros seleccionados",
    canvasFormSelectionMessageSingular: "{0} formulario de Canvas seleccionado",
    canvasFormSelectionMessagePlural: "{0} formularios de Canvas seleccionados",
    pspAccountSelectionMessageSingular: "{0} Cuenta seleccionada",
    pspAccountSelectionMessagePlural: "{0} Cuentas seleccionadas",
    manageTeamGroupLabel: " Grupo",
    manageTeamGroupsLabel: " Grupos",
    allAccessGroups: "todos los grupos de acceso",
    reactivate: "Reactivar",
    deactivate: "Desactivar",
    unselect: "Deseleccionar todo",
    deactivateInternalModalTitle: "Desactivar miembros internos",
    deactivateInternalModalMessage: "¿Está seguro de que desea desactivar los siguientes miembros del equipo?",
    deactivateInternalUsersSuccessMessage: "{0} Miembros se han desactivado con éxito.",
    deactivateExternalModalTitle: "Desactivar miembros externos",
    deactivateExternalModalMessage: "¿Está seguro de que desea desactivar los siguientes miembros del equipo de {0}? Los elementos asignados se reasignarán a los grupos de acceso respectivos.",
    deactivateExternalSuccessMessage: "Los miembros se han desactivado con éxito.",
    internalMember: "Miembros internos",
    addinternalmember: "Agregar miembros internos",
    addThirdPartymember: "Añadir miembro de terceros",
    missingResponsiblePerson: "Persona responsable faltante",
    sentRequests: "enviado",
    receivedRequests: "recibido",
    syncProfileNotAllowed: "Perfil de sincronización no permitido",
    allSyncProfileNotAllowedMessage: "El perfil de sincronización no está permitido. Formulario no disponible para este perfil.",
    allCanvasFormsContentUpdateMessage: "El contenido no se puede entregar para las actividades de habilitación de EY Canvas FIT que se comparten. Desvincule esas actividades para continuar con las actualizaciones de contenido.",
    someFormContentUpdateMessage: "Algunos de los formularios no se pueden sincronizar con el perfil del proyecto porque no hay contenido",
    linkedFormContentUpdateMessage: "No se entregará contenido para las actividades de habilitación de EY Canvas FIT que se comparten. Para actualizar el contenido para ellos, desvincule esas actividades.",
    leaveUsFeedback: "Déjanos tus comentarios",

    notApplicableLabel: "N/A",
    addThirdPartyMemberDescription: "Esta funcionalidad solo debe usarse para otorgar acceso a revisores externos a este compromiso de EY Canvas. Deben obtenerse las aprobaciones y autorizaciones adecuadas de Práctica Profesional.",
    hasOverallResponsibilityDescription: "Un miembro del equipo de auditoría o contratación que asume la responsabilidad general de la dirección, supervisión y desempeño de la auditoría o contratación y de que el informe y / o la conclusión entre oficinas sean apropiados en las circunstancias.",
    partnerInChargeHeader: "Socio a cargo / Ejecutivo a cargo",
    picFlag: "PIC",
    CannotUpdatePicInArchivedEngagement: "No se puede procesar ediciones a campos restringidos. Actualice y vuelva a intentarlo.",

    noGroupFound: "No se ha creado ningún grupo de acceso en esta compromiso. Seleccione 'Agregar grupo de acceso' para crear un nuevo grupo de acceso de miembro del equipo externo.",
    addGroup: "Añadir grupo",
    deleteGroup: "Eliminar acceso de grupo",
    deleteGroupMessage: "¿Está seguro de que desea eliminar el  acceso al grupo{0}?",
    addAccessGroup: "Agregar acceso de grupo",
    accessGroupCreated: "Se ha creado correctamente el nuevo {0} grupo de acceso.",
    accessGroupUpdated: "Cambios al grupo de acceso, han sido guardados",
    editAccessGroup: "Editar acceso de grupo",
    sharedGroupwarning: "Se trata de un grupo de acceso compartido y los cambios en esto se reflejarán para todos los compromisos asociados.",
    groups: "Grupos",
    addExternalMembers: "Todos los miembros externos",
    members: "Miembros",
    externalMember: "Miembros externos",
    member: "Miembro",
    role: "Rol",
    actions: "Acciones",
    internalUserEdit: "Editar",
    internalUserDeactivate: "Desactivar",
    usersFilter: "Filtro",
    externalUserEdit: "Editar",
    externalUserDeactivate: "Desactivar",
    externalUserGroupLabel: "grupos",
    externalNoUserInGroup: "No se han agregado miembros a este grupo de acceso",
    externalNoUserInAllGroup: "No se han agregado miembros a este compromiso,",
    alias: "Alias",
    independence: "Independencia",
    navManagegroup: "Administrar grupo",
    navCRAsummary: "Resumen del CRA",
    navAuditplan: "Plan de auditoría",
    navWorkplan: "Plan de trabajo",
    navSEM: "Matriz de evaluación sustantiva",
    nav440GL: "Cambios después de la fecha del informe",
    navFindings: "Resultados",
    navCanvasformupdates: "Actualizaciones de formularios de Canvas",
    navPSPContentUpdates: "Actualizaciones de contenido de PSP",
    navCopyhubNew: "Centro de copia - NUEVO",
    navCopyhub: "Centro de copiado",
    navArchiveChecklist: "Checklist de archivo",
    navExporthub: "Exportación de Hub",
    navReporting: "Informes",
    navAccountSummary: "Resumen de la cuenta",
    navScotSummary: "Resumen del SCOT",
    navItSummary: "Resumen de TI",
    navGroupInstructionSummary: "Instrucciones de grupo",
    navGroupInvolvement: "Participación grupal",
    navHelixProjects: "Conexiones EY Helix",
    navContentUpdates: "Actualización de contenido",
    contentUpdateErrorMsg: "No tiene permisos para guardar los cambios. Póngase en contacto con otros miembros del equipo con estos permisos para realizar cambios.",
    contentUpdateTitleTip: "Permisos insuficientes para realizar la actualización de contenido. Comuníquese con su administrador del compromiso y solicite permiso para iniciar una actualización de contenido.",
    noPreviousUpdates: "Sin actualizaciones previas",
    noContentUpdateResults: "No se han encontrado resultados",
    noPSPAccountsToUpdate: "No hay cuentas para actualizar",
    rbcaUnavailableMsg: "EY Canvas no pudo guardar los cambios en este momento. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia",
    showErrInProgressMsg: "29007 - Las actualizaciones de contenido no se pueden iniciar mientras hay otras actualizaciones en curso. Espere hasta que se complete la actualización de contenido actual o actualice la página e inténtelo de nuevo.",
    navHelp: "Ayuda general",
    validationNavHelp: "Ayuda de validación",
    searchUserText: "Buscar usuario",
    superModelTitle: "Objetos de compromiso",
    superModelText: "Súper modal",
    independenceOnlyMembers: "Miembros de solo independencia",
    noIndependenceOnlyPriorPeriodUsers: "No hay independencia inactiva, solo miembros para invitar",

    //Copyright
    copyRight: "Copyright © <year> todos los derechos reservados",

    //Copyhub List labels
    moreRecipient: "más",
    copyHubPackageName: "Nombre del paquete",
    copyHubSentBy: "Enviado por",
    copyHubSentTo: "Enviado a",
    copyHubReceivedBy: "Recibido por",
    copyHubDate: "datos",
    copyHubRemainingTime: "Tiempo restante",
    copyHubAvailableFor: "Disponible para",
    copyHubStatus: "Estado",
    noCopyHubSentPackages: "Los paquetes de copia aún no se han creado. Seleccione Crear paquete para crear un nuevo paquete de datos.",
    noCopyHubReceivedPackages: "No hay paquetes de copia disponibles para este compromiso",
    remainingTimeTooltip: "Los elementos se eliminarán permanentemente en el momento del archivo, o 10 días después de la creación",
    copyHubDeleteText: "Borrar",
    appendDays: " Días",
    generalInformation: "Información general",
    copyDocuments: "Documentos",
    copyFiles: "Archivos",
    scots: "SCOTs",
    accounts: "Cuentas",
    copyHubImport: "Importar",
    copyHubPackageType: "Tipo de paquete:",
    copyHubCreatedModal: "Creado:",
    copyHubRemainingTimeModal: "Tiempo restante:",
    copyHubAvailableForModal: "Disponible para:",
    copyHubInstructionModal: "instrucciones:",
    copyHubCategories: "Categorías",
    copyHubPendingDeletion: "Eliminación pendiente",
    copyHubVersionMismatchCat: "No se pueden mostrar categorías debido a la falta de coincidencia de la versión del paquete",
    copyHubVersionMismatchPersonInfo: "No se puede mostrar la información del remitente y del receptor debido a la falta de coincidencia de la versión del paquete",
    copyHubViewLegacyPacakgeDetails: "Se trata de un paquete de copia heredado para el que no se dispone de información detallada",
    associateTasks: "Asociar tareas",
    backToForms: "Volver a formularios",
    noTaskSelected: "Se debe seleccionar al menos una tarea",
    taskLabel: "Tarea:",
    taskMessage: "Debe asociar la tarea con estos formularios de importación.",
    importSuccessMessage: "Importar solicitud en cola correctamente",
    taskSelectedText: "Tareas seleccionadas",
    insufficientPermissionsToImport: "Permisos insuficientes para importar la copia del paquete. Póngase en contacto con el administrador de compromiso y solicite permiso para importar la copia del paquete.",
    cannotImportExpiredPackage: "No se puede importar la copia del paquete caducado.",
    cannotImportWhileInProgress: "No se puede importar la copia del paquete que ya está en curso.",
    deletePackageHeader: "Eliminar paquete",
    copyPackageDeleted: "El paquete se ha eliminado",
    copyPackageDeleteConfirmation: "¿Está seguro de que desea eliminar este paquete?",
    insufficientPermissionsToDelete: "Permisos insuficientes para eliminar el paquete de copia. Póngase en contacto con el administrador de su compromiso y solicite permiso para eliminar el paquete de copia.",
    insufficientPermissions: "Permisos insuficientes",
    GuidedWorkflowsPackageDisplayText: "Al seleccionar importar, se actualizarán los flujos de trabajo guiados coincidentes de la copia a este compromiso. Los flujos de trabajo guiados sin una coincidencia no se importarán.",
    copyRequestStatusInQueue: "En cola",
    GuidedWorkflowImportError: "La importación de flujos de trabajo guiados no está disponible para compromisos de varias entidades",

    //TopHeaderLayout.js
    topHeaderLayoutMilestoneText: "MileStone Está de acuerdo o concilia la información financiera con los registros contables.  Obtener evidencia de que la información financiera intermedia está de acuerdo o se reconcilia con los registros contables finales",
    //TaskLayoutHeader
    taskLayoutHeaderSearchPlaceholder: "Tareas de búsqueda",
    taskLayoutHeaderAssignments: "Asignaciones",
    taskLayoutHeaderAddTask: "Nueva tarea",
    wcgwSearchPlaceholder: "Buscar WCGW",
    //TaskListHeader
    taskTypeHeader: "Tipo",
    taskNameHeader: "Nombre",
    taskDueDateHeader: "Fecha de vencimiento",
    reviewNoteChangeDueDate: "Cambiar la fecha de vencimiento",
    taskListHeaderSortByDueDate: "Fecha de vencimiento",
    taskListHeaderSortByTaskName: "Nombre de la tarea",
    sortBy: "Ordenar por:",
    ascending: "Ascendente",
    descending: "Descendente",
    taskListHeaderSortByKnowledge: "Plan de auditoría",
    taskListHeaderDeleteWarning: "¿Está seguro de que desea eliminar las tareas seleccionadas.",
    taskListHeaderSortText: "Ordenar",
    taskListHeaderSortOrderText: "Ordenar orden",
    taskListHeaderTimePhaseText: "Establecer fase del tiempo",
    taskListHeaderBookMarkText: "Marcar",
    taskListHeaderFavoriteText: "Favorito",
    taskListHeaderEditText: "Editar título de la tarea",
    moreMenu: "Más",
    taskListHeaderMoveTaskText: "Cambiar grupo de tareas",
    taskGroupIconHoverText: "Cambiar grupo de tareas",
    taskGroupLabel: "Cambiar grupo",
    task: "Tarea",
    toc: "Toc",
    tenNotes: "10 Notas",
    source: "Fuente",
    nature: "Naturaleza",
    assertion: "Afirmaciones",
    relatedAccounts: "Cuentas relacionadas",
    testOfDetail: "Prueba de detalles",
    testOfControl: "Prueba de control",
    substantiveAnalyticalProcedure: "Procedimiento analítico sustantivo",
    tod: "TOD",
    sap: "SAP",
    int: "Int",
    ext: "Ext",
    notSel: "NO SELECCIONADO",
    internal: "Interno",
    external: "Externo",
    notSelected: "No seleccionado",
    documentCannotOpen: "Este documento no se puede abrir desde Detalles de la tarea. Navegue a la lista de documentos para abrir este documento.",
    //TaskPanelLayout
    emptyTaskDetailsMessage: "Seleccione una tarea para ver los detalles.",
    multiTaskSelectedMessage: "Para habilitar los controles masivos, use la clave de control y seleccione varias tareas. Si desea trabajar en una tarea individual, seleccione esa tarea en la lista de tareas.",
    emptyAndMultiSelectedMessage: "Para habilitar los controles masivos, utilice la casilla de verificación para seleccionar una o varias tareas. Utilice la tecla Mayús para seleccionar varias tareas a la vez. Si desea trabajar en una tarea individual, seleccione esa tarea de la lista.",
    //Evidence
    evidenceDragAndDrop: "Arrastrar y soltar o",
    //Timephases
    noResultTimePhase: "No se ha encontrado resultados",
    //handoff
    handoff: "Entrega",
    handoffConfirmButtonText: "Entrega",
    handoffModalTitle: "Entrega de Tarea",
    handoffTitle: "Traspaso al siguiente miembro del equipo",
    handoffTextLine2: "Para firmar un archivo de evidencias, seleccione una de las opciones siguientes.",
    return: "devolución",
    returnDisabledMessage: "Esta tarea no se puede devolver porque: (1) usted es el preparador asignado, (2) el estado de la tarea no es 'En revisión' o 'Completo', o (3) no hay ningún preparador asignado.",
    handOffTitleTip: "Entrega para revisión",
    //Mark Complete
    markCompleteTitleTip: "Marcar completado",
    markCompleteTitle: "Marcar tarea completada",
    markCompleteText: "Su firma se aplicará a la evidencia asociada a esta tarea como se indica a continuación. Esta tarea se marcará como completada.",
    markCompleteTextLine1: "Entregue esta tarea al siguiente miembro del equipo.",
    markCompleteTextLine2: "Para firmar un archivo de evidencia, seleccione una de las opciones a continuación. Si tiene una tarea para esta tarea y la completó, seleccione <b>Sí</b> para cerrarla. Si esta asignación requiere la aprobación de PIC o EQR, seleccione una de las opciones a continuación.",
    markCompleteConfirm: "Marca completada",
    signOffAs: "Firme en todo como:",
    additionalSignOff: "Firmas adicionales requeridas",
    additionalTaskStatus: "Cierra mi asignación",
    markCompleteModalHeaderTextPart1: "Esta tarea se marcará como completa.",
    markCompleteModalHeaderTextPart2: "Para firmar un archivo de evidencia, seleccione una de las opciones a continuación. Si tiene una tarea para esta tarea y la completó, seleccione <b>Sí</b> para cerrarla. Si esta asignación requiere la aprobación de PIC o EQR, seleccione una de las opciones a continuación.",
    ep: "PIC",
    eqr: "EQR",
    closeMyAssignment: "Cierra mi tarea",
    tempMarkCompleteMessage: "La tarea no se puede marcar como completada. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    tempMarkCompleteEnable: "Marcar Completa-habilitar",
    tempMarkCompleteDisable: "Marcar Completa-desactivar",
    //TaskDetails
    seeTask: "Ver tareas",
    NoTasksFound: "No se encontraron tareas",
    taskDetailsAddRelate: "Añadir/Relacionar",
    taskDetailsDocument: "Documento",
    taskDetailsAutomationRequest: "Solicitud de automatización",
    taskDetailsExternalTask: "Tarea externa",
    taskDetailsFinding: "Encontrar",
    taskDetailsRequest: "Petición",
    taskDetailsNotes: "Notas",
    taskDetailsRelatedTask: "Tarea relacionada",
    epeqr: "PIC/EQR",
    epeqrsignoffheader: "Se requiere cierre de sesión",
    addTaskGroupLabel: "Agregar grupo de tareas",
    itgcTaskDescription: "Realizar nuestras pruebas de diseño de ITGC para obtener suficiente evidencia de auditoría apropiada para  su efectividad operativa durante todo el período de confianza.",
    //create assignment
    createassignmentheaderLine1: "El miembro del equipo seleccionado no tiene una asignación para esta tarea.",
    createassignmentheaderLine2: "Cree una asignación aquí. Si otro miembro del equipo ya tiene una asignación incompleta del mismo tipo,",
    createassignmentheaderLine3: "Seleccione",
    createassignmentheaderLine4: "para reemplazarlo con esta asignación.",
    overwriteIncompleAssignments: "Sobrescribir asignaciones incompletas",
    //Create Assignment
    createassignmentheader1: "El miembro del equipo seleccionado no tiene una asignación para esta tarea.",
    createassignmentheader2: "Crea una tarea aquí.",
    //Guidance
    atlasLink: "Enlace Atlas",
    automationLink: "Enlace de automatización inteligente",
    otherLink: "Otro enlace",
    helixLink: "Enlace Helix",
    relatedAutomations: "Atomatizaciones relacionadas",
    noSuggestedAutomationLabel: "No hay automatizaciones sugeridas para esta tarea.",
    noSuggestedItemLabel: "No hay elementos sugeridos para esta tarea.",
    noAutomationRequestLabel: "Esta tarea no esta relacionada a ninguna automatización. Para comenzar, cree una nueva automatización o relacione una automatización existente.",
    relateAutomation: "relacionar",
    relateAutomationModelHeader: "Relacionar automatizaciones inteligentes",
    automationSolution: "solución",
    automationName: "Nombre de la automatización",
    relateAutomationTextLine1: "Relacione una automatización inteligente con esta tarea.",
    relateAutomationTextLine2: "Una vez relacionado, puede ver la automatización desde los detalles de la tarea y hacer clic para abrirla.",
    noSamrtAutomationForEngagement: "No se han creado automatizaciones inteligentes para su compromiso.",
    searchAutomationLabel: "Automatizaciones de búsqueda",

    //RelatedItemHeader
    relatedItemsHeader: "Artículos relacionados",
    relateButtonText: "Relacionar",
    createButtonText: "Crear",
    relatedItemREQ: "Petición",
    relatedItemET: "Tarea externa",
    relatedItemATM: "Automatización",
    relatedItemRelatedTask: "Tarea relacionada",
    relateObjectsToTaskTitle: "Relate objetos a esta tarea",
    relateObjectsToTaskSubTitle: "Relacione uno o varios objetos a esta tarea. Estos objetos aparecerán en la sección Elementos relacionados de los detalles de la tarea.",
    relateObjectOptionsHeaderPSPOSP: "Cuentas, aserciones y cuentas de riesgo limitado",
    relateObjectOptionsHeaderITWalkthrough: "procesos de TI",
    relateObjectOptionsHeaderITControl: "Controles de TI (ITGC y ITSP)",
    // SDM Nextwave services
    scheduledServicesText: "Servicios relacionados",
    suggestedServicesText: "Servicios sugeridos",
    suggestedServicesDefaultMessage: "Hay servicios NextWave sugeridos para esta tarea. Haga clic en el",
    suggestedServicesDefaultMessage1: '+',
    suggestedServicesDefaultMessage2: "icono para empezar.",
    suggestedServicesPlaceholderMessage: "No hay servicios sugeridos para esta tarea.",
    nextWaveServiceOfferingLabel: "Servicio",
    nextWaveServiceStatusLabel: "Estado",
    nextWaveServiceStartDateLabel: "Empezar",
    nextWaveServiceDueDateLabel: "Vencimiento",
    nextWaveServiceRequestCreate: "Crear solicitud",
    nextWaveServiceRequests: "Solicitudes de servicio centralizadas",
    nextWaveServiceGatewayRequests: "Solicitudes servicio Gateway",
    onlyShowSelectedTask: "Mostrar sólo la tarea seleccionada",
    sdmRestrictAddTaskLabel: "Haga clic en continuar para proceder con el siguiente paso. La selección de la tarea se produce después de que se haya aceptado la oferta de servicio y el gerente del equipo de procesos de GDS se acerque para discutir el trabajo que se debe completar.",
    //Links
    linksText: "Enlaces",
    //Forms
    formsText: "Formas",
    /*Accounts*/
    associatedTasks: "Tareas asociadas al elemento WCGW",
    noAssertionsChecked: "Seleccione una aseveración para ver WCGW relacionado",
    noAccountsCreated: "No se crearon cuentas",
    noDesignationSelected: "No se ha seleccionado ninguna designación",
    noRelatedAccounts: "No hay cuentas relacionadas",
    manageAccount: "Administrar cuentas y divulgaciones",
    /*Risks*/
    risk: "Riesgo",
    risks: "Riesgos",
    wcgw: "WCGW",
    riskWcgw: "Riesgo:WCGW",
    wcgwTasks: "WCGW: Tarea",
    riskWcgwLabel: "Relacionar los riesgos con los WCGW",
    wcgwTasksLabel: "Relacionar WCGW con la tarea",
    noRiskTypes: "No se han encontrado tipos de riesgo",
    saveRisk: "Salvar",
    noRisksFound: "No se han encontrado riesgos",
    haveBeenIdentified: "han sido identificados",
    noAssertionFound: "No hay aseveraciones relacionadas aplicables a este compromiso",
    noAssertionApplicable: "No se han asociado aseveraciones aplicables a este compromiso",
    noWCGWFound: "No hay WCGW relacionados con este riesgo. Haga clic en Editar asociaciones para relacionar uno o más WCGW.",
    noRelatedWCGWs: "No WCGW relacionados",
    noRelatedControls: "No hay controles relacionados",
    noRelatedRisks: "No hay  riesgos de TI relacionados",
    noRelatedITGCs: "No hay ITGC relacionados",
    iTriskVal: "Riesgo IT",
    iTrisksVal: "Riesgos IT",
    iTGCVal: "ITGC",
    iTGCsVal: "ITGCs",
    iTSPVal: "ITSP",
    iTSPsVal: "ITSP",
    iTGCname: "Nombre de ITGC",
    iTSPname: "Nombre del ITSP",
    noWCGWAvailable: "No hay ROMM disponible para las aseveraciones seleccionadas(s)",
    relevantWcgwCountHint: "El recuento que se muestra junto al nombre de la cuenta debe interpretarse como el número de WCGW relacionados con las aseveraciones con una evaluación del riesgo de control de no depender o afirmaciones relacionadas con estimaciones de riesgo más elevadas, que se han asociado a un procedimiento sustantivo, en comparación con el número total de estos WCGW.",
    noAccountsFound: "No se han encontrado registros",
    selectAssertionToRelateWCGW: "Seleccione Aseveración para relacionar el riesgo con WCGW",
    significantAccounts: "Cuentas significativas",
    riskName: "Riesgo:",
    accountName: "Cuenta:",
    noScotsFound: "No hay Scots relacionados",
    relatedwcgw: "WCGWs relacionados",
    relatedRisks: "Riesgos relacionados",
    noRelatedAssertionsLabel: "No se seleccionaron aseveraciones para la cuenta",
    boltIconTitle: "Riesgo relacionado",
    instructions: "Instrucciones",
    expandRisk: "1. Ampliar un riesgo",
    selectAssertion: "2. Seleccione una aseveracion",
    identifyRelatedWCGW: "3. Identificar los WCGW relacionadas con el riesgo",
    clickAccount: "1. Haga clic en una cuenta",
    selectWCGW: "2. Seleccione un WCGW",
    identifyRelatedTask: "3. Identifique las tareas que responden al WCGW",
    information: "Información",
    requiredAssertions: "Afirmaciones requeridas",
    wcgwWithoutTasks: "WCGW sin tareas",
    found: "Encontrado",
    editAssociations: "Editar asociaciones",
    riskWCGW: "Riesgo:Relación WCGW",
    wcgwTask: "WCGW:Relación tarea",
    requireTaskToBeRelated: "Requerir que una tarea esté relacionada",
    expandCollapse: "Haga clic aquí para expandir/contraer",
    requiredAssertionsInfo: "Mostrar únicamente aseveraciones con una evaluación del riesgo de control de no depender y afirmaciones relacionadas con estimaciones de riesgo más altas",
    wCGWwithoutTasksInfo: "Mostrar sólo WCGWs relacionados con una afirmación con una evaluación del riesgo de control de no depender y afirmaciones relacionadas con estimaciones de mayor riesgo, que no tienen ninguna tarea sustantiva responsiva asociada",
    noBuildStepsAvailable: "No hay pasos de compilación disponibles para ser presentados.",
    accountRiskAssessmentSummary: "Cuentas y divulgaciones",
    manageRisk: "Gestionar los riesgos",
    addResponsivePSPOSP: "Añadir PSP/OSP receptivo",
    assertionlbl: "Aseveración",
    addResponsiveControl: "Añadir control receptivo",
    addResponsiveTOC: "Añadir TOC receptivo",
    showOnlyRelatedItems: "Mostrar solo relacionados",
    relatedControlCounter: "Control {0}",
    relatedControlsCounter: "{0} controles",
    noControlsAvailableForRelateItem: "No hay controles disponibles",
    relateControlName: "Controles",
    relateContolsAPIErrorMessage: "El control no se puede relacionar con la aseveración. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    relateTasksAPIErrorMessage: "La tarea no se puede relacionar con la aserción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    toggleFilterWarningMessage: "Mostrar solo cuentas y divulgaciones sin ningún procedimiento sustantivo",
    toggleFilterWarningMessageForRisk: "Mostrar solo riesgos sin ningún procedimiento sustantivo o control/TOC que responda",
    warningIconHoverText: "Riesgo sin ningún procedimiento sustantivo o controles/TOC que respondan",
    filterYes: "Sí",
    filterNo: "No",

    /*OrphanedControls*/
    orphanedControls: 'View unrelated controls',
    unRelatedOrphanControls: 'Unrelated controls',
    noOrphanedControlsDataLabel: "No unrelated controls available",
    noOrphanedControlsResultLabel: "No unrelated controls available",
    noControlSelected: 'At least one control must be selected for deletion.',
    controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
    controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
    deleteControlModalHeader: 'Confirm deletion of selected control',
    deleteControlsModalHeader: 'Confirm deletion of selected controls',

    /*SEM*/
    select: "Seleccione",
    selectAnAccountFromTheDropDown: "1. Seleccione una cuenta en el menú desplegable",
    applyAsertionsFilters: "2. Aplicar filtros de aseveracion",
    reviewTheTasksThatRespondToTheRisks: "3. Revise la(s) tarea(s) que responda a los riesgos",
    riskOfMaterialMisstatement: "Riesgos de incorrección material",
    expandScot: "1. Expanda un SCOT",
    selectWCGWToDisplayTheResponsiveTask: "2. Seleccione el riesgo de error material para mostrar las tareas responsivas",
    tasksWithNoRelatedWCGW: "Tareas sin riesgos relacionados de incorrección material",
    selected: "Seleccionado",
    clearSelections: "Deseleccionar todo",
    romm: "Romm",
    selectAccount: "cuenta",
    selectHeader: "Seleccionar encabezado",
    riskOfMaterialMisstatementsWithoutRelatedTask: "Riesgos de incorrección material sin tareas relacionadas",
    selectOneOrMoreTasksToSeeTheRelatedROMM: "Seleccione una o más tareas para ver la ROMM relacionada",
    invalidRelatedEntity: "No se puede encontrar una cuenta relacionada. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el problema persiste.",
    scrollUp: "Desplácese hacia arriba",
    scrollDown: "Desplácese hacia abajo",
    duplicate: "Duplicado",
    showIndex: "Mostrar índice",
    noContentAvailable: "No hay contenido disponible",
    navigateTo: "Navegar a",
    /*validations */
    semValidation: "Validación SEM",
    riskWCGWValidation: "Validación de riesgo WCGW",
    showValidation: "Validaciones",
    wcgwWithNoRelatedTask: "WCGW sin tarea sustantiva relacionada",
    riskWithNoRelatedWCGW: "Riesgo sin WCGW relacionado",
    noValidationIdentified: "No se han identificado validaciones",
    onlyShowScotWithNoControlNoWCGW: "Mostrar solo SCOTs sin WCGW o control relacionado",
    /*CRA Badge*/
    ir: "IR",
    cr: "CR",
    cra: "CRA",
    selectToEdit: "Seleccione esta opción para editar",
    both: "Ambos",
    prefix: "Prefijo",
    suffix: "Sufijo",
    optional: "(opcional)",
    title: "Título",
    charLimitExceeded: "Se supera el límite de caracteres",
    requiredField: "Campo obligatorio",
    Lastmodifiedby: "Ultima modificación por",
    fileSize: " | {1} KB",
    fileSizeInKB: "{1} KB",
    fileSizeHeader: "Tamaño del archivo",
    daysAgo: "días atrás",
    weekAgo: "hace una semana",
    weeksAgo: "hace semanas",
    monthAgo: "hace un mes",
    monthsAgo: "hace meses",
    yearAgo: "hace un año",
    yearsAgo: "hace años",
    currentlyBeingModifiedBy: "Actualmente en proceso de modificación por",
    beingEditedInCoeditModeError: 'Being edited in multi-user edit',
    beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
    beingEditedInCoeditModeOn: 'on {0}.',
    coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
    coEditModeIsEnding: "La edición multiusuario está llegando a su fin",
    coEditMode: "Edición multiusuario",
    checkInInProgressMessage: "Registro en curso. El documento puede tardar hasta 20 minutos en registrarse. Actualice para ver actualizaciones",
    checkOutInProgressMessage: "Salida en curso. El documento puede tardar hasta 20 minutos en ser retirado. Actualice para obtener actualizaciones",
    daasErrorMessage: "La operación no se puede completar en este momento. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte",
    coEditModeIsStarting: "Comienza la edición multiusuario",
    daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
    daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
    documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
    documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
    documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
    documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
    documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
    documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
    startMultiuserEditing: 'Start',
    continue: "Continuar",
    openReadOnly: "Abrir solo lectura",
    takeControlFromTeam: "Toma el control del actual miembro del equipo",
    itapplication: "Aplicación de TI",
    aggregateITevaluation: "Evaluación agregada de TI:",
    control: "Control",
    itgcitsp: "ITGC/ITSP",
    limitedRisk: "Cuenta de riesgo limitada",
    so: "SO",
    itApp: "Aplicación de TI",
    itAppType: "IT app",
    deleteTaskModalHeader: "Confirmar la eliminación de la tarea seleccionada",
    deleteTasksModalHeader: "Confirmar la eliminación de las tareas seleccionadas",
    deleteTaskModalMessage: "¿Está seguro de que desea eliminar la tarea seleccionada?",
    deleteTaskModalMessage1: "Las pruebas relacionadas que no estén relacionadas con otras tareas de esta interacción se moverán a archivos temporales. Se eliminarán los hallazgos y las tareas de respuesta que no estén relacionados con ninguna otra evidencia.",
    deleteTasksModalMessage: "¿Está seguro de que desea eliminar las tareas seleccionadas?",
    someTasksCannotBeDeleted: "Algunas tareas no se pueden eliminar",
    onlySomeTasksCanBeDeleted: "Solo se pueden eliminar algunas de las tareas seleccionadas.",
    tasksThatCanBeDeleted: "Si elige continuar, <b>las tareas enumeradas a continuación se eliminarán</b> de su participación. La evidencia que no esté relacionada con otras tareas de su contratación se moverá a archivos temporales. También se eliminarán los hallazgos y las tareas de respuesta que no estén relacionadas con otras pruebas.",
    tasksThatCannnotBeDeleted: "<b>Las tareas enumeradas a continuación no se pueden eliminar</b> de su contratación, pero pueden rechazarse del Plan de auditoría si es necesario.",
    accountHeader: "Cuentas",
    noAccountsIdentified: "No se han identificado cuentas.",
    noRisksIdentified: "No se han identificado riesgos",
    noAssertionsIdentified: "No se han identificado aseveraciones",
    noWcgwsIdentified: "No se ha identificado WCGW",
    // Tasks/TaskDetails/Evidence
    addEvidence: "Añadir evidencia",
    relateEvidence: "Relacionar la evidencia",
    relateTemporary: "Relacionar archivos temporales",
    relatePriorPeriod: "Relacionar la evidencia del período anterior",
    relateExtDoc: "Relacionar documentos externos",
    relateFile: "Relacionar archivos",
    relateAnalytics: "Relacionar análisis",
    quickAddButton: "Adición rápida",
    createPaperProfile: "Crear papel",
    paperProfileInformationMessage: "Preparamos toda la documentación electrónicamente, incluida la la preparación y la revisión de las firmas. Sólo aquellos documentos que nos proporcionen la dirección o un tercero en papel y para los que no se dispone de una copia electrónica (por ejemplo, copia de un contrato firmado entre la entidad y un tercero) están permitidos como documentación en papel en nuestros documentos de trabajo.",
    paperProfileName: "Nombre del papel",
    paperProfileAdd: "Añadir",
    paperProfileError: "Introduzca un nombre de perfil de papel válido",
    otherEngagementsInWorkspace: "Otros compormisos en este espacio de trabajo",
    relateDescription: "Relacione un documento de este compromiso  o de otro compromiso en este espacio de trabajo.",
    onlyShowRelatedDocuments: "Mostrar sólo documentos relacionados",
    relateDescriptionTemp: "Relacione un documento de este compromiso.",
    added: "Añadido",
    documentLocation: "Ubicación del documento",
    documentIneligibleForSharingMessage: "Los documentos confidenciales no son elegibles para ser compartidos.",
    confidentialityNotAppropiateForSharing: "Usted no tiene el nivel de confidencialidad adecuado para enviar este documento.",
    documentIsCheckedOut: "El documento está en modo de coedición y no se puede compartir. Finalice el modo de coedición para compartir el documento.",
    addCanvasFormNew: "Agregar nueva forma de canvas",
    documentCount: "{0} documento",
    documentsCount: "{0} documentos",
    fitDocumentCannotbeSelected: "Los documentos FIT no se pueden compartir entre compromisos.",
    // Task/TaskDetail/Description
    noDescriptionAvailable: "No hay descripción disponible.",
    knowledge: "Conocimiento",
    knowledgeDescription: "Descripción del conocimiento",
    descriptionInstructions: "Descripción de las instrucciones",
    fromInstructions: "De las instrucciones",
    customizeDescription: "Descripción personalizada",
    custimizeTaskDescription: "Personalizar la descripción de la tarea",
    editTaskDescription: "Editar descripción de la tarea",
    saveLabel: "Salvar",
    okLabel: "De acuerdo",
    cancelLabel: "Cancelar",
    leaveCommentLabel: "Deja un comentario",
    addLabel: "Agregar",
    closeLabel: "Cerrar",
    editText: "Editar",
    enterReply: "Ingrese la respuesta",
    reply: "Responder",
    deleteTagDesc: "La eliminación de la etiqueta no se puede deshacer, ¿está seguro de que desea continuar?",
    requiredText: "Se requiere texto",
    descriptionEmptyError: "Se requiere descripción",
    descriptionMaxLengthError: "Longitud de la descripción excedió la longitud máxima permitida",
    assignmentDueDate: "Fecha de vencimiento de la asignación",
    navigateToGuidedWorkflow: "Navegue a la habilitación de EY Canvas FIT",
    openInTasksPage: "Abrir en Tareas",
    copyTaskLink: "Copiar vínculo de tarea",
    copyReviewNoteLink: "Copiar enlace de la nota de revisión",
    urlCopiedLabel: "Enlace copiado correctamente",
    //Related Tasks
    showOnlyRelatedTask: "Mostrar solo relacionados",
    noTaskAvailable: "No hay tareas disponibles",

    // Client Request / Client Request Detail /  Client Request Drawer
    openInCollaborationPage: "Abrir en colaboración",
    copyRequestLink: "Copiar enlace de solicitud",
    requestType2MessageTitleDrawer: "Esta solicitud tiene una funcionalidad adicional.",
    requestType2MessageSubtitleDrawer1: "Por favor",
    requestType2MessageSubtitleDrawer2: "Haga clic aquí",
    requestType2MessageSubtitleDrawer3: "para navegar hasta el",

    // SeeMore component
    showMore: "Mostrar más",
    showLess: "Mostrar menos",
    showMoreEllipsis: "Mostrar más...",
    showLessEllipsis: "Mostrar menos...",

    // Request Description
    saveAndCloseButtonLabel: "Guardar y cerrar",
    saveButtonLabel: "Guardar",
    cancelButtonLabel: "Cerrar",

    // Request Description Modal labels
    discardChangesModalText: "Descartar cambios",
    inlineSaveUnsavedChanges: "Hay cambios sin guardar, ¿quieres continuar?",

    // RelateWCGWModal labels
    wcgwName: "Nombre de WCGW",
    wcgwByScot: "WCGW por SCOT",
    unrelatedSCOTsHeader: "SCOTs no relacionados",
    unrelatedSCOTPlaceholder: "No hay SCOT no relacionados",
    noWcgwPlaceholder: "No se han creado WCGW",
    showOnlyUnrelatedWCGW: "Mostrar solo no relacionados",

    // CharCount component.
    of: "De",
    characters: "Caracteres",
    fromUserLabel: "De",
    toUserLabel: "Para",
    handoffto: "Entrega a",
    priorityLabel: "Prioridad",
    addNoteLabel: "Añadir",
    replyNoteLabel: "Responder",
    characterCountLabel: " de 4000 caracteres",
    taskNotePlacehodler: "Introduzca la nota de tarea",
    documentNotePlacehodler: "Introduzca la nota del documento",
    taskNoteStatusBy: "Por:",
    addNewReviewNoteButtonText: "Nueva nota",
    fromKnowledge: "Del conocimiento",
    /*day labels*/
    mon: "Lu",
    tues: "Mar",
    wed: "Mié",
    thurs: "Jue",
    fri: "Vie",
    sat: "Sab",
    sun: "Dom",
    /*month labels*/
    jan: "Enero",
    feb: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    sept: "Septiembre",
    oct: "Octubre",
    nov: "Noviembre",
    dec: "Diciembre",
    /*Rename*/
    documentDropdown: "Documento Desplegable",
    fileNameRequired: "Se requiere nombre de archivo",
	invalidCharacters: 'El nombre del archivo no puede incluir: */:<>\\?|\"',
    existingFileName: "El nombre de archivo no es único. Actualice la página o cambie el nombre del archivo para quitar este mensaje.",
    unknowError: "Se ha producido un error inesperado. Actualice la página para quitar este mensaje.",
    maxLengthExceeded: "El nombre del documento no puede superar los 115 caracteres.",
    documentNameSyncErrorMessage: "El nombre del documento no se pudo sincronizar con el Portal del Cliente de Canvas. Actualice la página e inténtelo de nuevo.",
    /*Delete*/
    deleteFileTitle: "Eliminar documento",
    deleteFileCloseBtnTitle: "Cancelar",
    deleteFileConfirmBtnTitle: "Eliminar",
    deleteFileCloseTitle: "Cerrar",
    deleteFileModalMessage: "¿Está seguro de que desea eliminar el documento seleccionado?",
    none: "Ninguno",
    /*Unlink*/
    unlinkFileTitle: "Desvincular evidencia compartida",
    unlinkSource: "Fuente",
    unlinkTarget: "Objetivo",
    unlinkFileCloseBtnTitle: "Cancelar",
    unlinkFileConfirmBtnTitle: "Confirmar",
    unlinkFileCloseTitle: "Cerrar",
    unlinkFileModalMessage: "¿Está seguro de que desea desvincular este archivo de evidencia compartida?",
    /*Relate Tasks*/
    relateTasksTitle: "Relacionar tareas",
    relateTaskSearchPlaceholder: "Entrar para buscar",
    relateTaskInstructionalText: "Agregar o quitar tareas con las que el documento debe estar relacionado. Si el documento es evidencia, eliminarlo de la última tarea lo moverá a archivos temporales.",
    relatedTaskInstructionalText: "El documento está relacionado con las siguientes tareas de este compromiso. Haga clic en un nombre de tarea para navegar hasta ella.",
    relateTaskName: "Nombre de la tarea",
    relateTaskType: "Tipo",
    relatedTaskCounter: "{0} tarea",
    relatedTasksCounter: "{0} tareas",
    /*Relate Entities*/
    relateEntitiesTitle: "Relacionar entidades",
    relateEntitiesSearchPlaceholder: "Entrar para buscar por nombre",
    relateEntitiesName: "Nombre de la entidad",
    relateEntitiesIndex: "Índice estándar de la entidad",
    relatedEntitiesCounter: "{0} entidades",
    relatedEntityCounter: "{0} entidades",
    onlyShowRelatedEntities: "Mostrar solo entidades relacionadas",
    unableToRemoveSystemAssociatedRelatedEntity: "No se pueden eliminar las relaciones del sistema entre documentos y entidades",
    /* Finalize document */
    document: "Documento",
    finalize: "Finalizar",
    finalizeDocument: "Finalizar documento",
    finalizeDocumentTitle: "¿Está seguro de que desea notificar al equipo primario que este documento está finalizado?",
    finalizeDocumentSubtitle: "Al finalizar un documento, se informa al equipo primario de que no se espera enviar ninguna versión adicional del documento y se cambia el estado del documento a <b>la versión final enviada</b>. En el caso de que realice cambios en un documento finalizado, aún podrá enviar una nueva versión al equipo primario.",
    /* Remove From Task */
    removeEvidenceModalTitle: "Eliminar de la tarea",
    remove: "eliminar",
    removeFromTaskModalContent: "¿Está seguro de que desea eliminar el documento seleccionado de esta tarea? Este documento no está asociado a ninguna otra tarea en este compromiso y, por lo tanto, se moverá a archivos temporales.",
    sharedEvidenceRemoveFromTaskModalContent: "Está seguro de que desea quitar el documento seleccionado de esta tarea? Este documento se comparte y no se asocia con ninguna otra tarea en este nombramiento. Ya no estará disponible en su compromiso si se elimina.",
    /*AddDocumentToTasksModal*/
    modalCheckboxHeading: "Añadir a la evidencia para una o más tareas",
    modalRadioHeading: "Asociar documento a una o más tareas",
    confirm: "Confirmar",
    proceed: "Proceder",
    modalCheckboxMessage: "Seleccione las tareas relevantes a las que desea agregar este documento.",
    selectedDocument: "Documento seleccionado",
    modalRadioMessage: "Este documento se ha agregado previamente a la evidencia o a los archivos temporales.",
    modalRadioMessage1: "Agregar este documento de nuevo creará una copia duplicada. Seleccione si desea asociar una copia existente de este documento o crear una nueva copia de este documento.",
    option: "Opción",
    option1Message: "Asociar el documento existente a esta tarea",
    option2Message: "Cree una nueva copia de este documento",
    addToEvidenceSelectAll: "Seleccionar todo",
    currentTask: "Tarea actual:",
    createNewCopy: "Crear una nueva copia",
	fileNameMaxLenError: (maxFileLen) => ` El nombre del archivo está limitado a los caracteres de ${maxFileLen}.`,
    /* Confidentiality */
    confidentiality: "Confidencialidad",
    confidentialityType: "Confidencialidad (opcional)",
    confidentialityTitle: "Confidencialidad del documento",
    confidentialityPlaceholder: "Seleccionar confidencialidad",
    confidentialityText: "Establezca el nivel de acceso necesario para que se abra este documento. Los administradores de interacción establecen los niveles de acceso en la página Administrar equipo. Si ya se ha establecido confidencialidad para este documento, solo los que pueden abrir el documento pueden cambiarlo.",
    confidentialityNotOpenable: "El documento no se puede abrir porque sus permisos en el compromiso son insuficientes. Los niveles de acceso son establecidos por los administradores del compromiso en la gestión del equipo.",
    confidentialityTargetNotOpenable: "Los documentos confidenciales solo pueden ser abiertos desde el compromiso de origen.",
    /*Sign-off requirements*/
    signOffRequirements: "Requisitos de cierre de sesión",
    signoffRequirementsModalTitle: "Requisitos de cierre de sesión",
    signoffRequirementsModalDescription1: "Ajuste los requisitos de firma ejecutiva de este documento a continuación.",
    signoffRequirementsModalDescription2: "Algunos requisitos de aprobación no se pueden ajustar porque son requeridos por EY Canvas.",
    signoffRequirementsModalSaveLabel: "Guardar",
    signoffRequirementsModalCancelLabel: "Cancelar",
    signoffRequirementsModalCloseLabel: "Cerrar",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    /*SEM summary*/
    nextAccount: '>',
    prevAccount: "<",
    reviewedBy: "Revisado por",
    displaytoc: "Pantalla TOC",
    viewBy: "Ver por",
    substantiveEvaluation: "Matriz de evaluación sustantiva",
    reviewed: "Revisado",
    estimate: "Estimación",
    /*440GL*/
    FourFortyTitle: "Evidencia modificada después de la fecha de informe ({0})",
    LeftContainerTitle440GL: "Razones del cambio",
    approvals: "Aprobaciones",
    approveChangesColumnTitle: "Aprobar cambios",
    approveChangesButton: "Aprobar cambios",
    deleteApproval: "Eliminar aprobación",
    unauthorizedAction: "La acción sólo puede ser realizada por ejecutivos del compromiso",
    reasonColumnTitle: "Razones",
    approvedBy: "Aprobado por",
    approvedByPeople: "Gente",
    noChangeReasonCommentAvailable: "Haga clic en Editar motivo en las opciones de la rueda dentada del documento para introducir el motivo del cambio.",
    changeReasonModalTitle: "Editar el motivo del cambio",
    changeReasonModalText: "Seleccione las razones para el cambio realizado posterior a la fecha de reporte. Si se tienen cambios administrativos multiples; selecciones los cambios mas significativos de la lista desplegable abajo. Si se han hecho ambos cambios administrativos y no administrativos, seleccione no administrativo abajo.",
    changeReasonUploadModalTitle: "Motivo de la carga de documentos",
    changeReasonUploadModalText: "Seleccione las razones para el cambio realizado posterior a la fecha de reporte. Si se tienen cambios administrativos multiples; selecciones los cambios mas significativos de la lista desplegable abajo. Si se han hecho ambos cambios administrativos y no administrativos, seleccione no administrativo abajo.",
    changeReasonModalComboPlaceholder: "Seleccione",
    changeReasonModalAnnotationText: "Documente las circunstancias encontradas y las razones para agregar informacion; procedimientos de auditoria nuevos o adicioanles, evidencia de auditoria obtenida y conclusiones alcanzadas y los efectos en nuestro reporte de auditoria",
    changeReasonUploadModalAnnotationText: "Documente las circunstancias encontradas y las razones para agregar informacion; procedimientos de auditoria nuevos o adicioanles, evidencia de auditoria obtenida y conclusiones alcanzadas y los efectos en nuestro reporte de auditoria",
    changeReasonModalAnnotationPlaceHolder: "Introduzca el motivo de la modificación",
    changeReasonModalChangeReasonRequired: "Cambie la razón para guardar.",
    noDocumentsModifiedAfterReportDate: "No se han modificado los documentos después de la fecha del informe",
    noReasonSelected: "No existen razones para el cambio seleccionado",
    fileSizeColumn: "Tamaño del archivo",
    changePercent: "% de variación",
    toolTipChangePercent: "El cambio en el tamaño del archivo se calcula utilizando el tamaño del archivo a partir de la fecha del informe y el tamaño del archivo actual",
    /*Account Conclusion*/
    AccountConclusion: "Conclusión de la cuenta",
    AccountDetails: "Detalles",
    Conclusions: "Conclusiones",
    accountDetailsTab: "Detalles",
    conclusionsTab: "Conclusiones",
    accountConclusionNoContentText: "El contenido no se ha entregado para este Formulario. Vaya a Actualizaciones de formularios de Canvas desde el menú Navegación global más y actualice manualmente el contenido.",
    validations: "Validaciones",
    /*RelatedFindings*/
    deficiency: "{0} Deficiencias relacionadas",
    misstatement: "{0} Declaraciones erróneas relacionadas",
    relatedDeficiency: "{0} Deficiencia relacionada",
    relatedMisstatement: "{0} Declaración errónea relacionada",
    deficiencies: "Deficiencias",
    misstatements: "Errores",
    pagingShowtext: "Mostrar",
    documentOpenModelLabel: "Documento en proceso de modificación",
    openedLabelText: "Abierto",
    modelDocumentOpenedText: "Este documento está siendo modificado actualmente por",
    modelUserOpenedTheDocumentText: "Este usuario abrió el documento",
    modelOpenedDocumentConflictText: "Abrir el documento podría causar conflictos, por lo que recomendamos abrir como de solo lectura. Si desea convertirse en el editor de este documento, entonces",
    clickHereEnabledText: "haga clic aquí.",
    reviewNotesTemporeryFilesTitle: "Revisar notas para archivos temporales",
    addNewReviewNoteTitle: "Notas de tareas",
    /*Assignments*/
    assignedTo: "Asignado a",
    createAssignment: "Crear asignación",
    createAssignments: "Crear asignaciones",
    editAssignments: "Editar asignaciones",
    deleteAssignments: "Eliminar asignaciones",
    removeAssignments: "'Eliminar asignaciones",
    noTimephaseSelected: "No seleccionado",
    unassigned: "sin asignar",
    unassignedCapitalized: "Sin asignar",
    dueDateBlank: "Dos",
    reviewerAssignment: "Asignaciones de revisores",
    manageAssignments: "Administrar asignaciones de tareas",
    manageTaskAssignments: "Crear asignaciones",
    selectedTasks: "tareas seleccionadas",
    someTasksCannotBeMoved: "Algunas tareas no se pueden mover",
    onlySomeTaskCanMoveToOtherGroup: "Solo algunas de las tareas seleccionadas se pueden mover a otro grupo de tareas.",
    taskThatCanBeMovedToOtherGroup: "Si elige continuar, <b>las tareas enumeradas a continuación se moverán</b> al grupo de tareas que seleccionó.",
    tasksThatCannotBeMovedToOtherGroup: "<b>Las tareas enumeradas a continuación no se pueden mover</b> a otro grupo de tareas.",
    taskGroupSectionNotFound: "No se han encontrado resultados",
    placeholderForSearch: "Búsqueda",
    taskFilter: "Filtro",
    noResultsAvavilable: "No se han encontrado resultados",
    noTasksAvavilable: "No hay tareas disponibles",
    clearAll: "Borrar todo",
    engagementPhase: "Fase de auditoría",
    noOptionAvailable: "No hay opciones disponibles",
    noTimePhase: "Sin fase de tiempo asignada",
    roles: "Roles",
    users: "Miembros del equipo",
    rommAssociatedWNotRelyAssertion: "ROMM está asociada a una Aseveración con Riesgo de Control de No Confianza o una Aseveración con Riesgo Inherente de Mas alto cuando la Cuenta tiene una estimación",
    hasRiskAssociated: "Riesgo asociado",
    canvas: "Canvas",
    workingoffline: "Trabajar sin conexión",
    syncinprogress: "Sincronización en curso",
    prepareoffline: "Preparación de datos para sin conexión",
    connectionavilable: "Conexión disponible",
    createAnAssignment: "Crear una asignación",
    createAssignmentEnd: "para que esta tarea comience.",
    // Manage Assignments
    step01: "Paso 01",
    step02: "Paso 02",
    step03: "Paso 03",
    step04: "Paso 04",
    step05: "Paso 05",
    manageAssigmentsStep1: "Seleccione una acción.",
    manageAssigmentsStep2: "Editar asignación de tareas",
    editAssignment: "Editar asignación",
    deleteAssignment: "Eliminar asignación",
    manageAssigmentsStep3: "Asignación completa",
    taskAssigmentStatusHeader: "Estado de asignación",
    taskAssigmentStatusTileHeader: "Estado de tareas y asignaciones",
    taskAssignmentName: "Asignación",
    dueDateAssigment: "Vencimiento",
    editDueDate: "Opcional: Editar días antes de la fecha de finalización",
    teamMemberAssigmentLabel: "Miembro del equipo",
    currentAssigmentLabel: "Actual",
    handOffToAssigmentLabel: "Entregado a:",
    priorToEndDateLabel: "antes de la fecha de finalización",
    noTimePhaseAssigmentLabel: "Sin fase de tiempo asignada",
    closedByAssigmentLabel: "Cerrado por",
    onAssingmentLabel: "en",
    preparerAssigmentOpenTitleTip: "Entregue esta tarea para cerrar su tarea asignada",
    reviewerAssigmentOpenTitleTip: "Marcar la tarea asignada como cerrada",
    reviewerAssigmentClosedTitleTip: "Marcar la tarea asignada como abierta",
    AssigmentLabel: "Entregue esta tarea para cerrar su tarea asignada",
    noEvidenceReviewerAssigmentTitleTip: "Agregue evidencia para marcar la asignación de tareas como cerrada",
    noTaskEvidencesHandoffModal: "No hay archivos de evidencia asociados a esta tarea.",
    back: "Atrás",
    savecontinue: "Guardar y continuar",
    finish: "Terminar",
    save: "Salvar",
    emptyManageAssignmentStep: "...",
    selectAssignmentActionToContinue: "Seleccione una acción para continuar.",
    createNewTaskAssingment: "Crear nueva tarea asignada",
    deleteTaskAssingment: "Eliminar asignación de tareas",
    createTaskAssingment: "Crear tarea asignada",
    editExistingTaskAssingment: "Editar asignación de tarea existente",
    editTaskAssingment: "Editar tarea asignada",
    removeExistingTaskAssingment: "Eliminar la asignación de tareas existente",
    warningPopUpPreparerAssignmentTitle: "Sobrescribir la asignación de preparador existente",
    warningPopUpPreparerAssignmentText: "Ya hay una asignación de preparador para esta tarea. ¿Está seguro de que desea sobrescribir esta asignación?",
    warningPopUpPreparerAssignmentConfirm: "Confirmar",
    warningPopUpPreparerAssignmentCancel: "Cancelar",
    selectTaskAssingment: "Seleccionar tarea asignada",
    viewHistoryAndConflicts: "Ver historial",
    noHistoryAvailable: "No hay historial disponible",
    teamMember: "Miembro del equipo",
    dateEdited: "Ultima modificación",
    viewHistoryHeader: "Este historial de versiones de documentos se muestra a continuación.",
    viewHistorySubHeader: "Haga clic en el nombre de los miembros de un equipo para abrir una versión anterior de este documento en modo de solo lectura. Los cambios realizados en esta versión anterior no se guardarán en EY Canvas.",
    docConflictedMessage: "Hay conflictos asociados con este documento. Navegue a la pestaña Conflictos en la lista Documentos para resolver.",
    removeTaskAssingment: "Eliminar tarea asignada",
    addAssignmentInstructionalText: "Ingrese un nuevo nombre de tarea asignada aquí (por ejemplo, Revisor de detalles, Revisor general)",
    addNewAssingmentName: "Añadir nuevo nombre de asignación",
    addTaskAssignmentName: "Agregar nombre de tarea asignada",
    assignmentName: "Nombre de la asignación de tarea",
    selectedTask: "tarea seleccionada",
    createTaskAssignmentHeading: "Crea una nueva tarea aquí.",
    createTaskAssignmentHeading1: "Ingrese los detalles de la tarea a continuación y seleccione <b>Guardar y cerrar</b> para finalizar. Para crear otra asignación, seleccione <b>Guardar y agregue otro</b>.",
    saveDelete: "Guardar y eliminar",
    createTaskAssignmentFinishLabel: "Guardar y cerrar",
    createTaskAssignment: "Guardar y añadir",
    editTaskAssignment: "guardar & gestionar otro",
    createTaskAssignmentSaveAndContinueLabel: "Guardar y administrar otro",
    daysPriorToEndDate: "Días antes de la fecha de finalización",
    daysdue: "Días vencidos",
    daysPriorToEndDateOptional: "Días antes de la fecha de finalización (opcional)",
    timephase: "Fase de tiempo",
    timephasesLabel: "Fases de tiempo",
    manageTimePhase: "Gestionar las Fases de tiempo",
    removeTaskAssingmentSingleTaskHeading: "Seleccione la asignación que desea eliminar.",
    removeTaskAssingmentSingleTaskHeading2: "Haga clic en 'Guardar y cerrar' si ha terminado o haga clic en 'Guardar y administrar otra' si desea administrar otra asignación de tareas.",
    removeTaskAssingmentMultipleTaskHeading: "Si existe la combinación de asignación y miembro del equipo para una tarea seleccionada, se eliminará la asignación. Haga sus selecciones y seleccione <b>Guardar y cerrar</b> para finalizar. Para eliminar otra asignación, seleccione <b>Guardar & eliminar</b>.",
    editTaskAssingnmentStep2Heading: "Seleccione la asignación de tareas que desea editar.",
    selectedAssignment: "Asignación seleccionada:",
    editTaskAssingmentBulkHeading: "Seleccione la asignación que desea editar.",
    editTaskAssingmentBulkSubHeading1: "Si la asignación y la combinación de miembro del equipo existen para una tarea seleccionada, la tarea se reasignará. Tiene la opción de editar los <b>Días antes de la fecha de finalización</b>. Si edita este valor, se actualizará para todas las tareas reasignadas. Realiza tus ediciones y selecciona <b>Guardar y cerrar</b> para finalizar. Para editar otra tarea, seleccione <b>Guardar y administrar otra</b>.",
    noResultInCategory: "No se encontraron resultados dentro de esta categoría de tarea",
    searchTaskList: "Buscar lista de tareas",
    searchCanvasFormList: "Búsqueda",
    clearHoverText: "Limpiar",
    filtersWarningMessage: "Límite de filtro excedido. Solo se pueden aplicar 25 filtros a la vez .",
    reviewNotesWarningMessage: "Se ha producido un error al recuperar los datos. Intente nuevamente y si el problema persiste, comuníquese con la Mesa de ayuda.",
    editTaskAssingmentSept3Header: "Editar la asignación seleccionada.",
    editTaskAssingmentSept3Header2: "Haga clic en 'Guardar y cerrar' si ha terminado o haga clic en 'Guardar y administrar otra' si desea administrar otra asignación de tareas.",
    editTaskAssignmentHeaderPart1: "Edite los detalles de la tarea a continuación y seleccione <b>Guardar cambios</b>.",
    calculatedDate: "Calcular Fecha",
    saveAndAddbtn: "Guarde y agregue otro",

    //Calendar Toggle Labels
    daysPriorToEndDateRequired: "Días antes de la fecha de finalización (requerido)",
    dueDateRequired: "Fecha de vencimiento (requerido)",
    selectDate: "Seleccione fecha",
    calculateDate: "Calcular fecha",

    /* Bulk TimePhase*/
    taskText: "Tarea",
    timephasesetsuccess: "{0} fase de tiempo establecida con éxito.",
    timephasessetsuccess: "{0} fases de tiempo establecidas correctamente.",
    addTimephaseLabel: "Agregar fase de tiempo",
    infoSetTimePhase: "<H3> Establezca fases de tiempo </h3> <p> Arrastre y suelte en una fase de tiempo para establecer esa fase de tiempo para los elementos seleccionados </p>",
    infoEditTimePhase: "<h3>Editar fase de tiempo</h3><p>Haga clic en el menú adicional (tres puntos) y seleccione Editar para editar las propiedades de la fase de tiempo.</p>",
    infoAddTimePhase: "<H3> Agregar fase de tiempo </h3> <p> Haga clic en Agregar fase de tiempo para crear una nueva fase de tiempo. </p>",
    infoDeleteTimePhase: "<H3> Eliminar fase de tiempo </h3> <p> Haga clic en el menú de desbordamiento (tres puntos) y seleccione Eliminar para eliminar la fase de tiempo. </p>",
    deletedTimePhaseFilterWarningMessage: "La fase de tiempo ha sido eliminada por otro usuario.",

    //Set assignment dates modal labels
    setAssignmentTitle: "Establecer la fecha de vencimiento de las tareas",
    setAssignmentDesc: "No ha definido la fecha de vencimiento de la(s) tarea(s). Seleccione la(s) fecha(s) de vencimiento de la(s) siguientes tarea(s) para continuar.",
    setAssignmentDesc2: "Una o más tareas tienen una fecha de fase temporal anterior a la fecha de vencimiento seleccionada de {0}. Ajuste las fechas de vencimiento de las tareas o la fecha de vencimiento de la fase temporal para continuar.",
    timePhaseNameLabel: "Fase de tiempo",
    timephaseEndDate: "Fecha de finalización de la fase de tiempo",
	tasksLabel: "No. de tareas",
    assignmentDateLabel: "Asignación",
    noAssignedTimePhase: "Sin fase de tiempo asignada",
    endDate: "Fecha finalización",
    calendarDateError: "La fecha de vencimiento debe ser anterior a la fecha de finalización de la fase de tiempo",

    /* Events*/
    addEventLabel: "Agregar evento",
    sharedWithClient: "Compartido",
    noEventsMessage: "No se han identificado hechos.",
    naLabel: "No Aplica",
    deleteEventModalTitle: "Eliminar evento",
    deleteEventDescription: " ¿Está seguro de que desea eliminar este evento?",
    showEventeName: "Evento",
    eventDateLabel: "Fecha",
    eventDatesLabel: "Fechas",
    showEventStartDate: "Fecha de inicio",
    showEventEndDate: "Fecha final",
    deleteEventSuccessMessage: "Evento eliminado correctamente.",
    eventTypeLabel: "Tipo de evento",
    singleDayEventLabel: "Un solo día",
    multiDayEventLabel: "Varios días",
    dateRangeEventLabel: "Intervalo de fechas",
    eventSharedWithClientLabel: "Compartido con el cliente",
    editEventLabel: "Editar evento",
    eventUpdateSuccessMessage: "Evento actualizado correctamente.",
    noTimephasesMessage: "No se han identificado fases de tiempo.",

    /* Review Notes */
    showAll: "Todo",
    reviewNotesLabel: "Notas de revisión",
    athoredByMeLabel: "Escrito por mí",
    assignedToMe: "Asignado a mí",
    assignedToOpen: "Asignado a (Abierto)",
    authoredByCleared: "Escrito por (Borrado)",
    totalOpenReviewLabel: "Total de notas de revisión abiertas",
    totalClearedReviewLabel: "Total de notas de revisión aclaradas",
    agingLabel: "Antigüedad",
    openLabel: "Abierto",
    clearedLabel: "Resuelto",
    noUsersFoundLabel: "No se encontraron resultados",
    chartDataLabel: "No hay datos disponibles.",
    noClientDataAvailable: "No hay datos disponibles",
    DaysLessThan10: "<10 días",
    Days11To30: "<30 días",
    Days31To60: "<60 días",
    Days61To90: "<90 días",
    DaysMoreThan90: ">90 días",
    noReviewNotesFound: "No se encontraron notas de revisión",

    formMaxLength: "El texto no puede exceder {number} caracteres.",
    voiceNote: "Nota de voz",
    microphoneBlockedMessage: "Permita que el navegador acceda a su micrófono para usar notas de voz. Si ya está permitido, actualice e inténtelo de nuevo.",
    microphoneBlockedOnVideoMessage: "Permita que el navegador acceda a su micrófono para usar la voz en la grabación de pantalla. Si ya está permitido, actualice e inténtelo de nuevo.",
    notInMainWindowVoice: "Las grabaciones de voz no están permitidas dentro del cajón, abra el documento en una nueva pestaña para realizar la acción.",
    notInMainWindowScreen: "Las grabaciones de pantalla no están permitidas dentro del cajón, abra el documento en una nueva pestaña para realizar la acción.",
    screenRecord: "Grabación de pantalla",
    playbackReview: "Revisión de reproducción",
    recording: "Grabando",

    /* Sign Offs */
    preparerHoverText: "Firmar como preparador",
    reviewerHoverText: "Firmar como revisor",
    preparerTitle: "Aprobaciones del preparador",
    reviewerTitle: "Aprobaciones del revisor",
    preparerLetter: "P",
    reviewerLetter: "R",
    deleteHoverText: "Eliminar la firma",
    signoffsrequired: "Se requieren firmas",
    signoffsOptional: "PIC/EQR opcional",
    eqrLabel: "EQR",
    partnerInChargeLabel: "PIC",

    landingPage: "Pagina Inicial",
    dashboardPage: "Panel de Control",
    tasksPage: "Tareas",
    documentsPage: "Documentos",
    collaborationPage: "Colaboración",
    automationPage: "Automatización",
    newContentUpdate: "Actualización de contenido",
    contentUpdatesHistory: "Historia",
    history: "Historial",
    contentUpdateType: "Tipo de actualización de contenido",
    iniciatedBy: "Iniciado por",
    date: "Fecha",
    clickForOptions: "Haga clic para más opciones",
    offline: "Desconectado",
    eyServiceGateway: 'EY Service Gateway',
    eyAutomation: 'EY Automation',
    eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

    // ContentUpdates
    contentUpdate: "Actualizaciones de contenido",
    canvasFormUpdates: "Formas de canvas actualizadas",
    syncFormProfile: "Sincronizar perfil de formulario",
    documentName: "Nombre del documento",
    analyticName: "Nombre del análisis",
    formType: "Tipo de forma",
    dateOfContent: "Fecha del contenido",
    formStatus: "Estatus",
    formsWarningMessage: "Se deben seleccionar uno o más formularios de EY Canvas para la actualización",
    formsUpdateSuccessMessage: "Actualización del formulario de EY Canvas enviada",
    filterTypeOfFormLabel: "Tipo de forma",
    filterSourceOfFormLabel: "Fuente de forma",
    documentSelectionRequired: "Seleccionar un documento para sobrescribirlo",
    overwriteForm: "Sobrescribir formulario",
    overwriteFormInstructionalText: "Seleccione un formulario para sobrescribir las respuestas con los datos del formulario de Canvas actual. Tenga en cuenta que el formulario Canvas actual se moverá a archivos temporales.",
    confirmOverwrite: "Confirmar sobrescritura",
    confirmOverwriteAreYouSure: "¿Está seguro de que desea copiar el contenido del formulario \'{0}\' al formulario \'{1}\'?",
    confirmOverwriteDesc: "Las respuestas se sobrescribirán en el \'{1}\' forma, pero la evidencia relacionada y los objetos no lo harán. La evidencia y los objetos relacionados aplicables deben volver a asociarse al formulario \'{1}\' después de que se haya completado la sobrescritura. \'{0}\' formulario conservará sus capas de perfiles/GAM existentes, por lo tanto, si esa generación de perfiles es diferente de \'{1}\' formulario, por favor revise y limpiar el contenido copiado.",
    confirmOverwriteDoNotClose: "No cierre el explorador ni navegue mientras el proceso de sobrescritura está en curso. Después de que el proceso de sobrescritura se ha completado, el formulario \'{0}\' se moverá a archivos temporales. Esta acción no se puede deshacer.",
    sourceDocument: "documento de origen",
    targetDocument: "documento de destino",
    profileLayers: "Layers GAM",
    pspAccountWarningMessage: "Se deben seleccionar una o más cuentas para la actualización",
    pspAccountUpdateSuccessMessage: "Actualización de contenido de PSP enviada",
    pspAccountconfirmUpdateMessage: "La actualización de estas cuentas puede tener un impacto significativo en el contenido. Una vez iniciado, no se pueden realizar actualizaciones de contenido adicionales hasta que se completen.",
    est: "ha estimado",
    bookmarkTaskModalHeader: "No se pueden descargar las tareas seleccionadas",
    bookmarkTaskModalMessage: "Las tareas seleccionadas no se pueden descargar para trabajar sin conexión.",
    noGuidanceAvailable: "No hay orientación disponible",
    next: "Siguiente",
    previous: "Previo",
    guidanceLink: "Link",
    addToEvidenceLabel: "Agregar a la evidencia",
    otherEngagements: "Otros compromisos",
    navigationView: "Vista de navegación",
    listView: "Vista de lista",
    detailsView: "Vista de detalles",
    closeguidance: "Cerrar guia",
    reviewNotesModalClose: "Cerrar",
    gamGuidanceLinkLabel: "Guía de GAM",
    inProgess: "En curso",
    upcomingReview: "Para la próxima revisión",
    teamSummaryEmptyTaskDetailsMesage1: "Utilice el Resumen del equipo para ver las asignaciones de preparadores y revisores para cada miembro del equipo por estado. Para administrar todas las asignaciones para su participación, seleccione",
    teamSummaryEmptyTaskDetailsMesage2: "Gestionar asignaciones",
    teamSummaryEmptyTaskDetailsMesage3: "Para habilitar controles masivos, use la casilla de verificación para seleccionar una o más tareas. Utilice la tecla de mayúsculas para seleccionar varias tareas a la vez. Si desea trabajar en una tarea individual, seleccione esa tarea de la lista.",
    taskSummaryPoint1: "Seleccione 'Preparar' para ver una lista de las asignaciones del preparador para cada miembro del equipo.",
    taskSummaryPoint2: "Seleccione 'Para revisar' para ver una lista de las asignaciones de revisor es para cada miembro del equipo.",
    taskSummaryPoint3: "Las asignaciones se ordenan por estado de asignación (no iniciado, en proceso y terminado).",
    noLinksfound: "No hay enlaces disponibles para esta tarea.",
    noFormsfound: "No hay formularios disponibles para esta tarea.",
    workofflinemsg: "Esto descargará las últimas versiones de las tareas seleccionadas y le permitirá continuar editando sin conexión. Puede sincronizar los cambios más adelante reconectándose.",
    workonlinemsg: "Volver a conectarte sincronizará automáticamente tus cambios. Asegúrese de que hay una conexión a Internet disponible antes de volver a conectarse.",
    workoffline: "Trabajar sin conexión",
    workonline: "Trabajar en línea",
    duplicateFileNames: "Nombres de archivos duplicados",
    training: "Entrenamiento",
    duplicateFileNameValidationMessage: "El archivo que está intentando agregar a este compromiso tiene el mismo nombre que un archivo existente en este compromiso. Cambie el nombre de uno de los archivos para continuar.",
	documentHelperConnectionIssue: 'Se ha detectado un problema con EY Canvas Document Helper. Haga clic <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">aquí</a> para obtener instrucciones sobre cómo resolver este problema.',
    incompleteCra: "CRA incompleta",
    noteItemCreated: "Creado:",
    NetworkErrorMessage: "La red de aplicaciones está experimentando un error. Actualice la página e inténtelo de nuevo más tarde. Póngase en contacto con el servicio de asistencia si el error persiste.",
    saveClose: "Guardar y cerrar",
    contentupdatePSPs: "Actualización de contenido - PSP",
    /* PAANS */
    paansIsNotReachable: "El servicio de creación, aprobaciones y notificaciones de directivas de EY no está disponible en este momento. No podemos confirmar si se han completado todas las políticas pertinentes. Si no ha revisado las directivas pertinentes, actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",

    /* Add New Task */
    standardtask: "Tarea estándar – OST",
    substantivetask: "Tarea sustantiva – OSP",
    walkthroughtask: "Tarea de Recorrido – WT",
    controltask: "Tarea de control – TOC",
    addnewTask: "Añadir nueva tarea",
    taskType: "Tipo de tarea",
    taskTypeError: "Seleccione el tipo de tarea",
    selectTaskTypeHeader: "Seleccione un tipo de tarea para continuar.",
    selectTaskType: "Seleccionar tipo de tarea",
    enterTaskDetails: "Introduzca los detalles de la tarea",
    assignTask: "Asignar tarea",
    taskGroup: "Tarea grupal",
    finishLabel: "Guardar & cerrar",
    addTaskContinueLabel: "Guardar y asignar",
    AssignTaskStepSaveandContinueLabel: "Guardar y añadir otro",
    addTaskDetailsHeader: "Ingrese los detalles de la tarea para continuar",
    addTaskAssignmentHeader: "Opcional: cree una asignación para esta tarea.",
    addTaskDetailsSubHeader: "Haga clic en <b>Guardar y asignar</b> si desea asignar esta tarea ahora o haga clic en <b>Guardar y cerrar</b> si desea asignar esta tarea más adelante.",
    addTaskAssignmentSubHeader: "Ingrese los detalles de la tarea a continuación y seleccione Guardar y cerrar para finalizar. Para crear otra asignación, seleccione Guardar y agregar.",
    addTaskAssignmentSubHeader1: "Introduzca los detalles de la asignación a continuación y seleccione <b>Guardar y cerrar</b> para finalizar. Para crear otra asignación, seleccione <b>Guardar & add.</b>",
    addTaskGroup: "Agregue un nuevo grupo de trabajo aquí. Una vez agregado, puede seleccionar este grupo de tareas al crear nuevas tareas, así como mover las tareas OST existentes a este grupo de tareas.",
    relateObjectHeaderAccount: "Seleccione una o más aseveraciones para una cuenta o divulgación significativa, o seleccione una cuenta de riesgo limitado.",
    relateObjectSubHeaderAccount: "Las tareas solo se pueden relacionar con una cuenta o divulgación.",
    relateObjectHeader: "Relacione uno o más objetos para continuar.",
    limitedRiskAccount: "Cuenta de riesgo limitado",
    onlyShowAddedObject: "Unicamente mostrar objetos agregados",
    relateObjectRequiredError: "Uno o mas objetos deben de ser seleccionados para proceder",
    invalidSelectionWarning: "Las tareas solo se pueden relacionar con una cuenta o divulgación. Quite las aseveraciones seleccionadas o la cuenta de riesgo limitado para relacionar la tarea con las aseveraciones de una cuenta o divulgación diferente o una cuenta de riesgo limitado diferente.",
    invalidSelctionCRA: "Seleccione un tipo de objeto sencillo",
    relateObjectOptionsHeaderAccountTask: "Aserciones y cuentas de riesgo limitadas",
    relateObjectOptionsHeaderITWalkthroughTask: "Procesos de TI/SO",
    relateObjectOptionsHeaderITControlTask: "Controles generales de TI",
    relateObjectOptionsHeaderITSubstantiveTask: "Procedimientos sustantivos de TI",
    relateObjectOptionsHeaderSCOTControlTask: "Controles",
    relateObjectOptionsHeaderSCOTWalkthroughTask: "Scots",
    StrategyTypeControls: "Controles",
    StrategyTypeSubstantive: "Sustantivo",

    //Manage quick filters labels
    manageQuickFilterHeader: "Seleccione un filtro guardado o sugerido para usar como predeterminado",
    manageQuickFilterText: "Si selecciona un valor predeterminado, este filtro se aplicará cuando navegue a la lista de tareas.",
    noDefaultFilter: "Sin filtro predeterminado",
    suggestedFiltersHeading: "Filtros sugeridos",
    savedFiltersHeading: "Filtros Guardados",
    manageQuickFilters: "Administrar filtros rápidos",
    manageLabel: "Gestionar",


    /* RNH Labels */
    emptyNoteDetailsMessage: "Seleccione una nota para ver los detalles. Para habilitar los controles masivos, utilice la tecla de control o mayús y seleccione varias notas de revisión. Si desea trabajar en una nota individual, seleccione esa nota de la lista.",
    emptyRepliesMessage: "No respuestas aun",
    emptyRepliesMessageAlt: "No hay respuestas",
    reviewNotes: "notas de revisión",
    reviewNotesStatus: "Revisar el estado de la nota",
    reviewNotesStatusAssignedToMe: "Estado de las notas de revisión que se me asignaron",
    reviewNotesStatusAuthoredByMe: "Estado de las notas de revisión escritas por mí",
    comments: "Notas de revisión",
    showHideNotes: "Mostrar/Ocultar notas",
    fileType: "Tipo de archivo",
    noteType: "Tipo",
    statusId: "Estado",
    rnhPriority: "Prioridad",
    rnhDueDate: "Vencimiento:",
    rnhModifiedDate: "Modificado",
    textAreaPlaceholder: "Introducir nota",
    requiredFieldErrorMessage: "Este es un campo obligatorio.",
    meLabel: "Yo",
    editIconHoverText: "Editar",
    deleteIconHoverText: "Eliminar",
    deleteIconModalTitle: "Eliminar nota",
    deleteIconCommentModalTitle: "Eliminar nota",
    deleteReplyIconModalTitle: "Eliminar respuesta",
    deleteIconModalConfirmMessage: "¿Está seguro de que desea eliminar su respuesta a esta nota?",
    deleteIconModalConfirmMessageParent: "¿Está seguro de que desea eliminar la nota seleccionada?",
    deleteIconModalCommentConfirmMessage: "¿Está seguro de que desea eliminar esta respuesta?",
    deleteIconModalCommentConfirmMessageParent: "¿Está seguro de que desea eliminar esta nota? También se eliminarán todas las respuestas a esta nota.",
    deleteIconModalAcceptText: "Eliminar",
    replyInputPlaceholder: "Responder a esta nota",
    changeStatus: "cambiar status",
    emptyReplyErrorMsg: "Agregar texto o una nota de voz para continuar",
    lengthReplyErrorMsg: "La respuesta no puede superar los 4.000 caracteres.",
    closeTitle: "Cerca",
    closedBy: "Cerrado por",
    ClearedBy: "Aclarado por",
    ReopenedBy: "Reabierto por",
    commentTitle: "Nota",
    noteDueDateLabel: "Vencer",
    reopen: "Reabrir",
    noNotesAssociatedWithDocumentLabel: "Deje una nota utilizando las entradas a continuación. Asigne la nota a un usuario y especifique la prioridad y la fecha de vencimiento.",
    noNotesFound: "No se han encontrado notas",

    /* Add new review note RNH */
    addNewNoteButtonTitle: "Nueva nota",
    addNewNoteModalTitle: "Agregar una nueva nota",
    addNewNoteModalClose: "Cerrar",
    backButtonLabel: "Atrás",
    cancelButtonLabel: "Cancelar",
    addNewNoteStep1Title: "Seleccione el tipo de nota",
    addNewNoteStep2Title: "Seleccionar documento o tarea",
    addNewNoteStep3Title: "Introduzca los detalles de la nota",
    editNoteModalTitle: "Editar nota",
    editReplyModelTitle: "Editar respuesta",
    voiceNoteButtonLabel: "Nota de voz",
    stopRecordingButtonLabel: "Detener",
    enterText: "Ingrese texto",

    /* RNH Review note hub Step 1 */
    step1Title: "Seleccione un tipo de nota para continuar.",
    step1Subtitle: "Solo puede agregar documentos y notas de tareas aquí. Los comentarios del formulario canvas deben agregarse dentro del formulario Canvas correspondiente.",
    step1NoTypeSelectedError: "Seleccione un tipo de nota para continuar.",

    /* RNH Review note hub Step 2 */
    step2DocumentTitle: "Seleccione el documento al que desea agregar una nota.",
    step2TaskTitle: "Seleccione la tarea a la que desea agregar una nota.",
    step2SearchTitle: "Búsqueda",
    step2SearchClearTitleTip: "Limpiar",
    step2ErrorMessageTop: "Seleccione un artículo para proceder.",
    step2ErrorMessageBottom: "Complete los campos requeridos identificados arriba para proceder.",
    step2EmptySearch: "No se han encontrado resultados",

    /* RNH Review note hub Step 3 */
    step3InstructionalText: "Introduzca los detalles de la nota para el documento o tarea seleccionados.",
    step3InstructionalSubTitle: "Haga clic en <b>Guardar y cerrar</b> cuando haya terminado o haga clic en <b>Guardar y agregar otra</b> si desea agregar otra nota al documento o tarea seleccionados.",
    step3SelectedDocument: "Documento seleccionado:",
    step3SelectedTask: "Tarea seleccionada:",
    step3SaveAndContinue: "Guardar y añadir otro",
    step3SaveAndClose: "Guardar y cerrar",

    /* RNH List Layout Labels*/
    searchReviewNotes: "Notas de búsqueda",
    searchReviewNotesResultsNotFound: "No se han encontrado resultados dentro de esta categoría de notas",
    searchReviewNotesNotAvailable: "No hay notas disponibles",
    notesRepliesNotFound: "No se han encontrado respuestas para las notas seleccionadas.",

    selectValueToContinue: "Seleccione un valor para continuar",
    required: "Obligatorio",
    invalidEngagementId: "El identificador de interacción no es válido. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    accessDenied: "Acceso denegado",
    annotationDeletedError: "La nota seleccionada ha sido eliminada. Actualice la página y vuelva a intentarlo.",

    /* RNH Filters */
    rnhClearAll: "Borrar todo",
    rnhShowMore: "más",
    rnhFilter: "Filtro",
    hideFiltersLabel: "Esconder",
    noDocumentChangeTypes: "No se tienen resultados",
    selectatasktype: "Seleccione un tipo de tarea",
    importfromknowledge: "Importar desde el conocimiento",
    assigntaskoptional: "Asignar tarea (opcional)",
    relateanobject: "Relacionar un objeto",
    account: "Cuenta",
    userOrRole: "Usuario o rol",
    userSummary: "Resumen de usuario",
    other: "Otro",
    userNotFound: "Usuario no encontrado",
    dueOnOrBefore: "Vence en o antes",
    dueOnOrAfter: "Vence en o despues",

    /*Dashboard - Milestone tile*/
    milestonesLabel: "Milestones",
    scopeAndStrategy: "Alcance y Estrategia",
    scopeAndStrategyTabLabel: "Alcance y estrategia",
    executionTabLabel: "Ejecución",
    conclusionTabLabel: "Conclusión",
    viewAllTabLabel: "Ver todo",
    noTaskAssociatedToMilestoneMsg: "No hay tareas asociadas a los hitos en esta fase de auditoría.",
    overdueLabel: "Atrasado",
    upcomingLabel: "Fecha de vencimiento próxima",
    quickLinkText: "Enlaces rápidos",
    inreviewLabel: "En revisión",
    CompleteLabel: "Completado",
    completeLabel: "Completado",
    startLabel: "Empezar",
    endLabel: "Final",
    auditPhaseSummary: "Resumen de la fase de auditoría",
    milestoneView: "Vista hito",
    timePhaseView: "Vista de fase de tiempo",
    localLandingPageHeader: "Esta página muestra solo los compromisos de EY Canvas que están disponibles en este centro de datos.",
    localLandingPage: "Página Principal Local",
    noEngagementsAvailable: "No hay compromisos disponibles en este centro de datos",
    engagements: "Engagements",
    /* Document List */
    docListRelatedTasks: "Tareas relacionadas",
    temporaryFilesTab: "Archivos temporales",
    priorPeriodEvidenceTab: "Evidencia de periodos anteriores",
    conflictsTab: "Conflictos",
    recentlyDeletedTab: "Recientemente eliminado",
    docListSelectedDocument: "{0} documento seleccionado",
    docListSelectedDocuments: "{0} documentos seleccionados",
    shared: "Compartido",
    shareStatusOwned: "Adueñado para este compromiso",
    shareStatusShared: "compartido dentro de este compromiso",
    unlinkInprogress: "Desvincular en curso",
    unlinkError: "Error de desvinculación",
    documentList: "Documentos",
    restoreModalTitle: "Restaurar a archivos temporales",
    restoreModalText: "Restaurar para devolver este documento a archivos temporales.",
    permanentlyDeleteModalTitle: "Eliminar permanentemente",
    permanentlyDeleteModalText: "La eliminación permanente del documento lo eliminará de EY Canvas y no se puede deshacer. Haga clic en Eliminar permanentemente para continuar.",
    misstatementsInstructionalText: "El documento está relacionado con las siguientes declaraciones erróneas en esta compromiso. Haga clic en un Estado erróneo para navegar hasta él.",
    deficienciesInstructionalText: "El documento está relacionado con las siguientes deficiencias en este compromiso. Haga clic en una Deficiencia para navegar hasta ella.",
    referenceId: "Id",
    findingDescription: "Descripción",
    deficienciesModalTitle: "Deficiencias relacionadas",
    misstatementsModalTitle: "Erróres relacionados",
    startsWith: "Comienza con",
    contains: "Contiene",
    documentsWherePICEQRSignOffIsRequired: "Documentos en los que se requiere la aprobación de PIC/EQR",
    otherDocuments: "Otros documentos",
    documentsWherePICSignOffIsRequired: "Documentos en los que se requiere la firma del PIC (socio a cargo)",
    documentSignoffRequiredLabel: "Firmas requeridas de:",
    timePhaseFilterLabel: "Fase de tiempo",
    drillDownTimePhaseFilterLabel: "Ver por fase temporal",
    auditPhasesLabel: "Fase de auditoría",
    openedLabel: "Abierto",

    clientApprovals: "Aprobación externa",
    noTeamsAvailable: "Todavía no se han creado equipos. Cree un equipo y envíe una solicitud de enlace para comenzar.",
    noDocumentRecieved: "Aún no se han recibido documentos.",
    team: "Equipo",
    pendingEvidence: "Evidencia pendiente",
    noTimePhasePlaceHolder: "No fases de tiempo",

    regionComponentEvidence: "Evidencia de región y componentes",
    preparersignoffs: "Firmas de preparadores",
    reviewersignoffs: "Firmas de los revisores",
    receivedon: "Recibido en:",
    nosignoffsyet: "Aún no hay firmas.",
    noRegionComponentEvidence: "Todavía no se han recibido documentos. Para ver una lista de regiones y componentes que aún no han enviado documentos, seleccione <b>Documentación pendiente</b>.",
    noComponentEvidence: "Todavía no se han recibido documentos.",
    assignToRegionOrComponent: "Asignar a región o componente",
    assignRegionComponentModalText: "Seleccione la región o el componente al que desea asignar este documento.",
    documentAssignedToPGT: "Este documento ya se ha asignado a otra región o componente. Por lo tanto, no está disponible para la asignación.",
    assignedToRegionComponent: "Región o componente asignado:",
    noRegionComponentsAvailable: "No hay regiones o componentes disponibles",
    documentUnassignedFromComponent: "{0} ha sido no asignado de {1}.",
    documentUnassigned: "{0} se ha quitado asignacion",
    documentReturnedToComponent: "{0} ha sido devuelto a {1}.",
    documentReturned: "{0} ha sido devuelto.",
    regionComponentName: "Nombre de región o componente.",
    relatedReviewNoteCount: "1 nota abierta de otros compromisos",
    relatedReviewNotesCount: "{0} notas abiertas de otros compromisos",

    deleteVersion: "Eliminar versión",
    deleteVersionMessage: "Seleccione una versión para continuar.",
    deleteVersionDisabledMessage: "Las versiones del historial solo pueden ser eliminadas del compromiso de origen del documento por los administradores del compromiso.",
    deleteVersionTitle: "Eliminar versión del documento",
    deleteVersionPlaceholder: "¿Está seguro de que desea eliminar esta versión del historial? Esta acción no se puede deshacer",

    childDocumentsCountLabel: "Copias existentes",
    childDocumentsModalTitle: "Copias existentes",
    childDocumentsModalDescription: "Los siguientes documentos se crearon a partir del documento original.",
    childDocumentsModalColumnDocumentName: "Nombre del documento",
    childDocumentsModalColumnDocumentType: "Tipo de documento",
    childDocumentsModalColumnRelatedTasks: "Tareas relacionadas",
    childDocumentsModalColumnSignoffs: "Firmas",

    bulkAddToEvidenceDescription1: "Cree una nueva copia de los documentos presentados como evidencia, o seleccione una copia existente si está disponible.",
	bulkAddToEvidenceDescription2: 'De forma predeterminada, los documentos recién creados se agregarán a todas las tareas y canvas Forms con los que estaba relacionado el documento anterior. Utilice "Opciones avanzadas" para seleccionar manualmente las tareas y Canvas Forms a los que asociar el nuevo documento. Utilice la función Buscar y reemplazar para reemplazar ciertas partes del nombre del nuevo documento (por ejemplo, el año); esta función se puede utilizar varias veces.',
    bulkAddToEvidenceDescription3: "Cuando se selecciona un documento existente, solo se agregará a la tarea actual. Si sólo hay un documento existente disponible, que ha sido preseleccionado; de lo contrario, elija una copia existente para agregar.",
    bulkAddToEvidenceAdvancedOn: "Opciones avanzadas",
    bulkAddToEvidenceAdvancedOff: "Apagado",
    bulkAddToEvidenceFindText: "Buscar texto",
    bulkAddToEvidenceFindTextRequired: "Introduce un texto de búsqueda válido.",
    bulkAddToEvidenceReplaceWith: "Reemplazar por",
    bulkAddToEvidenceReplaceSuccess: "Reemplazó {0} por {1}.",
    bulkAddToEvidenceUseExisting: "Utilizar los recursos existentes",
    bulkAddToEvidenceCreateNew: "Crear nuevo",
    bulkAddToEvidenceDocumentName: "Nombre del documento",
    bulkAddToEvidenceExistingDocument: "Documento existente",
    bulkAddToEvidenceSelectANewOrExistingCopy: "Seleccione una copia nueva o existente",
    bulkAddToEvidenceAssociateToTasks: "Asociar a tareas",
    bulkAddToEvidenceAssociateToCanvasForms: "Asociar a canvas Forms",
    bulkAddToEvidenceOtherRelatedTasks: "Otras tareas relacionadas",
    bulkAddToEvidenceAssociateToTasksPlaceholder: "Solo los documentos recién creados se pueden asociarse a las tareas. Los documentos existentes se asociarán automáticamente a la tarea actual.",
    bulkAddToEvidenceSelectedTask: "{0} tarea relacionada",
    bulkAddToEvidenceSelectedTasks: "{0} tareas relacionadas",
    bulkAddToEvidenceSelectedTasksPlaceholder: "No hay tarea relacionada disponible",
    bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "Solo los documentos recién creados se pueden asociar a los formularios de Canvas.",
    bulkAddToEvidenceRelatedCanvasForms: "Formularios de Canvas relacionados",
    bulkAddToEvidenceSelectedForm: "{0} formulario de Canvas relacionado",
    bulkAddToEvidenceSelectedForms: "{0} formularios de Canvas relacionados",
    bulkAddToEvidenceSelectedFormsPlaceholder: "No hay formularios de Canvas relacionados",
    picRequiredValidation: "Documento que requiere firma del PIC no está relacionado con una tarea de PIC",
    eqrRequiredValidation: "El documento requerido de firma de EQR no está relacionado con una tarea de EQR",
    picEqrRequiredValidation: "El documento requerido de firma de PIC/EQR no está relacionado con una tarea de PIC/EQR",

    viewSwitcherDefault: "Vista predeterminada",
    viewSwitcherEntity: "Vista de entidad",
    viewSwitcherAllEntities: "Todas las entidades",
    viewByEntities: "Vista por entidades",

    /* bulk delete modal */
    bulkDeleteFilesModalMessage: "¿Está seguro de que desea eliminar los documentos seleccionados?",
    bulkDeleteFIlesModalMessageSub: "Los documentos que no se pueden eliminar se indican a continuación y no se eliminarán.",
    bulkDeleteModalLabel: "Eliminar documentos",
    bulkDeleteSuccessMessage: "documentos eliminados con éxito",
    bulkDeleteValidDocumentsHeader: "Se eliminarán los siguientes documentos",
    bulkDeleteInvalidDocumentsHeader: "Los documentos enumerados a continuación no se pueden eliminar",

    /* Bulk sign-off requirements modal */
    bulkSignOffRequirementsModalMessage: "Ajuste los requisitos de aprobación ejecutiva de los documentos seleccionados a continuación. Algunos requisitos de aprobación no se pueden ajustar porque son requeridos por EY Canvas.",
    bulkSignOffRequirementsResultMessage: "{0} requisitos de aprobación de documentos actualizados con éxito",


    bulkOpenCountWarning: "El número de documentos seleccionados supera el máximo permitido. Solo se abrirá el primero {0}",

    /* Pending evidence modal */
    pendingEvidenceInstructionalText: "Los equipos que se enumeran a continuación aún no han enviado ningún documento grupal.",
    pendingEvidenceDueDate: "Fecha de vencimiento",
    searchRegionComponentLabel: "buscar región o componente.",

    /* Review Notes Count */
    noReviewNotesAssignedOrAuthored: "No hay notas para el miembro del equipo seleccionado.",
    noUserSelected: "Seleccione un usuario para ver detalles. No puede asignar notas a roles en EY Canvas.",
    reviewNotesText: "notas de revision",
    assigned: "Asignado",
    authored: "Autor",
    overdue: "atrasado",
    comingDue: "Próximamente",
    cleared: "Esclarecido",
    open: "Abrir",
    closed: "Cerrado",
    noTaskAssignedToUser: "No hay tareas asignadas al miembro del equipo o rol seleccionado.",
    preparer: "Preparador",
    reviewer: "Revisor",
    assignments: "Asignaciones",
    notStarted: "No iniciado",
    inProgress: "En curso",
    done: "Hecho",
    forUpcomingReview: "Próximos",
    noTaskOrNotesAssigned: "No hay tareas ni notas para el miembro o rol del equipo seleccionado.",
    fromTo: "Desde / Hasta",

    /* Collaboration grid */
    overdueCollaboration: "Atrasado",
    comingDueCollaboration: "Próximamente",

    /*Document Conflict*/
    documentConflict: "Conflicto de documentos",
    documentConflictModalConfirm: "Conservar esta versión",
    documentConflictModalClose: "Cancelar",
    documentConflictInstruction: "Para resolver el conflicto, seleccione la versión del documento que se debe conservar.",
    documentConflictMessage: "Haga clic en el nombre de un miembro del equipo para abrir una versión anterior de este documento en modo de solo lectura. Los cambios realizados en esta versión anterior no se guardarán en EY Canvas.",
    lastmodifiedDate: "Fecha de última modificación",
    modifiedBy: "Modificado por",
    documentConflictErrorMessage: "Seleccione una versión para proceder.",
    currentVersion: "Versión actual",
    documentConflictError: "Mensaje de error de conflicto de documentos",
    documentConflictHeader: "Este documento tiene un conflicto.",
    viewHistory: "Ver historial",
    confirmButtonToolTip: "Debe tener permiso para resolver conflictos para documentos de grupo. Póngase en contacto con un administrador del compromiso y solicite permiso para realizar esta acción.",
    documentHistoryHeader: "Este documento 's historial de versiones se muestra a continuación.",
    documentHistoryMessage: "Haga clic en el nombre de un miembro(s) del equipo para abrir una versión anterior de este documento en modo de solo lectura. Los cambios realizados en esta versión anterior no se guardarán en EY Canvas.",

	documentHistoryInstruction: 'Si una versión anterior debe ser la versión actual, seleccione esa versión y haga clic en "Actualizar versión"',
	documentHistoryAdminInstruction: 'Si no se requiere una versión, seleccione la versión y haga clic en "Eliminar versión".',

    documentHistoryModalConfirm: "Versión actualizada",
    documentHistoryModalClose: "Cerrar",
    documentHistoryErrorMessage: "El documento tiene un conflicto, por favor resuelva antes de proceder.",

    /* Dashboard  - Collaboration Tile*/
    clientCollboration: "Colaboración con el cliente",
    nextwaveServices: "Servicios centralizados",
    receivedStatusLabel: "Recibido",
    acceptedStatusLabel: "Aceptado",
    outstandingStatusLabel: "Excepcional",
    collaborationNonUsageMessage1: "Use Collaboration para enviar solicitudes y tareas externas a miembros externos del equipo directamente en EY Canvas. Para activar la colaboración, primero inscriba a su cliente en EY Canvas Client Portal. A continuación, configure grupos de acceso. Luego, cree solicitudes y / o asigne tareas externas. Haga clic en",
    collaborationNonUsageMessage2: "para saber cómo empezar",
    collaborationNonUsageMessageHyperlinkText: "aquí",
    collaborationNonSentMessage1: "Navegar a",
    collaborationNonSentMessage2: "y enviar borradores para comenzar",
    collaborationNonSentMessageHyperlinkText: "Colaboración",
    noBodies: "Sin cuerpos",
    editResponse: "Editar respuesta",
    unsentDrafts: "Borradores no enviados",
    unsentDraft: "Borrador no enviado",
    noUnsentDrafts: "No se tienen borradores no enviados",
    requestsSent: "Solicitudes enviadas",
    nextWavetotalTasks: "TOTAL DE TAREAS",
    comingDueTimeframe: "Periodo de tiempo",
    otherTimeframeDataAvailableMessage: "Seleccione otro período de tiempo para ver los datos",

    /* Dashboard Engagement Metrics */
    engagementMetricsTileHeader: "Métricas del compromiso",
    overdueColumnHeader: "Atrasado",
    comingDueColumnHeader: "Próximamente",
    whatsNewColumnHeader: "Qué hay de nuevo",
    placeholderMessageNoContentInSpecifiedTimeframe: "Seleccione otro período de tiempo para ver los datos",
    placeholderMessageNoEngagementMetrics: "No hay métricas disponibles para su compromiso.",
    performanceMetrics: "Métricas de rendimiento",
    reviewNotesAndAssignments: "Revisar notas y tareas",
    /*Dashboard Engagement overview*/
    engagementOverview: "Visión general del compromiso",
    engagementOverviewInstructionalText: "Revise el progreso de sus compromisos por fase de auditoría a continuación.",

    /*Dashboard Milestone tile*/
    milestoneprogressTileHeader: "Hitos",
    milestoneprogressSubHeader: "Seleccione una fase de auditoría a continuación para ver la finalización de la tarea por hito. Para ver la finalización de la tarea por fase de tiempo, seleccione <b>Ver por fase de tiempo</b>. Para ver el progreso detallado de cada hito o fase de tiempo, seleccione <b>Mostrar detalles.</b>",
    tasksStatus: "Estado de las tareas",
    preparerAssignments: "Asignaciones de preparadores",
    reviewerAssignments: "Asignaciones de revisores",
    openComments: "Abrir notas",
    /* Dashboard Profile Page */
    groupAudit: "Auditoría de grupo",
    groupStatus: "Estado del grupo",
    viewInstructions: "Ver instrucciones",
    instructionsInstructionalText: "Las instrucciones recibidas del equipo primario se muestran a continuación. Seleccione un link para ver las instrucciones.",
    noInstructionsAccepted: "Todavía no se han aceptado instrucciones.",

    /* Dashboard SDM Summary */
    nextWaveservices: "Servicios centralizados",
    totalTasksLabel: "Total de tareas",
    tasksUsingNextWaveservices: " tareas usando servicios centralizados",
    tasksSuggestedForNextwaveUse: " tareas sugeridas para Servicios centralizados",
    outOf: "Fuera de",
    tasksUsing: "tareas utilizando",
    suggestedFor: "sugerida para",
    nextwaveUse: "Servicios centralizados",
    draftRequests: "proyecto de solicitudes",
    draftRequest: "proyecto de solicitud",
    createRequests: "Crear solicitudes",
    noRequestCreated: "Todavía no se han creado solicitudes. Cree y envíe una solicitud para empezar.",

    /* RNH Bulk Controls */
    rnhBulkAssignPriorityTitle: "cambiar prioridad",
    rnhBulkAssignPriorityTooltip: "prioritario",
    rnhBulkDueDateTooltip: "fecha limite",
    rnhBulkAssignPriorityModalHeader: "No se pueden editar las notas seleccionadas",
    rnhBulkAssignPriorityModalContent: "Solo puede cambiar la prioridad de las notas con el estatus Abrir. Vuelva a abrir las notas con el estatus Borrado o Cerrado para cambiar la prioridad.",
    rnhBulkAssignDueDateModalContent: "Solo puede cambiar la fecha de vencimiento de las notas con el estatus Abrir. Vuelva a abrir las notas con el estatus Borrado o Cerrado para cambiar la fecha de vencimiento.",
    rnhBulkAssignUserTooltip: "Reasignar",
    rnhBulkAssignUserSearch: "buscar",
    rnhBulkAssignUserTitle: "No se pueden editar las notas de revisión seleccionadas",
    rnhBulkAssignUserText: "Solo puede reasignar notas de revisión con el estatus Abrir. Vuelva a abrir las notas de revisión con el estatus Borrado o Cerrado para reasignarlas.",
    rnhBulkAssignStatusTooltip: "Estatus",
    rnhBulkAssignUserNoFound: "No se tiene resultados",
    rnhBulkDueDatePlaceholder: "Seleccione una fecha",
    rnhBulkDeleteTextCorrect: "¿Está seguro de que desea eliminar las notas seleccionadas? Una vez que se elimina una nota de revisión, ya no podrá acceder a ella.",
    rnhBulkDeleteTextIncorrect: "Solo puede eliminar notas con el estatus Cerrado. Cierre las notas con el estado Abierto o Borrado para eliminarlas.",
    rhnBulkDeleteTitleCorrect: "Eliminar notas seleccionadas",
    rhnBulkDeleteTitleIncorrect: "No se pueden eliminar las notas seleccionadas",
    rnhBulkDeleteTextIncorrectComment: "Solo puede eliminar notas de revisión con el estado Cerrado. Cierre las notas de revisión con el estado Abierto o Borrado para eliminarlas.",
    rhnBulkDeleteDescriptionAuthorComment: "Solo puede eliminar las notas que haya creado.",
    rnhBulkDeleteEngagementComment: "¿Está seguro de que desea eliminar las notas de revisión seleccionadas? Una vez que se elimina una nota de revisión, ya no podrá acceder a ella.",
    rhnBulkDeleteTitleCorrectEngagementComment: "Eliminar notas seleccionadas",
    rhnBulkDeleteTitleCommentCloseStatus: "No se pueden eliminar las notas seleccionadas",


    fourFortyFilters: "Filtros",
    fourFortySearch: "Busqueda",

    /* Add External Member Start*/
    addExternalModalTitle: "Agregue miembros externos",
    accessGroupSelection: "Selección de grupos de accesos",
    noRecordinGroups: "No se tienen resultados",
    permission: "Permisos",
    permissionProjectManagement: "Administracion de proyectos",
    permissionProjectManagementDesc: "Posibilidad de ver el estado de las solicitudes de cliente y las tareas externas en EY Canvas Client Portal. Este miembro externo no podrá acceder a los detalles de las solicitudes de cliente y las tareas externas.",
    permissionInfoTooltip: "Lista de todos los permisos",
    groupInfoTooltip: "Lista de grupos",
    groupRequired: "De favor, seleccióne grupos",
    firstnameRequired: "Nombre requerido",
    lastnameRequired: "Apellido requerido",
    initialsRequired: "Iniciales requeridas",
    roleRequired: "Rol del compromiso requerido",
    confidentialityRequired: "Nivel de confidencialidad requerido",
    groupLabel: "Grupos de acceso",
    firstnameLabel: "Nombre",
    lastnameLabel: "apellido",
    initialsLabel: "Iniciales",
    userinfo: "Informacion del usuario",
    userinfoDescription: "Ingrese el nomre, apellido o email de los miembros del equipo que quiere invitar y presione enter",
    inviteAndClose: "Invitar & cerrar",
    inviteAndAddOther: "Invitar & agregue otros",
    addAndClose: "Invitar y cerrar",
    addAndAddOther: "Invitar y agregar otro",
    externalUserCreatedSuccessMessage: "Ha añadido con éxito",
    accessGroupSelectionMessage: "Los accesos de grupo permiten a los equipos administrar quién en el equipo externo puede ver las solicitudes que se envían al portal del cliente EY Canvas. Acuerde con su cliente en la lista de accesos de grupo y usuarios que tendrán acceso al portal del cliente EY Canvas. Cuando se asigna una solicitud a un usuario externo que forma parte del grupo, será visible para cada miembro de ese grupo.",
    accessGroupSectionMessage1: "Los miembros del equipo externo deben estar registrados utilizando el portal de My Admin EY antes de agregarlos a EY Canvas. Hacer clic",
    accessGroupSectionMessage2: "Para acceder al portal de admin de EY y comenzar.",
    accessGroupMessageHyperlinkText: "aquí",
    accessGroupUserMessage1: "Para obtener más información sobre los usuarios de incorporación, haga clic en",
    accessGroupUserMessage2: "Para acceder a EY Atlas.",
    noRecordForExternalMember1: "No se pudo encontrar la dirección de correo electrónico.",
    noRecordForExternalMember2: "Asegúrese de que el miembro del equipo externo esté registrado en My EY.",

    /* Add External Member End*/

    /* Edit External Member Start*/

    editExternalModalTitle: "Editar miembro externo",
    editExternalaccessGroupSelection: "Selección de grupo de acceso",
    editExternalGroupInfoTooltip: "Lista de grupos",
    editExternalGroupLabel: "Grupos de acceso",
    editExternalGroupRequired: "Seleccione grupo(s)",
    editExternalNoRecordinGroups: "No se han encontrado resultados",
    editExternalUserinfo: "Información del usuario",
    editExternalUserinfoDescription: "Edite el nombre, apellido o iniciales.",
    editExternalEmailLabel: "Correo electrónico",
    editExternalFirstnameLabel: "Nombre",
    editExternalLastnameLabel: "Apellido",
    editExternalInitialsLabel: "Iniciales",
    editExternalSaveLabel: "Guardar",
    editExternalUsersSuccessMessage: "Los cambios en {0} {1} se han guardado correctamente.",
    editExternalUsersCloseLabel: "Cerrar",

    /* Edit External Member End*/



    /*access group*/
    groupName: "Nombre del grupo",
    groupNameHelp: "Es requerido un nombre para crear a un grupo de acceso.",
    groupNameHelpOnEdit: "Se requiere nombre",
    groupNameReq: "Nombre del grupo requerido",
    groupNameInvalidCharacter: "Caracteres inválidos",
    grpDomainManage: "Administrar dominios",
    grpDomainHelp: "Los dominios restringen a los usuarios que se pueden agregar a este grupo de acceso. Se requiere al menos un dominio para crear un grupo de acceso. El dominio hace referencia a los caracteres después del símbolo . Utilice * para comodín (por ejemplo, *.ey.com).",
    btnAddNewDomain: "Añadir nuevo dominio",
    btnAddExistingDomain: "Añadir dominio existente",
    domainValidation01: "Se requiere al menos un dominio válido",
    domainValidation02: "Elija un dominio",
    domainValidation03: "Entrada duplicada",
    domainValidation04: "Nombre de dominio no válido",
    domainValidation05: "Nombre de dominio requerido",
    domainName: "Nombre de dominio",
    emailDomain: "Dominio de correo electrónico",
    groupDeletionErrorPendingReqMsg: "Se ha producido un error al eliminar el grupo de acceso. Asegúrese de que no haya solicitudes/tareas externas asignadas a este grupo o a los miembros de este grupo e inténtelo de nuevo",
    groupDeletionSuccessMsg: "{0} se ha eliminado correctamente. Todos los miembros activos han sido desactivados.",

    /* uncommon values for internal mem */
    editInternalMember: "Editar miembro interno",
    editThirdPartyMember: "Editar miembro de terceros",
    listOfAllPerm: "Lista de todos los permisos",
    internalPermiInviteExt: "Invite miembros internos",
    internalPermiInviteInt: "Invite miembros externos",
    internalPermiAssignPer: "Asignar permisos",
    internalPermiDeleteEng: "Borrar compromiso",
    internalPermiArchEng: "Archivar compromiso",
    internalPermiUpdateContet: "Actualizar contenido",

    internalPermiInviteExtToolTp: "Habilidad para invitar miembros del equipo interno para el compromiso",
    internalPermiInviteIntToolTp: "Habilidad para invitar miembros externos para el compromiso",
    internalPermiAssignPerToolTp: "Habilidad para asignar los permisos para los miembros internos y externos en el compromiso",
    internalPermiDeleteEngToolTp: "Habilidad para borrar el compromiso",
    internalPermiArchEngToolTp: "Habilidad para archivar el compromiso",
    internalPermiUpdateContetToolTp: "Posibilidad de editar el perfil y aceptar una actualización de contenido",
    internalMemberInviteSuccessMessage: "Ha enviado correctamente una invitación a {0} {1}",
    internalMemberPostArchivalAdditionSuccessMessage: "Ha añadido con éxito {0} {1}",
    invitePriorPeriodUsersSuccessMessage: "Ha enviado con éxito una invitación a usuarios inactivos",
    editInternalUsersSuccessMessage: "Los cambios en {0} {1} se han guardado correctamente",
    rbacErrorEditUser: "No se pueden guardar los cambios en este momento. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    universalQueueErrorEditUser: "La página principal de EY Canvas no es accesible en este momento y es necesario para editar. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia",
    removeExternalUsersSuccessMessage: "{0} {1} se ha eliminado correctamente.",
    reActivateExternalUsersSuccessMessage: "{0} {1} se ha reactivado en los siguientes grupos de acceso: {2}",

    /*user search component*/
    seachInputRequired: "Buscar datos requeridos",
    nameOrEmail: "Nombre o email",
    emailForExternal: "Correo electrónico",
    noRecord: "No se tienen resultados",
    userSearchPlaceholder: "Ingrese el nombre o email y presione enter para ver los resultados",
    userSearchPlaceholderForExternal: "Introduzca el correo electrónico y pulse Intro para ver los resultados.",
    clearAllValues: "Limpie todos los valores",
    inValidEmail: "Por favor, introduzca un correo electrónico válido",

    maxLengthForEditResponse: "limite maximo de caracteres, incluyendo formato de texto es 30,000. elimine los formatos innecesarios e intente de nuevo",
    clickEditResponseToContinue: "Click en editar respuesta para continuar",
    bodyDescriptionFromKnowledge: "Cuerpo de descripcion desde el conocimiento",
    execution: "Ejecucion",
    cannotpasteimages: "No se pueden pegar imágenes",
    pastingImagesNotAllowed: "Pegar imágenes no esta permitido. Si las imágenes son requeridas subalas como evidencia y refierase a ellos",
    saveResponse: "Se tienen cambios sin salvar, desea continuar?",
    conclusion: "conclusion",
    referenceDocsPlaceHolder: "Abra rápidamente los archivos a los que se accede con frecuencia agregándolos aquí.",
    referenceDocsTeamPlaceHolder: "No se han agregado documentos de referencia del equipo en este compromiso. Haga clic en 'Agregar documento' para comenzar.",
    referenceDocsMyPlaceHolder: "No ha añadido ningún documento de referencia. Haga clic en 'Agregar documento' para empezar.",
    teamDocuments: "Equipo fijado",
    myDocuments: "Mis fijados",
    teamDocumentsModalTitle: "Documentos del equipo",
    myDocumentsModalTitle: "Mis documentos",
    referenceDocuments: "Equipo fijado",

    /* PinnedDocument  */
    PinnedDocument: "Documentos anclados",
    PinnedDocumentSubTite: "Cree una lista de documentos a los que se accede con frecuencia anclando elementos a su propia lista o a la lista de equipos a continuación. Para modificar la lista, seleccione <b>Agregar documento</b>.",
    PinnedDocPaceholder: "No ha anclado ningún documento. <br>Seleccione <b>Agregar documento</b> para anclar documentos aquí.",
    PinnedTeamDocPlaceholder: "Su equipo no ha anclado ningún documento. <br>Seleccione <b>Agregar documento</b> para anclar documentos aquí.",
    PinnedDocAddDocHeaderText: "Seleccione evidencia y archivos temporales para personalizar la lista de documentos anclados.",
    onlyShowPinnedDocuments: "Mostrar solo documentos anclados",
    pinned: "Fijado",
    /* Arc Timeline */
    arcTitle: "Checklist de archivado",
    arcCompleted: "Completado",
    arcSubmit: "Archivo enviado",
    arcDescription: "Complete todos los elementos de la lista de comprobación para archivar esta compromiso",
    invalidEngagementCode: "Código de compromiso no válido",
    invalidClientCode: "Código de cliente no válido",
    arcCheckBox: "Anulación del archivo",
    arcUnlinkEvidenceButtonText: "Desvincular todo",
    arcUnlinkEvidenceModalTitle: "Desvincular toda la evidencia compartida",
    arcUnlinkEvidenceModalText: "¿Está seguro de que desea desvincular toda la evidencia compartida en este compromiso de otras compromisos en este espacio de trabajo? Una vez completada esta operación, no se puede deshacer.",
    arcUnlinkEvidenceModalConfirmButton: "Desvincular todo",
    arcUnlinkEvidenceModalCancelButton: "Cancelar",
    arcUnlinkEvidenceButtonUnlinkInProgress: "Desvincular en curso",
    arcUnlinkEvidenceButtonUnlinkError: "Error de desvinculación",
    arcUnlinkGroupEngagementButtonText: "Desvincular del grupo",
    arcUnlinkGroupEngagementModalTitle: "Desvincula este compromiso del grupo",
    arcUnlinkGroupEngagementModalText: "¿Está seguro de que desea desvincular esta compromiso de otros compromisos en este espacio de trabajo? Una vez completada esta operación, no se puede deshacer.",
    arcUnlinkGroupEngagementModalConfirmButton: "Desvincular",
    arcUnlinkGroupEngagementModalCancelButton: "Cancelar",
    arcUnlinkGroupEngagementButtonUnlinkInProcess: "Desvincular en curso",
    arcModalTitle: "Registro ARC existente",
    arcProceedWithArchive: "Continúe con el archivo",
    arcModalBodyText: "Está intentando archivar un archivo de compromiso restaurado. Este archivo ya existe en el Centro de registros de archivado (ARC). ¿Está seguro de que desea continuar?",
    noDataAvailabel: "No hay datos disponibles en este momento. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    reportDateBeforeCurrentDate: "La fecha del informe de compromiso debe ser en o antes de la fecha actual. Actualice la fecha del informe para continuar. Para actualizar la fecha del informe, haga clic en el enlace Confirmar la exactitud de las fechas clave de contratación.",

    /*Helix Projects*/
    linkedProjects: "Proyectos vinculados",
    suggestedAnalyzers: "Analizadores sugeridos",
    linkSelected: "Enlace seleccionado",
    noLinkedProjectsAvailable: "No hay proyectos vinculados",
    helixProjectTitle: "Proyectos EY Helix",
    findProjects: "Buscar proyectos",
    findProjectsModalTitle: "Encuentra proyectos de EY Helix",
    selectProjectsToLink: "Selecciona uno o más proyectos EY Helix a continuación para crear un enlace con tu compromiso Canvas. Puedes buscar manualmente por código de cliente para encontrar otros proyectos de EY Helix.",
    newSearch: "Nueva búsqueda",
    noResultsFound: "No se han encontrado resultados",
    enterClientCode: "Introduzca un código de cliente para buscar de nuevo.",
    enterClientCodeToDisplayAnalizers: "Introduzca un código de cliente para mostrar una lista de analizadores disponibles.",
    defaultClientCodeIsInvalid: "El código de cliente predeterminado {0} para este compromiso no es válido. Introduzca un código de cliente válido para mostrar una lista de analizadores disponibles.",
    mirrorCodesNotAccepted: "Tenga en cuenta que no se aceptan códigos espejo",
    helixProjectSearch: "Búsqueda",
    helixProjectsSearchPlaceholderText: "Introduzca el código de cliente para buscar",
    helixWizardProjectsSearchPlaceholderText: "Busque el analizador por código de cliente",
    selectOneOrMoreProjects: "Seleccione uno o más proyectos de Helix de la lista para vincular",
    noPermissionLabel: "Debe tener permisos de archivo para enviar esta compromiso para archivarlo",
    linkProject: "Proyecto de enlace",
    oneAnalyzerMustBeSelected: "Se debe seleccionar un analizador.",
    selectAnAnalyzer: "Seleccione un analizador",
    selectOneAnalyzer: "Seleccione un analizador EY Helix a continuación para crear un enlace con su compromiso de EY Canvas. Puede buscar manualmente por código de cliente para encontrar proyectos de EY Helix y los analizadores relacionados.",
    selectAnalyzerModalTitle: "Seleccione Analizador para",
    selectAnalyzerModalBodyText: "Seleccione un analizador EY Helix para vincularlo con su compromiso en EY Canvas",
    selectAnalyzerModalSubmitButtonLabel: "Proyecto de enlace",
    projectCanNotBeLikedTootip: "Este proyecto EY Helix no está disponible porque su ubicación no coincide con la ubicación del EY Canvas Engagement.",
    unlinkProjectConfirmationModalTitle: "Advertencia: desvincular proyecto",
    unlinkProjectConfirmationModalBodyText: "El analizador EY Helix que se está desvinculando tiene marcadores de cliente asociados a este compromiso. Al desvincular este analizador, esos marcadores ya no estarán disponibles. Esta acción no se puede deshacer. ¿Quieres continuar?",
    defineConnectionSettings: "Definir la configuración de conexión",

    helixConnectionPageTitle: "Conexiones EY Helix",
    helixConnectionPageSubtitle: "Analizadores EY Helix conectados, sus datos importados y el porcentaje de cuentas de GL que se han asignado a cuentas de EY. Haga clic en el porcentaje mapeado para ajustar el mapeo. El porcentaje asignado puede ser diferente entre la conexión y los datos importados. Por ejemplo, si la asignación se produjo después de la fecha de importación. Vuelva a importar los datos para obtener la asignación más reciente.",
    helixIntegrationPageNoConnectedAnalyzerLabel: "No hay analizadores conectados",
    helixIntegrationPageTitle: "Integración con EY Helix",
    helixIntegrationPageSubtitle: "Relacione uno o más analizadores EY Helix con su compromiso de EY Canvas.",
    helixIntegrationPageNoHelixProjectLinkedLabel1: "No hay analizadores relacionados. Para relacionar un nuevo analizador,",
    helixIntegrationPageNoHelixProjectLinkedLabel2: " Haga clic aquí.",
    helixIntegrationPageColumnConnectionName: "Nombre de la conexión",
    helixIntegrationPageColumnConnectionType: "Tipo de conexión",
    helixIntegrationPageColumnAnalysisPeriod: "Fecha de análisis",
    helixIntegrationPageColumnAnalyzerName: "Nombre del analizador EY Helix",
    helixIntegrationPageColumnLastConnectedBy: "Último conectado por",
    connectAnalyzer: "Conectar analizador",
    dataImportModalTitle: "Confirmación de Importación",
	dataImportModalBodyLabel: 'Ya existe una importación de "Alcance y estrategia" en este compromiso. Solo se permite una única importación de "Alcance y estrategia" por compromiso. La importación de estos datos reemplazará la importación existente de "Alcance y estrategia". ¿Quieres continuar? Esta acción no se puede deshacer.',
    dataImportModalBodyLabelMest: "Ya existe una importación de 'Alcance y estrategia' para esta entidad. Solo se permite una única importación de 'Alcance y estrategia' por entidad. La importación de estos datos reemplazará la importación existente de 'Alcance y estrategia'. ¿Quieres continuar? Esta acción no se puede deshacer.",
    dataImportModalCancelButtonLabel: "Cancelar",
    dataImportModalCloseButtonLabel: "Cerrar",
    dataImportModalConfirmButtonLabel: "Importar",
    dataImportModalImportError: "Se ha producido un error relacionado con el analizador EY Helix conectado. Los datos no se pueden importar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",

    //Entites to Business Mapping Modal
    entityMappingModalTitle: 'Entity mapping',
    entityMappingModalCancelLabel: 'Cancel',
    entityMappingModalSaveLabel: 'Save',
    entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
    entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
    entityMappingModalAllBusinessUnitsLabel: 'All business units',
    entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
    entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
    entityMappingModalNoResultsFound: 'No results found',
    entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
    entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
    entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
    /*Entites to Business Table*/
    entityMappingTableEntityColumnLabel: 'Entity',
    entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

    helixProjectPageTitle: "Proyectos EY Helix",
    helixProjectPageSubtitle: "Vincule los proyectos de EY Helix relevantes para este compromiso de EY Canvas. Cuando haya más de un proyecto de EY Helix vinculado, seleccione uno como proyecto principal para permitir la integración de datos en EY Canvas. Solo el proyecto principal se puede integrar en EY Canvas, por lo que debe contener toda la actividad de entrada de diario para la fecha que sea relevante para el compromiso.",
    helixProjectPageNoHelixProjectLinkedLabel1: "Actualmente no hay proyectos de EY Helix vinculados al compromiso.",
    helixProjectPageNoHelixProjectLinkedLabel2: "Añadir nuevo proyecto EY Helix",
    helixProjectPageNoHelixProjectLinkedLabel3: " para empezar.",
    helixProjectPageNoHelixProjectLinkedLabel4: "Clic",
    linkToHelixProject: "Abrir en EY Helix",
    addNewEYHelixProject: "Añadir nuevo proyecto EY Helix",
    eyHelixSetup: "Integre los datos de EY Helix",
    existingConnectionDetectedModalTitle: "Conexión(es) existente(s) detectada(s)",
    existingConnectionDetectedDescription: "El analizador seleccionado se ha conectado previamente a este compromiso de EY Canvas. Puede crear una nueva conexión o seleccionar una conexión existente a continuación.",
    selectExistingConnection: "Seleccionar una conexión existente",
    selectCreateNewConnection: "Crear una nueva conexión",
    connectionNoRecords: "No se han encontrado conexiones",
    selectOneOfTheOptionsToProceed: "Seleccione una de las opciones para continuar.",
    saveHelixProjectErrorMessage: "No se pudo guardar el analizador seleccionado. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    noResultFoundForAnalyzerSelection: "Asegúrese de que el analizador que está buscando esté en un estado válido y de que se le haya concedido acceso al analizador. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Introduzca un código de cliente para volver a buscar.",

    /*Helix Analyzer Details Drawer*/
    connectButtonLabel: "Conectar",
    reConnectButtonLabel: "Volver a conectar",
    demoteFromFinancialStatementsOptionLabel: "Retirar de los estados financieros",
    promoteToFinancialStatementsOptionLabel: "Promover a los estados financieros",
    deleteOptionLabel: "Eliminar",
    projectAndAnalyzerDetailsSectionTitle: "Detalles del proyecto y del analizador",
    projectNameLabel: "Nombre del proyecto",
    clientCodeLabel: "Código de cliente",
    analyzerNameLabel: "Nombre del analizador",
    periodEndDateLabel: "Fecha Fecha de finalización",
    analysisDateLabel: "Fecha de análisis",
    lastConnectedByLabel: "Conectado por última vez por",
    connectionSettingsSectionTitle: "Configuración de la conexión",
    connectionTypesLabel: "Tipo(s) de conexión(es)",
    currencyTypeLabel: "Tipo de moneda",
    currencyLabel: "Moneda",
    currencyCodeLabel: "Código de moneda",
    businessUnitsLabel: "Unidad(es) de negocio",
    entitiesLabel: "Entidades",
    analysisPeriodLabel: "Fecha de análisis",
    comparativePeriod1Label: "Fecha comparativa 1",
    comparativePeriod2Label: "Fecha comparativa 2",
    manageAccountMappingSectionTitle: "Administrar el mapeo de cuentas",
    manageAccountMappingButtonLabel: "Administrar el mapeo de cuentas",
    mappedGLAccountsLabel: "% de cuentas de GL asignadas:",
    updateSettingsButtonLabel: "Actualizar la configuración",
    deleteConnection: "Eliminar conexión",
    deleteConnectionQuestion: "¿Está seguro de que desea eliminar la conexión seleccionada? Se eliminarán todos los datos integrados anteriormente relacionados con esta conexión. Esta acción no se puede deshacer.",
    deleteConnectionWithAnalyticsQuestion: "¿Está seguro de que desea eliminar la conexión seleccionada? Se eliminarán todos los datos integrados anteriormente relacionados con esta conexión. Además, la conexión seleccionada tiene marcadores de cliente asociados a este compromiso. Si eliminas la conexión, esos marcadores dejarán de estar disponibles. Esta acción no se puede deshacer.",

    /*Helix Projects Table*/
    tableShowing: "Mostrando resultados para:",
    tableClientCode: " - Código de cliente:",
    tableEngagementCode: "Código de interacción",
    tableEngagementCodeName: "Nombre de compromiso",
    tableProjectID: "ID del proyecto",
    tableProjectName: "Nombre del proyecto",
    tableAnalyzerName: "Nombre del analizador",
    tablePeriodEndDate: 'Period end date',
    tableEYHelixPeriodEndDate: "Fecha final",
    tableAnalysisDate: "Fecha de análisis",
    tableEYHelixAnalysisDate: "Fecha de análisis",
    tableAssignedPartner: "Socio asignado",
    tableProjectLinked: "Proyecto vinculado",
    tableTooltipAnalizerIsDeleted: "El analizador se ha eliminado dentro de EY Helix. Para eliminar permanentemente la conexión, haga clic para abrir el panel de detalles. Considere si debe conectarse otro analizador.",
    tableTooltipAnalizerIsUnavailable: "El analizador no está disponible dentro de EY Helix. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, haga clic para abrir el panel de detalles. Considere si debe conectarse otro analizador..",
    tableTooltipNotValidUser: "No es un miembro autorizado del equipo del analizador seleccionado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso e intentarlo de nuevo.",

    /*Helix Project Cards*/
    cardAnalyzerConnectionLabel: "Conexiones",
    cardAnalyzerHelixLabel: "Analizadores EY Helix",
    cardAnalyzerMappedGLAccountsLabel: "Cuentas de GL asignadas",
    cardAnalyzerEntityMappingLabel: 'Entity mapping',
    cardAnalyzerManageGLAccountsLink: "Administrar la asignación de cuentas",
    cardAnalyzerSectionScopeAndStrategy: "Alcance y estrategia",
    cardAnalyzerSectionFinancialStatements: "Estados financieros",
    cardAnalyzerSectionButtonLink: "aquí",
    cardAnalyzerSectionButtonDisconnect: "Analizador de desconexión",
    cardAnalyzerSectionScopeAndStrategyNoBalance: "Los datos de alcance y estrategia se utilizan para presentar saldos en las actividades de alcance y estrategia, como la materialidad. Haga clic en {0} para importar los datos de alcance y estrategia.",
    cardAnalyzerSectionFinancialStatementsNoBalance: "Los estados financieros se pueden importar a EY Canvas para proporcionar un desglose de los estados financieros hasta donde se ha realizado el trabajo en el compromiso de EY Canvas. Haga clic en {0} para importar los estados financieros.",
    cardAnalyzerSectionAnotherAnalyzerType: "Este analizador se ha conectado para facilitar la integración entre EY Canvas, EY Helix y/o EY Smart Sampling. Haga clic {0} para desconectar este analizador.",
    cardAnalyzerSectionButtonLinkDisableTooltip: "No es un miembro autorizado del equipo del analizador vinculado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso.",
    cardAnalyzerSectionButtonLinkDisableTooltipPermission: "No tiene los permisos necesarios para importar estos datos. Asegúrese de tener el permiso 'Importar datos de EY Helix' dentro de este compromiso de Canvas e inténtelo de nuevo.",
    cardAnalyzerTrialBalanceAnalisysPeriod: "Fecha de análisis",
    cardAnalyzerTrialBalanceComparativePeriod: "Fecha comparativa",
    cardAnalyzerTrialBalanceSecondComparativePeriod: "Segunda fecha comparativa",
    cardAnalyzerTrialBalanceLastImportDate: "Fecha de la última importación",
    cardAnalyzerTrialBalanceCurrency: "Moneda",
    cardAnalyzerTrialBalanceBusinessUnits: "Unidad(es) de negocio",
    cardAnalyzerTrialBalanceMapedGLAccounts: "Cuentas de GL asignadas",
    cardAnalyzerTrialBalanceImportStatus: "Estado de la importación",
    cardAnalyzerTrialBalanceCurrencyTypeFunctional: "Funcional",
    cardAnalyzerTrialBalanceCurrencyTypeReporting: "Informes",
    cardAnalyzerTrialBalanceImportData: "Importar datos",
    cardAnalyzerTrialBalanceAdjustmentModule: "Módulo de ajuste",
    cardAnalyzerTrialBalanceReImport: "Volver a importar",
    cardAnalyzerTrialBalanceRemove: "Eliminar",
    cardAnalyzerTrialBalanceImportStatusInProgress: "En curso",
    cardAnalyzerTrialBalanceImportStatusImported: "Importado",
    cardAnalyzerTrialBalanceImportStatusError: "Error",
    cardAnalyzerTrialBalanceImportStatusDisconnected: "Desconectado",
    cardAnalyzerTrialBalanceImportModalTitle: "Importar datos",
    cardAnalyzerTrialBalanceImportModalDescription: "Seleccione los atributos de la importación y haga clic en 'importar' para importar",
    cardAnalyzerTrialBalanceImportModalButton: "Importar",
    cardAnalyzerTrialBalanceReImportModalTitle: "Volver a importar datos",
    cardAnalyzerTrialBalanceReImportModalDescription: "Seleccione los atributos de la importación y haga clic en 'reimportar' para volver a importar.",
    cardAnalyzerTrialBalanceReImportModalButton: "Volver a importar",
    cardAnalyzerTrialBalanceImportInProgressTooltip: "La importación está en curso. Esto puede tardar varios minutos.",
    cardAnalyzerTrialBalanceImportEntityTooltip: "La entidad no se puede cambiar durante una reimportación. Cree una nueva importación para seleccionar una entidad diferente.",
    cardAnalyzerTrialBalanceImportMestEntity: "Esta selección se realizó en el paso anterior. Para editar, debe volver allí.",
    cardAnalyzerTrialBalanceMestBusinessUnit: 'Esta selección se basa en la entidad anterior. Para editar la relación entre la entidad y las unidades de negocio, acceda a la "Asignación de entidades" en la página de resumen subyacente.',
    cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "Primero seleccione un 'Tipo de moneda' para habilitar este campo.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "Primero seleccione una 'Moneda' para habilitar este campo.",

    /*Helis Linked Projects Cards*/
    analysisDate: "Fecha de análisis:",
    unlinkProject: "Desvincular proyecto",
    editAnalyzer: "Editar analizador",
    deleteProject: "Borrar proyecto",
    projectDeleted: "Los proyectos han sido borrados",
    loadingProjectDataLinked: "Carga de datos de EY Helix",
    projectMarkPrimaryConfirmationHeader: "Cambiar el proyecto principal de EY Helix",
    projectMarkPrimaryConfirmationMsg: "¿Estás seguro de que quieres cambiar el proyecto Primario EY Helix?",
    projectPrimaryEYHexliProject: "Proyecto primario EY Helix",
    helixProjectUnlink: "Desvincular",
    helixProjectDelete: "Borrar",
    analyzersLabel: "Analizadores:",


    /*Helix Import List*/
    importHelixList: "Lista de importación de EY Helix",
    importDocumentName: "Nombre del documento",
    importDocumentID: "ID del documento",
    importFileSize: "Tamaño del archivo (en KB)",
    importDownload: "Descargar",
    importNoRecords: "No se han encontrado documentos",
    importInvalidDocumentID: "El ID del documento requiere una coincidencia completa para la búsqueda. Asegúrese de haber incluido el documento completo de identificación",

    /*Helix Connect analyzer modal*/
    connectAnalyzerClientLabel: "Cliente:",
    addConnectionNameLabel: "Agregar nombre de conexión",
    connectionNamePlaceholder: "Nombre de la conexión",
    connectionNameRequired: "Obligatorio",
    connectAnalyzerModalTitle: "Conectar analizador",
    connectAnalyzerDescription: "Seleccione un analizador a continuación para crear un enlace con este compromiso de EY Canvas. Busque por código de cliente para encontrar proyectos de EY Helix y los analizadores relacionados.",
    analyzerLocationIncompatibleErrorMessage: "El analizador no se puede conectar porque sus datos se almacenan en una ubicación incompatible con la ubicación del compromiso de EY Canvas.",
    analyzerMaxConnectionReachedErrorMessage: "Se ha alcanzado el número máximo de conexiones permitidas para el analizador seleccionado. Seleccione otro analizador para continuar.",
    helixAnalyzerErrorMessage: "Hubo un error al conectarse al analizador EY Helix. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    helixAnalyzerGLAConnectionErrorMessage: "Hay uno o más errores al conectarse al analizador EY Helix para obtener el recuento de cuentas asignado. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    helixReImportErrorMessage: "Se ha producido un error al importar datos de EY Helix. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",

    /*Helix Select Entity Modal*/
    selectEntityModalTitle: "Seleccionar entidad",
    noEntitiesMappedToBusiness: "No se ha asignado ninguna entidad a la(s) unidad(es) de negocio.",
    noEntitiesMappedToBusinessFirst: "Clic",
    noEntitiesMappedToBusinessLink: "aquí",
    noEntitiesMappedToBusinessLinkText: " para empezar.",
    searchEntityPlaceholder: "Entidad de búsqueda",
    entityListHeader: "Entidad",
    selectEntityErrorMessage: "Seleccione una entidad para continuar.",
    entityAlreadyConnectedToScopeAndStrategy: "Ya existe una importación de 'Alcance y estrategia' para esta entidad. Solo se permite una única importación de 'Alcance y estrategia' por entidad. Elimine la importación existente para habilitar esta selección.",
    selectEntityNoEntitiesFound: "No se han encontrado resultados",
    selectEntityModalDescription: "Seleccione una entidad para la que desee importar datos.",

    /*Manage Account Mapping*/
    manageAccountMapping: "Administrar la asignación de cuentas",
    manageAccountMappingErrorMessage: "No se pudo conectar a EY Helix. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    helixViewerLoader: "Cargando Helix Viewer...",

    /*Helix Remove Import Modal*/
    removeImportModalTitle: "Eliminar importación",
    removeImportRemoveButtonLabel: "Eliminar",
    removeImportDescription: "¿Está seguro de que desea eliminar la siguiente importación?",
    removeImportActionUndoneDescription1: "¿Está seguro de que desea eliminar la siguiente importación?",
    removeImportActionUndoneDescription2: "Esta acción no se puede deshacer.",
    removeImportErrorMessage: "Los datos importados se han modificado desde que abrió esta pantalla. Para continuar con la eliminación, actualice la página y vuelva a intentarlo.",

    /*Disconnect analyzer modal*/
    disconnectAnalyzerModalTitle: "Analizador de desconexión",
    disconnectAnalyzerDisconnectButtonLabel: "Desconectar",
    disconnectAnalyzerDescription: "¿Está seguro de que desea desconectar el analizador seleccionado?",
    disconnectAnalyzerImportsExistErrorMessage: "Se ha añadido una importación a esta conexión desde que se abrió esta pantalla. Una conexión solo se puede desconectar si primero se eliminan todas las importaciones asociadas. Actualice la página y vuelva a intentarlo.",

    /*Content Update */
    quote: '"',
    performContentUpdate: "Realizar la actualización de contenido",
    contentupdate: "Actualizaciones de contenido",
    btnContentUpdate: "actualizar",
    btnContentUpdateSelected: "Actualización",
    updateSuccessMessage: "Actualización de contenido enviada",
    msgContentUpdate: "Seleccione una o más categorías a continuación para actualizar el contenido. Si ya se han completado cantidades sustanciales de trabajo, hable con los ejecutivos de participación si una actualización de contenido es adecuada. Las actualizaciones de contenido no se pueden deshacer.",
    msgIndependance: "La actualización de la independencia puede dar lugar a que se requieran confirmaciones de independencia para completarse de nuevo.",
    msgProfile: "La actualización del perfil puede tener un impacto significativo en el contenido de interacción. Los usuarios pueden perder el acceso a la interacción hasta que se envíe un nuevo perfil. Esta acción no se puede deshacer.",
    msgHistoryContentUpdate: "Actualizaciones de contenido tomadas anteriormente y el estado de las mismas.",
    msgWarningTitle: "Advertencia",
    btnProceedContentUpdate: "Proceder",
    btnCancelContentUpdate: "Cancelar",
    confirmationMessageP1: "Está a punto de completar una actualización de contenido para las categorías de contenido seleccionadas. Seleccione",
    confirmationMessageP2: "para continuar o seleccionar",
    confirmationMessageP3: "si no desea completar la actualización de contenido en este momento.",
    warningMessage: "Se deben seleccionar uno o más tipos de contenido para la actualización",
    groupReportingFormsSent: "informes de grupo <b>formularios enviados</b>",
    groupReportingFromStatus: "Estatus del formulario de reportes de grupo",
    primaryTeamReviewStatus: "Estatus de revisión del equipo principal",
    reportingStatus: "Estado de los informes",
    taskStatusLabel: "Estado de la tarea",
    primaryTeam: "Equipo principal",
    componentTeam: "Equipo del componente",
    groupTasksReceived: "auditoría de grupo <b>tastas recibidas</b>",
    group: "Grupo",
    regionalTeam: "Equipo regional",
    unlinkedLabel: "Desvinculado",
    linkedLabel: "Linkeado",
    unlinkedTasks: "<b>táreas no vinculadas</b>",
    unlinkedTask: "<b>tarea no vinculada</b>",
    primaryTeamGroupTaskPlaceholder: "Cree componentes y envíe instrucciones de grupo para supervisar el progreso aquí.",
    componentTeamGroupTaskPlaceholder: "Acepte las tareas del grupo de componentes del equipo principal para ver un resumen del progreso aquí.",
    confirmUpdateMessage1: "La actualización de estos formularios puede tener un impacto significativo en el contenido. Una vez iniciado, no se puede realizar ninguna actualización de contenido adicional hasta que se completen.",
    confirmUpdateMessage2: "Seleccione 'Continuar' para continuar o seleccione 'Cancelar' si no desea completar la actualización de contenido en este momento.",
    updateSelectedTitle: "Actualización seleccionada",
    statusCodeForbidden: 403,
    pspAccountHeader: "Cuenta",
    pspAccountDateHeader: "Fecha del contenido",
    pspAccountStatus: "Estado",
    pspAccountSelected: "seleccionado",

    /*Preapre for Arc*/
    YearEndDate: "Fecha de fin de año:",
    PeriodEndDate: "Fecha de finalización del período cubierto:",
    ReportDate: "Fecha del informe:",
    ArcDeadlineDate: "Fecha límite del archivo:",
    ClientCode: "Código de cliente:",
    PrimaryEngCode: "Código del compromiso principal:",
    SecondaryEngCode: "Código del compromiso segundario:",
    ReportType: "¿Está calificado el(los) informe(s) de alguna manera y/o tiene un párrafo de énfasis?:",
    ProtectedDocuments: "Nota: Los documentos protegidos no deben conservarse en archivos de compromiso a menos que sea necesario",
    noObjectsAvailable: "No hay objetos disponibles",
    CurrentlyUnavailable: "Actualmente no disponible",
    showMoreToggle: "Mostrar más",
    showLessToggle: "Mostrar menos",

    //#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>No hay documentos disponibles<br />―<br />Puede arrastrar y soltar uno o más documentos o hacer clic en <button class="motif-button motif-text-alt-button motif-button-small">Agregar archivos temporales</button></center>',
    uploadEvidencePlaceholder: "Arrastre y suelte uno o más documentos o haga clic en <a>Agregar evidencia</a>",
    uploadTemporaryPlaceholder: "Arrastre y suelte uno o más documentos o haga clic en <a>Agregar archivos temporales</a>",

    processing: "En proceso",
    uploading: "Cargando",
    uploadComplete: "Procesando",
    downloading: "Descargar",
    downloadComplete: "Descargar completo",
    loading: "Cargar",

    //#region Filter

    filter: "Filtro",
    noFiltersAvailable: "No hay filtros disponibles",
    pickADate: "Elegir una fecha",
    filterYes: "Sí",
    filterNo: "No",

    //#region Document list filters
    filterGroupDocumentsLabel: "Documentos",
    filterDocumentContentLabel: "Contenido del documento",
    filterSharedEvidenceLabel: "Evidencia compartida",
    filterFileExtensionLabel: "Extensión de archivo",
    filterDocumentConflictLabel: "Conflictos",
    filterDuplicateFileNameLabel: "Nombre de archivo duplicado",
    filterCanvasFormsLabel: "Formularios Canvas",

    filterGroupModificationsLabel: "Modificaciones",
    filterLastModifyUserLabel: "Ultima modificación por",
    filterModifyAfterReviwerSignoffLabel: "Modificado desde la firma del revisor",
    filterModifiedAfterLabel: "Modificado después de",

    filterGroupReviewNotesLabel: "Notas de revisión",
    filterReviewNoteStatusLabel: "Estado",
    filterReviewNoteAssignedToLabel: "Asignado a",
    filterReviewNoteAuthoredByLabel: "Creado por",
    filterReviewNoteOtherEngagementLabel: "De otros compromisos",

    filterGroupSignOffsLabel: "Firmas",
    filterSignOffMissingLabel: "Firmas faltantes",
    filterSignedOffByUserLabel: "Firmado por",
    filterNotSignedOffByUserLabel: "No firmado por",
    filterSignOffRequirementsLabel: "Requisitos para firmar",

    filterGroupOtherLabel: "Otros",
    documentLink: "Enlace al documento",
    filterByCopyLinkDocument: "Filtrado por documento de enlace de copia",
    filterGroupAuditComponentLabel: "Equipo de región/componente",
    noGroupAuditComponents: "No se han creado componentes",
    filterFindingsLabel: "Resultados",
    filterGroupInstruction: "Instrucción del grupo",
    noGroupInstruction: "No se han creado instrucciones",

    documentSearchPlaceholderLabel: "Documentos de búsqueda",
    analyticSearchPlaceholderLabel: "Análisis de búsqueda",
    //#endregion

    //#endregion

    pendingResponseLabel: "Respuesta pendiente",
    receivedLabel: "Recibido",
    dueToPrimaryTeam: "Debido al equipo primario",
    sentToPrimaryTeam: "Enviado al equipo primario",
    documentationPending: "Documentación pendiente",
    documentationComplete: "Documentación completa",
    viewBytimephaseTextLabel: "Ver por fase de tiempo",
    showDetails: "Mostrar detalles",
    referenceDocAddDocHeaderText: "Relacione pruebas o archivos temporales de esta compromiso para acceder a ellos desde el panel principal",
    addDocsToTeam: "Añadir documentos a los documentos del equipo",
    addDocsToMy: "Añadir documentos a mis documentos",
    addDocument: "Añadir documento",
    externalUserRemove: "eliminar",

    // Internal user roles abbr
    adminRole: "Admin",
    readOnlyRoleForThirdPartyUser: "Solo lectura",
    legacy: "Irrestricto",
    permissionLabel: "Permiso",
    displayPermissionErrorText: "No se pueden mostrar permisos en este momento. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    onlyShowRelatedTasks: "Mostrar solo tareas relacionadas",

    softwareUpdate: "Actualizaciones de software",
    updateNow: "Actualizar ahora",
    updateMsg: "Las actualizaciones de software están disponibles para EY Canvas. Seleccione Actualizar ahora para descargar e instalar las actualizaciones. La página se actualizará.",

    processingError: "Error de procesamiento",

    //Create tag modal labels
    createtags: "Selección creada",
    reportDate: "Fechas de reporte",
    managetags: "Administrar selecciones",
    savechanges: "Guardar cambios",
    manageTagGroupCreate: "Crear",
    manageTagGroupDiscard: "descartar",
    manageTagGroupCreateTooltip: "Tagear grupo",
    deletetag: "Eliminar etiqueta",
    deletetaggroup: "borrar selecciones de grupo",
    createTagGroup: "Crear selecciones de grupo",
    manageTagGroupName: "Selección grupal",
    countOftasksAssigned: "Recuento de tareas asignadas",
    createTagGroupMessage: "Cree grupos de etiquetas y etiquetas para empezar. Haga clic en {0} para crear un grupo de etiquetas.",
    tagsContnetSearchPlaceholder: "Buscar selecciones",
    deleteTagHoverText: "Una vez guardados, las etiquetas o grupos de etiquetas eliminados no se pueden recuperar.",
    deleteTagGroupHoverText: "Esta etiqueta se eliminará de todas las tareas de su compromiso.",
    tagSaveChangesInfoText: "Todas las etiquetas de este grupo se eliminarán y removera de todas las tareas de su interacción.",
    tagConfirmModalTitleText: "Los cambios se aplicarán al guardar.",
    tagConfirmModalPrimaryMessage: "¿Estás seguro de que quieres guardar estos cambios?",
    tagConfirmModalSecondaryMessage: "¿Está seguro de que desea guardar estos cambios?",
    tagDeleteModalSecondaryMessage: "Una vez guardadas, las etiquetas eliminadas no se pueden recuperar.",
    createNewTag: "Crear nueva etiqueta",
    tagWillBeRemovedFromRequests: "Esta etiqueta se eliminará de todas las solicitudes de su compromiso.",
    eyTags: "Etiquetas EY",
    clientTags: "Etiquetas de cliente",
    allTags: "Todas las etiquetas",
    // Add canvas form
    addCanvasForm: "Añadir formulario de lienzo",
    addCanvasFormName: "Nombre del documento",
    addCanvasFormNameBlankMessage: "Nombre del documento es un campo requerido",
	addCanvasFormNameInvalidCharacterMessage: 'El nombre no puede contener ninguno de los siguientes caracteres: */:<br>\\?|"',
    addCanvasFormDigital: "Digital",
    addCanvasFormCore: "global",
    addCanvasFormNonComplex: "no- complejo",
    addCanvasFormComplex: "complejo",
    addCanvasFormListed: "listada",
    addCanvasFormGroupAudit: "auditoria de grupo",
    addCanvasFormPCAOBFS: "PCAOB-FS",
    addCanvasFormPCAOBIA: "PCAOB-IA",
    addCanvasFormStandards: "Normas",
    addCanvasFormStandardsNotSelectedMessage: "Se requieren normas",
    addCanvasFormLanguage: "Idioma",
    addCanvasFormLanguageNotSelectedMessage: "El idioma es obligatorio",
    addCanvasFormNoResultFound: "No se han encontrado resultados",
    addCanvasFormManageTasks: "Administre las tareas",
    addCanvasFormAvailableTasks: "Nombre de las tareas",
    addCanvasFormAvailableTaskType: "Tipo",
    addCanvasFormTypeOfForm: "Tipo de forma",
    addCanvasFormSubServiceLine: "Sub línea de servicio",
    addCanvasFormTypeOfFormNotSelectedMessage: "Se requiere el tipo de formulario",
    addCanvasFormSelectedTasks: "Seleccione tareas",
	addCanvasFormNoTaskDataAvailable: "Ninguna tarea seleccionada. Seleccione al menos una tarea para crear un formulario.",
    addCanvasFormCreateForm: "Crear formato",
    addCanvasFormCancel: "cancelar",
    addCanvasFormSuccessMessage: "{0} se ha creado correctamente. El contenido puede tardar hasta diez minutos en entregarse.",
    // Add Canvas form manage Objects
    addCanvasFormManageObjects: "Administrar {0}",
    addCanvasFormAvailableObjects: "{0} nombre //",
    addCanvasFormSelectedObjects: "{0} seleccionado",
    addCanvasFormClickHereToOpenManageTab: "Haga clic aquí para abrir la pestaña Administrar {0}",
    addCanvasFormNoObjectsDataAvailableRequired: "No {0} seleccionado. Seleccione al menos uno para crear un formulario",
	addCanvasFormNoObjectsDataAvailableOptional: "No {0} seleccionado.",
    addCanvasFormObjectNotDefinedMessage: "Los objetos no están disponibles para este formulario",
    addCanvasFormOptional: "(opcional)",
    addCanvasFormObjects: "objetos",
    addCanvasFormObject: "Objeto",
    addCanvasFormSCOT: "SCOT",
    addCanvasFormSCOTs: "SCOTs",
    addCanvasFormITProcess: "proceso de TI",
    addCanvasFormITProcesses: "procesos de TI",
    addCanvasFormControl: "Control",
    addCanvasFormControls: "Controles",
    addCanvasFormITControl: "Control de TI",
    addCanvasFormITControls: "Controles de TI",
    addCanvasFormITApplication: "Aplicación de TI",
    addCanvasFormITApplications: "Aplicaciones de TI",
    addCanvasFormSignoffRequirements: "Firmas requeridas:",
    addCanvasFormPICCheckBox: "PIC",
    addCanvasFormEQRCheckBox: "EQR",
    itProcessRelatedITGCITSP: "Proceso de TI y ITGC/ITSP relacionados",
    taskTitle: "Comprender y documentar el proceso de TI: {0}",
    taskDescription: "Documente nuestra comprensión del proceso de TI. Adjunte el formulario relevante como evidencia para respaldar nuestra comprensión del proceso de TI. <br>Cuando los ITGC aparezcan en la sección Atributos de tarea, realice procedimientos de recorrido para confirmar nuestra comprensión de los ITGC y evaluar su diseño e implementación. Adjunte evidencia de nuestros procedimientos.",
    addCanvasFormAccounts: "cuentas",
    addCanvasFormAccount: "cuenta",
    addCanvasFormErrorMessage: "Este formulario solo puede estar relacionado con una cuenta",
    addCanvasFormValidationMessage: "Se requiere una selección",
    addCanvasFormEstimates: "Estimaciones",
    addCanvasFormEstimate: "estimado",
    addEstimateCanvasFormErrorMessage: "Este formulario solo se puede relacionar con un estimado",
    addControlCanvasFormErrorMessage: "Este formulario solo puede estar relacionado a un control",
    addScotCanvasFormErrorMessage: "Este formulario solo puede estar relacionado a un SCOT",

    //Independence Confirmation
    sortOrderIndependence: "Ordenar",
    confirmationStatus: "Estatus de confirmacion",
    confirmationDate: "Fecha de confirmacion",
    independenceConfirmationSearch: "Buscar miembros del equipo",
    editTemplate: "Editar plantilla",
    viewTemplate: "Ver plantilla",
    confirmedBy: "Confirmado por",
    overriddenBy: "Eliminado por",
    grantedBy: "Acceso concedido por",
    deniedBy: "Aceso denegado por",
    list: "Lista",
    paginationShow: "Mostrar",
    options: "Opciones",
    removeTeamMemberModalText: "¿Está seguro de que desea eliminar a este miembro del equipo de su compromiso?",
    removeTeamMemberModalTitle: "Eliminiar miembro del equipo",
    overrideRemovedBy: "Anulación eliminada por",

    // Custom instructions
    addCustomInstruction: "Agregar instrucciones personalizadas",
    editCustomInstruction: "Editar instrucciones personalizadas",
    customInstructionInstructionalText: "Agregue o edite instrucciones personalizadas aquí. Estas instrucciones aparecerán en la confirmación de independencia individual de cada miembro del equipo para proporcionar orientación sobre cómo responder a las preguntas específicas del cliente.",
    customInstructionPermissionTooltip: "Debe tener el permiso <b>Administrador del compromiso</b> para realizar esta acción. Hable con un <b>Administrador del compromiso</b> para solicitar el permiso.",
    customInstructionMaxLengthExceeded: "El texto superó la longitud máxima permitida",

    //Independence Confirmation Details
    details: "Detalles",
    question: "Pregunta",
    answer: "Respuesta",
    countTeamMembers: "Recuento de miembros del equipo",
    executiveApproval: "Aprobación ejecutiva",
    yes: "Sí",
    no: "No",
    independenceModalText: "Aquí puedes ver a los miembros del equipo que seleccionaron esta respuesta en su Confirmación de Independencia Individual.",
    notApplicable: "No aplicable",
    readMore: "Leer más",
    readLess: "Leer menos",
    teamMembsersTitle: "Detalles de los miembros del equipo",

    tasksSelected: "Tareas seleccionadas",
    taskSelected: "Tarea seleccionada",
    unselectAll: "Deseleccionar todo",
    addForm: "Agregar formato",
    addFormName: "Nombre",
    addFormDigital: "Digital",
    addFormCore: "Global",
    addFormNonComplex: "no- complejo",
    addFormComplex: "complejo",
    addFormListed: "Listada",
    addFormGroupAudit: "auditoria de grupo",
    addFormPCAOBFS: "PCAOB-FS",
    addFormPCAOBIA: "PCAOB-IA",
    addFormStandards: "Normas",
    addFormLanguage: "Idioma",
    addFormManageTasks: "Administrar tareas",
    addFormManageObjects: "Administrar objetos",
    addFormAvailableTasks: "Tareas disponibles",
    addFormAvailableObjects: "Objetos disponibles",
    addFormTypeOfForm: "Tipo de forma",
    addFormSelectedTasks: "Tareas seleccionadas",
    addFormSelectedObjects: "Objetos seleccionados",
    addFormCreateForm: "Crear formato",
    addFormCancel: "Cancelar",
    createtag: "Crear selección",
    tagsLabel: "Selección",

    //Group instruction summary
    sInstruction: "Alcance",
    iInstruction: "Individual",

    //CGT and CGT Unlinked related labels
    cgtSend: "Enviar",
    cgtDueDate: "Fecha de vencimiento",
    cgtFrom: "De",

    notesSelected: "notas seleccionadas",
    noteSelected: "nota seleccionada",
    cgtUnlinkedLabel: "Desvincular",
    cgtUnlinkedInformationMessage: "Esta tarea no esta linkeada a otro compromiso de grupo y puede borrarse si ya no es requerida",
    sendtoPrimaryTeam: "Enviar al equipo principal",
    sendtoPrimaryTeamdisableBtn: "Esta tarea debe contener evidencia con al menos una firma del preparador y revisor para enviar al equipo principal",
	cgtSendModalHeader: 'Seleccione uno o más documentos para enviarlos al equipo primario. <span class="modal-instruction-text">Los formularios de Canvas se enviarán en formato PDF. Un registro de los formularios PDF Canvas enviados al equipo primario está disponible en los Archivos temporales.</span>',
    cgtNotifyCheck: "Notificar al equipo principal que no se deben enviar otros documentos.",
    cgtCanvasFormValidation: "Hay validaciones no resueltas en este formulario de Canvas. Considere si las validaciones deben resolverse antes de enviarlas al equipo primario.",
    finalVersionLabel: "Versión final",
    draftVersionLabel: "Versión preliminar",
    otherEvidence: "Otra evidencia",
    selectAtLeastOneDocument: "Seleccione al menos un documento para continuar.",
	cgtsendmodelinstructionheader: 'Seleccione uno o más documentos para enviarlos al equipo principal. <span class="modal-instruction-text">Marcando un documento como <b>versión preliminar</b> informa al equipo primario de que todavía está trabajando en el documento y puede enviar versiones adicionales. Marcar un documento como <b>versión final</b> informa al equipo primario de que su trabajo está completo y que no espera enviar ninguna versión adicional del documento.</span>',
    //Independence confirmation
    undefined: "Sin definicion",
    incomplete: "Incompleto",
    nomattersidentified: "No hay sujetos identificados",
    matteridentifiedpendingaction: "Asunto identificado - Acción pendiente",
    matterresolveddeniedaccess: "Asunto resuelto - Acceso denegado",
    matterresolvedgrantedaccess: "Asunto resuelto - Acceso concedido",
    notapplicable: "No es aplicable",
    restored: "Restaurado",
    overriden: "Eliminado",
    override: "Eliminar",
    priornomattersidentified: "Previo - No hay asuntos identificados",
    priormatteridentifiedpendingaction: "Previo - No hay asuntos identificados - Acción pendiente",
    priormatterresolvedgrantedaccess: "Previo - No hay asuntos identificados - Acceso concedido",
    priormatterresolveddeniedaccess: "Previo - No hay asuntos identificados - Acceso denegado",
    addTagsLabelForTaskList: "Agregar selecciones",
    addTagLabelForTaskDetails: "Agregar selección",
    manageTagsColorInputLabel: "Color",
    manageTagsTagNameInputLabel: "Nombre de la selección",
    addTagRequiredMessage: "Requerido",
    addNewTagLinkText: "Agregar nueva selección",
    manageTagsLabel: "Administrar selección",
    manageTagGroupHeader: "Crea nuevas etiquetas y grupos aquí. También puede editar y eliminar etiquetas y grupos existentes. Las tareas de etiquetado pueden mejorar la organización de su participación y gestión de proyectos.",
    //add tag color dropdown
    addTagRedColorText: "Rojo",
    addTagOrangeColorText: "Naranja",
    addTagTealColorText: "Gris",
    addTagBlueColorText: "Azul",
    addTagPurpleColorText: "Morado",
    addTagGreenColorText: "Verde",
    deleteAssignmentConfirmationMessage: "¿Está seguro de que desea eliminar esta asignación?",

    // Return label for Returned document
    recieved: "Recibido",

    selectServiceOffering: "Seleccionar oferta de servicio",
    selectTasks: "Seleccionar tareas",
    reviewSuggestedTasks: "Revisar las tareas sugeridas",
    reviewAvailableTasks: "Revisar las tareas disponibles",
    setDueDate: "Establecer fecha de vencimiento",
    schedulerCreateRequestStep4TabText: "Protocolos operativos y de comunicación",
    createWorkRequestHeadingpart1: "Nombre su solicitud de servicio y seleccione una oferta de servicio para comenzar.",
    createWorkRequestHeadingpart2: "Las ofertas de servicios que se enumeran a continuación se basan en el perfil de su compromiso y los servicios disponibles en su región. Los costos varían según el rango de recursos asignados y la complejidad.",
    createWorkRequestHeadingpart3: "Si su compromiso se ha reenviado, cualquier oferta de servicio utilizada por su compromiso en el período anterior se etiqueta con un",
    createWorkRequestHeadingpart4: "Período anterior",
    createWorkRequestHeadingpart5: "insignia.",
    createWorkRequestStep2Headingpart1: "Revise las tareas disponibles para el",
    createWorkRequestStep2Headingpart2: "oferta de servicio.",
    createWorkRequestStep2Headingpart3: "<u>Para la participación del equipo en el piloto de centralización de la segunda fase 2</u>, seleccione las tareas relevantes en función de los siguientes criterios, que los miembros del equipo centralizado pueden realizar: (1) Procedimientos de auditoría objetivos (es decir, aquellos procedimientos que requieren poco o ningún juicio), (2) Procedimientos subjetivos (es decir, aquellos procedimientos que requieren juicio) solo para estimaciones de menor riesgo o cuando el riesgo inherente es menor para la(s) afirmación(es) relevante(s). Las tareas que ya están incluidas en otra solicitud de servicio centralizada se etiquetan como",
    createWorkRequestStep2Headingpart4: ". Si utilizó este servicio antes, las tareas que se incluyeron en su solicitud de período anterior se etiquetan como",
    createWorkRequestStep2Headingpart5: "Período anterior.",
    requestName: "Nombre de la solicitud",
    submittedBy: "Enviado por",

    // Next wave labels
    totalTasks: "Tareas",
    noServiceRequest: "Todavía no se ha creado ninguna solicitud de servicio. Crear y enviar solicitudes de servicio para empezar.",
    eyContact: "Contacto EY",
    requestStatusText: "Estado de la solicitud",
    requestsByStatusText: "Solicitudes por status",
    serviceRequest: "Solicitudes de servicio",
    serviceGateway: "Portal de Servicio",
    centralizedServices: "Solicitar servicios",
    serviceRequestDueDate: "Vencimiento",
    NA: "N/A",
    more: "Más",
    eycontacts: "Contactos EY",
    addEYContact: "Agregar contacto EY",
    editEYContacts: "Editar contactos de EY",
    addEYContactInstructions: "Agregue o elimine contactos de EY para esta solicitud. Los contactos actualizados de EY se enviarán a los administradores de recursos y a los recursos asignados.",
    editEYContactDisabledInstructions: "Debe tener el permiso <b>Solicitar servicios</b> para realizar esta acción. Hable con un administrador de compromiso para obtener acceso.",
    emptyEYContactsPlaceholder: "Agregue al menos un contacto de EY para continuar.",
    estimatedHours: "Tiempo para completar (horas)",
    resourceManagers: "Gestores de recursos",
    nextWaveServices: "Servicios centralizados",
    centralizedservices: "Servicios centralizados",
    onlyShowAccepetedRequests: "Sólo mostrar solicitudes aceptadas",
    showSelectedOnly: "Mostrar sólo seleccionado",
    emptyEngCodeMessage: "No hay códigos válidos para su compromiso.",
    primary: "Primaria",
    estimatedCosts: "Costos estimados",
    assignedResources: "Recursos asignados",
    generalAuditTasks: "Tareas de auditoría general",
    generalInfo: "Información general",
    requestID: "Solicitar ID",
    createdDate: "Creado",
    startDate: "Inicio",
    serviceRequestDue: "Vencimiento",
    comingDueIn: "Vencimiento en",
    comingDueTodayLabel: "Vencimiento hoy",
    daysLabel: "días",
    dayLabel: "día",
    createByLabel: "Creado por",
    notProvidedLabel: "No proporcionado",
    editLabel: "Editar",
    serviceRequestNoHistoryLabel: "No hay historia para esta solicitud",
    serviceRequestHistoryLabel: "Registro de historia",
    serviceRequestTasks: "Tareas de solicitud de servicio",
    suggestedRequestTasks: "Tareas de solicitud sugeridas",
    estimatedCost: "Costo estimado,",
    addinstructionsAndRelatedFiles: "Agregue otros protocolos de funcionamiento y comunicación a esta solicitud.",
    instructionText: "Las pruebas relacionadas con esta solicitud se archivarán e incluirán con esta solicitud si usted avanza su compromiso el próximo año. Los archivos temporales no se archivarán y no se incluirán con esta solicitud si avanza su compromiso.",
    instructionPlaceHolder: "Otros protocolos de funcionamiento y comunicación",
    warningText: "La evidencia se archivará con la solicitud, pero los archivos temporales no lo harán.",
    availableDocuments: "Documentos disponibles,",
    noDocumentsAvailable: "No hay documentos disponibles.",
    selectAll: "Seleccione todos los",
    deselectAll: "Deseleccionar todo",
    documentsSelected: "documentos seleccionados",
    selectedDocuments: "Documentos seleccionados",
    noDocumentSelected: "Aún no se ha seleccionado ningún documento. Seleccione un documento para empezar (opcional).",
    TaskName: "Nombre de la tarea",
    AssignmentsLabel: "Asignaciones",
    noTaskAssociatedToServiceRequest: "No hay tareas asociadas a esta solicitud.",
    requestServices: "Solicitar servicios",

    serviceNotEditable1: "Para modificar las tareas incluidas en esta solicitud, seleccione",
    serviceNotEditable2: "editar",
    serviceNotEditable3: "en el",
    serviceNotEditable4: "Tareas",
    serviceNotEditable5: "pestaña. Para realizar cambios adicionales o cancelar esta solicitud de servicio, entonces",
    serviceNotEditable6: "ponerse en contacto con uno de los administradores de recursos",
    serviceNotEditable7: "(si se asigna).",

    serviceReqMarkComplete: "Marcar una solicitud de servicio centralizada como completa informará al proveedor de servicios que no se requiere ningún trabajo adicional y que ha terminado su revisión. Una vez que la solicitud de servicio se marca como completada, no se puede deshacer.",
    serviceReqMarkCompleted: "Completado",
    editServiceRequestTasks1: "Revise las tareas seleccionadas para esta solicitud de servicio.",
    editServiceRequestTasks2: "Todas las tareas que se sugieren para el",
    editServiceRequestTasks3: "oferta de servicio se presentan aquí. Para agregar una tarea, selecciónela en la lista siguiente. Para quitar una tarea, anule la selección.",

    submitServiceRequestConfirmation1: "¿Está seguro de que desea enviar esta solicitud de servicio?",
    submitServiceRequestConfirmation2: "Ha seleccionado una oferta de servicio que ya se ha enviado para su interacción.",
    alreadyScheduledHeader: "Oferta de servicio ya programada",

    createServiceRequestPermission1: "Debe tener permisos de creación de solicitud de servicio para continuar.",
    createServiceRequestPermission: "Debe tener el permiso <b>Administrar solicitudes de servicio</b> para realizar esta acción. Hable con un administrador de Engagement para obtener acceso.",
    schedulerRequestSubmissionError: "Se produjo un error que impidió que esta solicitud se enviara al programador. Seleccione <b> Reenviar </b> para volver a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    resubmit: "Reenviar",
    noServiceManager: "Aún no se ha asignado un administrador de recursos a esta solicitud.",
    noAssignedResource: "Aún no se han asignado recursos a esta solicitud.",
    noMileStoneSetForService: "Aún no se han fijado fechas de inicio y vencimiento de Milestone para esta solicitud.",
    isEngagementNominnatedForCentralizeService: "¿Su participación ha sido seleccionada o confirmada por su Región para participar en el piloto de centralización de GDS?",
    needApprovalForSericeRequestCreation: "Póngase en contacto con su socio regional de gestión de garantías para obtener la aprobación adecuada para continuar con esta solicitud de servicio.",

    //TaskList Filters
    filterMissingRelatedTaskLabel: "Documento PIC/EQR no relacionado con la tarea",
    filterRelatedToRisksLabel: "Relacionado con los riesgos",
    filterGroupTasksLabel: "Tareas",
    filterGroupAssignmentsLabel: "Asignaciones",
    filterGroupDocumentsignoffsLabel: "Firmas de documentos",
    filterGroupProjectManagementLabel: "Gestión de proyectos",
    filterAssignmentTypeLabel: "Tipo de asignación",
    filterTaskStatusLabel: "Estado de la tarea",
    filterTaskTypeLabel: "Tipo de tarea",
    filterAssignedToLabel: "Asignado a",
    filterAssignmentStatusLabel: "Estado de la asignación",
    filterTaskReviewNoteStatusLabel: "Estado de la nota",
    filterTaskCommentStatusLabel: "Estado de las notas",
    filterTaskReviewNoteAssignedToLabel: "Asignado a",
    filterTaskReviewNoteAuthoredByLabel: "Creado por",
    filterPICDocumentsAssociated: "Documentos PIC asociados",
    filterEQRDocumentsAssociated: "Documentos EQR asociados",
    missingSignOffs: "Faltan firmas",
    signedOffBy: "Firmado por",
    notSignedOffBy: "No firmado por",
    filterTimePhaseLabel: "Fase de tiempo",
    filterMilestoneLabel: "Milestone",
    filterAuditPhaseLabel: "Fase de auditoría",
    filterEngagementPhaseLabel: "Fase del Compromiso",
    filterDocumentConflictsLabel: "Conflictos de documentos",
    filterEntitiesLabel: "Entidad",
    missingEntityDocuments: "Documentos de entidad faltantes",
    filterDownloadedForOfflineLabel: "Descargado para trabajo fuera de linea",
    filterNextwaveServicesLabel: "Servicios centralizados",
    filterServiceGateway: "Service gateway",
    filterScheduledServicesLabel: "Servicios relacionados",
    filterSuggestedServicesLabel: "Servicios sugeridos",
    NoDocumentSignedOffLabel: "No hay documentos firmados por",
    SomeDocumentSignedOffLabel: "Algunos documentos firmados por",
    AllDocumentSignedOffLabel: "Todos los documentos firmados por",
    usersLabel: "Miembros del equipo",
    serviceRequests: "Servicios centralizados",
    backToMainPage: "Volver a la página principal",
    suggestedNextwaveRequests: "Solicitudes centralizadas sugeridas",
    /* Component Send Status */
    deliveredDate: "Entregado: {0}",
    sentDate: "Enviado: {0}",
    sentFailure: "Error de entrega se ha producido, vuelva a intentarlo y, si el problema persiste, póngase en contacto con el servicio de asistencia.",
    chooseTaskInstructionLabel: "Elija las tareas que desea incluir con esta solicitud.",
    createSRstep2InstructionalTextPart1: "Las tareas que ya están incluidas en otra solicitud se etiquetan como",
    createSRstep2InstructionalTextPart2: ". Si utilizó esta oferta de servicio antes, las tareas que se incluyeron en su solicitud de período anterior se etiquetan como",
    createSRstep2InstructionalTextPart3: "Utilice el botón de abajo siguiente para mostrar solo las tareas sugeridas.",
    availableTasksLabel: "Tareas disponibles",
    guidance: "Guía Atlas",
    helixAnalyzers: "Analizadores de Helix",
    eyHelix: "EY Helix",
    smartAutomationLinks: "Automatización inteligente",
    createAutomation: "Crear automatización",
    noProjectTitle: "Vincular un proyecto de Helix",
    multipleProjectsTitle: "Seleccione el vinculo del  proyecto de Helix",
    noProjectMessage: "Vincule un proyecto de Helix a este compromiso para comenzar con este analizador Helix.",
    multipleProjectsMessage: "Esta participación está vinculada a varios proyectos de Helix. Seleccione un proyecto De Helix de la lista siguiente para continuar.",

    automationGuidanceHeader: "Automatizaciones sugeridas",
    helixAnalyzersHeader: "Analizadores sugeridos",
    linkToHelixLabel: "Enlace a Helix",
    noSelectedTasksText: "Aún no se ha seleccionado ninguna tarea. Seleccione una tarea para empezar.",
    selectedTasksLabel: "Tareas seleccionadas",
    serviceOffering: "Oferta de servicios",
    submitRequest: "Enviar solicitud",
    scheduleYourRequest: "Programe su solicitud.",
    serviceRequestStep3HeaderText: "Seleccione la fecha de inicio en la que desea que los recursos asignados comiencen a trabajar en estas tareas. A continuación, seleccione la fecha en la que se deben completar estas tareas.",
    serviceRequestMilestoneDueDateHeaderText1: "Seleccione la",
    startanddue: "fecha de inicio y de vencimiento",
    eachmilestone: "por cada milestone",
    serviceRequestMilestoneDueDateHeaderText2: " Su equipo es el responsable último de todo el trabajo realizado. Por lo tanto, la fecha de vencimiento seleccionada debería dar tiempo suficiente para que su equipo revise el trabajo enviado.",
    serviceRequestMilestoneDueDateHeaderText3: "El tiempo estimado para completar debe incluir solo el tiempo en el que el proveedor de servicios espera incurrir.",
    schedulerBudgetMainQuestion: "Tienes tu equipo de compromiso:",
    schedulerBudgetFirstQuestion: "¿Incluyó todo el trabajo para esta aplicación en sus procesos financieros, de precios y de planificación?",
    schedulerBudgetSecondQuestion: "¿Ha notificado a su administrador de experiencia en su territorio sobre esta solicitud?",
    schedulerBudgetThirdQuestion: "¿Ajustó adecuadamente las horas para los miembros del equipo?",
    timetocompleteinfo1: "El tiempo estimado para completar sólo debe incluir",
    timetocompleteinfo2: "tiempo que espera que el proveedor de servicios incurra.",
    serviceRequestStartDate: "Empezar",
    saveDraft: "Guardar borrador",
    step3ValidationError: "La fecha de vencimiento debe ser posterior de la fecha de inicio",
    scheduledLabel: "Programado",
    suggestedLabel: "Sugerido",
    searchTasksLabel: "Tareas de búsqueda",
    submit: "Enviar",
    selectTaskRequiredErrorMessage: "Debe seleccionar al menos una tarea para continuar.",
    moveToCompleted: "Moverse a completado",
    requestResubmitMessagePart1: "Volver a enviar esta solicitud restablecerá el estado a",
    requestResubmitMessagePart2: "Pendiente.",
    requestResubmitMessagePart3: "Cualquier cambio realizado será revisado por el Programador.",
    showSuggestedTaskToggle: "Mostrar solo las tareas sugeridas",

    // Assignments
    addAssignmentName: "Añadir nombre de asignación",
    editAssignmentName: "Editar nombre de la asignación",
    deleteAssignmentName: "Eliminar nombre de la asignación",
    deleteAssignmentNameInstructionalTextHeader: "¿Está seguro de que desea eliminar este nombre de asignación?",
    deleteAssignmentNameInstructionalText: "Una vez eliminada, la asignación se eliminará de todos los miembros del equipo y de los roles de tu interacción.",
    assignmentType: "Tipo de asignación",
    assignmentTypeInstructionalText: "Seleccione un tipo de asignación e introduzca un nombre a continuación. Haga clic en <b>Agregar</b> cuando haya terminado.",
    assignmentEditInstructionalText: "Edite el tipo de asignación y el nombre a continuación. Haga clic en <b>Guardar cambios</b> cuando haya terminado.",
    noSuggestedTaskLabel: "No hay tareas sugeridas en esta categoría.",
    manageAssignmentsLabel: "Administrar asignaciones",
    myAssignmentsLabel: "Mis asignaciones",
    myAssignedTasks: "Mis tareas asignadas",
    currentlyAssignedTasks: "Asignados actualmente",
    assignmentModalInstructionalText1: "Para reasignar o remover tareas asignadas a un miembro del equipo o rol, seleccione su nombre a continuación. También puede utilizar el icono <b>Eliminar</b> para eliminar todas las asignaciones de un miembro del equipo o un rol. Para editar o eliminar el nombre de una asignación, seleccione el menú <b>Más</b>.",
    unassignedTasks: "Tareas sin asignar",
    assignedTasks: "Tareas asignadas",
    type: "Tipo",
    priorperiodservicerequests: "Solicitudes de servicio de período anterior",
    unmarkcomplete: "Desmarcar completo",
    taskAttributes: "Atributos de tarea",
    engagementTeam: "Equipo de compromiso",
    assignTo: "Asignar a",
    reAssignTo: "Reasignación a",
    assign: "Asignar",
    reAssign: "Reasignar",
    reAssignWarningLabel: "Seleccione una o varias tareas para reasignarlas.",
    assignWarningLabel: "Seleccione una o más tareas para asignar.",
    searchByTaskName: "Buscar por nombre de tarea",
    searchByTimePhaseName: "Buscar por nombre de fase de tiempo",
    assignment: "Asignación",
    noMembersWithThisAssignment: "No hay miembros del equipo ni roles con esta asignación.",
    deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "La asignación se eliminará de todas las tareas de su compromiso.",
    noTaskAttributes: "No hay atributos para esta tarea. Seleccione Crear o Relacionar para empezar.",
    assignmentWithoutAssignedUser: "Este nombre de asignación no está actualmente en uso.",

    // v2 profile navigation Zeus to Hercules to Kronos message
    v2ProfileDocumentIdAvailableMessage: "Recopilación de información de perfil, por favor espere",
    v2ProfileDocumentIdDeletedMessage: "No se ha encontrado información de perfil. Actualice la página e inténtelo de nuevo. si el error persiste, póngase en contacto con el servicio de asistencia.",
    accountAndRelatedAssertions: "Cuenta y aserciones relacionadas",
    risks: "Riesgos",
    scotName: "Nombre de SCOT",
    strategy: "Estrategia",
    transactionType: "Tipo de transacción",
    notSelectedText: "No seleccionado",
    relatedBy: "Relacionado por",
    collaboration: "Colaboración",
    controlsLabel: "Controles",
    scotAndRelatedControls: "SCOT y controles relacionados",
    scotAndRelatedRisks: "SCOT y los riesgos relacionados de la declaración errónea material",
    frequencyLabel: "Frecuencia",
    operatingEffectively: "Operando de manera efectiva",
    designedEffectively: "Diseñado de manera efectiva",
    timeToCompleteHours: "Tiempo de finalización (horas)",
    completeRequiredFieldValidationError: "Por favor complete todos los campos requeridos para continuar.",
    itgcsAndItsps: "ITGCs y ITSP",
    itprocessItgcsAndItsps: "Proceso de TI y ITGC/ITSP",
    approachLabel: "Enfoque",
    typeLabel: "Tipo",
    itProcessName: "Nombre del proceso de TI",
    processEvaluation: "Evaluación de procesos",
    unrelatedControls: "Controles no relacionados",
    disableNextwavePlaceholder: "Los servicios centralizados no están disponibles actualmente para su país. Actualice la página e inténtelo de nuevo. Póngase en contacto con mesa de ayuda si el error persiste.",
    disableNextwavePlaceholderDataCenter: "Los servicios centralizados no están disponibles actualmente para su centro de datos local. Actualice la página e inténtelo de nuevo. póngase en contacto con service desk si el error persiste.",
    dataPrivacyInviteMessage: "Antes de invitar, ¿ha considerado adecuadamente las restricciones de acceso a los papeles de trabajo que pueden aplicarse debido a las reglas de privacidad de datos?",
    //Session Timeout
    sessionTimerMsg: "Debido a la inactividad, su sesión de trabajo actual está a punto de expirar. Por su seguridad, las sesiones de EY Canvas finalizan automáticamente después de 30 minutos de inactividad. Su sesión actual caducará en {0} minutos. Si desea permanecer conectado, haga clic en Continuar.",
    logout: "Cerrar sesión",
    sessionPopupTitle: "Cierre automático de sesión para su protección",
    allSuggestedTasks: "Tareas",
    viewByAccount: "Ver por cuenta",
    viewBySCOT: "Vista por SCOT",
    noServiceOfferingsAvailable: "No hay ofertas de servicio disponibles para su compromiso en este momento. Actualice la página e inténtelo de nuevo. Póngase en contacto con mesa de ayuda si el problema persiste.",

    //Collaboration
    myRequests: "Mis solicitudes",
    allRequests: "Todas las solicitudes",
    calendar: "Calendario",
    calendarTodayButton: "Hoy",
    requestsListButton: "Lista de Requerimientos",
    eventsButton: "Eventos",
    analyticsButton: "Analítica",
    showAssignedToMe: "Mostrar mis solicitudes",
    selectRequestsTitle: "Seleccione las solicitudes para ver los detalles",
    selectRequestsSub1: "Para habilitar los controles masivos, utilice las casillas de verificación o mantenga pulsada la tecla",
    selectRequestsSub2: "Teclas Shift o Control mientras selecciona múltiples solicitudes",
    noTagMessage: "No hay etiquetas creadas todavía. Haga clic en <b> aquí <b> para empezar.",
    tagAs: "Etiqueta como:",
    addTag: "Añadir etiqueta",
    searchTag: "Etiquetas de búsqueda",
    documentsAttached: "Documentos adjuntos",
    editDraftRequest: "Editar solicitud de borrador",
    deleteRequest: "Eliminar solicitud",
    deleteLabel: "Eliminar",
    deleteLabelDisabled: "Permisos insuficientes para la eliminación masiva. Póngase en contacto con su administrador de contratación y solicite permiso para eliminar masivamente.",
    DeleteRequestConfirmMsg1: "¿Está seguro de que desea eliminar esta solicitud?",
    DeleteRequestConfirmMsg2: "Esta acción no se puede deshacer.",
    deleteRequestSuccess: "Se ha eliminado la solicitud",
    DeleteRequestsConfirmMsg1: "¿Está seguro de que desea eliminar estas solicitudes de {0}?",
    dueDateCollabLabel: "Fecha de vencimiento",
    requestLabel: "Solicitud",
    statusLabel: "Estado",
    inValidRequestTitleLabel: "Las siguientes solicitudes no se pueden eliminar en el estado actual",
    bulkSendButton: "Enviar",
    bulkDeleteButton: "Borrar",
    commentSyncFailedRetry: "No se pudo entregar el comentario en EY Canvas Client Portal.",
    commentSyncFailedRetrySendAgain: "Enviar de nuevo.",
    commentDeleted: "Este mensaje se ha eliminado.",
    CommmentDeletionSyncFailed: "No se pudo eliminar el comentario del portal de cliente de EY Canvas",
    clickLabel: "Clic",
    toRetry: "Volver a intentarlo.",
    replySyncFailedRetry: "No se pudo entregar la respuesta en EY Canvas Client Portal.",
    quickFilterPriority: "Prioridad",
    quickFilterErrorCounterTooltip: "Una o más solicitudes tiene un error y requiere atención.",

    eyContactNoResultsFound: "Usuario no encontrado",
    eyContactClear: "Limpiar",
    eyContactSearch: "Buscar",
    eyContactCollaboration: "Contacto EY",
    eyParticipantsCollaboration: "Participantes de EY",
    externalParticipantsCollaboration: "Participantes externos",
    syncInProgressEYContact: "Sincronización en curso",
    syncErrorEyContact: "Error de sincronización. Inténtelo de nuevo.",
    noAssignedContact: "Sin contacto asignado",
    noAssignedParticipant: "No se agregaron participantes",

    commentsTooltipLabel: "Comentarios",
    recordingVirusScanInProgress1: "Análisis de virus en curso. La nota de voz estará disponible una vez completada.",
    screenrecordVirusScanInProgress1: "Análisis de virus en curso. La grabación de pantalla estará disponible una vez completada.",
    recordingVirusScanInProgress2: "Actualice la página e inténtelo de nuevo.",
    confidentialDocumentsModalTitle: "Documentos confidenciales",
    confidentialDocumentsModalMsg1: "Se han añadido a la solicitud el (los) siguiente(s) documento (s) confidencial (es).",
    confidentialDocumentsModalMsg2: "Al hacer clic en Continuar, usted confirma que tiene el nivel de confidencialidad adecuado para enviar el documento al Portal de Cliente EY Canvas y que ha revisado la asignación de la solicitud.",
    confidentialDocumentsModalMsg3: "Usted no tiene el nivel de confidencialidad apropiado para enviar uno o más de estos documentos al Portal de Cliente EY Canvas. Elimine cualquier documento confidencial al que no tenga acceso para continuar.",
    confidentialityLevel: "Nivel de confidencialidad",
    voiceNoteUploadError: "Error al obtener los detalles del documento. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    requestEventTitle: "Evento",
    noTaskDescription: "Sin descripción de la tarea",

    newRequestLabel: "Nueva solicitud",
    newEventLabel: "Nuevo evento",

    //Analytics Tab
    analyticsCreateDateLabel: "Fecha de Creación:",
    createdByLabel: "Creado por:",
    expirationDateLabel: "Fecha de caducidad:",
    sharedWithLabel1: "Compartido con",
    sharedWithLabel2: "requerimientos",
    sharedWithLabel3: "Requerimiento",
    analyticsTabTitle: "Análisis",
    analyticsTabSubtitle: "Comparta análisis con los clientes de los proyectos conectados de EY Helix. Para empezar, cree una consulta de cliente desde el panel de marcadores en",
    analyticsTabSubtitle2: "EY Helix",
    analyticsTabSubtitle3: '.',
    noActiveAnalyticsLabel: "No se han seleccionado análisis",
    noActiveAnalyticsSubtitleLabel1: "No se han creado análisis. Clic",
    noActiveAnalyticsSubtitleLabel2: "aquí",
    noActiveAnalyticsSubtitleLabel3: " para empezar.",
    noActiveAnalyticsSubtitleLabel4: "Después de vincular un proyecto y guardar marcadores en EY Helix, regrese a esta página para obtener una vista previa de los análisis que se pueden compartir en EY Canvas Client Portal.",
    selectAnalyticsLabel: "Seleccionar análisis",
    analyticsNoPrimaryHelixProjectsMessage: "Este compromiso no está vinculado a un proyecto principal de EY Helix",
    selectAnalyticsModal: {
        closeTitleTip: "Cerrar",
        modalTitle: "Seleccionar analítica",
        modalHeader: "Seleccionar un analítico para compartirlo con miembros externos del equipo",
        selectAnalyticPlaceholder: "Seleccionar analítica",
        selectAnalyticError: "Se requiere analítica",
        analyticNamePlaceholder: "Introduzca el nombre analítico (obligatorio)",
        analyticNameError: "Se requiere un nombre analítico",
        cancel: "Cancelar",
        viewPreview: "Ver analítica",
        noPreviewAvailable: "No hay vista previa disponible",
        noPreviewDescription: "Seleccione un analizador para habilitar la vista previa",
        clickPreviewAnalytic: "Haga clic para obtener una vista previa del análisis seleccionado",
        documentObservation: {
            label: "Documenta cualquier observación o consulta sobre el analítico seleccionado",
            placeHolderLabel: "Introduzca observación o consulta (opcional)"
        }
    },
    viewAnalyticsModal: {
        closeTitleTip: "Cerrar",
        observationFieldPlaceholder: "Observaciones o consultas sobre el análisis seleccionado",
        noObservationField: "No existen observaciones ni consultas para este análisis.",
        appliedFiltersLabel: "Filtros aplicados",
        appliedFilters: [{
                id: '1',
                label: "Moneda de análisis"
            },
            {
                id: '2',
                label: "Código de moneda"
            },
            {
                id: '3',
                label: "Redondeo de pantalla"
            },
            {
                id: '4',
                label: "Grupo de unidades de negocio"
            },
            {
                id: '5',
                label: "Unidad de negocio"
            },
            {
                id: '6',
                label: "Tipo de cuenta Primaria"
            },
            {
                id: '7',
                label: "Subtipo de cuenta Primaria"
            },
            {
                id: '8',
                label: "Clase de cuenta Primaria"
            },
            {
                id: '9',
                label: "Subclase de cuenta Primaria"
            },
            {
                id: '10',
                label: "Nombre de la cuenta Primaria"
            },
            {
                id: '11',
                label: "Designación de la cuenta Primaria de EY"
            },
            {
                id: '12',
                label: "Cuenta Primaria de EY"
            },
            {
                id: '13',
                label: "Unidad de negocio"
            },
            {
                id: '14',
                label: "Fecha de análisis"
            },
            {
                id: '15',
                label: "Fecha comparativa"
            },
            {
                id: '16',
                label: "Grupo Segmento 01"
            },
            {
                id: '17',
                label: "Grupo Segmento 02"
            },
            {
                id: '18',
                label: "Grupo Segmento 03"
            },
            {
                id: '19',
                label: "Grupo Segmento 04"
            },
            {
                id: '20',
                label: "Grupo Segmento 05"
            }
        ],
        save: "Guardar",
        cancel: "Cancelar",
        disabledEdit: "La observación no se puede editar porque la solicitud ya se ha enviado al Portal de cliente de EY Canvas. Retire la solicitud para habilitar esta acción.",
        errors: {
            unautorizedUser: "Usted no es un miembro autorizado del equipo del proyecto EY Helix relacionado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso e intentarlo de nuevo.",
            bookmarkNotFound: "Se ha eliminado el estudio analítico seleccionado. Vaya a EY Helix para administrar análisis eliminados o para crear un nuevo análisis.",
            unautorizedAccessToBookmark: "No tiene acceso al marcador EY Helix solicitado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso e intentarlo de nuevo.",
            authenticationError: "Error de autenticación. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
            genericError: "Actualice la página y vuelva a intentarlo. Póngase en contacto con mesa de ayuda si el error persiste.",
            defaultError: "{0} Actualice la página e inténtelo de nuevo. Póngase en contacto con mesa de ayuda si el error persiste."
        }
    },
    deleteAnalyticModal: {
        modalTitle: "Eliminar analítica",
        modalHeader: "¿Está seguro de que desea eliminar este análisis? El análisis ya no estará disponible en EY Canvas."
    },
    // activity feed
    search: "Buscar",
    searchTeams: "Buscar equipo",
    clear: "Claro",
    groupActivityLabel: "Actividad de grupo",
    documents: "Documentos",
    documentLabel: "Documento",
    linkRequests: "Enlace de solicitudes",
    received: "recibido",
    returned: "Devuelta",
    rejected: "rechazado",
    accepted: "aceptado",
    sent: "enviado",
    unlinked: "Desvinculado",
    finalized: "Finalizado",
    groupActivityFeed: "Fuente de actividades de grupo",
    component: "componente",
    noExternalApprovalsMessage: "No hay aprobaciones externas",
    noFileSelectedMessage: "Seleccionar un documento para ver los detalles",
    noInstructionSelectedMessage: "Seleccione un elemento para ver los detalles.",
    noLinkRequestSelectedMessage: "Seleccione un elemento para ver los detalles.",
    noItemSelectedMessage: "Seleccionar un elemento para ver los detalles",
    viewGroupActivity: "Ver actividad de grupo",
    pointOfContact: "Punto de contacto",
    currentStatus: "Estado actual",
    resolved: "resuelto",
    viewVersion: "Ver versión",

    // activity feed right pane headings
    scope: "alcance",
    groupRole: "Rol de grupo",
    linkRequestStatus: "Estado de la solicitud del enlace",
    instructionStatus: "Estado de la instrucción",
    linkStatus: "Estado del enlace",
    today: "Hoy",
    yesterday: "Ayer",
    thisWeek: "Esta semana",
    lastWeek: "La semana pasada",
    twoWeeksAgo: "Hace dos semanas",
    threeWeeksAgo: "Hace tres semanas",
    lastMonth: "El mes pasado",
    older: "más antiguo",
    actionsDateNote: "Todas las fechas y horas se notifican en horario GMT.",
    noActionsMessage: "No hay datos que mostrar.",
    noManageRequestPermissionMessagePart1: "Debe tener permisos <b>Manage service request</b> para realizar esta acción.",
    guidedWorkflow: "Habilitación de EY Canvas FIT",
    navExecution: "Ejecución",
    navCanvasEconomics: "EY Canvas Economics",
    navOversight: "Supervisión de EY Canvas",
    navConclusion: "Conclusión",
    navTeamMemberIndependence: "Independencia de los miembros del equipo",
    navGroupAudit: "Gestión de grupos",
    navGroupActivityFeed: "Fuente de actividades de grupo",
    navPrimaryStatus: "Estado principal",
    navComponentStatus: "Estado del componente",
    navGroupStatus: "Estado del grupo",
    navEngagementManagement: "Gestión del compromiso",
    navProfile: "Perfil",
    navGroupStructureSummary: "Estructura de grupo",
    OpenGuidedWorkflowDocument: "Abra este documento a través de la habilitación EY Canvas FIT",
    navNotApplicable: "No aplicable",
    canvasForms: "Formularios de canvas",
    eYCanvasEconomics: "EY Canvas Economics",
    overDueAssignments: "Asignaciones vencidas",
    comingDueAssignments: "Asignaciones de vencimiento",
    overDueReviewNotes: "Notas de revisión vencidas",
    comingDueReviewNotes: "Notas de revisión de vencimiento",

    //Group Audit/Status  for DashboardV2

    Reportingformsbystatus: "Formularios de informes por estado",
    ReportingStatusSubTitle: "Vea las tareas de grupo asignadas a los equipos de componentes a continuación, así como un resumen de los documentos de grupo recibidos por estado. <br/> Puede seleccionar revisar el progreso detallado por equipo o por tarea de grupo.",

    Total: "Total",
    Returned: "Devuelto",
    Overdue: "Atrasado",
    PendingResponse: "Pendiente de respuesta",
    Received: "Recibido",
    ReadyForReview: "Listo para revisión",
    messageNoDocument: "Aún no se han recibido documentos.",
    byTeam: "Por equipo",
    byGroupTask: "Por tarea de grupo",
    groupStructureLabel: "Estructura del grupo",
    instructionPending: "Instrucciones pendientes de aceptación",
    linkRequestPending: "Solicitud de enlace pendiente",
    notusingeycanvas: "No usará EY Canvas",
    pendingLabel: "Pendiente",
    teams: "Equipos",
    NoDocumentReceiced: "Aún no se han recibido documentos.",
    selectTeamToSeeData: "No hay datos disponibles. Seleccione un equipo para ver los datos aquí.",
    noDataAvailable: "No hay datos disponibles.",
    prepared: "Preparado",
    tasksAssigned: "Tareas asignadas",
    taskAssigned: "Tarea asignada",
    instructionNotSent: "Instrucciones no enviadas",
    assignedTeamNotProvidedDocForTasks: "\{0}\ los equipos no han enviado documentos para estas tareas | \{1}\ documentos esperados",
    documentRecievedOutOfAssignedTasks: "Documentos recibidos <br> <b> \ {0} \ </ b> OUT OUT \ {1} \ Tareas asignadas",
    documentRecievedOutOfAssignedTeams: "Documentos recibidos <br> <b> \ {0} \ </ b> Fuera de \ {1} \ Equipos asignados",

    groupStatusSubTitle: "Vea las tareas de grupo asignadas por el equipo primario a continuación, así como un resumen de los documentos de grupo por estado. <br/> Puede seleccionar filtrar las tareas de grupo por tarea o estado del documento.",
    notSent: "No enviado",
    draftsent: "Borrador enviado",
    finalsent: "Enviado final",
    noTaskForComponent: "No hay datos disponibles. <p> Las tareas de grupo enviadas desde el equipo principal se mostrarán aquí después de que hayan sido aceptadas.</p>",
    noTaskForComponentWithStatus: "No hay datos disponibles. <p> Seleccione una o más opciones de status para ver los datos aquí.</p>",

    //Dashboard V2 - activity feed
    activityFeedSubHeadingText: "Seleccione un tipo de actividad para revisar la actividad de participación relevante de los últimos 10 días. <br/> Haga clic en el icono <b>De actividad</b> de un elemento específico para ver toda la actividad de ese elemento. <br/> También puede usar el interruptor para refinar su vista.",
    activityFeedSubHeadingGroupAudit: "Seleccione un tipo de actividad para revisar la actividad de participación relevante de los últimos 10 días. <br/> Haga clic en el icono <b>De actividad</b> de un elemento específico para ver toda la actividad de ese elemento. <br/> También puede usar el interruptor para refinar su vista.",
    teamHistoryInstructionalText: "Revise la actividad de este equipo durante los últimos 10 días.",
    teamHistory: "Historia del equipo",
    onlySeeMyActivity: "Ver solo mi actividad",

    taskAddedBy: "Tarea agregada por",
    taskMarkedCompleteBy: "Tarea marcada como completada por",
    taskUnmarkedCompleteBy: "Tarea no marcada completada por",
    taskHandedOffBy: "Tarea entregada por",
    assignmentAddedBy: "Asignación agregada por",
    assignmentEditedBy: "Asignación editada por",
    assignmentClosedBy: "Asignación cerrada por",
    assignmentReOpenedBy: "Asignación reabierta por",
    assignmentDeletedBy: "Asignación eliminada por",
    noteAddedBy: "Nota añadida por",
    noteClearedBy: "Nota borrada por",
    noteClosedBy: "Nota cerrada por",
    noteReopenedBy: "Nota reabierta por",

    linkRequestSent: "Solicitud de enlace enviada por",
    instructionSentBy: "Instrucciones enviadas por",
    linkRequestAcceptedBy: "Solicitud de enlace aceptada por",
    engagementUnlinkedBy: "Compromiso desvinculado por",
    instructionAcceptedBy: "Instrucciones aceptadas por",
    instructionReturnedBy: "Instrucciones devueltas por,",
    labelTo: "Para",
    instructionReceivedFrom: "Instrucciones recibidas de",
    filtersLabel: "Filtros",
    advanceOptions: "Operaciones masivas",
    advanceOptionsLabel: "Operaciones masivas",
    relatedScots: "SCOTs relacionados",
    noRelatedScots: "No hay SCOTs relacionados",
    materialityLabel: "Materialidad",
    currentPeriod: "Fecha actual",
    previousPeriod: "Fecha previa",
    showCurrentPeriod: "Mostrar la fecha actual",
    showPriorPeriod: "Mostrar fecha anterior",
    planningMateriality: "Materialidad de la planificación",
    tolerableError: "error tolerable",
    sadNominalAmount: "Importe nominal del SAD",
    pmLabel: "MP",
    teLabel: "TE",
    sadLabel: "SAD",
    accountBalance: "Saldo de la cuenta",
    mapAccountBalances: "Mapear saldos de cuentas",
    connectToHelixProject: "Conectar con un proyecto Helix",
    connectToImportBalances: "para importar saldos",
    helixMultiple: "Múltiple",
    selectMESTentity: "Seleccione una entidad para ver los detalles",
    relatedWCGWAndControls: "WCGW y controles relacionados",
    relateAtLeastOneWCGW: "Cada aseveración con un riesgo de control de Confianza debe tener al menos un WCGW relacionado.",
    notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
    relatedITProcesses: "Procesos de TI relacionados",
    noRelatedITProcesses: "No hay procesos de TI relacionados",
    relatedITRiskITGCs: "Riesgos de TI relacionados, ITGC e ITSP",
    relatedITRisks: "Riesgos de TI relacionados",
    ALRAHigherRiskCode: "H",
    materialityMestSelectEntity: "Seleccione una entidad para ver los detalles",
    OARCurrentPeriod: "Fecha de análisis",
    OARComparative1Period: "Fecha comparativa 1",
    xTELabel: "xTE",
    priorPeriodDesignation: "Designación del período anterior:",
    priorPeriodEstimate: "Estimación del período anterior:",
    notApplicableAbbreviation: "N/A",
    accountDetails: "Detalles de la cuenta",
    launchGuidedWorkflow: "Iniciar Flujo de Trabajo Guiado",
    guidedWorkflowTitle: 'Guided workflow',
    viewAccountBalace: "Ver los saldos de las cuentas",
    viewAccountBalaceForEntity: "Seleccione una entidad para ver los saldos de las cuentas",
    mainActivities: "Principales actividades",
    oversightProjectTile: {
        typeOversight: "supervisión",
        createProject: "Crear proyecto",
        oversightProjectengagementNotConnectedMessage1: "La aplicación de supervisión de EY Canvas resume el progreso de los milestones, la gestión de proyectos  y la auditoría de grupo para los compromisos vinculados. Úselo para asegurarse de que la auditoría de su grupo o la cartera de compromisos esté bien encaminada.",
        oversightProjectengagementNotConnectedMessage2: "Su compromiso no está conectado a ningún proyecto de supervision de EY Canvas.",
        click: "Clic",
        togetstarted: "para empezar",
        clickProjectmessage: "Haga clic en <b>+ Crear proyecto </b> para iniciar.",
        lblclient: "Clientes:",
        lblEngagementCount: "Compromisos:",
        lblTaskscompleted: "Tareas completadas:",
        lblMore: "más",
        myProject: "Mis proyectos",
        OtherProject: "Otros proyectos",
        oversightNoProjectConnectedMessage: "No eres miembro de ninguno de los proyectos de supervisión de  EY Canvas a los que está conectado tu compromiso.",
        oversightOtherProjectNotConnectedMessage: "Eres miembro de todos los proyectos de supervision de EY Canvas a los que está conectado tu compromiso.",
        draft: "Borrador",
        allTask: "Todas las tareas",
        totalTask: "Tareas totales"
    },

    economicsProjectTile: {
        typeEconomics: "ciencias económicas",
        economicsProjectengagementNotConnectedMessage1: "La Aplicación Económica de Ey Canvas resume el progreso de los lienzos financieros y ey. Úselo para administrar la economía para su cartera de compromisos.",
        economicsProjectengagementNotConnectedMessage2: "Su compromiso no está conectado a los proyectos de Economía de Canvas Ey.",
        clickProjectmessage: "Haga clic en <b>+ Crear proyecto </b> para iniciar.",
        economicsNoProjectConnectedMessage: "Usted no es miembro de ninguno de los proyectos de Eycomics Economics para que su compromiso está conectado.",
        lblForecasted: "Pronosticado:",
        lblActual: "Real:",
        lblETC: "Etc.",
        lblVariance: "Diferencia"
    },
    leftNavigation: {

        engagementOverview: "Visión general del compromiso",
        myProgress: "Mi progreso",
        executiveTasks: "Áreas de enfoque",
        integration: "Integración",
        groupAudit: "Estado del grupo",
        pinnedDocuments: "Documentos fijados",
        Validations: "Validaciones",
        activityFeed: "Alimentación de actividad",
        primaryStatus: "Estado primario",
        componentStatus: "Estado del componente",
        picProgress: "Progreso del PIC",
        picEQRProgress: "Progreso de PIC/EQR",
        drillDown: "Desglose",
        maps: "Mapas",
        financialStatement: "Estados financieros"
    },
    nowRowOverlayClientRequest: {
        createNew: "Haga clic en Agregar solicitud para crear una nueva solicitud",
        all: "No se han creado solicitudes.",
        draft: "No hay solicitudes en el estado de borrador",
        pending: "No hay solicitudes en estado pendiente de respuesta",
        received: "No se han recibido solicitudes.",
        accepted: "No se han aceptado solicitudes.",
        customFilter: "No se encontraron coincidencias. Inténtelo de nuevo."
    },

    clientRequestPrefixes: {
        draft: "Borrador",
        returned: "Devuelto",
        recalled: "Recordado",
        withdrawn: "Retirado"
    },

    clientRequestsTabHeader: {
        all: "Todo",
        draft: "Borrador",
        pending: "Pendiente",
        received: "Recibido",
        accepted: "Aceptado"
    },

    clientRequestsPriorityFilters: {
        all: "Todo",
        normal: "Normal",
        high: "Alta",
        critical: "Crítica",
        highAndCritical: "Alta + crítica"
    },

    requestTableHeader: {
        requestId: "ID de solicitud",
        title: "Título",
        receivedDate: "Fecha recibida",
        dueDate: "Fecha límite",
        sentDate: "Fecha enviada",
        acceptedDate: "Fecha de aceptación",
        assignedTo: "Asignado a",
        group: "Grupo",
        status: "Estado",
        priorityType: "Prioridad",
        tags: "Etiquetas"
    },

    dropdownColumnsFilter: {
        1: "Asignado a",
        2: "Grupo",
        3: "Fecha de vencimiento",
        4: "Fecha de envío",
        5: "Fecha de recepción",
        6: "Fecha de aceptación",
        7: "Status",
        8: "Prioridad",
        9: "Etiquetas"
    },

    requestTableDropdownFilter: {
        customizeTable: "Personalizar tabla",
        selectInfo: "Seleccione hasta 4 opciones",
        selectInfoTooltip: "Seleccione hasta cuatro columnas. Desmarque una o más opciones para continuar."
    },

    ClientStatus: {
        1: "Borrador",
        2: "Borrador - Sin contacto",
        3: "Enviado",
        4: "Error del sistema",
        5: "Contacto de cliente no válido",
        6: "Respuesta pendiente",
        7: "Recibido",
        8: "Aceptado",
        9: "Devuelto",
        10: "Retirado",
        11: "Enviar en curso",
        12: "Aceptar en curso",
        13: "Retirada en curso",
        14: "Eliminar en curso",
        15: "Regreso en curso",
        16: "Respuesta en curso",
        17: "Eliminado",
        18: "Contacto de cliente no válido",
        19: "Retirada en tránsito",
        20: "Recuperado",
        21: "Finalización en curso",
        22: "Retirada en curso"
    },

    analyticStatus: {
        1: "Borrador",
        2: "Pendiente de aprobación",
        3: "Aprobado",
        4: "Caducado"
    },

    paginationControl: {
        firstPage: "Primera página",
        lastPage: "Última página",
        previousPage: "Página anterior",
        nextPage: "Página siguiente",
        show: "Mostrar"
    },

    auditPlanFilterLabels: {
        showMore: "más",
        filterTypeOfScots: "SCOT",
        noScotsAvailable: "No hay SCOTs disponibles",
        filterTypeOfITProcess: "Proceso de IT",
        noITProcessAvailable: "No hay procesos IT disponibles"
    },

    controlListBuildStep4FilterLabels: {
        scots: {
            filterTypeOfScots: "SCOTs",
            noScotsAvailable: "No hay SCOTs disponibles"
        },
        testing: {
            filterTypeOfTesting: "Pruebas",
            noTestingAvailable: "No hay pruebas disponibles"
        },
        designEffectiveness: {
            filterTypeOfDesignEffectiveness: "Efectividad del diseño",
            noDesignEffectivenessAvailable: "No hay efectividad de diseño disponible"
        },
    },

    clientRequestsFilterLabels: {
        filterAssignedTo: "Asignado a",
        filterAttachmentsLabel: "Tipo de archivo adjunto",
        filterCreatedByLabel: "Creado por",
        filterStatusLabel: "Estado",
        filterDueAfterLabel: "Vencimiento después",
        filterDueBeforeLabel: "Vencimiento antes",
        filterErrorsLabel: "Errores",
        filterOverdueLabel: "Atrasado",
        filterTagLabel: "Etiqueta",
        filterTimePhaseLabel: "Fase de tiempo",
        filterTypeLabel: "Tipo",
        filterPriorityLabel: "Prioridad",
        searchMembers: "Buscar miembros",
        noTags: "No se han creado etiquetas",
        noTimephase: "Sin fase de tiempo",
        clearAll: "Resolver todo",
        clearHoverText: "Resuelto",
        noResultsFound: "No se han encontrado resultados",
        yes: "Sí",
        no: "No",
        showMore: "Mostrar más",
        // Check this
        filterNoMatchesFound: "No se encontraron coincidencias. Inténtelo de nuevo.",
        filter: "Filtro",
        title: "Filtros",
        noRelatedTask: "No hay tarea relacionada"
    },
    //Dashboard - integration

    collaborationInstruction: "Vea sus solicitudes de colaboración por estado a continuación. <br/> Haga clic en un recuento para navegar a la lista de solicitudes con filtros aplicados.",
    noValidationsAvailable: "No hay validaciones para esta fase de auditoría.",
    individualView: "Vista individual",
    engagementView: "Vista del compromiso",
    centralizedServiceInstruction: "Vea el porcentaje de tareas que aprovechan los servicios centralizados, así como las solicitudes por estado a continuación. <sección >Para crear una nueva solicitud, seleccione <b>Solicitar servicios.</b></section>",
    // Dashboard - todo list
    todoList: "Lista de tareas pendientes",
    todoListInProgress: "Actual",
    todoListOpen: "Próximo",
    todoListClosed: "Completado",
    todoListInstruction: "Vea las tareas y revise las notas que vencen por estado. <br /> Seleccione un período de tiempo o una categoría para refinar la vista. <br /> Para abrir un elemento, haga clic en el nombre de la tarea o de la nota de revisión.",
    noOpenAssignments: "No tiene ninguna asignación abierta.",
    noInProgressAssignments: "No tiene ninguna asignación en curso.",
    noClosedAssignments: "No tiene ninguna asignación cerrada.",
    allLabel: "Todo",
    dueLabel: "Vencimiento",
    noAssignments: "No tiene ninguna asignación.",
    executiveReview: "Revisión ejecutiva",
    epTasksStatusSignOffWithoutDetails: "Vea un resumen del estado de PIC a continuación.",
    epTasksStatusSignOff: "Vea un resumen del estado de PIC a continuación. Para obtener una vista detallada, seleccione <b>Ver detalles</b>.",
    epeqrTasksStatusSignOffWithoutDetails: "Vea un resumen del estado de PIC y EQR a continuación.",
    epeqrTasksStatusSignOff: "Vea un resumen del estado de PIC y EQR a continuación. Para obtener una vista detallada, seleccione <b>Ver detalles</b>.",
    eqrDefaultMessage: "Este compromiso no requiere un EQR.",
    selectPartners: "Seleccione un socio",
    noPartnersInEng: "No hay socios en su compromiso.",
    epTasks: "Tareas de PIC",
    eqrTasks: "Tareas de EQR",
    viewDetails: "Ver detalles",
    picReview: "Revisión de PIC",
    eqrReview: "Revisión de EQR",
    eqrtasksWithSignOff: "Tareas con EQR <br/> firmas incompletas",
    eqrdocumentsWithSignOff: "Documentos con EQR <br/> firmas incompletas",
    pictasksWithSignOff: "Tareas con firmas PIC <br/> incompletas",
    picdocumentsWithSignOff: "Documentos con firmas PIC <br/> incompletas",
    partnerSignoffs: "Aprobaciones de socios",
    epTaskswithpartnersignoffs: "Haga clic en un recuento para navegar a la lista de tareas con filtros aplicados.",
    allDocssignedoff: "Todos los documentos <br/>firmados",
    someDocssignedoff: "Algunos documentos <br/>firmados",
    noDocssignedoff: "Sin documentos <br/>firmados",
    partnernotinvited: "Socio no invitado",
    noEQRsinyourengagement: "No hay EQR en su compromiso.",
    selectEQRs: "Seleccione un EQR",
    eqrNotinvited: "EQR no invitado",
    eqrsignoffs: "Aprobaciones de EQR",
    eqrtaskswithpartnersignoffs: "Haga clic en un recuento para navegar a la lista de tareas con filtros aplicados.",
    allpartners: "Todos los socios",
    allEQRs: "Todos los EQR",
    reviewComments: "Notas de revisión",
    noOpenReviewComments: "No tiene ninguna nota de revisión abierta.",
    noClearedReviewComments: "No tiene ninguna nota de revisión autorizada.",
    noClosedReviewComments: "No tiene ninguna nota de revisión cerrada.",
    noReviewCommentsForSelectedTime: "No tiene ninguna nota de revisión para el período de tiempo seleccionado. Seleccione otro período de tiempo para continuar.",
    picTasksSomeDocSignOff: "Tareas con algunos documentos firmados por el PIC",
    picTasksNoDocSignOff: "Tareas sin documentos firmados por el PIC",
    eqrTasksSomeDocSignOff: "Tareas con algunos documentos firmados por EQR",
    eqrTasksNoDocSignOff: "Tareas sin documentos firmados por EQR",
    picNotIdentified: "No se ha identificado ningún PIC",
    eqrNotIndentified: "No se ha identificado ningún EQR",
    todoReviewNote: "Nota de revisión",

    // Dashboard - Executive Tasks
    executiveTasks: "Áreas de enfoque",
    executiveTasksInstruction: "Seleccione esta opción para ver las tareas por riesgo o por cuenta a continuación. <br/> Una vez que haya realizado su selección, coloque el cursor sobre un recuento para ver más detalles o seleccione una tarea para navegar a su página de detalles específicos.",
    byRisk: "Por riesgo",
    byAccount: "Por cuenta",
    responsiveTasks: "Tareas relacionadas",
    openNotes: "Abrir notas",
    lowLabel: "Bajo",
    mediumLabel: "Medio",
    highLabel: "Alto",
    criticalLabel: "Crítico",
    epRequired: "PIC requerido",
    eqrRequired: "EQR requerido",
    noDocumentsSignedOff: "No hay documentos firmados",
    someDocumentsSignedOff: "Algunos documentos firmados",
    allDocumentsSignedOff: "Todos los documentos firmados",
    completedAssignments: "Tareas finalizadas",
    designation: "Designación",
    significantAccount: "Cuenta significativa",
    epSignOff: "Firma del PIC",
    eqrSignOff: "EQR sign-off",
    someLabel: "Alguno",
    riskNoDataLabel: "Este riesgo no se ha relacionado con ninguna tarea.",
    accountNoDataLabel: "Esa cuenta y sus aseveraciones no se han relacionado con ninguna tarea.",
    NoDataLabel: "No hay datos disponibles para el acordeón seleccionado",
    // Manage tags
	manageTagsInstructionalText: "Crea nuevas etiquetas aquí.También puede editar y eliminar etiquetas existentes.Las solicitudes de etiquetado pueden mejorar la organización de su compromiso y la gestión de proyectos.",
    noTagsAdded: "No se han añadido etiquetas. Cree una etiqueta para comenzar.",

    // Client Request Comments
    noCommentsCreatedYet: "No se han creado comentarios.",
    addCommentTitleTip: "Agregar comentario",
    addReplyTitleTip: "Agregar respuesta",
    addAComment: "Deja un comentario…",
    addAReply: "Añadir una respuesta",
    deleteCommentConfirmationModalTitle: "Eliminar comentario",
    deleteCommentConfirmationModalMessage: "¿Está seguro de que desea eliminar este comentario? Todas las respuestas a este comentario también serán eliminadas.",

    // Client Request Voice Note Comment Labels
    voiceNoteCommentRecordLabel: "Nota de voz",
    voiceNoteCommentStopLabel: "Parar",
    voiceNoteCommentPlayLabel: "Reproducir",
    voiceNoteCommentDeleteLabel: "Borrar",

    //Client Request Status/Tooltip messages
    SendRequestSuccess: "La solicitud se ha enviado correctamente",
    BulkSendRequestSuccess: "{0} solicitudes se han enviado correctamente",
    BulkSendOneRequestSuccess: "1 solicitud ha sido enviada con éxito",
    SendInProgress: "Enviar en curso",
    AcceptInProgress: "Aceptar en curso",
    CompleteInProgress: "Completo en curso",
    HasErrorState: "No se pudo enviar la solicitud. Inténtalo de nuevo.",
    WithdrawRequestSuccess: "Solicitud ha sido retirada",
    WithdrawInProgress: "Retiro en progreso",
    WithdrawRequestError: "La solicitud no pudo ser retirada, inténtelo de nuevo.",
    DeleteRequestError: "No se pudo eliminar la solicitud. Actualice la página e inténtelo de nuevo.",
    AcceptRequestError: "No se ha podido aceptar la solicitud, inténtelo de nuevo.",
    CompleteRequestError: "No se pudo completar la solicitud, inténtelo de nuevo.",
    InvalidClientContact: "Contacto de cliente no válido.",
    BulkSendInvalid: "Una o más solicitudes seleccionadas no se pueden enviar sin tomar medidas adicionales. Revise e inténtelo de nuevo.",
    returnInProgress: "Volver a en progreso",
    returnRequestError: "No se ha podido devolver la solicitud, inténtelo de nuevo",

    //Client Withdraw Request
    WithdrawRequest: "petición de retiro",
    WithdrawReuestConfirmMsg: "¿Está seguro de que desea retirar esta solicitud? Una vez retirado, el cliente ya no puede verlo. La solicitud se moverá a la lista de borradores una vez completada",
    WithdrawMenuOption: "Retirar",
    MoreOptions: "Mas opciones",
    Complete: "Completo",
    WithdrawLabel: "Retirado",
    CompleteInstructionalText: "Usar Completado cuando la información ya ha sido proporcionada por el cliente",

    //Client Complete Request
    CompleteRequestConfirmMsg: "Al completar una solicitud, se elimina la solicitud de la lista de tareas pendientes del cliente y se actualiza el estado a Enviado para el cliente. La solicitud se moverá a la lista Recibidos en EY Canvas. Se puede utilizar, por ejemplo, cuando la información solicitada ya se ha recibido a través de medios alternativos.",
    CompleteRequest: "Solicitud completa",
    CompleteRequestSuccess: "La solicitud se ha completado",

    //Client Accept Return Request
    AcceptLabel: "Aceptar",
    ReturnLabel: "Devolución",
    ReturnRequest: "Solicitud de devolución",
    acceptRequest: "Aceptar solicitud",
    acceptRequestWithoutTask: "¿Está seguro de que desea aceptar la solicitud seleccionada?",
    acceptRequestWithTask: "<b>¿Está seguro de que desea aceptar la solicitud seleccionada?</b> Los documentos adjuntos estarán disponibles en la pestaña de documentos externos de la(s) tarea(s) relacionada(s) {0}.",
    acceptRequestSuccess: "La solicitud ha sido aceptada",
    returnedRequestSuccess: "La solicitud ha sido devuelta -",

    // Client Request Relate Files modal
    noRecordsFound: "No se han encontrado registros",
    relateSelected: "Relacionar seleccionado",
    relateFilesModalHeader: "Para relacionar los documentos existentes con esta solicitud, seleccione los documentos y haga clic en relacionar seleccionado.",
    relateAnalyticModalHeader: "Para relacionar el análisis existente con esta solicitud, marque la casilla del análisis seleccionado. Para obtener una vista previa de otros análisis disponibles, haga clic en",
    relateAnalyticHereModalHeader: "aquí",
    noAnalyticsRecordsFound: "No hay análisis disponibles para compartir. Haga clic",
    noAnalyticsRecordsFoundGetStarted: "Para empezar.",
    associateExistingDocumentsSelected: "Documentos agregados",
    associateExistingDocumentSelected: "Documento agregado",

    // Client Request Details Header
    timePhaseLabel: "Fase de tiempo:",
    receivedDateLabel: "Recibido:",
    dueDateLabel: "Dos:",
    sentDateLabel: "Enviado:",
    acceptedDateLabel: "Aceptado:",
    clientRequestSyncLabel: "Se están enviando actualizaciones a EY Canvas Client Portal",
    editDescriptionLabel: "Editar descripción",
    createdDateLabel: "Creado:",

    //Client Advance Search
    advancedSearch: "Búsqueda avanzada",
    advancedSearchRefereceNumberCheck: "Referencia #",
    advancedSearchTitleCheck: "Título",
    advancedSearchDocumentsCheck: "Documentos",
    advancedSearchCommentsCheck: "Comentarios",
    advancedSearchApplyButton: "Aplicar",
    searchRequest: "Buscar",
    clearSearch: "Borrar búsqueda",

    //Adjustment Topup module
    adjustmentModule: {
        currencyType: "Tipo de moneda",
        currencyCode: "Código de moneda",
        businessUnit: "Unidad de negocio",
        all: "Todo",
        moduleName: "Módulo de ajuste",
        financialStatement: "Estados financieros",
        viewByTrialBalanceType: "Visualización por tipo de balance de comprobación",
        multiEntry: "Multientidad",
        balanceSheet: "Balance General",
        incomeStatement: "Estado de resultados",
        currentperiodUnadjusted: "Analysis date",
        unadjusted: "(sin ajustar)",
        currentperiodAdjusted: "Analysis date",
        adjusted: "(ajustado)",
        adjustment: "Ajuste",
        newAdjustment: "Nuevo ajuste",
        noRecordsFound: "No se han encontrado registros",
        periodEnded: " Fecha de finalización",
        periodsEnded: " Fechas finalizadas",
        noResultsFound: "No se han encontrado resultados",
        notApplicableAbbreviation: "N/A",
        noAdjustmentCreated: "No se ha creado ningún ajuste.",
        createAdjustment: "Crea un {0}.",
        next: "Página siguiente",
        previous: "Página anterior",
        reclassification: "Reclasificación",
        manageAdjustment: "Gestionar ajustes",
        lastPage: "Última página",
        firstPage: "Primera página",
        filterYes: "Sí",
        filterNo: "No",
        showOnlyAdjustedAccountClasses: "Mostrar solo las clases de cuenta ajustadas",
        noneAvailable: "Ninguno disponible",
        noImportedTrialbalanceAvailable: "No hay balance de comprobación importada.",
        trialBalanceRequired: "Balance de comprobación",
        comparativeperiodUnadjusted: "Fecha comparativa",
        comparativeperiodAdjusted: "Fecha comparativa",
        multityEntityRequired: "Multientidad",
        placeHolderMessageWhenHelixMappingIsTrue: "No hay balance de comprobación importada. Haga clic en {0} para relacionar un nuevo analizador.",
        placeHolderMessageWhenHelixMappingIsFalse: "La integración con EY Helix no está disponible. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
        eyHelixIntegrationLinkText: "Conexiones EY Helix",
        noEntitiesAvailablePlaceholder: "No se han creado entidades. Cree entidades para empezar.",
        search: "Buscar",
        viewAdjustmentWithValidations: "Ver ajustes con validaciones ({0})",
    },

    misstatementLabels: {
        name: "Nombre",
        notes: "Notas",
        signOffs: "Firmas",
        open: "Abrir",
        openReadOnly: "Abrir solo lectura",
        delete: "Borrar",
        rename: "Renombrar",
        signOffRequirements: "Requisitos de aprobación",
        confidentiality: "Confidencialidad",
        unlink: "Desvincular",
        removeFromAdjustment: "Quitar del ajuste"
    },

    allControls: "Todos los controles",
    //Client Request Document labels
    clientRequestDocuments: {
        externalDocuments: "Externo",
        taskDocuments: "Documentos",
        deletedDocuments: "Borrado",
        priorPeriodDocuments: "Año anterior",
        priorPeriodInfoMessage: "Estos documentos no se pueden descargar",
        uploadedBy: "subido por",
        deletedBy: "Eliminado por",
        lastModifiedBy: "Ultima modificacion por",
        eyBadge: "Eliminado de documentos",
        externalBadge: "Eliminado de Externo",
        uploadInProgress: "Carga en curso",
        refreshdocuments: "Actualizar documentos",
        disabledDocument: "No se permiten operaciones masivas para este tipo de documento.",
        menuOptions: {
            delete: "Borrar",
            open: "Abierto",
            openr: "Abierto solo lectura",
            restore: "Restaurar",
            remove: "Eliminar",
            rename: "Renombrar",
            editInHelix: "Editar en EY Helix"
        },
        externalPriorPeriod: "Cliente",
        eyPriorPeriod: "EY",
        uploadedByEY: "EY"
    },

    //Client Request Assigned To Errors
    clientRequestAssignedToErrorLabel: "El usuario o grupo asignado no es válido. Actualice la asignación para continuar. Clic",
    clientRequestAssignedToErrorLabelEnd: "para editar miembros externos del equipo.",
    clickHereLabel: "aquí",
    clientRequestAssignedToIconErrorLabel: "El grupo asignado no tiene miembros activos. Asigne la solicitud a un usuario/grupo activo o agregue miembros al grupo para continuar.",
    clientRequestDueDateErrorLabel: "Se requiere fecha de vencimiento. Actualice la fecha de vencimiento para continuar.",

    clientRequestDocumentsNoDocsFound: [{
            id: 'externalDocuments',
            label: "No se han añadido documentos externos"
        },
        {
            id: 'taskDocuments',
            label: "Arrastre y suelte uno o más documentos o haga clic en Agregar documento"
        },
        {
            id: 'deletedDocuments',
            label: "No se ha eliminado ningún documento"
        },
        {
            id: 'searchRequestDocuments',
            label: "No se encontraron coincidencias, intente nuevamente"
        },
        {
            id: 'priorPeriodDocuments',
            label: "No se dispone de documentos de años anteriores"
        }
    ],

    liveNotifications: {
        "ey.at.hercules.annotation.created": "Anotación creada",
        "ey.at.hercules.annotation.edited": "Anotación editada",
        "ey.at.hercules.annotation.replied": "Anotación respondida",
        "ey.at.hercules.contentupdate.updated": "Contenido actualizado",
        "ey.at.hercules.contentupdate.failed": "Error en la actualización de contenido"
    },

    //Assign to
    usersOption: "Usuarios",
    externalUsersOption: "Usuarios externos",
    groupsOption: "Grupo",
    lblassignedto: "Asignado a",
    searchGroup: "Grupo de búsqueda",
    requiredAssignedTo: "Se requiere asignado a",
    rdSubmitRequest: "Enviar peticion",

    closeDrawer: "Cerrar y anular la selección de todos",
    requestSelected: "solicitud seleccionada",
    requestsSelected: "solicitudes seleccionadas",
    //GA Scopes labels
    engagementScopesAndCustomSubScopes: "Alcance de compromiso y subalcance personalizados",
    defineGroupScopes: "Definir alcance  de grupo",
    gaScopeIntro: "Los ámbitos de participación por EY GAM se incluyen aquí de forma predeterminada. Si necesita personalizar las tareas de grupo y las instrucciones para los equipos que comparten el mismo ámbito, considere la posibilidad de crear un subámbito. Al enviar instrucciones, podrás enviar diferentes versiones a cada subámbito.",
    addSubScope: "Agregar subalcance",
    customSubScope: "Subalcance personalizado",
    noCustomSubscopes1: "No hay subalcances personalizados para este compromiso en alcance.",
    noCustomSubscopes2: "Seleccione <b>Agregar sub alcance  <b> para comenzar.",
    subScopeName: "Nombre del subalcance",
    addDescription: "Añadir descripción",
    textExceedsLength500: "El texto no puede superar los 500 caracteres.",
    manageGroupPermission: "Debe tener permiso <b> administrar grupo </ b> para tomar esta acción. Hable con un administrador de compromiso para solicitar permiso.",
    deleteCustomSubScope: "Eliminar sub-alcance personalizado",
    areYouSureDeleteCustomSubScope: "¿Está seguro de que desea eliminar este sub-alcance personalizado?",

    //GA Component labels
    newTeam: "Nuevo equipo",
    teamName: "Nombre del equipo",
    legalEntityName: "Nombre de entidad legal",
    parentTeam: "Equipo de padres",
    isReferenceOnly: "Solo referencia",
    isNotUsingCanvas: "Equipo no esta usando EY Canvas.",

    referenceOnlyTooltip: "Los equipos designados como <b> referencia solo </ b> no recibirán solicitudes de enlace, instrucciones o tareas. Se utilizan solo para fines organizacionales.",

    canvasFormNotOwnedByEng: "Los formularios de Canvas compartidos que no son propiedad de este compromiso no se pueden enviar al portal de cliente de EY Canvas. Haga una copia del formulario en este compromiso si necesita enviarlo o envíelo desde el compromiso de origen.",
    canvasFormNotAllowedInCtry: "Compartir formularios de Canvas con clientes no está disponible en su país.",
    on: "en",
    sendRequest: "Enviar solicitud",
    selectUserOrGroup: "Seleccionar usuario o grupo",
    canvasFormShowAttachments: "Mostrar {0} archivos adjuntos",
    canvasFormShowOneAttachment: "Mostrar 1 archivo adjunto",
    canvasFormHideAttachments: "Ocultar {0} archivos adjuntos",
    canvasFormHideOneAttachment: "Ocultar 1 archivo adjunto",

    //GA Components
    createGroupStructure: "Crear estructura de grupo",
    componentText: "Cree regiones y componentes para cada equipo de compromiso que enviará entregables a través de EY Canvas. Tiene la opción de designar equipos como <b>No usar EY Canvas</b> si no enviarán entregables a través de EY Canvas. También puede crear equipos con fines organizativos y designarlos <b>solo como Referencia</b>. Estos equipos no recibirán solicitudes de enlaces, instrucciones o tareas. Cuando haya terminado, seleccione <b>Enviar solicitudes de vínculo</b>.",
    addTeam: "Agregar equipo",
    sendLinkRequests: "Enviar solicitudes de enlace",
    noComponents: "Aún no se han creado equipos. Seleccione <b> Agregar equipo <B> para empezar.",
    editTeam: "Editar equipo",
    deleteTeam: "Eliminar equipo",
    deleteInstructional: "¿Estás seguro de que quieres eliminar este equipo? <br/><br/> El enlace a este equipo se romperá y sus compromisos ya no podrán intercambiar documentación. Además, se eliminarán todas las instrucciones y tareas personalizadas asignadas a este equipo.",
    linkRequestHasBeenSent: "No puede editar el alcance o la designación de este equipo porque ya se ha enviado una solicitud de vínculo o la designación ya está establecida.",
    selectScopes: "Seleccionar alcance(s)",
    searchScopes: "Alcance de búsqueda",
    selectTeams: "Seleccionar equipo(s)",
    sendLinkRequestsDescription: "Seleccione el alcance o equipos a los que desea vincular su compromiso. <br> Se enviará una solicitud con enlace al  contacto de cada equipo. Después de que el contacto acepte la solicitud de enlace, recibirán instrucciones y tareas grupales a través de EY Canvas.",
    sendVersionsDescription: "Seleccione los ámbitos o equipos a los que desea enviar la versión más reciente de las instrucciones y tareas del grupo. <br>Un equipo debe estar vinculado a su compromiso para recibir instrucciones y tareas grupales. Después de que el equipo acepte la última versión, estará disponible en su compromiso.",
    notSentYet: "Aún no se ha enviado ninguna versión",
    notLinkedYet: "Solicitud de enlace no enviada",
    cardView: "Vista de tarjetas",
    noItemsPlaceholder: "Todavía no se ha publicado una versión. Publique una versión de las instrucciones y tareas de grupo para ver los datos aquí.",

    //GA Instructions
    customizeGroupInstructions: "Personalizar instrucciones de grupo",
    gaInstructionsIntro: "Las instrucciones de grupo por EY GAM se incluyen de forma predeterminada y son informativas por naturaleza. Están destinados a informar a los equipos regionales y componentes de la información clave, el alcance del trabajo y los procedimientos realizados de forma centralizada. Personalice las instrucciones de EY GAM, agregue instrucciones adicionales si es necesario y designe si cada instrucción debe asignarse a un alcance o a un equipo. Una vez que haya terminado, publique sus instrucciones para que estén disponibles para enviar a los ámbitos o equipos asignados.",
    addInstruction: "Agregar instrucción",
    instruction: "Instrucción",
    groupTaskSelected: "Tarea de grupo",
    assignScopes: "Asignar a alcances",
    assignTeams: "Asignar a equipos",
    maxLengthMessage: "El texto no puede superar los <b>500<b> caracteres.",
    addScope: "Agregar alcance",
    editInstruction: "Editar instrucciones personalizadas",
    editKnowledgeInstruction: "Editar instrucción de conocimiento",
    editKnowledgeTask: "Editar tarea de conocimiento",
    editCustomTask: "Editar tarea personalizada",
    saveChangesInstruction: "Guardar cambios",
    updatedOnInstruction: "Última actualización:",
    knowledgeDescriptionInstruction: "Descripción del conocimiento",
    editDisabledTitle: "Debe tener el permiso <b>Administrar grupo</b> para realizar esta acción. Hable con un administrador del compromiso para solicitar permiso.",
    deleteCustomInstruction: "Eliminar instruccion",
    deleteGroupTask: "Eliminar tarea de grupo",
    areYouSureDeleteCustomInstruction: "¿Está seguro de que desea eliminar esta instrucción personalizada?",
    areYouSureDeleteCustomTask: "¿Está seguro de que desea eliminar esta tarea personalizada?",
    publishAfterDelete: "Si elimina esta instrucción, debe publicar los cambios y volver a enviar el conjunto de nuevas instrucciones a los alcances o equipos asignados.",
    publishAfterDeleteGroupTask: "Si elimina esta tarea de grupo, debe publicar los cambios y reenviar el conjunto de tareas recién publicado a los alcances o equipos asignados.",
    resendPublishInformation: "Puede publicar los cambios en este paso. Puede reenviar el conjunto de instrucciones recién publicado desde el resumen.",
    resendPublishInformationGroupTask: "Puede publicar los cambios en este paso. Puede reenviar el conjunto de tareas recién publicado desde el resumen.",
    compareVersionsNoVersionSelectedTitle: "¡No se ha seleccionado ninguna versión para comparar!",
    compareVersionsNoVersionSelectedSubtitle: "Seleccione la versión en el menú desplegable para compararla con la última versión",

    //Add Section
    addSection: "Agregar sección",
    addSectionInstructionalText: "Agregue una sección para organizar sus instrucciones personalizadas.",
    addSectionPlaceholder: "Nombre de la sección",

    //Edit Section
    editSection: "Editar nombre de sección",
    editSectionInstructionalText: "Realice cambios en el nombre de esta sección personalizada. <br> Cuando haya terminado, publique los cambios para enviar una versión actualizada a los ámbitos o equipos seleccionados.",
    editSectionSave: "Guardar cambios",

    //Delete Section
    deleteCustomSection: "Eliminar sección",
    areYouSureDeleteCustomSection: "¿Está seguro de que desea eliminar esta sección? <br>Se eliminarán todas las instrucciones de esta sección. Cuando haya terminado, publique los cambios para enviar una versión actualizada a los ámbitos o equipos seleccionados.",
    customSection: "Sección",

    //Publish Changes
    publishChanges: "Publicar cambios",
    publishChangesInstructional: "¿Está seguro de que desea publicar cambios en las instrucciones y tareas actuales? <br><br>Se sobrescribirá las instrucciones y tareas anteriores. Una vez que publique los cambios, puede enviar las instrucciones y tareas actualizadas desde el resumen.",
    publishChangesNotAvailable: "Aún no está disponible",

    //GA Tasks
    costomizeGroupTasks: "Personalizar tareas de grupo",
    gaTasksIntro: "Las tareas de grupo por EY GAM se incluyen de forma predeterminada y se envían a compromisos vinculados. Personalice las tareas de EY GAM, agregue tareas adicionales si es necesario y designe si cada tarea debe asignarse a un ámbito o a un equipo. Una vez que haya terminado, publique sus tareas para que estén disponibles para enviar a los ámbitos o equipos asignados.",
    addCustomTask: "Agregar tarea personalizada",
    groupTask: "Tareas de grupo",
    gaTasks: "Tareas",
    attachments: "Archivos adjuntos",
    notAvailable: "No disponible",
    gaDocument: "documento",
    gaDocuments: "Documentos",
    gaScope: "alcance",
    gaScopes: "alcances",
    gaScopesCapitalized: "Alcances",
    gaTeam: "equipo",
    gaTeams: "Equipos",
    gaUnassignedScopeTeam: "Sin asignar",
    hideDetails: "Ocultar detalles",
    gaAssignedScopes: "Alcances asignados",
    gaAssignedTeams: "Equipos asignados",
    addTask: 'New task',
    due: "Vence",
    noAttachments: "No se han agregado archivos adjuntos.",

    // Chip component
    chipMore: "más",

    // GS Group Summary labels
    assignedTeam: "Equipo asignado",
    lastPublished: "Última publicación",
    versionStatus: "Estatus de la versión",
    lastSent: "Último envío",
    lastSentTooltip: "Esta es la fecha en que se envió por última vez una versión de las instrucciones y tareas a cada equipo. Haga clic en la fecha para ver la versión enviada al equipo.",
    lastSentBeforeTooltip: "Hay una nueva versión de instrucciones y tareas disponibles para <b><<nombre de alcance>><b>. Considere si debe enviar la última versión a este equipo.",
    groupSummary: "Resumen del grupo",
    summarySubTitle: "Revise la versión más reciente de las instrucciones y tareas asignadas a cada ámbito y equipo a continuación. Para enviar esta versión a los ámbitos y equipos asignados, seleccione <b>Enviar versión</b>.<br/> También puede ver la versión enviada a un equipo específico seleccionando la fecha de envío correspondiente.",
    compareVersions: "Comparar versiones",
    sendVersion: "Enviar versión",
    compareVersionsInstructional: "Compare la última versión de las instrucciones y tareas publicadas con la versión enviada a un equipo para identificar diferencias. Si hay diferencias entre las versiones, evalúe si es necesario enviar una nueva versión al equipo.",
    publishedVersion: "Versión publicada",
    sentVersion: "Versión enviada",
    emptyPublishedVersion: "No hay alcances disponibles. <br/>Los alcances asignados a los equipos de componentes se enumeran aquí.",
    emptySentVersion: "No hay equipos disponibles.",
    selectPublishedVersion: "Seleccione una versión publicada para ver los datos aquí.",
    selectSentVersion: "Seleccione una versión enviada para ver los datos aquí.",
    dueDate: "Fecha de vencimiento",
    emptyPublishedSnapshot: "No hay ninguna versión de instrucciones publicada ni tareas disponibles para  seleccionadar en el alcance. <br/>Publique una versión para ver los datos aquí.",
    emptySentSnapshot: "No se han enviado instrucciones y tareas al equipo seleccionado. <br/>Publicar y enviar instrucciones y tareas a este equipo para ver datos aquí.",
    update: "Actualizar",
    updates: "Actualizaciones",
    noTeamsPlaceholder: "Marcador de posición sin equipos",
    noTeamSelected: "Seleccione al menos un alcance o equipo para continuar.",
    latestVersionAlreadySent: "Todavía no se han creado equipos. Cree uno o más equipos para publicar una versión de instrucciones y tareas.",
    latestHasBeenSended: "La última versión de instrucciones y tareas ha sido enviado a este equipo",
    noNewVersionToSend: "Los alcances o equipos seleccionados ya han recibido la última versión de instrucciones y tareas. No hay actualizaciones disponibles para enviar.",
    notSelectedTask: "No seleccionado",
    assignedTeams: "Equipos asignados",
    noTeamsCreatedYet: "Todavía no se han creado equipos. Cree uno o más equipos para publicar una versión de instrucciones y tareas.",
    newersTeamsSended: "La última versión de instrucciones y tareas se ha enviado a los ámbitos o equipos correspondientes.",
    LinkRequestNotSent: "Solicitud de enlace no enviada",
    lastVersionSentInstructionalText: "La versión de las tareas e instrucciones enviadas a <b>{teamName}</b> en <b>{sentDate}</b> se muestra a continuación. Esta es la última versión enviada a este equipo.",

    // ReceiveInstructions labels
    receiveInstructionsTitle: "{versionType} versión de instrucciones de grupo y tareas",
    receiveInstructionsInstructional: "{primaryEng} enviado {versionType} versión de instrucciones de grupo y tareas en {sentDate}. Revise esta versión y seleccione si la acepta o devuelve. Puede usar la opción <b> Compare Versiones </b> para comparar esta versión con versiones anteriores.",
    fromLabel: "De",
    assignedScope: "Alcance asignado",
    dateSent: "Fecha de envío",
    acceptVersion: "Aceptar versión",
    returnVersion: "Versión de retorno",
    returnPrimaryButton: "Devolución",
    returnVersionDescription: "¿Estás seguro de que quieres devolver esta versión de instrucciones y tareas al equipo principal? <br> Esta versión no se importará a su compromiso. Deje un comentario para el equipo principal que explica su justificación.",
    noContent: "No hay instrucciones disponibles en este momento, intente nuevamente más tarde o comuníquese con mesa de ayuda",
    editorPlaceHolder: "Comentario",
    receiveCompareVersionInstructional: "Compare la versión seleccionada de las instrucciones y tareas recibidas de {primaryEng} con una versión anterior recibida para identificar diferencias.",
    latestReceiveCompareVersionInstructional: "Compare la última versión de las instrucciones y tareas recibidas de {primaryEng} con una versión anterior recibida para identificar diferencias.",
    latestVersion: "Última versión",
    earlierVersion: "Versión anterior",
    earlierVersionEmpty: "No hay versiones anteriores disponibles para la comparación.",
    selectEarlierVersion: "Seleccione una versión anterior para ver los datos aquí.",
    pstName: "Revise las instrucciones de participación grupal",
    pstDescription: "Revise las instrucciones de auditoría del grupo. Completa tareas grupales en 'Ejecución - General'. Estas tareas se agregaron a la lista de tareas después de que se aceptaron las instrucciones de auditoría del grupo.",
    selectedVersion: "Versión seleccionada",
    issuingEngagement: "Emisión de compromiso",
    accountsAndDisclosureLink: "Cuenta y divulgación",
    openRiskAssessmentDocuments: "Abrir documentos de evaluación de riesgos",
    openRiskAssessmentDocument: "Abrir documento de evaluación de riesgos",

    //Client engagement name labels
    successQueueMessage: "El nombre para mostrar de la interacción se ha actualizado correctamente en EY Canvas Client Portal.",
    clientEngagementInstructionalText: "Agregue o edite un nombre para mostrar el compromiso personalizado aquí. Este nombre será visible para los miembros externos del equipo que accedan a este compromiso en EY Canvas Client Portal.",
    clientEngagementPlaceholder: "Nombre para mostrar del compromiso",
    clientEngagementModalTitle: "Nombre para mostrar de compromiso en EY Canvas Client Portal",
    clientDisplayName: "Nombre para mostrar del cliente",
    textExceedsLength: "El texto no puede exceder los 100 caracteres.",

    // Manage client access locations
    location: "Ubicación",
    locationName: "Nombre del lugar",
    accessLocations: "Ubicaciones de acceso",
    inputType: "Tipo de entrada",
    ipAddress: "dirección IP",
    ipAddresses: "Direcciones IP",
    startOfIpRange: "Inicio del rango de IP",
    endOfIpRange: "Fin del rango de IP",
    cidrNotation: "Notación de CIDR",
    manageClientAccessLocationsLink: "Agregar Direccion",
    manageClientAccessLocationsModalTitle: "Administrar ubicaciones de acceso al cliente",
    manageClientAccessLocationsInstructionalText: "Agregue direcciones IP a la lista a continuación para habilitar el acceso basado en la ubicación al portal de clientes de EY Canvas. <br>Si las ubicaciones de acceso de los clientes están habilitadas, solo los miembros externos del equipo con las direcciones IP enumeradas aquí tendrán acceso a este compromiso. Si no se agregan direcciones IP, los miembros externos del equipo podrán acceder a este compromiso desde cualquier ubicación.<br> Haga clic en <b>aquí<b> para obtener más información.",
    manageClientAccessLocationsNoResultFound: "No se han agregado direcciones IP para este compromiso. Los miembros internos y externos del equipo pueden acceder a este compromiso desde cualquier ubicación.",
    deleteAccessLocations: "Eliminar ubicaciones de acceso",
    deleteAccessLocationsInstructionalText: "¿Está seguro de que desea eliminar la ubicación de acceso seleccionada? <b>Si un miembro externo del equipo intenta acceder a EY Canvas Client Portal desde esta ubicación, ya no podrá acceder a este compromiso",
    locationLengthError: "La ubicación no puede exceder los 100 caracteres.",
    oneOrMoreIpAddressFormatError: "Una o más de la dirección IP proporcionada no son válidas.",
    ipAddressFormatError: "La dirección IP proporcionada no es válida.",
    ipSuffixError: "El sufijo CIDR para la dirección IP debe ser un decimal ≥ 1 y ≤ 32.",
    ipRangeStartSmallerThanEnd: "Inicio IP debe ser menor que el final IP.",
    ipInputTypeInfo: "Seleccione la dirección IP para ingresar una dirección IP individual o una lista de direcciones IP. Solo se admiten las direcciones IPv4. <br> Seleccione Gama IP para ingresar un rango de direcciones IP que comparten el mismo prefijo de red (es decir, los tres primeros segmentos de la dirección). <br> Seleccione el bloque CIDR para ingresar un rango de direcciones IP con notación de CIDR. Solo las direcciones de CIDR son compatibles",
    ipAddressInfo: "Puede ingresar direcciones IP individualmente, en una lista separada por comas, o en una lista con cada dirección en una nueva fila. <br> Las direcciones IPv4 válidas contienen cuatro enteros que van desde 0 a 255, separados por períodos",
    ipCidrInfo: "Introduzca la notación CIDR que representa un intervalo de direcciones IP que deberían poder acceder a este compromiso. <br>La notación CIDR válida contiene una dirección IPv4 válida, una barra diagonal / carácter y un sufijo decimal ≥ 1 y ≤ 32.",
    ipAddressEg: "p.ej. 192.xxx.x.1 192.xxx.x.2",
    ipRangeStartEg: "p.ej. 192.xxx.x.1",
    ipRangeEndEg: "p.ej. 192.xxx.x.2",
    ipCidrEg: "p.ej. 192.xxx.x.1 / 22",
    searchIpPlaceholder: "Comprobar la dirección IP",
    ipNotAddedMessage: "no se ha agregado a la lista de permitidos.",
    ipIsAllowedMessage: "La dirección IP está permitida.",
    importAccessLocationsLink: "Importar ubicaciones de acceso",
    importAccessLocationsInstructionalText: "Las ubicaciones de acceso se pueden importar desde su compromiso anterior. <br>¿Está seguro de que desea importar ubicaciones de acceso?",
    importAccessLocationsCloseButton: "Cerrar",
    importAccessLocationsCancelButton: "Cancelar",

    // Export Requests
    exportRequests: "Solicitudes de exportación",

    // Add custom request labels
    addCustomRequestModal: {
        titleTip: "Nueva solicitud",
        titleTipAddButton: "Añadir nuevo",
        closeTitleTip: "Cerrar",
        modalTitle: "Nueva solicitud",
        returnModalTitle: "Solicitud de devolución",
        modalHeader: "Agregar una nueva solicitud para enviar al Portal de Clientes de EY Canvas",
        requiredAssignedTo: "(requerido)",
        assignToError: "Requiere ser asignado",
        dueDate: "Fecha de vencimiento (requerido)",
        dueDateError: "Se requiere fecha de vencimiento",
        titlePlaceholder: "Título (obligatorio)",
        titleError: "Se requiere título",
        description: "Descripción",
        descriptionplaceholder: "Introduzca la descripción",
        descriptionError: "La descripción de la solicitud supera la longitud máxima, (4,000 caracteres)",
        associateDocuments: "Documentos asociados",
        emptyAssociatedDocumentsList: "Arrastre y suelte uno o más documentos o haga clic en Agregar documento",
        addDocumentButton: "Añadir documento",
        signOffCheckbox: "Los documentos cargados en EY Canvas Client Portal requerirán la aprobación",
        sendRequest: "Enviar petición",
        returnRequest: "Solicitud de devolución",
        saveAsDraft: "Guardar como borrador",
        cancel: "Cancelar",
        copyTitleAndDescription: "Copiar el título y la descripción de la tarea",
        copyAssociatedDocuments: "Copiar documentos de la tarea",
        priority: "Solicitar prioridad",
        addNewRequestButton: "Agregar nueva solicitud",
        addExistingRequestButton: "Agregar solicitud(es) existente(s)"
    },
    addCustomEventModal: {
        titleTip: "Nuevo evento",
        closeTitleTip: "Cerrar",
        modalTitle: "Nuevo evento",
        eventDate: "Fecha del evento",
        eventDateError: "Se requiere fecha",
        titlePlaceholder: "Título",
        titleError: "Se requiere título",
        description: "Descripción (opcional)",
        descriptionplaceholder: "Introduzca la descripción",
        descriptionError: "La descripción del evento excede la longitud máxima (4000 caracteres)",
        sendEvent: "Enviar evento",
        saveAsDraft: "Guardar evento como borrador",
        cancel: "Cancelar",
        eyParticipantsCollaborationError: "Se requiere al menos un participante de EY",
        externalParticipantsCollaborationError: "Se requiere al menos un participante externo"
    },
    eyHelixInstructionText: "Revise los proyectos vinculados de EY Helix y los analizadores sugeridos a continuación. <br/> Haga clic en cualquiera de los proyectos o analizadores para navegar a su página específica de EY Helix.",
    smartAutomationInstrText: "Revise las soluciones de automatización inteligente que está utilizando actualmente a continuación. <br/> Haga clic en una solución para navegar al Smart Automation Hub.",
    smartAutomationSolutionsNotAvailable: "Las soluciones de automatización inteligente no están disponibles para su compromiso en este momento.",
    noSmartAutomationAvailable: "No hay soluciones de automatización inteligente disponibles para su compromiso.",
    availableSolutions: "Soluciones disponibles",
    useOfSuggestedSolutions: "Uso de soluciones sugeridas.",
    useOfOtherSolutions: "Uso de otras soluciones.",
    suggestedSolutions: "Soluciones sugeridas",
    otherSolutions: "Otras soluciones",
    currentlyusing: "Actualmente en uso",
    suggested: "propuesto",
    primaryProject: "Proyecto Primario",
    noLinkedProjects: "No hay proyectos vinculados para su compromiso.",
    noSuggestedAnalyzers: "No hay analizadores sugeridos para su compromiso.",
    eyHelixNotAvailable: "EY Helix no disponible",
    helixNotAvailableMessage: "EY Helix no está disponible para su compromiso en este momento.",

    noGroupTaskCreatedYet: "Todavía no se ha creado ninguna tarea de grupo.",
    noInstructionsCreatedYet: "Todavía no se han creado instrucciones.",
    documentsReceived: "Documentos recibidos",
    documentsPending: "Documentos pendientes",

    teamLabel: "Equipo",
    scopeLabel: "Alcance",

    documentSignOffby: "Documento firmado por",
    documentAddedBy: "Documento añadido por",
    documentModifiedBy: "Documento modificado por",
    documentDeletedBy: "Documento eliminado por",
    commentAddedBy: "Nota añadida por",
    commentClearedBy: "Nota borrada por",
    commentClosedBy: "Nota cerrada por",
    commentReopenedBy: "Nota reabierta por",

    documentAssignedTo: "Documento asignado a",
    draftDocReceivedFrom: "Proyecto de documento recibido de",
    finalDocReceivedFrom: "Documento final recibido de",
    documentReturnedBy: "Documento devuelto por",
    returnedDocumentClearedBy: "Documento devuelto borrado por",
    documentConflictResolvedBy: "Conflicto de documentos resuelto por",
    draftDocumentSentBy: "Proyecto de documento enviado por",
    documentReturnedFrom: "Documento devuelto desde",
    finalDocumentSentBy: "Documento final enviado por",
    noActivityAvailable: "No hay actividad disponible.",
    allEngagementFilterLabel: "Todos los demás engagements",
    otherEngagementComments: "Otras notas de compromiso",
    engagements: "Engagements",
    engagement: "Engagement",
    view: "Visualizar",
    notesModalInstructionalText: "Vea y responda a las notas de los {0} seleccionados a continuación.",

    //New collaboration Related Labels
    searchRelateFileNoMatchesFound: "No se encontraron coincidencias. Inténtelo de nuevo.",

    //New collaboration Related tasks
    relatedTasksLabel: "Tareas relacionadas",
    selectRelatedTasks: "Seleccionar tarea",
    searchAndPressEnter: "Buscar y pulsar intro",
    noRelatedTasksSelected: "No se han seleccionado tareas relacionadas",
    relatedTasksCount: "tareas relacionadas",
    notFoundTasks: "Tarea no encontrada",
    dueDateDetailLabel: "Fecha de vencimiento",
    requestType2MessageTitle: "Esta solicitud se abrirá en una nueva pestaña",
    requestType2MessageSubtitle: "Actualice la página para ver las actualizaciones realizadas.",
    requestType2InTrnasitMessageTitle: "Esta solicitud no se puede abrir ya que está en tránsito.",
    requestType2InTrnasitMessageSubtitle: "Espere a que se complete la sincronización y actualice la página e inténtelo de nuevo.",

    //New collaboration Time Phase
    selectTimePhase: "Seleccionar etapa",
    timePhaseNotFound: "Etapa no encontrada",

    understandITProcess: "Comprender los procesos de TI",

    //New collaboration Access Location
    accessLocationLabel: "Ubicación de acceso habilitada",
    accessLocationTitle: "Solo los usuarios que se conecten desde una ubicación de red autorizada tendrán acceso a EY Canvas Client Portal para este Compromiso. Las ubicaciones permitidas se pueden administrar desde Ubicaciones de acceso en el menú de opciones.",

    // Reporting Labels
    summaryScreenLabel: "Pantalla de resumen",
    dataExportLabel: "Exportación de datos",
    projectManagementLabel: "Gestión de proyectos",
    reportingHeaderName: "Informes",
    repAllTasks: "Todas las tareas",
    repDeletedTasks: "Tareas eliminadas",
    repMultiEntityTasks: "Tareas de varias entidades",
    repAllAuditPlan: "Plan de auditoría",
    repITAppSOSummary: "Resumen IT App/SO",
    repITProcessScotControls: "Proceso de TI, SCOT y Controles",
    repTaskAssignments: "asignaciones de tareas",
    repTaskDetails: "Detalles de la tarea",
    repTaskAnalysis: "Análisis de tareas",
    repTaskSummary: "Resumen de tareas (piloto)",
    repExportToExcel: "Exportar datos",
    repExportDate: "Fecha de exportación",
    repEngInfo: "Información del compromiso",
    repNoRecordMessage: "No hay registros que mostrar",
    dateInUTC: "En UTC",
    repSCOTsControls: "SCOTs y controles",
    repITProcessSummary: "Resumen del proceso de TI",
    repCanvasForms: "Formularios EY Canvas",
    repControlForms: "Formularios de control",
    projectInsight: "Información del proyecto",
    archiveForm: "Formulario de archivo",
    archive: "Archivo",
    repCanvasFormResponse: "Respuestas de formulario Canvas",
    repCanvasFormRelatedComments: "Comentarios relacionados",
    repControlFormResponse: "Controlar las respuestas de los formularios",
    repNoRecordFound: "No se encontraron registros",
    repCanvasFormsIncomplete: "Respuestas incompletas",
    repCanvasFormRelatedObjects: "Objetos relacionados",
    voiceNoteLabel: "Nota de voz",
    repComponentTeamGroup: "Equipo componente",
    componentTeamCanvasFormExport: "Exportar formularios Canvas",

    // Reporting Tasks
    repTaskTitle: "Título de la tarea",
    repTaskDescription: "Descripción de la tarea",
    repTaskSource: "Fuente de la tarea",
    repTaskNature: "Naturaleza de la tarea",
    repTaskCloseEarly: "Temprano",
    repTaskCloseLate: "Tarde",

    // Reporting Documents
    repAllDocuments: "Todos los documentos",
    repSignOffs: "Firma",
    repDocumentsModified: "Documentos modificados después de RRD",

    //Reporting Collaboration
    repRequestsAndTasks: "Solicitudes y tareas",
    repRequestsTasksComments: "Solicitudes/comentarios de tareas",

    SCOTSummaryReportHeader: "Resumen de SCOT",
    GroupReportHeader: "Informe de grupo",
    SCOTSummaryEffective: "Efectivo",
    GroupInstructionSummary: "Resumen de instrucciones de grupo",
    GroupActivity: "Historial de asignación de cuentas de componentes",
    SEMReportHeader: "SEM",
    GroupComponentAccountReportHeader: "Asignación de cuentas de componentes de grupo",
    AccountDisclosuresReportHeader: "Cuentas y divulgaciones",

    //Reporting Collaboation Details
    collaborationDetails: "Detalles de la colaboración",
    collaborationSummary: "Resumen",
    collaborationActivity: "Detalles de la actividad",
    ReviewNotesReportHeader: "Notas de revisión",

    GroupStructureSummary: "Resumen de la estructura de grupo",

    //Reporting CRT Summary
    wcgwSummary: "Resumen de WCGW",
    crtlabel: "Herramienta de revisión de controles (CRT)",
    assertionSummary: "Resumen de aseveraciones",
    scotSummary: "Resumen de SCOT",
    noRecordsToExport: "No hay registros para exportar",
    statisticsSummary: "Estadística",
    qualityChecks: "Controles de calidad",
    controlSummary: "Resumen de control",
    filterBySCOT: "Filtrar por SCOT",

    //Reporting manage team
    independenceSummaryReportTabName: "Resumen de la independencia",

    //MEST dashboard
    viewAllRiskTypesAndAssertions: "Ver todos los tipos de riesgos y aseveraciones",
    riskRelatedToAssertion: "Riesgo relacionado con la aseveración",
    higherRiskRelatedToAssertion: "Riesgo alto relacionado con la aseveración",
    noRisksAvailable: "No hay riesgos disponibles",
    relatedEstimates: "Estimaciones relacionadas",
    viewAllAssertions: "Ver todas las aseveraciones",
    wcgwRelatedToAssertion: "WCGW relacionado con la aseveración",
    noWcgwsAvailable: "No hay WCGW disponibles",
    goTo: "Ir a",
    allItems: "Todos los elementos",

    // Create TimePhase Labels
    createTimePhaseLabels: {
        modalTitle: "Agregar fase de tiempo",
        modalDescription: "Agregue los atributos y haga clic en Guardar y cerrar o Guardar y agregar.",
        timephaseNameLabel: "Nombre de la fase de tiempo",
        milestoneSelectLabel: "Milestone",
        timephaseLabel: "Fase de tiempo",
        startDateLabel: "Fecha de inicio",
        endDateLabel: "Fecha final",
        startDateErrorMessage: "Se requiere fecha de inicio.",
        endDateErrorMessage: "Se requiere fecha de finalización.",
        timephaseNameErrorMessage: "Se requiere el nombre.",
        milestoneErrorMessage: "se requiere Milestone",
        isKeyEvent: "Evento clave",
        timephaseDescription: "Descripción (opcional)",
        addSuccessMessage: "Fase de tiempo agregada correctamente."
    },

    AccountListHeaderLabels: {
        pspAndosp: "PSPs/OSPs",
        limitRiskAssertionLabel: "Cuenta de riesgo limitado",
        heading: "Cuentas y divulgaciones relacionadas",
        accountsOrDisclosure: "Cuentas y divulgaciones",
        psps: "PSPs",
        rejected: "Rechazado",
        remove: "Eliminar",
        risks: "Riesgos",
        assertions: "Aseveraciones",
        noRecordsFound: "No hay cuentas ni divulgaciones disponibles",
        noResultsFound: "No se han encontrado resultados",
        responsiveHeading: "Responsivo",
        rejectedPspsHeading: "PSPs rechazados",
        importPsps: "Importar PSPs",
        importOsps: "Importar OSPs",
        addOsps: "Agregar OSPs",
        pspEnded: "para empezar.",
        noPspsandOsps: "No hay {0} disponible.",
        allAreRejected: "Todos los PSP han sido rechazados.",
        rejectButton: "Rechazar",
        acceptButton: "Aceptar",
        additionalInfo: "Fundamento:",
        noAssertionsAvailableLabel: "No hay aseveraciones disponibles",
        noAssertionAvailableTooltip: "No hay aserción disponible. Haga clic en <strong>Administrar cuentas y divulgaciones</strong> para agregar aserciones.",
        importFromKnowledge: "Importar desde el conocimiento",
        disabledAddOspTooltip: "Al menos una aserción debe estar disponible para agregar una tarea sustantiva. Haga clic en <strong>Administrar cuentas y divulgaciones</strong> para agregar aserciones.",
        noPsps: "No hay PSP disponibles. {0} para empezar.",
        noOspsPsps: "No hay PSP/OSP disponibles. {0}, {1} o {2} para empezar.",
        acceptErrorMsg: "No se puede aceptar la tarea rechazada. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
        build7NoPspOrOspAttachedToAssertion: "Cada aseveración debe tener al menos un procedimiento sustantivo de respuesta. Las siguientes aseveraciones no tienen ningún PSP/OSP que responda: <b>{orphanAssertions}</b>. {0}, {1} o agregue un {2} para abordar todas las aserciones de la cuenta o haga clic en el icono de edición de los PSP/OSP existentes que responden a esta cuenta para relacionarlos con otras aserciones.",
        build7NoPspOrOsp: "Cada aseveración debe tener al menos un procedimiento sustantivo de respuesta. Ninguna de las aseveraciones tiene PSP/OSP receptivos. {0}, {1} o crear un {2} para abordar todas las aseveraciones de la cuenta.",
        build7NoOspsAndAllPspAreRejected: "Cada aseveración debe tener al menos un procedimiento sustantivo de respuesta. Todos los PSP han sido rechazados y ninguna de las aseveraciones tiene PSP/OSP que respondan. {0} o cree una {1} para abordar todas las aseveraciones de la cuenta.",
        build6And7NoAssertions: "Cada cuenta significativa o divulgación significativa debe tener al menos una aseveración relacionada disponible para agregar un procedimiento sustantivo. Haga clic en {0} para agregar aseveraciones.",
        build7LimitedAccountNoPspOsp: "Cada cuenta de riesgo limitado debe tener al menos un procedimiento sustantivo que responda. {0} o crear una {1} para responder a los riesgos de esta cuenta.",
        manageAccountAndDisclosures: "Administrar cuentas y divulgaciones"
    },

    AddTaskLabels: {
        accountLabel: "Cuenta:",
        taskSectionLabel: "Sección de tareas:",
        ospModelTitle: "Nuevo OSP",
        ostModelTitle: "Nueso OST",
        saveAndClose: "Guardar",
        saveAndCreate: "Guardar y crear otro",
        cancel: "Cancelar",
        prefix: "Prefijo",
        title: "Título",
        suffix: "Sufijo",
        timePhase: "Fase de tiempo",
        description: "Descripción personalizada",
        descriptionPlaceholder: "Descripción personalizada de la tarea (obligatorio)",
        assertions: "Aseveraciones",
        optional: "(Opcional)",
        required: "Obligatorio",
        noResultFound: "No se han encontrado resultados",
        of: "de",
        characters: "Caracteres",
        descriptionMaxLengthError: "La longitud de la Descripción excedió la longitud máxima permitida",
        noteDiscriptionErrorMessage: "La respuesta contiene {0} caracteres que superan el máximo de {1} caracteres. Ajuste la descripción reduciendo el texto o el formato e inténtelo de nuevo. Si el problema persiste, póngase en contacto con Mesa de ayuda",
        customizeDescription: "Descripción personalizada de la tarea (obligatorio)",
        errorMsg: "No se pudo agregar el OSP. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
        customizeTaskDescription: "Personalizar la descripción de la tarea"
    },

    RemoveTaskLabels: {
        modelOspTitle: "Eliminar OSP",
        modelOstTitle: "Eliminar OST",
        deleteBtn: "Eliminar",
        cancel: "Cancelar",
        confimationOspMsg: "¿Está seguro de que desea eliminar el OSP seleccionado?",
        confimationOstMsg: "¿Está seguro de que desea eliminar la OST seleccionada?",
        warning1Msg: "Las evidencias relacionadas que no estén relacionadas con ninguna otra tarea de este compromiso se moverán a archivos temporales.",
        warning2Msg: "Se eliminarán las conclusiones y las tareas de respuesta que no estén relacionadas con ninguna otra evidencia."
    },

    TaskReportHeaderLabels: {
        Tasktype: "Tipo de tarea",
        Taskstatus: "Estado de la tarea",
        Taskassignedto: "Tarea asignada a",
        Tasktitleprefix: "Prefijo de título de tarea",
        Tasktitle: "Título de la tarea",
        Tasktitlesuffix: "Sufijo del título de la tarea",
        Taskdescription: "Descripción de la tarea",
        Knowledgetasktitle: "Título de la tarea de conocimiento",
        Knowledgetaskdescription: "Descripción de la tarea de conocimiento",
        Oldtaskname: "Nombre antiguo de tarea",
        Oldtaskdetail: "Detalle de tareas antiguas",
        Rejected: "Rechazado",
        Rationalforrejection: "Razon para el rechazo",
        Auditphase: "Fase de auditoría",
        Timephasetype: "Hito",
        Timephase: "Fase de tiempo",
        Timephasestartdate: "Fecha de inicio de la fase de tiempo",
        Timephaseduedate: "Fecha de vencimiento de la fase de tiempo",
        Keyevent: "Evento clave",
        Tasksource: "Fuente de la tarea",
        Tasknature: "Naturaleza de la tarea",
        Lasttaskstatuschangedate: "Fecha de cambio de estado de la última tarea",
        Taggroup: "grupo de etiquetas",
        Tags: "Etiquetas",
        RelatedMESTentities: "Entidades MEST relacionadas",
        Schedulednextwaveservices: "Servicios programados de nextwave",
        Priority: "Prioridad",
        Taskid: "Identificador de tarea",
        Roleid: "Identificador de rol",
        Tasktypeid: "Identificador de tipo de tarea",
        Taskstatusid: "Identificador de estado de la tarea",
        Auditphaseid: "Identificador de fase de auditoría",
        Timephasetypeid: "Identificador de Hito",
        Tasksourceid: "Identificador de origen de tarea",
        Tasknatureid: "Identificador de naturaleza de tarea"
    },

    glAccountDocumentLabels: {
        modelTitle: "Cuenta GL",
        modelName: "Relacionar las pruebas",
        documentName: "Nombre del documento",
        documentCounter: "{0} Documento",
        documentsCounter: "{0} Documentos",
        btnCancel: "Cancelar",
        btnSave: "Guardar",
        errorMessage: "Seleccione un documento para continuar",
        noResultsFound: "No se han encontrado resultados",
        newTickMark: "Nueva marca de verificación",
        bulkModePlaceholder: "Seleccione una evidencia para relacionar y seleccione <fuerte>\'Guardar\'</fuerte> para terminar."
    },

    // Edit TimePhase Labels
    editTimePhaseLabels: {
        modalTitle: "Editar fase de tiempo",
        modalDescription: "Edite los atributos y haga clic en <b> Guardar. </b>",
        editSuccessMessage: "Fase de tiempo actualizada correctamente."
    },

    // Delete TimePhase Labels
    deleteTimePhaseLabels: {
        deleteTimePhaseModalTitle: "Eliminar fase de tiempo",
        deleteDescription: "¿Estás seguro de que quieres eliminar esta fase de tiempo?",
        showTimePhaseName: "Fase de tiempo",
        showMileStone: "Hito",
        showStartDate: "Fecha de inicio",
        showEndDate: "Fecha final",
        showDescription: "Descripción:",
        showAssignedTasks: "Recuento de tareas asignadas",
        showAssignedAssignments: "Recuento de tareas",
        deleteSuccessMessage: "Fase de tiempo eliminada correctamente."
    },

    // Create Tag Labels
    createTagGrouplabels: {
        modalTitle: "Agregar grupo de etiquetas",
        modalDescription: "Ingrese un nombre y haga clic en Guardar y cerrar o Guardar y agregar para continuar.",
        tagGroupNameLabel: "Grupo de etiquetas",
        tagGroupNameErrorMessage: "Grupo de etiquetas requerido",
        saveAndClose: "Guardar y cerrar",
        saveAndAdd: "Guardar y agregar",
        addSuccessMessage: "El grupo de etiquetas se ha agregado correctamente. "
    },

    // Bulk Tags
    tags: {
        noTagsAvailabel: "No hay etiquetas disponibles",
        deleteTag: "Eliminar etiqueta",
        deleteDescription: "La eliminación de la etiqueta no se puede deshacer, ¿está seguro de que desea continuar?",
        showDeleteTagName: "Etiqueta",
        showDeleteTagGroupName: "Grupo de etiquetas",
        showAssignedTasks: "Tareas asignadas",
        deleteSuccessMessage: "Etiqueta eliminada correctamente.",
        task: "Tarea",
        tasks: "Tareas",
        addTagGrouplabels: "Agregar grupo de etiquetas",
        addTag: "Agregar etiqueta",
        action: "Acción",
        addTagDesc: "<h3>Agregar etiqueta</h3><p>Haga clic en 'Agregar grupo de etiquetas' para crear un nuevo grupo de etiquetas que se pueda utilizar para agregar etiquetas.</p>",
        assignTagDesc: "<h3>Asignar etiquetas</h3><p>Arrastre y suelte los elementos seleccionados en la etiqueta deseada en un grupo de etiquetas.</p>",
        editTagDesc: "<h3>Editar etiquetas</h3><p>Haga clic en el menú de desbordamiento (tres puntos) y seleccione 'Editar' para editar las propiedades de la etiqueta.</p>",
        deleteTagDesc: "<h3>Eliminar etiquetas</h3><p>Haga clic en el menú de desbordamiento (tres puntos) y seleccione 'Eliminar' para eliminar la etiqueta.</p>",
        removeTagDesc: "<h3>Quitar etiqueta</h3><p>Para quitar una etiqueta, arrastre uno o más elementos con una etiqueta existente al nombre de etiqueta asociado en un grupo de etiquetas.</p>",
        expand: "Expandir",
        collapse: "Colapso",
        TagName: "Nombre de la etiqueta",
        TagGroupName: "Nombre del grupo de etiquetas",
        addTagSuccessMessage: "Etiqueta agregada correctamente.",
        editTagSuccessMessage: "Etiqueta actualizada correctamente.",
        addTagModalTitle: "Agregar etiqueta a",
        editTagModalTitle: "Editar etiqueta",
        addTagModalDescription: "Cree una nueva etiqueta y haga clic en Guardar y cerrar o Guardar y agregar para continuar.",
        editTagModalDescription: "Edite los atributos y haga clic en <b>Guardar.</b>",
        tagSetSuccessMessage: "etiquetado exitoso.",
        tagsSetSuccessMessage: "etiquetados exitosos.",
        tagRemoveSuccessMessage: "etiqueta eliminada correctamente.",
        tagsRemoveSuccessMessage: "etiquetas eliminadas correctamente.",
        tagRemovedSuccessfully: "Etiqueta eliminada correctamente. "
    },

    relateEvidenceHeader: "Relacionar las pruebas que proporcionan información sobre el ajuste.",
    relatedDocumentCounter: "{0} Documento",
    relatedDocumentsCounter: "{0} Documentos",
    documentsLocationLabel: "Ubicación de los documentos",
    relateTemporaryFilesHeader: "Relacionar un documento temporal de este compromiso.",

    // Create Assignment Labels
    addAssignmentlabels: {
        modalTitle: "Agregar asignación",
        modalDescription: "Introduzca un nombre y haga clic en Guardar cuando haya terminado.",
        assignmentNameLabel: "Nombre de la asignación",
        assignmentNameErrorMessage: "El nombre de la asignación no puede estar vacío",
        saveAndClose: "Guardar y cerrar",
        saveAndAdd: "Guardar y agregar",
        addSuccessMessage: "Asignación agregada con éxito."
    },
    addUserOrRoleLabelto: "Agregar usuario o rol a",
    addUserOrRoleheader: "Busque el miembro del equipo o el rol que desea agregar.",
    saveAndAdd: "Guardar y agregar",

    // Bulk Assignment
    BulkActionsLabel: "Acciones masivas",
    BulkAssignmentAction: "Acción",
    BulkShow: "Mostrar",
    BulkActionsInstructionalText: "Realice operaciones masivas para agrupaciones de tareas usando arrastrar y soltar. Para ver las tareas individuales de un grupo de tareas, coloque el mouse sobre el grupo de tareas y haga clic en el icono de flecha.",
    bulkOperationsModalDescription: "Realizar operaciones masivas para las tareas. Para ver las tareas individuales de una agrupación de tareas, pase el ratón por encima del grupo de tareas y haga clic en el icono de flecha.",
    selectRequest: "Seleccione una solicitud para enviar.",
    replaceLabel: "Reemplazar",
    labelStaff: "personal-",
    addModeLabel: "Agregar",
    replaceModeLabel: "Reemplazar",
    dueDateModeLabel: "Días de vencimiento de actualización",
    searchByAssignmentName: "Buscar",
    addTeamMemberLabel: "Agregar miembro del equipo",
    noTeamMembersFound: "No hay miembros del equipo disponibles",
    addMemberSuccessMessage: "Miembro del equipo agregado con éxito.",
    addAssignmentLabel: "Agregar asignación",
    addAssignmentNameLabel: "Agregar nombre de asignación",
    noAvailableAssignmentsMessage: "No hay asignaciones disponibles",
    showDuplicateError: "El miembro del equipo o el rol seleccionado no puede tener una asignación duplicada para las tareas seleccionadas. Elija una tarea, un miembro del equipo o un rol diferente para continuar.",
    infoBulkAssignments: "Asignaciones masivas",
    infoBulkAssignmentDesc: "Seleccione una o más agrupaciones de tareas para crear nuevas asignaciones o reemplazar las asignaciones existentes. Cuando se crean o editan asignaciones, el miembro del equipo asignado actualmente se volverá a calcular como el miembro del equipo con la asignación prevista para el momento más temprano.",
    infoAssignmentsDueDate: "Establecer la fecha de vencimiento de la(s) tarea(s)",
	infoAssignmentsDueDateDesc: 'Utilice "Seleccionar fecha / Calcular fecha" para establecer la fecha de vencimiento de las tareas. El conmutador se puede usar para dar una fecha de vencimiento específica para la(s) tarea(s) o para proporcionar días antes de la fecha de finalización de la fase de tiempo.',
    infoAddAssignmentExisting: "Agregar asignación a un miembro del equipo existente",
    infoAddAssignmentExistingDesc: "Agregar tareas requiere que se establezca una cantidad de días antes de la fecha de vencimiento. Alternativamente, la fecha de vencimiento exacta se puede establecer usando el control de calendario. Una vez hecho esto, arrastre y suelte los elementos seleccionados para crear un nuevo conjunto de tareas.",
    infoAddAssignmentNew: "Agregar asignación a un nuevo miembro del equipo",
    infoAddAssignmentNewDesc: "Si el miembro o rol del equipo no se presenta para la asignación dada, haga clic en agregar miembro del equipo para ver una lista de los miembros y roles del equipo disponibles. Una vez seleccionado, ese miembro del equipo se agregará a la parte inferior de la lista y se puede usar para la asignación de arrastrar y soltar.",
    infoRemove: "Quitar asignación",
    infoRemoveDesc: "Para quitar una asignación, arrastre uno o más elementos a un miembro del equipo con un nombre de asignación. Cualquier asignación incompleta para ese miembro del equipo será eliminada. Las asignaciones completadas no se eliminarán.",
    infoReplace: "Reemplazar asignación",
    infoReplaceDesc: "Al reemplazar una asignación, arrastrará uno o más elementos a un miembro del equipo bajo un nombre de asignación. Cualquier asignación existente con ese mismo nombre de asignación se reasignará al miembro del equipo seleccionado. Si varios miembros del equipo tenían asignaciones para ese nombre de asignación, se consolidarán en el usuario seleccionado. Establecer los días de vencimiento antes es opcional cuando se usa la asignación de reemplazo. Si no se establecen días de vencimiento anteriores, se utilizarán los días de vencimiento anteriores existentes.",
    infoUpdateDueDate: "Días de vencimiento de actualización",
	infoUpdateDueDateDesc: 'Establezca los nuevos "Días de vencimiento", usando "Seleccionar fecha " o "Calcular fecha" y luego arrastre y suelte sobre el miembro del equipo cuyos días de vencimiento desea cambiar. Las asignaciones abiertas y en progreso para ese miembro del equipo tendrán sus días de vencimiento actualizados. Las tareas completadas no se cambiarán.',
    infoDelete: "Eliminar asignación",
    infoDeleteDesc: "Haga clic en la asignación en el lado derecho y aparecerá una opción para eliminar ese conjunto de asignaciones.",
    infoExecutive: "Asignación ejecutiva",
    infoExecutiveDesc: "Utilice los filtros y la funcionalidad de búsqueda para filtrar las tareas de las aplicables a los ejecutivos para realizar asignaciones más rápidamente.",
    infoSpecificTask: "Asignaciones a tareas específicas",
    infoSpecificTaskDesc: "Si es necesario realizar asignaciones a nivel de tarea, coloque el cursor sobre la agrupación en el lado izquierdo y seleccione la opción para ver tareas individuales. Esto presentará las tareas individuales para el grupo y permitirá asignaciones de grano fino.",
    unassignedLabel: "sin asignar",
    replaceSignleSuccessMessage: "tarea actualizada correctamente.",
    replaceMultipleSuccessMessage: "tareas actualizadas correctamente.",
    dueDateSingleSuccessMessage: "asignación actualizada correctamente.",
    dueDateMultipleSuccessMessage: "las asignaciones se actualizaron correctamente.",
    invalidAssignmentUpdate: "Asigne la tarea a la misma persona para proceder con la actualización de los días de vencimiento.",
    removeSuccessMessage: "asignaciones se actualizaron correctamente.",
    colorCode: "Código de color",
    removeSuccessSingleMessage: "asignación actualizada con éxito.",
    removeSuccessMultipleMessage: "Asignaciones actualizadas con éxito",
    assignmentRemovedSuccessfully: "Asignación eliminada con éxito.",

    // Bulk Task
    itemsSelected: "tareas seleccionadas",
    itemSelected: "tarea seleccionada",
    dragAndDrop: "Arrastrar y soltar",
    currentApplication: "Aplicación actual",
    allAssignmentsClosed: "Todas las tareas cerradas",
    allAssignmentsCompleted: "Todas las tareas completadas",

    onOrBeforeCurrentDate: "En o antes de la fecha actual",
    withInCurrentWeek: "Esta semana",
    quickFilter: "Filtro rápido",
    suggestedFilters: "Filtros sugeridos",
    showXMore: "Mostrar {0} más",

    // Task due date Events
    addEventlabels: {
        modalTitle: "Agregar evento",
        startDateLabel: "Fecha de inicio",
        modalDescription: "Agregue los atributos y haga clic en Guardar y cerrar o Guardar y agregar.",
        eventNameLabel: "Nombre del evento",
        eventType: "Tipo de evento",
        singleDay: "Un solo día",
        dateRange: "Intervalo de fechas",
        eventDate: "Fecha del evento",
        eventDescription: "Descripción (opcional)",
        isEvent: "Compartir evento con el cliente",
        EventNameErrorMessage: "El nombre del evento es obligatorio.",
        eventDateErrorMessage: "Se requiere la fecha del evento.",
        addSuccessMessage: "Evento agregado correctamente."
    },

    // Bulk Notes
    DeleteSomeNotesAreClosed: "<b>Solo algunas de las notas que seleccionó tienen estado cerrado y se pueden eliminar.</b> <br /> Si elige continuar, se eliminarán las notas que se enumeran a continuación.",
    DeleteSomeNotesAreNotClosed: "Las notas enumeradas a continuación no se pueden eliminar porque no se han cerrado.",
    DeleteDontHaveClosedNotes: "Las notas enumeradas a continuación no se pueden eliminar porque no se han cerrado.",
    someNotesAreOpen: "<b>Solo algunas de las notas seleccionadas tienen el estado abierto.</b> <br/> Si elige continuar, se actualizarán las notas que se enumeran a continuación.",
    someNotesAreNotOpen: "Las notas que se enumeran a continuación no se actualizarán porque ya se han borrado o cerrado.",
    dontHaveOpenNotes: "Las notas que se enumeran a continuación no se pueden actualizar porque ya se han borrado o cerrado.",
    ShowNumberMore: "Mostrar {0} más",

    // Drag and Drop
    assignmentLabel: "asignación",
    assignmentsLabel: "asignaciones",
    singleAssignmentCreatedMessage: "asignación creada correctamente.",
    multipleAssignmentCreatedMessage: "asignaciones creadas correctamente.",
    daysPriorWarning: "Establezca los días de vencimiento antes de crear tareas.",



    // Related Tasks - Engagement selector
    selectEngagement: "Seleccionar compromiso",
    thisEngagement: "Este compromiso",
    noResultsFoundLabel: "No se han encontrado resultados",
    taskLocationLabel: "Ubicación de tareas",

    // Delete Assginment
    deleteDescription: "La eliminación de la tarea no se puede deshacer, ¿está seguro de que desea continuar?",
    deleteAssignmentModalTitle: "Eliminar la tarea",
    deleteSingleSuccessMessage: "asignación eliminada correctamente.",
    deleteMultipleSuccessMessage: "las asignaciones se han eliminado correctamente.",
    teamMemberLabel: "Miembro del equipo",
    assignedTasksCountLable: "Tareas asignadas",
    deleteAssignmentLabel: "Asignación",
    selectengagement: "Seleccionar compromiso",

    //Due Days
    dueDateTitle: "Introduzca los días de vencimiento",
    dueDatedescription: "Introduzca el número de días antes de la fecha de vencimiento de la fase de tiempo en la que se debe completar la asignación.",
    dueDateAssign: "Asignar",
    dueDateSelect: "Escoger",
    dueDateCalculate: "Calcular",

    // Tasklist - bulk markcomplete
    markComplete: "Marca completa",
    markCompleteMessgae1: "¿Estás seguro de que quieres <b> completar las tareas seleccionadas </b>? <br /> Si tiene alguna tarea incompleta para las tareas seleccionadas, se cerrarán.",
    markCompleteMessgae2: "Solo algunas de las tareas que seleccionó se pueden marcar completas. <br /> Si elige continuar, <b> las tareas enumeradas a continuación se marcarán completas </b>. Si tiene alguna tarea incompleta, se cerrarán.",
    markCompleteMessgae3: "<b> Las tareas enumeradas a continuación no se marcarán completas </b> porque no tienen ninguna evidencia asociada o la evidencia asociada le faltan firmas.",
    markCompleteMessgae4: "<b> Las tareas enumeradas a continuación no se pueden marcar completas </b> porque no tienen ninguna evidencia asociada o la evidencia asociada faltan firmas.",

    // Tasklist - bulk handoff
    handOffLabel: "Transladar",
    confirmHandOff: "Confirmar translado",
    handOffMessgae1: "¿Está seguro de que desea <b> entregar las tareas seleccionadas </b> al siguiente miembro del equipo asignado? <br /> Si tiene alguna tarea incompleta para las tareas seleccionadas, se cerrarán.",
    handOffMessgae2: "Solo algunas de las tareas que seleccionó tienen otro miembro del equipo asignado. <br /> Si elige continuar, <b> las tareas enumeradas a continuación se entregarán </b>. Si tiene alguna tarea incompleta para las tareas seleccionadas, se cerrarán.",
    handOffMessgae3: "<b> Las tareas enumeradas a continuación no se entregarán </b> porque no tienen ninguna tarea incompleta.",
    handOffMessgae4: "<b> Las tareas enumeradas a continuación no se pueden entregar </b> porque no tienen ninguna tarea incompleta.",
    closeMyAssignments: "Cerrar mis tareas",

    saveQuickFilter: "Guardar filtro rápido",
    saveQuickFilterModalHeader: "Guarde el filtro que aplicó como un filtro rápido.",
    saveQuickFilterModalText: "Seleccione los filtros rápidos guardados y sugeridos para ahorrar tiempo cuando vuelva a acceder a este compromiso. Puede crear hasta cinco filtros rápidos guardados por compromiso.",
    quickfiltername: "Nombre de filtro rápido",
    taskCategory: "Categoría de tareas",

    cannotsavefilter: "No se puede guardar el filtro rápido personalizado",
    cannotsavefiltermodalheadertext: "<b> Solo puede guardar cinco filtros rápidos personalizados por compromiso. </b> <br /> Si desea continuar, elimine uno de sus filtros rápidos personalizados existentes e intente nuevamente.",
    savedFilters: "Filtros Guardados",
    taskassignedto: "Tarea asignada a",
    noteassignedto: "Nota asignada a",
    taskPrefix: "Prefijo de tarea",
    taskSuffix: "Sufijo de tarea",

    // Mark complete/HandOff Evidences category
    noSignOffs: "Sin firmas",
    noSignOffsByMe: "Sin firmas por mí",
    myPreparerSignOffs: "Aprobación de mi preparador",
    myReviewerSignOffs: "Aprobación de mi revisor",
    myPreparerAndReviewerSignOffs: "Mis firmas de preparador y revisor",

    notificationDownErrorMessage: "La función Notificaciones no está disponible temporalmente. Actualice la página e inténtelo de nuevo. Si este mensaje persiste, póngase en contacto con el servicio de asistencia.",
    notificationUpbutSomeLoadingErrorMessage: "El Centro de notificaciones no está disponible temporalmente. Actualice la página e inténtelo de nuevo, estará disponible en breve.",

    timeTrackerErrorFallBackMessage: "La función Seguimiento del tiempo no está disponible temporalmente. Actualice la página y vuelva a intentarlo. Si este mensaje persiste, comuníquese con la mesa de ayuda.",
    timeTrackerLoadingFallbackMessage: "La función de seguimiento de tiempo no está disponible temporalmente. Estará disponible en breve.",

    signOffOnAllAs: "Aprobación de todo como",
    accountType: "Tipo de cuenta",

    openDocumentInstructionalText: "Este documento se abrirá automáticamente. <b>No es necesario hacer clic para abrirlo.</b> <br>Una vez abierto el documento, puede cerrar esta pestaña.",
    closeTab: "Cerrar pestaña",

    // Build Step - Add Due Date
    milestones: "Hitos (Milestones)",
    events: "Eventos",
    noTimePhasesHaveBeenIdentified: "No se han identificado fases de tiempo.",

    wcgws: "WCGWs (recorridos)",
    relatedControls: "Controles relacionados,",
    relatedControlsWCGWsRatio: "Controles relacionados / WCGW",
    wcgwsToControlsRatio: "Relación entre WCGWs y controles",
    controlsToWCGWsRatio: "Relación entre controles y WCGWs",
    testedControls: "Controles probados",

    // Collaboration request to Task relation
    CollaborationModalTitle: "Relacionar las solicitudes con las tareas",
    CollaborationModalDescription: "Para relacionar una solicitud con una tarea, arrastre y suelte una o más solicitudes en la tarea siguiente.",
    noDataFound: "No se encontraron datos",
    taskName: "Tarea",
    showMessage: "Selecciona una categoría y grupo de tareas para empezar",
    showCategory: "Categoría",
    showTaskGroup: "Grupo de tareas",
    optionITProcesses: "Procesos de TI",
    optionExecutionGeneral: "Ejecución general",
    relatedRequestsLabel: "Solicitudes relacionadas",
    relatedRequestsFormatted: "{0} Solicitudes relacionadas",
    relatedRequestFormatted: "{0} Solicitud relacionada",
    relatedRequests: "Solicitudes relacionadas",
    relatedTasks: "Tareas relacionadas",
    relatedSuccessSingleMessage: "{0} solicitud se ha relacionado con la tarea con éxito.",
    relatedSuccessMultipleMessage: "{0} solicitudes se han relacionado con la tarea con éxito.",
    showUnrelated: "Mostrar {0} no relacionado",
    unrelate: "Sin relacionar",
    noRequestsMessage: "No hay solicitudes disponibles",
    requestNumber: "Número de solicitud",
    sortAscending: "Ordenar de forma ascendente",
    sortDescending: "Ordenar de forma descendente",
    removeSorting: 'Remove sorting',

    // PIC Dashboard
    groupBy: "Agrupar por",
    allTasks: "Todas las tareas",
    iTSOs: "TI/SOs",
    generalExecution: "Ejecución general",
    PICSignOff: "Aprobación del PIC",
    EQRSignOff: "Firma de EQR",
    completed: "Completado",
    allAssigned: "Todos asignados",
    picTaskAssignmentLabel: "Sus tareas",
    assignReadyForReview: "Actual",
    assignUpcomingForReview: "Próximas",
    assignReadyForReviewTasks: "Asignaciones actuales",
    assignUpcomingForReviewTasks: "Próximas tareas",
    picTaskSignoffInComplete: "Tareas con <b>PIC</b> firmas incompletas",
    picDocSignoffInComplete: "Documentos con <b>PIC</b> firmas incompletas",
    eqrTaskSignoffInComplete: "Tareas con <b>EQR</b> firmas incompletas",
    eqrDocSignoffInComplete: "Documentos con <b>EQR</b> firmas incompletas",
    collapseCards: "Contraer tarjetas",
    expandCards: "Expandir tarjetas",
    noUserSelectedPlaceholder1: "El {0} no ha sido identificado ni invitado al compromiso.",
    noUserSelectedPlaceholder2: "Haga clic aquí",
    noUserSelectedPlaceholder3: "para identificar o invitar a la {0}.",
    notInvitedLabel: "No invitado",
    noTasksPlaceholder: "No hay tareas asociadas con hitos en esta fase de auditoría.",
    noTasksTilesPlaceholder: "No hay tareas asignadas al usuario seleccionado",
    noAssignmentPlaceholder: "No se han encontrado asignaciones",
    dueDateAssignmentPlaceholder: "Asignaciones por fecha de vencimiento",
    countAssignmentPlaceholder: "Recuento de asignaciones",
    OverduetPlaceholder: "Atrasado",
    TodayPlaceholder: "Hoy",
    tasksView: "Vista de tareas",
    documentsView: "Visualización de documentos",
    picAndEqr: "PIC & EQR",
    ResponsiveToSR: "Relacionados con ⚡RS",
    responsiveToFR: "Relacionados con ⚡RF",
    relatedTasksFormatted: "{0} Tareas relacionadas",
    relatedTaskFormatted: "{0} Tarea relacionada",
    autoAssignWarning2: "haga clic aquí",
    toAssign: "asignar",
    taskAssignWarning: "tarea con {0} requisitos de aprobación no asignados,",
    tasksAssignWarning: "tareas con {0} requisitos de aprobación no asignados,",
    taskAdditionalFuncText1: "<b>Esta tarea tiene funcionalidad adicional. Por favor, </b>",
    taskAdditionalFuncText2: "<b> para navegar hasta ella.</b><p>Build Las tareas no requieren que se asocie evidencia para marcarse como completadas, a menos que la tarea requiera una revisión de PIC/EQR.</p>",
    taskadditionalfunctionality: "<b>Esta tarea tiene una funcionalidad adicional. Por favor</b> {0} <b>para navegar hasta él.</b><p>Build Las tareas no requieren que se asocie evidencia para marcarlas como completadas, a menos que la tarea requiera una revisión de PIC/EQR.</p>",
    taskclickhere: "haga clic aquí",
    taskAutoAssignModalTitle: "Asignación automática",
	taskAutoAssignModalDescription: 'Hay {0} tarea que requiere firma de EQR, que no ha sido asignada a {1}. Haz clic en "Asignar" para crear una asignación EQR para {1}.',
	tasksAutoAssignModalDescription: 'Hay {0} tareas con un requisito de aprobación de EQR que no se han asignado a {1}. Haga clic en "Asignar" para crear asignaciones de EQR para {1}.',
    picTaskAutoAssignSuccessMessage: "tarea con el requisito de aprobación de PIC asignado a",
    picTasksAutoAssignSuccessMessage: "Tareas con requisito de aprobación de PIC asignadas a",
    eqrTaskAutoAssignSuccessMessage: "tarea con el requisito de aprobación de EQR asignado a",
    eqrTasksAutoAssignSuccessMessage: "Tareas con requisito de aprobación de EQR asignadas a",
    taskEntityDocumentValidationMsg: "Esta tarea tiene entidades que no tienen ninguna evidencia de respuesta. Alterne a ver por entidades para ver qué entidades necesitan documentación adicional.",
    // PIC/EQR Sign-Off validation message
    picSignOffValidationMsg: "Esta tarea requiere la firma de PIC, pero no hay documentos de PIC asociados. Agregue al menos un documento con este requisito.",
    eqrSignOffValidationMsg: "Esta tarea requiere la firma de EQR, pero no hay documentos de EQR asociados. Agregue al menos un documento con este requisito.",
    picAndEQRSignOffValidationMsg: "Esta tarea requiere la firma de PIC/EQR, pero no hay documentos de PIC/EQR asociados. Agregue al menos un documento con este requisito.",
    updateDataOnPicEqrDashboardBannerMessage: "Los cambios realizados no se han actualizado a continuación. Por favor {0} para actualizar la página.",
    showMissingSignOffByLabel: "Mostrar documentos que faltan {0} firma",

    FindingsReportName: "Observaciones",
    FindingsDeficiencyReportTabName: "Deficiencia",
    FindingsMisstatementReportTabName: "Error",
    FindingsDeficiencyITReportTabName: "Deficiencia-TI",
    auditPlanRelatedEvidenceReporLabel: "Plan de auditoría con evidencia relacionada",
    groupStructureSummaryReportReportLabel: "Resumen de la estructura del grupo",
    auditPlanReportLabel: "Informe del plan de auditoría",
    itAppSOSummaryReportLabel: "Resumen de la aplicación de IT y SO",
    craSummaryReportLabel: "Resumen del CRA",
    teamMembersLabel: "Miembros del equipo",
    ipeLabel: 'Information produced by the entity (IPE)',
    validationChecksReportLabel: "Comprobaciones de validación",
    trialBalanceReportLabel: "Balance de comprobación",
    trialBalanceReportTabLabel: "Informe de balance de comprobación",
    reportLabelYes: "Sí",
    reportLabelNo: "No",
    assignedBy: "Asignado por",
    openInReviewNotesHub: "Abrir en el centro de notas de revisión",
    nextNote: "Siguiente",
    previousNote: "Anterior",

    //component team group tab names
    accountInfoCanvasFormExport: "Información de la cuenta",

    //project insight tab names
    projectInsightCanvasFormExport: "Exportación de formularios Canvas",
    projectInsightSCOTToWCGWToControl: "SCOT a WCGW para controlar",
    projectInsightControlToITApplication: "Control a la aplicación de TI",
    projectInsightControlToAssertion: "Control a la aseveración",
    projectInsightRiskToWCGW: "Riesgos para los WCGW",

    //IPE Report
    ipeControlsReport: 'Controls',
    ipeSubstantiveReport: 'Substantive',
    ipeITGCReport: 'ITGC',

    // Milestone tab names
    milestonesReport: "Informe de hitos",
    unmappedTasks: "Tareas no asignadas",

    // Effective
    isEffective: "Efectivo",
    inEffective: "Inefectivo",
    nonEffective: "No efectivo",

    clientRequests: "Solicitudes de clientes",
    externalTasks: "Tareas externas",
    requestPriority: "Solicitar prioridad",
    scot: "SCOT",
    assertionR: "Aserción",
    wcgwToControlMappingTotal: "Totales del mapeo de WCGW a controles",

    //CRA build step
    buildStep2EntityHeaderText: "Cuentas significativas y divulgaciones, afirmaciones, WCGW y controles relacionados",
    buildStep4EntityHeaderText: "Cuentas significativas, revelaciones y afirmaciones relacionadas",
    accountNameHeader: "Cuentas significativas y revelaciones",
    noAssertionsLabel: "No hay aseveraciones relacionadas. Haga clic en <a>Administrar cuentas y divulgaciones</a> para comenzar.",
    noAssertionsBuildStep2text1: "Al menos una aseveración debe estar relacionada con esta cuenta. Haga clic en",
    accountWithoutAssertionsBuildStep2text1: "Cada cuenta o divulgación significativa debe tener al menos una aseveración relacionada. Clic",
    noAssertionsBuildStep2text2: "Administrar cuentas y divulgaciones",
	noAccountsLabel: 'No se han creado cuentas ni divulgaciones significativas. Haga clic en <span class="bold-text">Administrar cuentas y divulgaciones</span> para comenzar.',
	noAccountsLabelPlaceHolder: 'No se han creado cuentas ni divulgaciones significativas. <span class="bold-text">Administrar cuentas y divulgaciones</span> para comenzar.',
    noAccountsOrDiscloserPreText: "No se han creado cuentas ni divulgaciones significativas.",
    noAccountsOrDiscloserText: "Administrar cuentas y divulgaciones",
    noAccountsOrDiscloserPostText: " para empezar.",
    noAssertionsBuildStep1text1: "Al menos una aseveración debe estar relacionada con este riesgo. Haga clic en",
    noAssertionsBuildStep1text1Msg: "Cada riesgo debe tener al menos una aseveración relacionada.",
    noAssertionsBuildStep1text2: "Relacionar aseveraciones",
    noAssertionsBuildStep1text3: " para empezar.",
    editRisk: "Editar riesgo",
    deleteRisk: "Eliminar riesgo",
    noControlsRelatedWWCGW: "No hay controles relacionados.",
    noControlsRelatedWCGW: "Para cada WCGW relacionado con una aseveración con un riesgo de control de Confianza, se debe seleccionar al menos un control para la prueba. Cree un",
    noControlsRelatedWCGWNewCont: " Nuevo control",
    noControlsRelatedWCGWor: " o",
    noControlsRelatedWCGWRelateCont: " Relacionar un control existente",
    noControlsForWCGW: "Las aserciones con un riesgo de control de No confiar no tienen un requisito para identificar controles.",
    noControlsRelatedWCGWFooter: " para empezar.",
    relateWCGWs: "<a> Relacionar WCGWs</a>",
    noWCGWs: "No hay WCGW relacionados.",
    noWCGWsClick: " Clic",
    noWCGWsFooter: " para empezar.",
    showOnlyRisksWithNoAssertion: "Mostrar solo riesgos sin ninguna aserción relacionada",
    showIncomplete: "Mostrar solo aseveraciones con CRA incompleto",
    showOnlyInvalidBuildStep2: "Mostrar solo las cuentas a las que les faltan los detalles obligatorios",
    noTestedControlsWithRelyAssertion: "Para cada WCGW relacionado con una aserción con un riesgo de control de Rely, se debe seleccionar al menos un control para la prueba.",

    // Account build step
    accountOrDisclosure: "Cuenta / divulgaciones",
    relatedAssertions: "Aseveraciones relacionadas",
    relatedAccountsAndAssertions: "Cuentas relacionadas y aseveraciones",
    pspIndexTitle: "Índice PSP",
    statementTypeTitle: "Tipo de instrucción",
    significantAccountLabel: "Significativo",
    limitedRiskLabel: "Riesgo limitado",
    insignificant: "Insignificante",
    significantDiscloure: "Revelación significativa",
	accountAddedMessage: 'La cuenta "##" se creó con éxito',
    accounHeaderText: "Cuentas y divulgaciones",

    // Add accounts / disclosures Modal labels
    accountsListTitle: "Cuentas / divulgaciones y aseveraciones relacionadas",
    addAccountsDisclosures: "Agregar cuentas / divulgaciones",
    editAccountsDisclosures: "Editar cuentas/revelaciones",
    accountNameLabel: "Nombre de la cuenta (requerido)",
    accountDesignationLabel: "Designación (requerido)",
    accountEstimateLabel: "La cuenta tiene una estimación",
    accountStatementTypeLabel: "Tipo de instrucción (obligatorio)",
    pspIndexDropdownLabel: "Índice PSP (obligatorio)",
    removePSPIndexLabel: "Quitar índice PSP",
    assertionsLabel: "Aseveraciones (requerido)",
    noAccounsMessage: "No se encontraron cuentas. Agregue cuentas para comenzar.",

    //Delete account / disclosure modal labels
    deleteAccountDisclosure: "Eliminar cuenta / revelacion",
    deleteAcConfirmMessage: "¿Está seguro de que desea eliminar la cuenta/revelación {0}? Todas las aserciones relacionadas serán eliminadas. Cualquier tarea que solo esté relacionada con la cuenta/revelación seleccionada también se eliminará.",

    true: "Verdadero",
    false: "Falso",
    taskSummaryReportEngagementInfo: "Múltiples compromisos",
    viewPriority: "Prioridad de visualización",
    priorityRequestsSent: "Solicitudes prioritarias enviadas",

    //reactive frame
    maxTabsLocked: "Se ha alcanzado el número máximo de pestañas permitidas. Desancla y cierra una de las pestañas para abrir una nueva.",
    openInNewTab: "Abrir en una nueva pestaña",
    copyLink: "Copiar enlace",
    copySuccess: "Enlace copiado al portapapeles",
    copyFailure: "No se pudo copiar el enlace al portapapeles",
    minimize: "Minimizar",

    //Risk status for account cards
    riskStatusLabels: {
        NoAssertionsAvailableLabel: "No hay aseveraciones disponibles",
        SignificanceNotSelectedLabel: "Significado no seleccionado",
        InsignificantLabel: "Insignificante"
    },

    lockTab: "Pestaña Anclar",
    keyDocuments: "Documentos clave",
    suggestedDocuments: "Documentos sugeridos",
    noSuggestedDocuments: "No hay documentos sugeridos",
    exitBulkMode: "Salir del modo masivo",
    bulkLabel: "Volumen",

    me: "A mí",
    viewByUser: "Ver por usuario",
    unsentDraftCapitalized: "Borradores no enviados",
    picSignoffInComplete: "Aprobación de PIC incompleta",
    eqrSignOffIncomplete: "Aprobación de EQR incompleta",

    tableView: "Vista de tabla",
    noRelatedAssertions: "No hay aseveraciones relacionadas.",

    multiEntityTileMessage1: "Clic",
    multiEntityTileMessage2: "aquí",
    multiEntityTileMessage3: " Para ver el estado por entidad",
    allItemsMessage: " Para ver todos los artículos",

    EntitySelector: "Seleccione una entidad para empezar",
    allEntities: "Todas las entidades",
    multiEntity: "Entidad múltiple",
    ungrouped: "No agrupado",
    numberSelected: "{0} seleccionado",
    allTimePhases: "Todo",
    timePhases: "Fase de tiempo",
    noTimePhaseFound: "No se han encontrado fases temporales",
    unrelatedAssignments: "Asignaciones no relacionadas",
    unrelatedRequests: "Solicitudes no relacionadas",
    relateRequests: "Relacionar solicitudes",
    taskWithoutAnyAssignments: "Tareas sin asignaciones",
    privacyNotice: "Aviso de privacidad",
    lastPublishedAndSent: "Última publicación y envío",
    drafts: "Borradores",
    allEntitiesTask: "Se trata de una tarea que concierne a todas las entidades del compromiso",
    noRelatedEntities: "Sin entidades vinculadas",
    clickNewRisk: "para empezar.",
    relatedAccountsDisclosuresAndAssertions: "Cuentas significativas relacionadas, divulgaciones y aseveraciones.",
    relateAssertion: "Relacionar aseveraciones",
    taskByEntity: "Tarea por entidad",
    engagementWideTask: "Tarea para todo el compromiso",
    componentEngagementPill: "CT",
    primaryAndComponentEngagementPill: "PT/CT",
    // Scot build steps
    scotHeader: "SCOTs",
    searchScot: "Buscar",
    manageScots: "Gestionar los SCOTs",
    superModelStep1ScotMessage: "Cuentas y divulgaciones significativas y SCOTs relacionados",
    scotRelatedITApplicationServiceOrg: "SCOTs y organizaciones de servicios y aplicaciones de TI relacionadas",
    noScotsAvailable: "No se ha encontraron resultados",
    searchScotPlaceholder: "Buscar",
    searchScotClearHoverText: "Limpiar",
    showOnlyUnrelatedScotToggleSwitch: "Mostrar solo no relacionados",
    newScot: "Nuevo SCOT",
    importFromKnowledgeScot: "Importar SCOTs",
    importAccountsAndDisclosures: "Importar cuentas y divulgaciones",
    showOnlyAccountRelatedScot: "Mostrar solo SCOTs sin ninguna cuenta significativa relacionada y divulgación",
    warningMessageEstimateScotNotAssociatedWithEstimatedAccount: "Cada estimación SCOT debe estar relacionada con al menos una cuenta significativa o divulgación significativa con una estimación. Arrastre y suelte este SCOT en una cuenta significativa relevante o en una divulgación significativa.",
    warningMessageScotNotAssociatedWithAccount: "Cada SCOT debe estar relacionado con al menos una cuenta significativa o divulgación significativa. Arrastre y suelte este SCOT en una cuenta significativa relevante o en una divulgación significativa.",
    showvalidations: "Mostrar validaciones",

    scotRelatedWCGWandControls: "SCOTs y WCGWs y controles relacionados",
    newWcgw: "Nueva WCGW",
    manageWCGWs: "Gestionar WCGW",
    manageControl: "Gestionar controles",
    importWCGWs: "Importar WCGW",
    relateWCGWs: "Relacionar WCGW",
    newControl: "Nuevo control",
    importControl: "Importar control",
    importControls: "Controles de importación",
    relateControl: "Controles de relación",
    scotStrategyIsControlMessage: "No se han identificado controles para este WCGW. La estrategia SCOT no está definida.",
    scotStrategyIsWCGWMessage: "No se identificaron WCGW para este SCOT. La estrategia SCOT no está definida.",
    controlsPlaceholderWithNoRelatedWCGWsMessage: "Cada SCOT debe estar relacionado con al menos una WCGW. Cree un archivo",
    controlsPlaceholderWithNoRelatedControlsMessage: "Cada WCGW debe estar relacionado con al menos un control. Cree un archivo",
    noITApplicationSOMessage: "No se han identificado aplicaciones de TI ni organizaciones de servicios para este SCOT. Clic",
    relatedItAppSOHeaderMessage: "Aplicaciones IT relacionadas  y organizaciones de servicios",
    substantivePlaceholderWithNoRelatedControlsMessage: "No se han identificado controles para este SCOT. En el caso de los SCOT con una estrategia sustantiva, no es necesario identificar controles.",
    substantivePlaceholderWithNoRelatedWCGWsMessage: "No se identificó ninguna WCGW para este SCOT. En el caso de los SCOT con una estrategia sustantiva, es necesario identificar a los WCGW.",
    noITApplicationSOMessageText: "para relacionarse cuando sea necesario.",
    notSelected: "No seleccionado",
    or: "o",

    //WCGWControls
    showOnlyWCGWRelatedControls: "Mostrar solo elementos relacionados",

    createorRelateControl: "Crear un nuevo control o relacionar un control existente",

    //Accounts Scot build steps
    accountHeader: "Cuentas",
    searchAccount: "Buscar cuenta",
    searchAccountPlaceholder: "Buscar",
    manageAccounts: " Administrar cuentas y divulgaciones",
    showOnlyUnrelatedAccountToggleSwitch: "Mostrar solo no relacionados",
    searchAccountClearHoverText: "Limpiar",
    noAccountsAvailable: "No se han encontrado resultados",
    showOnlyScotRelatedAccount: "Mostrar solo las cuentas y divulgaciones significativas sin ningún SCOT relacionado",
    warningMessageEstimateAccountNotAssociatedWithEstimatedScot: "Cada cuenta o divulgación significativa con una estimación debe estar relacionada con al menos una estimación SCOT. Arrastre y suelte un SCOT relevante existente en esta cuenta significativa o divulgación significativa",
    warningMessageAccountNotAssociatedWithScot: "Cada cuenta o divulgación significativa debe estar relacionada con al menos un SCOT. Arrastre y suelte un SCOT relevante existente en esta cuenta significativa o divulgación significativa",
    significantAccountsAndDisclosures: "Cuentas significativas y divulgaciones",
    // Independence Only

    independenceOnlyStatus: "Solo independencia",

    //Controls
    controlDesignEffectivenessWarningValidation: "Los controles deben tener una eficacia de diseño seleccionada",
    controlHeader: "SCOT y controles relacionados",
    manageControls: "Gestionar controles",
    manageITApplications: "Gestionar aplicaciones de TI",
    searchControlClearHoverText: "Limpiar",
    searchControlPlaceholder: "Buscar",
    noControlsAvailable: "No se han encontrado resultados",
    controlName: "Nombre del control",
    frequency: "Frecuencia",
    type: "Tipo",
    newSO: "Nuevo SO",
    designEffectiveness: "Efectividad del diseño",
    testing: "Pruebas",
    strategyTypeName: "Estrategia SCOT",
    controlTestingYes: "Sí",
    controlTestingNo: "No",
    effective: "Efectivo",
    ineffective: "Inefectivo",
    noControlsResult: "No se han encontrado resultados",
    noControlsLabel: "No se han encontrado resultados",
    relatedControl: "Control relacionado",
    relateControls: "Relacionar Controles",
    controlTypeValues: {
        itApplication: "Controles de aplicaciones de TI",
        itDependentManual: "Control manual dependiente de TI",
        manualPrevent: "Manual preventivo",
        manualDetect: "Manual de Detección"
    },
    controlFrequencyTypes: {
        manyTimesPerDay: "Muchas veces al día",
        daily: "Diario",
        weekly: "Semanal",
        monthly: "Mensual",
        quarterly: "Trimestral",
        annually: "Anualmente",
        iTApplicationControl: "Control de aplicaciones de TI",
        other: "diario"
    },
    filterTypeOfScots: "SCOTs",
    noScotsAvailable: "No se han encontrado resultados",


    onlyShowControlsWithNoDesignEffectiveness: "Mostrar solo controles sin efectividad de diseño seleccionada",

    // control Tasks
    controlCount: "{0} controles",

    //Create and Edit WCGW
    wcgwInputName: "Nombre de WCGW",
    editWCGW: "Editar WCGW",
    createNewWCGW: "Crear una nueva WCGW",
    editTheWCGW: "Editar el WCGW",
    createEditWCGWSave: "Guardar",
    createEditWCGWClose: "Cancelar",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "Nueva WCGW",
    wcgwNameIsRequired: "Nombre de WCGW requerido",
    deleteWCGW: "Eliminar WCGW",


    //Audit Plan
    importPSPButtonText: "Importar PSPs",
    commonContentUpdateSuccessMessage: "Actualización de contenido en curso. Esto puede tardar hasta quince minutos en completarse. Actualice la página para ver los PSPs recién importados.",
    responsivetoRisks: "Responsivo a los riesgos",
    procedures: "Procedimientos",
    toc: "Toc",
    significantandFraudRisksHeading: "Riesgos significativos y de fraude y sus procedimientos y controles responsivos",
    risksBeingRespondedToByComponentTeam: "Los riesgos están siendo respondidos por los equipos componentes.",
    responsivecontrolsandTOCs: "Controles responsivos y TOCs",
    ResponsivePSPOSP: "PSP/OSP responsivo",
    responsivePSPsOSPs: "PSPs/OSPs responsivos",
    responsiveTOC: "TOC Responsivo",
    responsiveControl: "Control responsivo",
    responsivePSPOPSMessage: "Al menos un procedimiento sustantivo debe identificarse como adecuado para esta aseveración y para este riesgo. Haga clic {0} para identificar los procedimientos sustantivos receptivos.",
    responsiveControlMessage: "Se debe identificar al menos un control (con la evaluación de la eficacia del diseño completada) que responda a esta aseveración para este riesgo. Haga clic en {0} para identificar los controles interactivos. Haga clic {1} para establecer la eficacia del diseño o la estrategia de prueba.",
    responsiveTOCMessage: "Las aseveraciones con riesgo de control de Rely deben tener al menos una tabla de contenido que responda al riesgo de un control (1) no está designado como de menor riesgo y (2) tiene una eficacia de diseño completada. Haga clic en <b>Tabla de contenido interactiva</b> para identificar las tablas de contenido interactivas.",
    notcompleted: "No completado",
    noResponsiveTOCAvailable: "No se han identificado TOC que respondan a este control.",
    refresh: "Actualizar datos",
    tocHoverOverWhenControlTestingHasNoorNotCompleted: "Este control no ha sido seleccionado para la realización de pruebas. Utilice <b>Administrar controles</b> para cambiar la selección de pruebas.",
    noresponsiveTOCIdentified: "No se ha identificado ningún TOC que responda.",
    taskAssertionnotModified: "Las aseveraciones de tareas no se han modificado. Edite la relación de aseveración para continuar o haga clic en cancelar para salir.",
    failedToEditRelatedAssertions: "No se pudieron editar las aseveraciones relacionadas con la tarea. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.».",
    assertionCannotEdited: "Las aseveraciones con una casilla de verificación deshabilitada han sido establecidas por la metodología EY y no se pueden editar.",
    editAssertionInfoMessage: "Agregue o elimine aseveraciones para la tarea. Debe haber al menos una aseveración seleccionada.",
    editRelatedAssertions: "Editar aseveraciones relacionadas",
    loweRiskHeader: "Menor riesgo",
    placeholderWhenControlTestingHasNotCompleted: "Este control no se ha seleccionado para la prueba. Utilice {0} para cambiar la selección de pruebas.",
    pspandOSP: "PSP/OSP",
    tocs: "TOCs",
    norelatedAssertionPlaceHolder: "Cada riesgo significativo o de fraude debe tener al menos una afirmación identificada como relacionada con este riesgo. Haga clic en {0} para identificar las aserciones relacionadas.",
    assertionMustHaveOneControlWithCompleteDesignEffectiveness: "Cada aserción debe tener al menos un control con la eficacia del diseño completado identificada como sensible al riesgo. Haga clic en {0} para identificar un control interactivo.",
    controlRiskRelyNotLowerRisk: "Cada aserción con riesgo de confianza de control debe tener al menos un control que (1) no esté designado como de menor riesgo, (2) esté diseñado de manera efectiva y (3) seleccionado para pruebas. Haga clic en {0} para identificar el control interactivo.",
    controlRiskRelyWithDesignEffectively: "Cada aserción con riesgo de control de confianza debe tener al menos un control que (1) esté diseñado de forma eficaz y (2) seleccionado para la prueba. Haga clic en {0} para identificar el control interactivo.",

    assertionWithControlRiskNotRely: "Las aserciones con riesgo de control de no confiar no tienen el requisito de identificar una prueba de control.",
    thisControlNotSelectedForTesting: "Este control no se ha seleccionado para la prueba. Haga clic en {0} para cambiar la selección de pruebas.",
    testControlRelatedToControlAsLowerRisk: "Una prueba de control relacionada con un control designado como de menor riesgo no abordará el riesgo de esta afirmación.",
    testControlWithoutCompleteDE: "Una prueba de control relacionada con un control sin una evaluación completa de la eficacia del diseño no abordará el riesgo de esta aseveración. Haga clic en {0} para establecer la eficacia del diseño.",
    testControlrelatedToineffective: "Una prueba de control relacionada con un control con una evaluación de la eficacia del diseño ineficaz no abordará el riesgo de esta aseveración. Haga clic en {0} para cambiar la eficacia del diseño.",
    anotherTestControlIdentified: "Se ha identificado otra prueba de control que responde al riesgo de esta afirmación y no es necesario identificar más pruebas de control. No se han identificado TOC que respondan a este control.",
    eachControlMustHaveOneToc: "Cada aserción con riesgo de control de confianza debe tener al menos un TOC que responda al riesgo de un control que (1) no esté designado como de menor riesgo, (2) esté diseñado de manera efectiva y (3) seleccionado para pruebas. No se han identificado TOC que respondan a este control. Haga clic en {0} para identificar las tablas de contenido interactivas.",
    eachAssertionControlHaveAtleasetOneTOC: "Cada aserción con riesgo de control de confianza debe tener al menos una tabla de contenido que responda al riesgo de un control que (1) esté diseñado de manera efectiva y (2) seleccionado para pruebas. No se han identificado TOC que respondan a este control. Haga clic en {0} para identificar las tablas de contenido interactivas.",
    norepsonsivePSPOSPplaceholder: "Cada aserción debe tener al menos un procedimiento sustantivo identificado como sensible a este riesgo. Haga clic {0} para identificar un procedimiento sustantivo receptivo.",

    //Reject Task
    rejectPspModalTitle: "Rechazar PSP",
    rationaleRequired: "Obligatorio",
    rationaleTextEditorLabel: "Razones para rechazar el PSP",
    rejectTaskErrorMessage: "No se puede rechazar la tarea. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    rejectTaskModalHeader: "¿Estás seguro de que quieres rechazar el PSP seleccionado?",
    rejectTaskModaWarningText: "Las evidencias relacionadas que no estén relacionadas con ninguna otra tarea de este compromiso se moverán a archivos temporales.",
    rejectTaskRationaleLabel: "Justificación (obligatorio)",

    // Adobe Analytics
    aaCookieConsentTitle: "Bienvenidos a",
    aaCookieContentPrompt: "¿Desea permitir las cookies?",
	aaCookieConsentExplanation: '<p>Además de las cookies que son estrictamente necesarias para el funcionamiento de este sitio web, utilizamos los siguientes tipos de cookies para mejorar su experiencia y nuestros servicios: <cookies fuertes>funcionales</fuertes> para mejorar su experiencia (por ejemplo, recordar la configuración), <cookies fuertes>Rendimiento</fuertes> para medir el rendimiento del sitio web y mejorar su experiencia,  <cookies de publicidad/segmentación >strong</strong>, que son establecidas por terceros con los que ejecutamos campañas publicitarias y nos permiten proporcionarle anuncios relevantes para usted.</p><p>Revise nuestra <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">política de cookies</a> para obtener más información.</p>',
	aaCookieConsentExplanationWithDoNotTrack: '<p>Además de las cookies que son estrictamente necesarias para el funcionamiento de este sitio web, utilizamos los siguientes tipos de cookies para mejorar su experiencia y nuestros servicios: <cookies fuertes>funcionales</fuertes> para mejorar su experiencia (por ejemplo, recordar la configuración), <cookies fuertes>Rendimiento</fuertes> para medir el rendimiento del sitio web y mejorar su experiencia,  <cookies > fuerte/de segmentación</strong>, que son establecidas por terceros con los que ejecutamos campañas publicitarias y nos permiten proporcionarle anuncios relevantes para usted.</p><p>Hemos detectado que ha habilitado la configuración No rastrear en su navegador; como resultado, las cookies publicitarias/de orientación se desactivan automáticamente.</p><p>Revise nuestra <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">política de cookies</a> para obtener más información.</p>',
    aaCookieConsentDeclineOptionalAction: "Rechazo las cookies opcionales",
    aaCookieConsentAcceptAllAction: "Acepto todas las cookies",
    aaCookieConsentCustomizeAction: "Personalizar cookies",
    aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

    //Task Sections
    taskSectionLabels: {
        taskSectionHeader: "Grupos de tareas y tareas relacionadas",
        manageTaskSections: "Administrar grupos de tareas",
        taskSectionsAccordionHeader: "Grupos de tareas",
        phaseAccordionHeader: "Fase",
        tasksAccordionHeader: "Tareas",
        rejectedAccordionHeader: "Rechazado",
        noRelatedTasksMessage: "No hay PST/OST disponibles. Crea una {0} para empezar.",
        taskSectionTaskHeader: "Tareas",
        newOSTButtonText: "Nueva OST",
        cutomTaskSectionBadgeText: "Personalizar",
        rejectedTasksLabel: "PST rechazados",
        additionalInfo: "Fundamento",
        rejectButton: "Rechazar",
        acceptButton: "Aceptar",
        removeButton: "Remover",
        addButton: "Añadir",
        allPSTsRejectedMessage: "Todos los PST han sido rechazados.",
        rejectModalTitle: "Rechazar el PST",
        rationaleTextEditorLabel: "Justificación del rechazo del PST",
        rejectTaskModalHeader: "¿Está seguro de que desea rechazar el PST seleccionado?",
        noResultsMessage: "No se han encontrado resultados",
        noTaskSetionsAvailableMessage: "No hay secciones de tareas disponibles",
        rejectTaskModaWarningText: "Las pruebas relacionadas que no estén relacionadas con ninguna otra tarea de este compromiso se moverán a archivos temporales. Los PST con documentos entregados por EY Canvas no se pueden rechazar.",
        rejectTaskRationaleLabel: "Justificación (obligatorio)"
    },

    // Cookie Settings
    cookieSettings: {
        title: "Configuración de cookies",
        explanation: "Proporcione su consentimiento para el uso de cookies en ey.com y en la plataforma My EY. Seleccione uno o más de los tipos de cookies que se enumeran a continuación y luego guarde su(s) selección(es). Consulte la lista a continuación para obtener detalles sobre los tipos de cookies y su propósito.",
        emptyCookieListNotice: "Las cookies de esta categoría no se utilizan en esta aplicación",
        nameTableHeader: "Nombre de la cookie",
        providerTableHeader: "Proveedor de cookies",
        purposeTableHeader: "Finalidad de la cookie",
        typeTableHeader: "Tipo de cookie",
        durationTableHeader: "Duración de la cookie",
        formSubmit: "Guardar mi selección",
        requiredCookieListTitle: "Cookies requeridas",
        functionalCookieListTitle: "Cookies funcionales",
        functionalCookieAcceptance: "Acepto las siguientes cookies funcionales",
        functionalCookieExplanation: "Cookies de funcionalidad, que nos permiten mejorar su experiencia (por ejemplo, recordando cualquier configuración que haya seleccionado).",
        performanceCookieListTitle: "Cookies de rendimiento",
        performanceCookieAcceptance: "Acepto las siguientes cookies de rendimiento",
        performanceCookieExplanation: "Cookies de funcionalidad, que nos ayudan a medir el rendimiento del sitio web y mejorar su experiencia. Al utilizar cookies de rendimiento, no almacenamos ningún dato personal y solo utilizamos la información recopilada a través de estas cookies de forma agregada y anónima.",
        advertisingCookieListTitle: "Cookies de segmentación",
        advertisingCookieAcceptance: "Acepto las cookies de publicidad/segmentación a continuación",
        advertisingCookieExplanation: "Cookies de publicidad/segmentación, que usamos para rastrear la actividad y las sesiones del usuario para que podamos ofrecer un servicio más personalizado, y (en el caso de las cookies publicitarias) que son establecidas por los terceros con los que ejecutamos campañas publicitarias y nos permiten proporcionar anuncios relevantes para usted.",
        doNotTrackNotice: "Hemos detectado que ha habilitado la configuración No rastrear en su navegador; Como resultado, las cookies de  publicidad/segmentación están automáticamente deshabilitadas.",
    },

    //Task Sections and related Tasks
    taskSectionAndRelatedTask: "Secciones de tareas y tareas relacionadas",
    manageTaskSections: "Administrar secciones de tareas",

    // Financial Statments
    financialStatementLabels: {
        financialStatements: "Estados financieros",
        trialBalance: "Balance de comprobación",
        okButton: "OK",
        leadSheet: "Balance General",
        balanceSheet: "Balance",
        incomeStatement: "Cuenta de resultados",
        eyreferences: "Referencia",
        currenPeriod: "Fecha de análisis",
        comparativePeriod: "Fecha comparativa",
        changeFrom: "Cambiar de",
        percentageChangeFrom: "Variación porcentual de",
        notesColumn: "Notas",
        viewTrialBalanceType: "Visualización por tipo de balance de comprobación",
        multiEntity: "Multientidad",
        placeHolderText: "Clases de cuenta de búsqueda",
        currencyType: "Tipo de moneda",
        currencyCode: "Código de moneda",
        businessUnit: "Unidad de negocio",
        periodEnded: "Fecha de finalización",
        periodsEnded: "Fechas finalizadas",
        searchGLAccountPlaceholder: "Buscar cuentas de GL",
        eyReferenceDocuments: "{0} documentos",
        relatedNotes: "Notas relacionadas",
        notAvailable: "No disponible",
        significantDisclosures: "Divulgaciones significativas",
        noResultFound: "No se han encontrado resultados",
        openEYHelixProjects: "Abrir proyectos EY Helix",
        openAdjustmentModule: "Módulo de ajuste abierto",
        goToSubstantiveProcedureLink: "Ir a los procedimientos sustantivos",
        cancel: "Cancelar",
        remove: "Eliminar"
    },

    financialStatementsClassView: {
        bulk: "Grupo",
        eyAccount: "Cuenta EY",
        placeHolderText: "Buscar cuentas de GL",
        noAccountDesignation: "No se ha establecido la designación de la cuenta.",
        insignificantLeadSheetMessage: "Las hojas de trabajos no se presentan para cuentas insignificantes",
        unmappedGLAccounts: "Las hojas de trabajos no se presentan para cuentas no asignadas",
        unmappedAccountText: 'Unmapped'
    },
    financialStatementTypeIds: [{
            id: 1,
            label: "Activos"
        },
        {
            id: 4,
            label: "Pasivos"
        },
        {
            id: 7,
            label: "Fondos propios"
        },
        {
            id: 8,
            label: "Ingresos"
        },
        {
            id: 9,
            label: "Gastos"
        },
        {
            id: 17,
            label: "Ingresos netos"
        }
    ],
    copyrightMessage: "Copyright © <año> todos los derechos reservados",
    createNotes: {
        notesPlaceholderText: "Agregue notas haciendo clic en {0} o {1}.",
        newNote: "Añadir nota",
        relateNote: "Nota de relación",
        addNewNotesHeader: "Ingrese los detalles de la nota a continuación y seleccione <b>\'Guardar y cerrar\'</b> para finalizar. Para crear otra nota, seleccione <b>\'Guardar y crear otra\'</b>.",
        noteIndex: "Índice",
        noteIndexRequired: "Índice (obligatorio)",
        noteDescription: "Descripción",
        noteDescriptionRequired: "Descripción (obligatorio)",
        saveAndClose: "Guardar y cerrar",
        newTickmarkDescription: "Seleccione el motivo por el que no hay ninguna evidencia que haga referencia a esta cuenta de GL.",
        newTickmarkBulkModalDescription: " Seleccione el motivo por el que no hay pruebas a las cuentas de GL seleccionadas."
    },
    deleteNotes: {
        deleteNote: "Eliminar nota",
        deleteNoteTitle: "¿Estás seguro de que quieres eliminar la nota seleccionada?",
        delete: "Borrar",
        cancel: "Cancelar"
    },
    editNotes: {
        editNote: "Editar nota",
        editNotesHeader: "Edite los detalles de la nota a continuación y seleccione <b>\'Guardar y cerrar\'</b> para finalizar.",
        edit: "Editar",
        cancel: "Cancelar"
    },
    notesListLabels: {
        actions: "Acciones",
        noteCount: "{0} nota",
        notesCount: "{0} notas"
    },
    relateNotes: {
        relateNoteLabel: "Nota de relación",
        searchPlaceholder: "Buscar",
        accountLabel: "Cuenta",
        indexLabel: "Índice",
        descriptionLabel: "Descripción",
        addedLabel: "Añadido",
        showOnlyRelatedLabel: "Mostrar solo relacionados",
        noResultsFoundMessage: "No se han encontrado resultados",
        noteCount: "{0} Nota",
        notesCount: "{0} Notas",
        closeBtnTitle: "Cerrar"
    },
    uploadEvidenceDocuments: {
        addnewEvidencesPlaceholderandLinks: "Agregar evidencia haciendo clic en {0}, {1} o designe no se requiere evidencia haciendo clic en {2}.",
        newEvidence: "Nuevas evidencias",
        relateEvidence: "Relacionar las evidencias",
        newTickMark: "Nueva marca de verificación",
        relateTasks: 'Relate task',
        noTasksSeleted: "Seleccione una tarea para continuar.",
        relateTaskPlaceholder: "Las nuevas referencias deben estar relacionadas con al menos una tarea. Seleccione una tarea a la que se debe agregar este documento como evidencia.",
        confirmButtonTitle: "Continuar",
        closeButtonTitle: "Cancelar",
        noResultsFound: "No se han encontrado resultados",
        taskType: "Tipo",
        taskName: "Nombre de la tarea",
        taskCount: "{0} tarea",
        tasksCount: "{0} Tareas",
        title: "Referencia",
        removeReference: "Eliminar referencia"
    },
    glAccountAssociatedNotes: {
        aggregatedNotesPlaceholder: "No hay notas disponibles. Seleccione una cuenta de GL para crear una nota.",
        notes: "Notas",
        relatedGlAccountPlaceholder: "Cuentas de GL relacionadas"

    },
    finacialStatementsBulkOperations: {
        relateEvidenceLabel: "Relacionar las evidencias",
        selectedCountGLAccount: "{0} cuenta de GL seleccionada",
        selectedCountGLAccounts: "{0} cuentas de GL seleccionadas",
        selectAll: "Seleccionar todo",
        deselectAll: "Deseleccionar todo",
        exitBulkMode: "Salir del modo masivo",
        noGLAccountsSelectedValidationMessageEvidence: "Seleccione al menos una cuenta de GL para relacionar las pruebas o haga clic en Salir del modo masivo.",
        noGLAccountsSelectedValidationMessageTickmark: "Seleccione al menos una cuenta de GL para la nueva marca de verificación o haga clic en Salir del modo masivo.",
        noGLAccountsSelectedValidationMessageRemoveReference: "Seleccione al menos una cuenta de GL para eliminar la referencia o haga clic en Salir del modo masivo.",
        relateTickmarkLabel: "Nueva marca de verificación",
        removeReferenceLabel: "Eliminar referencia",
        removeReferenceConfirmationMsg: "Confirme si desea eliminar las referencias de todas las cuentas de GL seleccionadas."

    },
    financialStatementsFilters: {
        referenceFilterKey: "Referencias faltantes a las cuentas de GL",
        accountFilterKey: "Cuentas de GL sin asignación",
        noResultsPlaceholder: "No se han encontrado resultados",
        trialBalance: "Balance de comprobación",
        noneAvailable: "Ninguno disponible",
        search: "Buscar",
        multityEntity: "Multientidad",
        placeHolderMessageWhenHelixMappingIsTrue: "No hay balance de comprobación importada. Haga clic en {0} para relacionar un nuevo analizador.",
        placeHolderMessageWhenHelixMappingIsFalse: "La integración con EY Helix no está disponible. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
		eyHelixIntegrationLinkText: "Integración con EY Helix",
        noEntitiesAvailablePlaceholder: "No se han creado entidades. Cree entidades para empezar."
    },
    //Group instructions
    assertionTabButton: "Aseveraciones",
    inherentRiskFactorButton: "Factores de riesgo inherentes",
    accountsAndDisclosure: "Cuentas/Divulgaciones",
    assertions: "Aseveraciones",
    assertionC: "C",
    assertionEO: "E/O",
    assertionMV: "M/V",
    assertionRO: "R&O",
    assertionPO: "P&D",

    complexity: "Complejidad",
    subjUncertainty: "Incertidumbre del asunto",
    fraudOrError: "Fraude o error",
    change: "Cambio",
    natureOfAccount: "Naturaleza de la cuenta",
    relatedParties: "Partes Relacionadas",
    higherInherentRiskLabel: "Mayor riesgo inherente",
    lowerInherentRiskLabel: "Menor riesgo inherente",
    relevantLabel: "Riesgo asociado",
    relevantContributeLabel: "Riesgo asociado y contribuye al mayor riesgo inherente",
    incompleteInherentRiskTooltip: "Riesgo inherente incompleto",
    estimateLabel: "Estimado",
    riskAssociatedLabel: "Riesgo asociado",
    greaterExtentLabel: "Mayor extensión",
    lesserExtentLabel: "Menor extensión",
    accordionNoRiskLabel: "No hay ningún riesgo relacionado con esta aseveración de la cuenta.",
    accordionNoRiskAccountLabel: "No hay riesgo relacionado con esta cuenta",
    accordionNoAssertionsLabel: "No hay aseveraciones relacionadas con esta cuenta.",
    accordionLimitedRiskLabel: "La cuenta ha sido identificada como de riesgo limitado.",

    maps: "Mapas",
    financialStatements: "Estados Financieros",
    serviceGatewayAutomation: "Puerta de enlace de servicios y automatización",
    manageTaskGroups: "Administrar Grupos de tareas",
    openAssignmentsLabel: "Tareas abiertas",
    inProgressAssignmentsLabel: "Tareas en curso",
    // My Progress collaboration view.
	calendarDays: [
		"Domingo",
		"Lunes",
		"Martes",
		"Miércoles",
		"Jueves",
		"Viernes",
		"Sábado"
	],
	calendarMonths: [
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"Mayo",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre"
	],
    myProgressToday: "Hoy",
    noDueDateAssignedGroup: "No se ha asignado una fecha de vencimiento",
    myProgressStatusTile: {
        yourRequests: "Sus requerimientos",
        totalCount: "Cuenta Total",
        requestStatus: "Estado de la solicitud",
        draft: "Borrador",
        pending: "Pendiente",
        received: "Recibido",
        accepted: "Aceptado",
        overdue: "Atrasado",
        noRelatedTasks: "{0} Sin tareas relacionadas",
        oneNoRelatedTask: "1 sin tarea relacionada",
        addRequest: "Nueva solicitud",

        //Requests dues tile 2
        pendingRequestsByDueDate: "Solicitudes pendientes por fecha de vencimiento",
        requestsYAxisLabel: "Solicitudes",
        requestsXAxisLabel: "Días",
        tooltipDaysLabel: "días",
        tooltipTotalLabel: "Total:",
        normalLabel: "Normal",
        highLabel: "Alto",
        criticalLabel: "Crítico",
        overdueLabel: "Atrasado",
        overDueCatFirst: "Atrasado > 90",
        overDueCatSecond: "Atrasado 31-90",
        overDueCatThird: "Atrasado 10-30",
        overDueCatFourth: 'Overdue 1-9',
        catFifth: '1-9',
        catSixth: '10-30',
        catSeventh: '31-90',
        catEighth: '> 90',
        noRequestsFound: "No se han encontrado solicitudes",
        daysOverdue: 'Days overdue',
        daysComingDue: 'Days coming due'
    },
    documentAttributeReference: {
        name: "Nombre",
        notes: "Notas",
        signOffs: "Firmas",
        tasks: "Tareas relacionadas",
        open: "Abrir",
        openReadOnly: "Abrir solo lectura",
        delete: "Borrar",
        rename: "Renombrar",
        signOffRequirements: "Requisitos de aprobación",
        confidentiality: "Confidencialidad",
        unlink: "Desvincular",
        relateTasks: "Relacionar tareas"
    },
    aiChatbot: 'EYQ Assurance Knowledge',
    selectDueDate: "Seleccione una fecha de vencimiento",
    daysOverdue: 'Days overdue',
    daysComingdue: 'Days coming due',
    loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
    106: "Roles insuficientes para editar contenido. Trabaje con un administrador del compromiso para obtener suficientes derechos."
};

/*Errors*/
export const Errors = {
    /*Doc Helper Custom Messages */
    0: "Conexión perdida. Vuelva a conectar e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    101: "Estado de compromiso no válido.",
    102: "No se ha encontrado un usuario de compromiso válido.",
    103: "Falta el cumplimiento de la independencia del usuario de compromiso.",
    104: "Falta los ámbitos de Azure AD necesarios",
    105: "Se produjo un error al obtener los permisos del compromiso. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con el departamento de soporte.",
    106: "No tiene los permisos necesarios para realizar esta acción.",
    107: "No se ha encontrado un usuario del compromiso válido. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con Help Desk.",
    108: "El perfil del compromiso está incompleto. Vaya a Página de destino y  complete el perfil.",
    303: "Actualmente se está cargando un documento con el mismo nombre.",
    401: "No se puede completar la operación. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    403: "es un formato de archivo no compatible y no se ha cargado. Vuelva a guardar el documento en un formato de archivo válido e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    410: "Este documento ha sido eliminado y, por lo tanto, no se puede abrir.",
    411: "No se permiten documentos vacíos.",
    412: "Ya existe un documento con el mismo nombre en este compromiso",
    413: "El documento supera el tamaño máximo de archivo permitido (250 MB) y no se puede cargar. Reduzca el tamaño del archivo e inténtelo de nuevo.",
    500: "Conexión perdida. Vuelva a conectar e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    414: "El nombre supera la longitud máxima ({0} caracteres).",
    600: "La operación no se puede completar en este momento. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    601: "Existe un documento con el mismo nombre.",
    602: "El documento ya está en Colaboración",
    603: "Documento no encontrado.",
    'zip': "El archivo .zip no se puede cargar porque contiene uno o más tipos de archivos no compatibles, o contiene más que la cantidad máxima de archivos .zip incrustados.",
    401000: "Se detecta el cambio de red y vuelva a cargar la página para continuar",

    /*Accounts*/
    1001: "Error al crear llamada de cuenta.",
    1002: "Falta el nombre de la cuenta.",
    1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1004: "No se ha encontrado ningún artículo. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    1005: "Identificador de interacción no válido.",
    1006: "Tipo de cuenta no válida.",
    1007: "Tipo de instrucción no válida.",
    1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1009: "Error al obtener la llamada de cuenta por identificador.",
    1010: "Error al obtener la llamada al identificador de cuenta por cuenta de interacción.",
    1011: "Obtener resumen SEM para una llamada accountid fallido debido a una solicitud no válida.",
    1012: "Tipo de resumen no válido.",
    1013: "Error al crear la llamada de revisión de cuenta.",
    1014: "Error al eliminar la llamada de revisión de la cuenta.",
    1015: "Solicitud de creación de revisión de cuenta no válida.",
    1016: "ID de revisión de cuenta no válido.",
    1017: "La cuenta no forma parte de esta compromiso o se ha eliminado.",
    1018: "Revisión de cuenta fue creado por otro usuario.",
    1019: "La cuenta ha sido eliminada por otro usuario. Actualice la página e inténtelo de nuevo.",
    1020: "La cuenta necesita PSP para actualizarse",
    1024: "El nombre de la cuenta tiene más de 500 caracteres.",
    1025: "No se puede estimar el riesgo limitado o la cuenta insignificante",
    1026: "La cuenta no puede tener aseveraciones duplicadas",
    1027: "Identificador de aseveración no válido",
    1037: "No puede tener índices PSP duplicados",
    1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1048: "El tipo de ejecución de la cuenta no es válido.",
    1053: "La cuenta tiene asociado el riesgo o la estimación, no se puede establecer en una cuenta de riesgo limitado o una cuenta insignificante.",
    1054: "Las aseveraciones que se van a eliminar tienen asociadas con Riesgo o Estimación",
    1065: "No puede realizar cambios en las afirmaciones que tengan un riesgo significativo, o riesgo de fraude, o riesgo de error material o una estimación relacionada. Primero debe eliminar estas relaciones.",

    1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
    1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
    1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
    1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

    /*Assertions*/
    2001: "Solicitud de creación no válida.",
    2002: "Falta el nombre de aseveracion",
    2003: "Falta afirmación.",
    2004: "Error al obtener la llamada de afirmacion",
    2005: "Identificador de Canvas no válido.",
    2006: "Error al obtener la aserción por llamada de identificador.",
    2007: "Error en la llamada de los WCGWs de aseveracion",
    2050: "Aseveración no encontrada. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    /*Tags*/
    5120: "Etiqueta de ID no encontrado.",
    5121: "Falta la etiqueta de Identificación.",
    5123: "Asociacion de selección duplicada",
    5124: "Asociacion de selección no encontrada",


    /*Risks*/
    4001: "La operación no pudo completarse en este momento. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    4002: "Falta el nombre del riesgo.",
    4003: "Falta de riesgo.",
    4004: "Error al recibir una llamada de riesgo.",
    4005: "Identificador de compromiso no válido.",
    4006: "Error al obtener el riesgo por llamada de id.",
    4007: "Solicitud de consulta no válida.",
    4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4009: "Solicitud de actualización no válida.",
    4010: "WCGW específico ya asignado a este riesgo",
    4011: "La lista WCGW no puede ser nula.",
    4012: "No se han podido obtener los tipos de riesgo.",
    4013: "Solicitud de creación no válida.",
    4014: "La aseveracion relacionada no es válida. Actualice la página e inténtelo de nuevo. Si este error persiste, póngase en contacto con el servicio de asistencia.",
    4015: "El WCGW no es válido. Actualice la página e inténtelo de nuevo. Si este error persiste, póngase en contacto con el servicio de asistencia.",
    4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4017: "La aseveración no es válida para el riesgo. Actualice la página e inténtelo de nuevo. Si este error persiste, póngase en contacto con el servicio de asistencia.",
    4018: "El identificador de tipo de riesgo pasado no es válido.",
    4019: "RiskName no es válido.",
    4020: "ID de documento no válido.",
    4021: "RiskName no debe tener más de 500 caracteres.",
    4023: "La lista AssertonIds no puede ser nula.",
    4024: "No se pudo crear el formulario de documentación de riesgo limitado debido a un error. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    4025: "ID de cuenta no válido.",
    4026: "Id. de Aseveración no válido.",
    4027: "El modelo AssertionRisk no puede estar vacío",
    4031: "Opción inválida de Riesgo o Cuerpo del formulario.",

    4035: "No se puede editar IsHigherRisk para riesgos significativos o de fraude.",
    4036: "KnowledgeAssertionId no puede estar vacío si no se pasa ningún AssertionId. KnowledgeAssertionId debe estar en enumeraciones",
    4037: "KnowledgeAssertionId ya existe para esta cuenta.",
    4038: "RiskTypeId no coincide con las opciones permitidas.",
    4040: "Esta acción no se puede llevar a cabo. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",

    /*TASK*/
    5001: "Fallan todos.",
    5002: "Esta tarea ya no está disponible en este compromiso",
    5003: "Error al obtener documentos para la tarea. Parámetros de solicitud no válidos.",
    5004: "Error al obtener la tarea relacionada con el documento. Parámetros de solicitud no válidos.",
    5005: "Error al obtener tarea por identificador.",
    5006: "Error al llamar a las categorías de tareas.",
    5007: "Error al llamar a Get Task SubCategories.",
    5008: "Error al obtener la llamada a la descripción de la tarea.",
    5009: "Error al llamar a Get Task ClientRequests.",
    5010: "Error al guardar la llamada ClientRequests de la tarea.",
    5011: "La tarea con la que intenta relacionar elementos se ha eliminado o rechazado.",
    5012: "Se ha eliminado el elemento que está intentando relacionar.",
    5013: "La tarea con la que intenta relacionar elementos se ha eliminado o rechazado.",
    5014: "Se ha eliminado el documento que está intentando relacionar.",
    5015: "Error al llamar a Get Task Evidences.",
    5016: "Error al obtener la llamada de la tarea WCGW.",
    5017: "El identificador de compromiso debe ser mayor que cero.",
    5018: "Esta acción no se puede llevar a cabo. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    5019: "La descripción de la tarea está vacía",
    5020: "La tarea seleccionada se ha eliminado o rechazado. Como tal, esta acción no se puede completar en este momento.",
    5021: "Falta el identificador de compromiso de origen.",
    5022: "Error al guardar la anotación",
    5023: "No se ha encontrado el usuario de interacción.",
    5024: "Error al eliminar la llamada a la tarea.",
    5025: "Error al eliminar la llamada a tareas.",
    5026: "La lista de tareas está vacía",
    5027: "Revisión no encontrada.",
    5028: "Se requiere el nombre del archivo.",
    5029: "Se requiere extensión de archivo.",
	5030: 'El nombre del archivo no puede incluir: */:<>\\?|\"',
    5031: "Error al actualizar el nombre del documento.",
    5032: "Id. de documento no válido.",
    5033: "No se ha encontrado el tipo de operación.",
    5034: "Error al cambiar el estado de la tarea",
    5035: "La acción que está intentando realizar no se puede completar en este momento. Inténtelo de nuevo más tarde. Póngase en contacto con el servicio de asistencia si este error persiste.",
    5036: "Body no puede ser nulo o vacío en la llamada.",
    5037: "La solicitud no puede ser nula en la llamada.",
    5038: "Introduzca un nombre de archivo único para continuar.",
    5039: "Se requiere el nombre del archivo.",
    5040: "El nombre del archivo está limitado a 100 caracteres.",
	5041: 'El nombre del archivo no puede incluir: */:<>\\?|\"',
    5042: "Se rechaza la tarea seleccionada.",
    5043: "La tarea es una tarea paso de compilación.",
    5044: "La tarea es una tarea clave.",
    5045: "La tarea no es ningún tipo PSP u OSP.",
    5046: "Se supera el límite de caracteres.",
    5047: "Se supera el límite de caracteres.",
    5048: "Campo obligatorio.",
    5049: "El documento seleccionado no se puede quitar de esta tarea. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    5050: "El identificador del grupo de tareas no debe ser cero o no válido",
    5051: "El identificador de la sección de tareas no debe ser cero o no válido",
    5052: "Error al intentar agregar este documento a la tarea actual. La llamada falló.",
    5053: "Error al intentar actualizar este documento en la tarea actual. La llamada falló.",
    5054: "Error al intentar agregar una copia de este documento en la tarea actual. La llamada falló.",
    5055: "Error al intentar cambiar el nombre del documento. La llamada falló.",
    5056: "No se puede editar el título de la tarea para el conocimiento o la tarea de grupo",
    5057: "El tipo de tarea debe ser Tipo Ost",
    5058: "Este documento no se puede eliminar de la tarea porque está asociado al sistema.",
    5059: "Valor de fase de tiempo no válido.",
    5060: "Agregar al error de evidencia. Llamada fallida",
    5061: "Otro usuario ha actualizado la información presentada. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con el servicio de asistencia.",
    5062: "El documento solicitado no está disponible para el canal seleccionado del compromiso en EY Atlas. Por favor, comuníquese con la mesa de ayuda para que se pueda proporcionar información a los autores del contenido para su inclusión futura.",
    5063: "Operación de parche no válida.",
    5064: "La tarea seleccionada se ha eliminado o rechazado. Como tal, esta acción no se puede completar en este momento.",
    5065: "No se puede actualizar el tipo de origen de la tarea. La solicitud no es válida",
    5066: "Obtener error de orientación. La llamada falló.",
    5067: "No se puede actualizar el tipo de naturaleza de la tarea. La solicitud no es válida",
    5068: "No se puede actualizar el tipo de naturaleza de la tarea. La solicitud no es válida",
    5069: "La solicitud de eliminación de asignación de tarea fallo",
    5070: "Se han eliminado una o más tareas seleccionadas. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia si el error persiste.",
    5071: "No se puede actualizar la tarea. La solicitud no es válida",
    5072: "Preparador no encontrado. La solicitud no es válida",
    5073: "Asignación no encontrada.",
    5074: "Error al guardar la asignación de tareas",
    5075: "El miembro o rol del equipo seleccionado no puede tener una asignación duplicada para las tareas seleccionadas. Elija una asignación, un miembro del equipo o un rol diferentes para continuar. Póngase en contacto con el servicio de asistencia si el error persiste.",
    5076: "El miembro del equipo seleccionado no es un miembro activo de este engagement. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia si el error persiste.",
    5077: "Se han eliminado una o más tareas seleccionadas. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia si el error persiste.",
    5078: "Se ha eliminado la asignación de tareas seleccionada. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia si el error persiste.",
    5079: "Se han eliminado una o más tareas seleccionadas. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia si el error persiste.",
    5080: "La version grabada del documento no existe",
    5081: "El usuario que está asignado actualmente a esta tarea no se puede reasignar como Preparador. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia si el error persiste.",
    5082: "Error en la actualización. El nombre del documento debe ser único para un compormiso. Actualice la página para quitar este mensaje.",
    5083: "Se supera el límite de caracteres de detalle de tarea.",
    5084: "Error en la llamada al crear el documento de tarea.",
    5085: "Error en la llamada de eliminación del documento de tarea.",
    5086: "Error en la llamada de los desvíos de tareas.",
    5087: "Error en la llamada a la revisión de tareas.",
    5088: "Esta tarea debe contener pruebas para entregar. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia.",
    5089: "Todas las pruebas asociadas a esta tarea (con la excepción de los perfiles en papel) deben tener al menos un preparador y revisor para marcar como completos. Inténtelo de nuevo y póngase en contacto con el servicio de asistencia si el error persiste.",
    5091: "El nombre del perfil de papel ya existe en el compromiso.",
    5092: "El nombre no puede contener ninguno de los siguientes caracteres: */:<>?? \\",
    5093: "El nombre del perfil de papel supera la longitud máxima (100 caracteres).",
    5101: "Error al crear tarea.",
    5102: "Falta la descripción de la tarea.",
    5103: "Falta el título de la tarea.",
    5104: "Falta la fase de tiempo de la tarea.",
    5105: "La relación de tareas no se puede editar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con mesa de ayuda.",
    5106: "La fase de auditoría no es válida.",
    5107: "La fase de auditoría debe ser 'Alcance y estrategia' o 'Ejecución'.",
    5108: "La descripción de la tarea es demasiado larga.",
    5109: "Parámetro de tipo de rol no válido.",
    5110: "El identificador de asignación debe ser mayor que cero.",
    5111: "Se ha eliminado el elemento con el que está intentando relacionar las tareas. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    5112: "Se ha eliminado el elemento con el que está intentando relacionar las tareas. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    5113: "Se ha eliminado el elemento con el que está intentando relacionar las tareas. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    5116: "El tipo de documento no es válido.",
    5119: "EL estatus de las tareas para una o mas de las tareas seleccionadas no han sido actualizadas. Actualice la pagina e intente de nuevo. Contacte al Help Desk si el error continua.",
    5127: "No se puede completar la asociación. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    5129: "No se puede completar la asociación. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    5133: "No se puede completar la asociación. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    5137: "La relación de tareas no se puede editar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con mesa de ayuda.",
    5138: "La relación de tareas no se puede editar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con mesa de ayuda.",
    5140: "La relación de tareas no se puede editar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con mesa de ayuda.",
    5146: "Para marcar una tarea completa, todas las pruebas asociadas (con la excepción de los perfiles en papel) deben tener al menos un preparador y la firma del revisor. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    5150: "Una o varias automatizaciones no podrían estar relacionadas con la tarea seleccionada en este momento. Actualice la página e inténtelo de nuevo. Póngase en contacto con mesa de ayuda si el error persiste.",
    5156: "La relación de tareas no se puede editar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con mesa de ayuda.",
    5157: "La relación de tareas no se puede editar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con mesa de ayuda.",
    5159: "El tipo de documento compartido no es válido.",
    5160: "Ocurrió un error al intentar vincular el documento. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",
    5174: "La tarea debe estar relacionada con una o más entidades. Para que la interacción de la tarea sea para toda la tarea, cambie el botón de alternancia Tareas por entidad.",
    5184: "El tipo de tarea no es una tarea estándar primaria ni una tarea de procedimiento sustantivo Principal.",
    5185: "La tarea con documentos entregados de EY Canvas no puede ser rechazada.",
    5188: "Documento no válido o desvinculación en curso.",
    5189: "La tarea tiene documentos que son Evidencia Vinculada o Respuesta Vinculada.",
    5190: "La tarea debe tener al menos una aserción.",
    5191: "No se puede completar la asociación. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    5192: "Se ha eliminado el elemento con el que está intentando relacionar las tareas. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    5193: "El elemento seleccionado se ha eliminado. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",


    /*WCGW*/
    6001: "Error en la llamada de la creación WCGW.",
    6002: "Falta el nombre WCGW.",
    6003: "Falta WCGW.",
    6004: "Conseguir la llamada WCGW falló.",
    6005: "Identificador de interacción no válido.",
    6006: "No se pudo completar la acción solicitada, ya que el ID de aseveración no es válido o se ha eliminado. Actualice la página e inténtelo de nuevo.",
    6007: "Consiga el WCGW por la llamada del Id falló.",
    6008: "Solicitud no válida.",
    6009: "No se pudo completar la acción solicitada, ya que el ID de WCGW no es válido o se ha eliminado. Actualice la página e inténtelo de nuevo.",
    6010: "La tarea no se pudo asociar al WCGW.",
    6011: "Se elimina el WCGW seleccionado.",
    6012: "La tarea y WCGW no están relacionados con la misma aseveracion",
    6013: "La tarea seleccionada no pertenece al mismo compromiso",
    6014: "La tarea no se pudo desvincular del WCGW.",
    6015: "La tarea no se pudo asociar al WCGW.",
    6016: "La tarea se rechaza y no se puede asociar al WCGW.",
    6017: "La tarea no es una tarea de hito y no se puede asociar al WCGW.",
    6018: "La tarea no es una tarea de paso de compilación y no se puede asociar al WCGW.",
    6019: "La tarea no es un PSP u OSP y no se puede asociar al WCGW.",
    6020: "La tarea y wcGW se asocian a la misma aseveración y no se pueden asociar al WCGW.",
    6027: "WCGWId o ControlId no válidos.",
    6028: "No se puede completar la asociación. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    6029: "No se puede completar la eliminación. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",

    /*Engagement*/
    7001: "Obtener por ID no encontrado.",
    7002: "Error al obtener compromisos por llamada de identificador de área de trabajo.",
    7003: "Error en la llamada de getAll engagement entities.",
    7004: "Error al obtener compromiso por llamada de identificación.",
    7005: "Error al llamar a los usuarios de la interacción de Get.",
    7006: "El apellido no debe superar los 250 caracteres.",
    7007: "Error de tipo de usuario no válido.",
    7008: "El nombre no debe superar los 250 caracteres.",
    7009: "La GUI de usuario no puede ser nula.",
    7010: "Error de estado de usuario no válido.",
    7011: "Error al crear la llamada de usuario de compromiso.",
    7012: "{0} {1} no se puede invitar porque ya es un miembro del equipo activo o pendiente.",
    7013: "Las iniciales no deben superar los 3 caracteres.",
    7014: "La página de destino de EY Canvas no es accesible en este momento. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7015: "{0} {1} no se puede invitar como los siguientes grupos de acceso: {2} se han eliminado de la compromiso. Actualice e inténtelo de nuevo.",
    7016: "{0} {1} no se puede invitar, ya que el usuario ya es un miembro del equipo activo en los siguientes grupos de acceso: {2}",
    7017: "El dominio no está permitido para los grupos seleccionados: {0}",
    7018: "La dirección de correo electrónico no debe ser nula.",
    7019: "Nombre no debe ser null.",
    7020: "Apellido no debe ser nulo",
    7021: "La inicial del usuario no debe ser null.",
    7022: "La oficina principal del usuario no debe ser null.",
    7023: "El LoginName del usuario no debe ser null.",
    7024: "El EYRole del usuario no debe ser null.",
    7025: "El rol de compromiso del usuario no debe ser null.",
    7026: "No se puede completar la operación. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7027: "Dirección de correo electrónico no válida",
    7028: "Error en la llamada de usuario de Patch Engagement.",
    7029: "usuarios del compromiso - Invalid EngagementUserStatusId.",
    7030: "usuarios del compromiso - Invalid EngagementUserRoleId.",
    7031: "No se ha encontrado uno o varios usuarios de compromiso.",
    7032: "El correo electrónico no debe tener más de 250 caracteres.",
    7033: "El usuario solicitado no puede ser Null.",
    7034: "Error en la cola del procesador de mensajes universal.",
    7035: "Las iniciales no deben superar los 3 caracteres.",
    7036: "El nombre no debe superar los 250 caracteres.",
    7037: "El apellido no debe superar los 250 caracteres.",
    7038: "Error al crear la llamada de usuario externo.",
    7039: "No se puede invitar a uno o más usuarios porque ya son miembros del equipo activos o pendientes. Actualice la página e inténtelo de nuevo, si el problema persiste, póngase en contacto con el servicio de asistencia",
    7040: "El nombre no debe superar los 250 caracteres.",
    7041: "El apellido no debe superar los 250 caracteres.",
    7042: "Las iniciales no deben superar los 3 caracteres.",
    7043: "GPN no debe tener más de 250 caracteres.",
    7044: "La GUI no debe tener más de 250 caracteres.",
    7045: "Error al obtener el usuario externo por ID.",
    7046: "El usuario no debe ser null.",
    7047: "No se pueden guardar los cambios en este momento. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7048: "La página principal de EY Canvas no es accesible en este momento y es necesario para editar. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7049: "Error al actualizar la llamada de usuario de compromiso.",
    7050: "Los miembros no se pueden desactivar. El compromiso debe tener al menos un miembro que tenga permisos para administrar la compromiso. Actualice la selección e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7051: "Error al obtener el usuario interno por ID.",
    7052: "Usuario no encontrado.",
    7053: "Obtener por ID no encontrado.",
    7054: "Error en los vínculos rápidos por llamada de ID de compromiso.",
    7055: "Derechos insuficientes para agregar miembros anteriores. Hable con un miembro del equipo de compromiso con los derechos apropiados para tomar esta acción.",
    7056: "EY Canvas no pudo guardar los cambios en este momento. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7057: "Derechos insuficientes para añadir nuevos miembros. Hable con un miembro del equipo de compromiso con los derechos apropiados para tomar esta acción.",
    7058: "El estado del usuario ha cambiado. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7062: "No se puede acceder al Portal del cliente de EY Canvas en este momento y se requiere para actualizar la información de los miembros existentes. Vuelva a intentarlo y, si el problema persiste, póngase en contacto con el servicio de asistencia técnica.",
    7063: "No se pueden desactivar miembros externos. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",
    7064: "Operación de parche no válida.",
    7065: "{0} {1} no se puede activar en uno o varios grupos de acceso. El dominio no está permitido para los grupos seleccionados: {2}.",
    7066: "{0} no es un usuario válido.",
    7067: "Error al poner la llamada de usuario externo.",
    7068: "No se puede acceder al Portal del cliente de EY Canvas en este momento y se requiere para actualizar la información de los miembros existentes. Vuelva a intentarlo y, si el problema persiste, póngase en contacto con el servicio de asistencia técnica.",
    7069: "Los grupos de acceso seleccionados no están activos: {0}. Quitar e intentarlo de nuevo.",
    7072: "Se ha producido un error durante el proceso de desvinculación. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    7074: "Los cambios no se pueden guardar. El compromiso debe tener al menos un miembro activo que tenga permisos para administrar el compromiso y haya resuelto la independencia. Si el problema persiste, comuníquese con la mesa de ayuda.",
    7075: "{0} {1} no se puede invitar porque ya eres un miembro activo del equipo",
    7077: "Uno o más usuarios no se pueden desactivar. Actualice la página e inténtelo de nuevo, si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7079: "El dominio no está permitido. Inténtelo de nuevo y si el problema persiste, póngase en contacto con el servicio de asistencia.",
    7080: "No tiene permiso para invitar a miembros de terceros. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia para obtener permiso si procede.",
    7094: "El miembro del equipo seleccionado ha firmado los documentos de esta contratación y no se puede quitar.",
    7100: "No se puede procesar ediciones a campos restringidos. Actualice y vuelva a intentarlo.",

    /*SCOT*/
    8001: "Error al crear la llamada SCOT",
    8002: "Falta el nombre Scot",
    8003: "SCOT faltante",
    8004: "Error al recibir la llamada SCOT",
    8005: "Identificador de compromiso no válido.",
    8006: "Identificador de aseveración no válido.",
    8007: "Error al llamar a Scot by Id.",
    8008: "Solicitud no válida.",
    8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
    8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

    /*User*/
    10001: "No se han encontrado las preferencias del usuario que han iniciado sesión.",
    10002: "Error en la llamada GetAll del usuario.",
    10003: "Error en la llamada de la llamada de la presencia del usuario.",

    /*Risk Type*/
    11001: "Solicitud de creación no válida.",
    11002: "Falta el nombre RiskType.",
    11003: "Falta RiskType.",
    11004: "Error al recibir la llamada RiskType.",
    11005: "Identificador de cmpromiso no válido.",

    /* Annotation Errors*/
    12001: "Parámetros de solicitud no válidos.",
    12002: "Error al crear llamada de anotación.",
    12003: "Error al obtener anotación.",
    12004: "ID de compromiso no válido.",
    12005: "Los datos de identificación de la colección deben ser mayores que cero.",
    12006: "La colección de ID no puede estar vacía.",
    12007: "ID de tarea no válido.",
    12008: "ID de documento no válido.",
    12009: "Debe tener ID de Documento, ID de Tarea o ID de estados financieros válidos.",
    12010: "Las respuestas requieren Tenencia",
    12011: "ID de estado no válido.",
    12012: "El tipo de documento debe ser 440GL.",
    12013: "Tipo de anontación no válido.",
    12014: "Usuario de interacción no válido.",
    12015: "Este documento ha sido borrado por otro usuario.",
    12016: "Error al actualizar la llamada de anotación.",
    12017: "La nota a la que está respondiendo ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo.",
    12018: "El tipo de acción de cambio de anotación no debe ser Null.",
    12019: "Nota de revisión eliminada",
    12020: "Acción no válida para realizar",
    12021: "El usuario no es autor de la anotación",
    12022: "Usuario autor faltante",
    12023: "El usuario autor no existe ni pertenece al compromiso",
    12024: "Asignación de usuario requerida",
    12025: "El usuario asignado no existe o no pertenece al compromiso",
    12026: "Notas no válidas.",
    12027: "Las notas no deben estar vacías.",
    12028: "Fecha de vencimiento requerida",
    12029: "Se requiere prioridad válida",
    12030: "La respuesta o edicion es muy larga. Cierre y reabra la ventana para actualizar los datos y continuar editando",
    12031: "La anotación debe ser de nivel superior",
    12032: "La anotación no debe ser de nivel superior.",
    12033: "Al menos uno de los siguientes valores no debe estar vacío: tipo de prioridad, fecha de vencimiento, estado o usuario asignado.",
    12034: "Las notas superan la longitud máxima (4.000 caracteres).",
    12035: "La cadena de búsqueda supera la longitud máxima (500 caracteres).",
    12036: "Solo se debe aceptar TaskId o DocumentId, ambos no están permitidos.",
    12037: "Operación de patch inválida.",
    12038: "Esta tratando de editar una nota que no existe. Refreque la pagina y trate de nuevo",
    12039: "Está intentando editar la misma nota que otro miembro del equipo. Actualice la página e intente nuevamente.",
    12040: "llamada para Obtener anotación  de usuarios fallida.",
    12041: "Error al obtener anotaciones de usuarios. Valor de consulta no válido.",
    12042: "El tipo de documento no es válido para crear una anotación.",
    12043: "Está intentando agregar una nota a una tarea o documento que ya no existe. Actualice la página e intente nuevamente.",
    12044: "Esta tratando de editar una replica a una nota que no existe aun. Refreque la pagina y trate de nuevo",
    12045: "Nota de revisión no encontrada.",
    12046: "Está intentando eliminar una nota que ya ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo.",
    12047: "Solo puede eliminar las respuestas a las notas que se encuentran en estado Abierto. Actualice la página e inténtelo de nuevo.",
    12048: "Está intentando cambiar el estado de una nota que ya no existe. Actualice la página e inténtelo de nuevo.",
    12049: "Está intentando eliminar una respuesta a una nota que ya ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo.",
    12050: "Solo puede eliminar notas que están en estado Cerrado.",
    12059: "Las notas de revisión solo pueden ser eliminadas por el usuario que creó la nota.",
    12066: "Solo puede responder a las notas abiertas.",
    12067: "Está intentando eliminar una respuesta a un comentario que ya ha sido eliminado por otro miembro del equipo. Actualice la página e inténtelo de nuevo.",
    12068: "No se pudo agregar el comentario. Actualiza la página y vuelve a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",
    12070: "Solo puede agregar un comentario por estado financiero. Por favor, edite el existente.",
    12071: "Error al eliminar la información. Inténtalo de nuevo. Si el problema persiste, póngase en contacto con Mesa de ayuda.",

    /*Configuration*/
    13001: "No se han encontrado configuraciones.",
    13002: "Error al obtener la llamada a la API Configurations.",

    /*Documents*/
    14001: "No se puede realizar la llamada porque la solicitud es null.",
    14002: "Documento no encontrado. La llamada falló.",
    14003: "El identificador de compromiso debe ser mayor que cero.",
    14004: "El identificador de documento no debe ser nulo ni estar vacío.",
    14005: "Error al intentar obtener las tareas asociadas. Error en la llamada.",
    14006: "El documento seleccionado no se puede eliminar. Inténtalo de nuevo más tarde. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    14007: "Se ha producido un error inesperado.",
    14008: "Se ha producido un error inesperado durante la firma.",
    14009: "Se ha producido un error al agregar una firma.",
    14010: "El identificador de aprobación debe ser mayor que cero.",
    14011: "Se ha producido un error al eliminar una firma.",
    14012: "El cuerpo no puede estar vacío.",
    14013: "El documento seleccionado no se puede desvincular. Inténtalo de nuevo más tarde. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    14014: "Error al obtener la llamada al id de cuenta por documento.",
    14015: "Entidad relacionada no válida.",
    14016: "Error al obtener la llamada de aprobación de documento.",
    14017: "Error en la llamada a GetAll Document Findings.",
    14018: "Error al llamar a GetAll Documents.",
    14019: "No se ha encontrado la firma de registro.",
    14020: "Valor de acción no válido.",
    14021: "Tipo de hallazgo no válido.",
    14022: "El documento no pertenece al compromiso.",
    14023: "El tipo de cambio de documento no es válido.",
    14024: "Falló la llamada a GetAll Documents. El parámetro no es válido.",
    14025: "Se ha producido un error al crear la revisión del documento. Error en la llamada a la API.",
    14026: "Se ha producido un error al eliminar la revisión del documento. Error en la llamada a la API.",
    14027: "El identificador de compromiso no debe ser nulo ni estar vacío.",
    14028: "El ID de usuario no es válido.",
    14029: "El Usuario no está autorizado a realizar esta acción.",
    14030: "No se encontró ningún documento con el identificador pasado en este compromiso.",
    14031: "El ID de revisión de documentos no es válido.",
    14032: "No se encontró la revisión del Documento.",
    14033: "El Documento ya fue aprobado.",
    14034: "Un proceso de desvinculación está en curso para otra compromiso en el área de trabajo o este documento ya se ha desvinculado. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    14035: "El documento no se comparte con el compromiso dado.",
    14036: "El número de versión debe ser mayor que cero.",
    14037: "La operación no puede ser completada en este momento. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    14038: "No se han podido obtener los motivos de cambio de documento.",
    14039: "No se pudo obtener el motivo del cambio de documento por id.",
    14040: "No se pudo actualizar el motivo del cambio.",
    14041: "Razón de cambio no válida.",
    14042: "Error en el motivo del cambio de actualización.",
    14043: "No se pudo crear el motivo del cambio.",
    14044: "No se pudo eliminar el motivo del cambio.",
    14045: "Identificador de razón de cambio no válido.",
    14046: "El documento no está disponible. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    14047: "El documento ya tiene asignado un motivo de modificación.",
    14048: "El documento tiene un conflicto, por favor resuelva antes de continuar.",
    14049: "Datos no válidos para comprobar si el documento se agrega al equipo o al usuario.",
    14050: "Error al quitar el documento de referencia.",
    14051: "Desvincule toda la lista de comprobación de evidencia compartida que no se ha encontrado.",
    14052: "El texto de búsqueda supera la longitud máxima permitida (500 caracteres).",
    14053: "No se puede realizar la llamada porque la solicitud es null.",
    14054: "Operación de parche no válida.",
    14055: "Error en la llamada al historial de documentos.",
    14056: "Se ha producido un error al intentar poner en cola el mensaje.",
    14057: "Ya existe un documento con el mismo nombre en el compromiso.",
    14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
    14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
    14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
    14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
    14062: 'The document confidentiality type id is not valid.',
    14063: 'Cannot change confidentiality type of this document type.',
    14064: 'User doesnt have permission.',
    14065: 'Invalid custom description.',
    14066: 'Failed to update extension.',
    14067: 'Invalid extension.',
    14068: 'Failed to get document extensions.',
    14069: "Este documento ya ha sido desvinculado por otro miembro del equipo. Actualice la página y póngase en contacto con el servicio de asistencia si el error persiste.",
    14070: "Tipo de archivo no válido.",
    14071: "La versión del documento seleccionado ya no está disponible. Cierre y vuelva a abrir esta ventana para ver el último conjunto de versiones históricas del documento.",
    14072: 'Source document Id should not be null or empty.',
    14073: 'Canvas form ids should not be null or empty.',
    14074: "Canvas form ID's should not be duplicates.",
    14075: 'Failed to associate document to canvas forms.',
    14076: "No se han encontrado formularios de Canvas asociados al documento de origen.",
    14077: 'Source document not found. Call failed.',
    14078: 'Current document is already associated with given canvas forms.',
    14079: "Este documento se ha eliminado y, por lo tanto, no se puede abrir.",
    14080: 'The source approval user id is invalid.',
    14081: 'The source approval user id should valid GUID and must not be empty GUID.',
    14082: 'The modify user id is invalid.',
    14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
    14084: 'File name cannot include: */:<>\\?|""',
    14085: 'The document name exceeded maximum length allowed.',
    14086: 'DocService failed while updating document details.',
    14087: 'The input is not valid.',
    14088: 'A input has duplicate document names.',
    14089: "La observación del marcador no es válida.",
    14090: "El estado de la solicitud ha cambiado. Actualice la página y vuelva a intentarlo si es necesario. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    14091: "Esta solicitud ha sido eliminada. Actualice la página para ver los datos actualizados. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

    /*SEM*/
    15001: "Obtener resumen SEM para una llamada de identificador de cuenta fallido debido a una solicitud no válida.",
    15002: "Id. de cuenta no válido.",
    15003: "Identificador de interacción no válido.",
    15004: "Tipo de resumen no válido.",
    15005: "No se puede encontrar una cuenta relacionada. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el problema persiste.",

    /*Timephase*/
    16001: "Error al obtener fases de tiempo.",
    16002: "El compromiso debe ser mayor que cero.",
    16003: "La fase temporal debe ser mayor que cero.",
    16004: "Valor de identificador de tarea no válido.",
    16005: "Valor de fase de tiempo no válido.",

    /*Validations*/
    17001: "Falta el identificador de paso de compilación o el identificador de tipo de documento.",

    /*TaskGroupSection*/
    18001: "Error en la llamada al grupo de tareas GetAll.",
    18005: "Este grupo de tareas ya no está disponible en este compromiso.",
    18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    18016: "Los grupos de tareas solo se pueden eliminar cuando no hay tareas relacionadas. Elimine o mueva las tareas relacionadas e inténtelo de nuevo.",
    18019: "El grupo de tareas que está intentando actualizar ya se ha eliminado.",

    /*Assignments*/
    19001: "Error al crear una llamada de asignación.",
    19002: "Error al obtener la llamada de asignación.",
    19003: "El nombre de la asignación debe ser único",
    19004: "Nombre de asignación no válido",
    19005: "La longitud del nombre de asignación supera más de 100 caracteres",
    19006: "Tipo de asignación no válido",
    19007: "La longitud de la asignación de búsqueda supera los 500 caracteres.",
    19008: "Otro miembro del equipo eliminó este nombre de asignación. Actualice la página e inténtelo de nuevo.",

    19012: "Los IDs de la tarea no se pueden repetir.",
    19013: "Los campos ID de Rol y el ID de usuario no pueden tener valores al mismo tiempo.",
    19014: "El ID de usuario no puede ser el valor predeterminado.",
    19016: "El usuario PIC no valido o usuario PIC no invitado",
    19017: "El usuario de EQR no válido o el usuario de EQR no está invitado.",
    19018: "El valor de los días de vencimiento debe ser mayor que 0 y menor que 1000.",
    19019: "La llamada de asignación automática de tareas falló.",

    /*Client Request*/
    21001: "La solicitud no se pudo enviar a EY Canvas Client Portal. Actualiza la página y vuelve a intentarlo. Si el problema persiste, póngase en contacto con la mesa de ayuda.",
    21002: "Esta solicitud se ha eliminado. Actualice la página para ver los datos actualizados. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    21009: "Error al eliminar la llamada del documento de solicitud del cliente.",
    21010: "El comentario que está respondiendo ha sido eliminado por otro miembro del equipo. Actualiza la página y vuelve a intentarlo.",
    21011: "El documento de solicitud del cliente ha sido eliminado.",
    21012: "No se encontró el documento de solicitud del cliente.",
    21013: "La solicitud del documento está vacía.",
    21014: "La identificación del documento está vacía.",
    21015: "El ID de solicitud del cliente está vacío.",
    21016: "Error al crear la llamada del documento de solicitud del cliente.",
    21017: "Uno o más de los documentos asociados se han eliminado del compromiso. Remueva los documentos eliminados de esta solicitud o actualice la página e inténtelo de nuevo.",
    21018: "No se encontró el documento.",
    21019: "El estado de solicitud del cliente ha cambiado.",
    21030: "El ID del grupo de clientes no coincide.",
    21031: "El estado de solicitud ha cambiado. Refresque la página y vuelva a intentarlo si es necesario. Si el problema persiste, póngase en contacto con la mesa de ayuda.",
    21032: "El usuario de contacto del grupo del cliente no está activo.",
    21033: "El grupo de clientes no está activo.",
    21034: "El grupo de clientes no contiene usuario activo.",
    21045: "El estado de solicitud ha cambiado. Refresque la página para ver los últimos cambios.",
    21046: "La solicitud no se pudo enviar a EY Canvas Client Portal. Actualiza la página y vuelve a intentarlo. Si el problema persiste, póngase en contacto con la mesa de ayuda.",
    21050: "No se pudieron eliminar las solicitudes. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con Help Desk",
    21053: "La tarea ya no está disponible en el engagement. Actualice la página para actualizar la lista.",
    21057: "No se pudo asignar el contacto de EY. Actualice la página e inténtelo de nuevo.",
    21028: "Se requiere fecha de vencimiento.",
    21036: "No se encontró fase temporal",
    21064: "La tarea no se puede asociar a la solicitud. Las solicitudes se pueden asociar a hasta 25 tareas. Elimine una o más tareas asociadas para asociar una nueva.",
    21065: "Se han agregado uno o más documentos confidenciales a la solicitud. No tiene el nivel de confidencialidad adecuado para enviar uno o más de estos documentos al Portal de Cliente EY Canvas. Elimine cualquier documento confidencial al que no tenga acceso para continuar.",
    21066: "Ocurrió un error al recuperar los datos. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    21067: "No se pudo actualizar la prioridad. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    21035: "No se ha encontrado la solicitud del cliente.",
    21074: "La solicitud recibida no permite cambios en Título, Descripción, Prioridad.",
    21075: "No se permiten cambios a la solicitud aceptada Título, Descripción, Asignado a (grupo), Asignado a (usuario), Fecha de vencimiento, Prioridad.",
    21077: "La fecha de vencimiento es necesaria para las solicitudes de cliente en estado Recibido y Pendiente.",
    21039: "No se encontró el ID de Grupo de clientes.",
    21078: "Tanto el grupo como el usuario son obligatorios al actualizar el Grupo asignado o el Usuario asignado a.",
    21079: "El formato de fecha no es válido.",
    21027: "Se requiere el título de la solicitud.",
    21041: "La longitud del título de la solicitud supera el número máximo de caracteres permitidos.",
    21042: "La longitud de la descripción de la solicitud supera el número máximo de caracteres permitidos.",
    21060: "ID de Usuario del Cliente está vacío.",
    21076: "No se permite el tipo de prioridad.",

    /* Group Components*/
    22001: "Error al obtener la llamada de componentes relacionados.",
    22002: "Error en la llamada de los componentes del grupo.",
    22003: "Error al crear la llamada de los componentes del grupo.",
    22004: "ID de componente principal no válido, el componente principal que especificó no existe.",
    22005: "El nombre del equipo ha excedido la longitud máxima.",
    22006: "El nombre legal del equipo ha excedido la longitud máxima.",
    22008: "El alcance que especificó no existe.",
    22009: "Nombre corto de componentes no válidos.",
    22010: "Nombre legal componente no válido.",
    22011: "ID de alcance componente no válido.",
    22012: "Si se proporcionó el correo electrónico del punto de contacto, la guía del punto de contacto no puede ser nula o vacía.",
    22013: "Si se proporcionó el correo electrónico del punto de contacto, el texto del punto de contacto no puede ser nulo ni estar vacío.",
    22016: "Este equipo ya ha sido eliminado por otro miembro del equipo. Actualice la página e inténtelo de nuevo.",
    22022: "El nombre del equipo ya existe en este compromiso.",
    22043: "Error en la llamada de Envio de instrucciones.",

    /*User Presence*/
    23001: "No se ha encontrado la presencia del usuario iniciada.",
    23002: "Error en la llamada de la presencia del usuario.",
    23003: "Error en la validación del documento de presencia del usuario.",
    23004: "Error en la llamada de eliminación de presencia del usuario.",
    23005: "El documento ya no lo abre ningún otro usuario. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el problema persiste.",

    /* Forms */
    24001: "llamada obtenida fallida.",
    24002: "ID de compromiso no válido.",
    24003: "ID del documento no debe ser nulo o vacío.",
    24004: "ID de documento no válido.",
    24005: "ID de encabezado de formulario no válido.",
    24006: "ID de sección de formulario no válido.",
    24007: "Parámetros de solicitud no válidos.",
    24008: "El ID del encabezado no debe ser nula o vacío.",
    24009: "El ID de la sección no debe ser nulo o vacío.",
    24010: "Falló la operación de actualización de respuesta del texto del formulario.",
    24011: "Solicitud no válida para la actualización de la respuesta del texto del formulario.",
    24012: "Identificación del texto no válida.",
    24013: "ID de opción de texto de formulario no válido.",
    24014: "ID de tipo de texto de formulario no válido.",
    24015: "Texto de solicitud inválido para o ID de tipo de texto especificado.",
    24016: "Texto libre no válido para el ID de tipo de texto dado.",
    24017: "Caracteres máximos, incluye etiquetas de formato de texto enriquecido. Reduzca la longitud o elimine el formato innecesario e inténtelo de nuevo.",
    24018: "Para un determinado tipo de ID la respuesta no está permitido.",
    24019: "El ID no debe ser nulo ni estar vacío.",
    24020: "Cuerdo de requisicion invalido",
    24021: "cuerpo es borrado",
    24038: "El documento no es válido o no existe.",
    24049: "Los objetos seleccionados se han eliminado. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con el servicio de asistencia.",
    24057: "Error en la validación de Document FormProfile.",
    24063: "El ID de país no es válido.",
    24064: "El ID de idioma no es válido.",

    /*Document Change Types*/
    25001: "Error en la llamada a los tipos de cambio de documento.",
    25002: "ID de compromiso no válido.",
    25003: "Solicitud no válida.",

    /* Manage team */
    26001: "Error en la llamada GetAll de ClientUserGroups.",
    26002: "Error en la nueva llamada al grupo de clientes o al dominio de correo electrónico.",
    26003: "GroupName no debe ser null.",
    26004: "El dominio de correo electrónico no debe ser null.",
    26005: "{0} etiqueta Dominio de correo electrónico no debe superar los 263 caracteres.",
    26006: "{0} dominio de correo electrónico no debe superar los 263 caracteres.",
    26007: "{0} Primera parte del dominio de correo electrónico puede ser * o alfanumérica, no se permiten otros caracteres especiales.",
    26008: "{0} Si la primera parte es un comodín, debe tener 2 o más partes seguidas.",
    26009: "{0} Primera parte puede ser * o alfanumérica, otras partes de dominio caracteres especiales no permitidos.",
    26010: "El dominio de correo electrónico debe ser único.",
    26011: "El groupid de acceso de cliente no sea válido.",
    26012: "Se ha producido un error al eliminar el grupo de acceso. Asegúrese de que no haya solicitudes/tareas externas asignadas a este grupo o a los miembros de este grupo e inténtelo de nuevo.",
    26013: "El grupo de acceso ya se ha eliminado, actualice la página para obtener los datos más recientes.",
    26014: "Se requiere al menos un dominio de correo electrónico.",
    26015: "No se puede acceder al Portal del cliente de EY Canvas en este momento y se requiere para actualizar la información de los miembros existentes. Vuelva a intentarlo y, si el problema persiste, póngase en contacto con el servicio de asistencia técnica.",
    26016: "Error durante la operación de eliminación.",
    26017: "Error al obtener la operación de datos.",
    26018: "Error de concurrencia, el acceso al grupo no esta activo. Actualice la pagina e intente de nuevo",
    26019: "Error en la operación de guardado.",
    26020: "Los dominios de correo electrónico no se pueden eliminar cuando tienen usuarios activos asignados. Los cambios no se han guardado.",


    /* TimePhaseTypes - Milestones */
    27001: "Error en los detalles del milestone",

    /*Client Request Counts*/
    28001: "La llamada a obtener información de solicitudes de cliente no obtuvo ningún resultado.",

    /*Content updates Error messages*/
    29001: "Obtener por ID no encontrado.",
    29002: "No se ha encontrado el tipo De acton.",
    29003: "Id. de contenido no encontrados.",
    29004: "Error en la llamada a la API de actualización de contenido.",
    29005: "Actualización de contenido en curso. Inténtelo de nuevo más tarde y, si el problema persiste, póngase en contacto con el servicio de asistencia.",
    29006: "Parámetros solicitados no válidos.",
    29010: "El contenido se está actualizando. Inténtalo de nuevo más tarde. Si el problema persiste durante un tiempo prolongado, póngase en contacto con el servicio de soporte técnico de TI.",
    29012: "Al compromiso le falta la pregunta del perfil de estándares aplicables. Póngase en contacto con Help Desk de TI.",
    29013: "Las tareas estándar principales (PST) y las actualizaciones de contenido de perfil no están permitidas cuando hay actividades de habilitación de EY Canvas FIT que se comparten. Para actualizar los archivos PST o el contenido del perfil, desvincula esas actividades. Si se han seleccionado varios tipos de actualización de contenido, anule la selección de Tareas estándar principales (PST) y/o Perfil y vuelva a inicializar Actualización.",
    /*IT Process*/
    30001: "Error al obtener todo ITProcess.",
    30002: "Obtenga todo el ID de compromiso no válido de ITProcess.",
    30003: "El nombre del Proceso de TI no puede estar vacío.",
    30004: "El nombre del proceso de TI no debe tener más de 500 caracteres.",
    30005: "Su ID del proceso no es válido.",
    30006: "Obtener el proceso por llamada de identificación fallida.",
    30007: "Solicitud no válida.",
    30008: "El proceso de IT no es válido.",
    30009: "Documento no encontrado.",
    30010: "Error en la eliminación de Proceso TI",
    30012: "Riesgo de TI no válido",

    /*Checklist*/
    31001: "Error en la llamada a GetAll CheckLists.",
    31002: "Error al llamar a Put CheckLists.",
    31003: "Parámetro CheckList no válido.",
    31004: "Error de compromiso no válido.",
    31005: "Error de parámetros de solicitud no válidos.",
    31006: "Error del parámetro de solicitud IsChecked no válido.",

    /*Archive*/
    32001: "El estado del compromiso no es válido, resuelva la validación e intente de nuevo el proceso de archivado. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32002: "Error al archivar al actualizar el estado de visualización de los cuerpos del formulario, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32003: "Error al archivar al actualizar el estado del compromiso, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32004: "Error al archivar al invalidar la caché del compromiso, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32005: "La actualización de contenido está en curso. No puede archivar este compromiso hasta que se complete la actualización de contenido. Inténtelo de nuevo más tarde y póngase en contacto con el servicio de asistencia si el error persiste.",
    32006: "Hay validaciones no resueltas en este compromiso. Actualice la página, resuelva las validaciones e intente de nuevo el proceso de archivado. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32007: "Error al archivar al crear el modelo de solicitud ARC, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32008: "Error al archivar al obtener la URL de la API de Arc, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32009: "Error al archivar al realizar la llamada a la API de Arc, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32010: "Error en el archivo debido a la falta de datos en la respuesta de Arc API, inténtelo de nuevo. Póngase en contacto con el departamento de soporte técnico si el error persiste.",
    32011: "Error al archivar al guardar los detalles del formulario de ARC, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32012: "Error al archivar al actualizar el estado de interacción para reintentar, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32013: "Error al archivar mientras se pone en cola el mensaje de archivo, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32014: "El archivo se ha realizado correctamente, pero se ha producido un error al hacer cola con el mensaje de actualización de estado universal. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32015: "El archivo se ha realizado correctamente, pero se ha producido un error al hacer cola con el mensaje de actualización de estado de CCP. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32016: "El estado de interacción debe estar en el estado Error de archivo para volver a intentar el proceso de archivado.",
    32017: "No se ha encontrado el compromiso, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    32019: "No podemos procesar su solicitud en este momento. Por favor, inténtelo de nuevo. Si el problema persiste, ponte en contacto con el servicio de asistencia de EY.",
    32020: "La URL de ARC no está configurada, inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
	32200: 'Hay validaciones no resueltas en su compromiso. Ejecute el informe Comprobaciones de validaciones desde Informes o consulte el vínculo "Ayuda de validaciones" en el menú "Más" para obtener más detalles. Si el error persiste, póngase en contacto con el servicio de asistencia.',
    32400: "Se han producido los siguientes errores al comunicarse con el sistema ARC. Póngase en contacto con el servicio de asistencia y muéstreles este mensaje de error para continuar.",

    /*RBAC*/
    33001: "No se ha encontrado el identificador de compromiso.",
    33002: "Id. de usuario no encontrado.",

    /*Helix Linked Projects*/
    34001: "El proyecto de EY Helix ya se ha desvinculado, actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    34002: "El identificador de compromiso no debe ser nulo ni estar vacío.",
    34003: "El cuerpo no puede ser nulo o vacío en la llamada.",
    34004: "El identificador de proyecto no puede ser nulo ni estar vacío.",
    34005: "El nombre del proyecto no puede ser nulo o vacío.",
    34006: "El proyecto de EY Helix ya ha sido vinculado, actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    34007: "Error en la llamada a GetAll Helix Projects.",
    34008: "El identificador de compromiso debe ser mayor que cero.",
    34009: "No se pudo completar la operación. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    34020: "No se pudo vincular Helix Project. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",
    34024: "No se puede enviar una notificación a Helix. Falta información de la región para el proyecto.",
    34029: "El proyecto no está vinculado porque su ubicación no coincide con la ubicación del compromiso EY Canvas.",
    34030: "El analizador no se puede vincular. No es un miembro autorizado del equipo del analizador seleccionado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso e intentarlo de nuevo.",
    34031: "Parece que no has accedido antes a la aplicación EY Helix.",
    34038: "La analítica seleccionada ya no está disponible. Actualiza la página y vuelve a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",
	34043: 'El proyecto EY Helix seleccionado ya no está disponible. Haga clic en "Vincular proyecto" para vincular un proyecto diferente.',
	34044: 'El proyecto EY Helix seleccionado se marca para su eliminación. Haga clic en "Vincular proyecto" para vincular un proyecto diferente.',
	34045: 'El proyecto EY Helix seleccionado está marcado para su almacenamiento. Haga clic en "Vincular proyecto" para vincular un proyecto diferente.',
    34046: "Analizador no válido o faltante en EY Helix. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    34047: "El analizador seleccionado no está disponible en EY Helix. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    34048: "Los análisis no están disponibles en el proyecto vinculado. Vaya a EY Helix y complete los pasos de procesamiento de datos y análisis para continuar.",
    34080: "Se ha superado el número máximo de conexiones de Hélix de este compromiso.",

    /* PAANS */
    35001: "La autoria de la Politica de EY; el servicio de aprobaciones y notificaciones no esta disponible en este momento. No podemos confirmar si todas las politicas relevantes han sido completadas. Si no ha revisado las politicas relevantes, actualice la pagina e intente de nuevo. si el problema persiste contacte al Help desk",

    /*Engagement Comments*/
    38001: "Error al crear la llamada EngagementComments",
    38002: "Error en la llamada GetAll EngagementComments",
    38003: "No se pudo completar esta acción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    38004: "No se pudo completasr esta acción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    38005: "No se pudo completasr esta acción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    38006: "No se pudo completasr esta acción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    38007: "No se pudo completasr esta acción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    38008: "No se pudo completasr esta acción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    38009: "No se pudo completasr esta acción. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia",
    38010: "El contenido no debe ser nulo",
    38011: "CommentText no debe ser nulo o vacío",
    38012: "La entidad no existe en el compromiso dado",
    38013: "El ID de estado de los comentarios de compromiso debe ser mayor que 0",
    38014: "El ID del comentario del compromiso primario debe ser mayor que 0",
    38015: "No había ningún cuerpo de formulario de Canvas que coincidiera con los criterios especificados",
    38016: "La nota a la que está respondiendo ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo",
    38017: "El comentario del compromiso primario proporcionado esta aclarado",
    38018: "El comentario de compromiso primario proporcionado es una respuesta en sí misma.",
    38019: "El texto del comentario proporcionado no debe tener menos de 1 ni más de 4000 caracteres.",
    38020: "El uid de entidad proporcionado no es válido",
    38021: "El UID de la entidad principal proporcionado no es válido",
    38022: "No se pudo eliminar la llamada de EngagementComments",
    38023: "El ID del comentario no debe estar vacía",
    38024: "La acción debe ser una acción válida.",
    38025: "El estado de la nota ha cambiado. Actualice la página e inténtelo de nuevo.",
    38026: "Las notas de revisión solo pueden ser eliminadas por el usuario que creó la nota.",
    38027: "Está intentando editar un comentario que ya no existe. Actualice la página y vuelva a intentarlo.",
    38028: "No se permiten actualizaciones sobre comentarios borrados",
    38029: "Solo el autor puede cambiar el texto del comentario.",
    38030: "El ID del comentario de compromiso no es válido",
    38031: "El Id. de estado del comentario no debe estar vacío.",
    38032: "No había ningún registro de relación entre el usuario solicitado y el compromiso. Actualice la página y vuelva a intentarlo. Si el error persiste comuníquese con Help Desk",
    38033: "La acción de actualización no es válida",
    38034: "El CommentId solicitado ya está siendo utilizado por otro comentario.",
    38035: "El ID de comentario proporcionado no es válido",
    38036: "El ID del documento no debe ser nulo ni estar vacío",
    38037: "El Id del usuario al que se le asignará el comentario no debe ser nulo",
    38038: "No se debe reasignar el comentario al abrirlo o cerrarlo.",
    38039: "La nota que estás eliminando es una respuesta a una que ya ha sido eliminada. Actualiza la página e inténtalo de nuevo",
    38040: "La respuesta no debe tener fecha de vencimiento",
    38041: "La respuesta no debe tener prioridad",
    38042: "El comentario debe tener una fecha de vencimiento",
    38043: "El comentario debe tener prioridad.",
    38044: "Está intentando editar una respuesta a un comentario que ya no existe. Actualiza la página e inténtalo de nuevo",
    38045: "No se permite editar el ID del estado del compromiso  el contenido, el usuario asignado o la prioridad",
    38046: "No se pudo actualizar la llamada de EngagementComments",
    38047: "Solo puedes responder a las notas abiertas",

    /*Tags*/
    39004: "Otro miembro del equipo ha eliminado el grupo de etiquetas que está editando. Actualice la página e inténtelo de nuevo.",
    40003: "El grupo de etiquetas seleccionado fue eliminado por otro miembro del equipo. Seleccione otro grupo de etiquetas para continuar.",
    40007: "Se han eliminado una o más notas seleccionadas. Actualice la página y vuelva a intentarlo. Póngase en contacto con Mesa de ayuda si el error persiste.",
    40011: 'Note index cannot exceed 5 characters.',
    40012: "El código de color de la etiqueta no es válido. Actualiza la página y vuelve a intentarlo.",
    40014: "Otro miembro del equipo ha eliminado el grupo de etiquetas que contiene la etiqueta que está editando. Actualice la página e inténtelo de nuevo.",
    40016: "No se pudieron agregar ni quitar etiquetas de una o más de las tareas seleccionadas. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    40019: "Otro miembro del equipo ha eliminado una o más etiquetas que está editando. Actualice la página e inténtelo de nuevo.",
    40020: "Una o más etiquetas no se pudieron sincronizar en este momento. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    40021: "Una o más de las etiquetas que seleccionó han sido eliminadas. Actualiza la página y vuelve a intentarlo.",
    40022: "Agregue uno o más miembros externos del equipo a este compromiso y, a continuación, vuelva a intentar esta operación. Póngase en contacto con Help Desk si este error persiste.",
    40027: 'Description is too long.',

    // Scheduler request
    70022: "No hay tareas asociadas a esta solicitud de servicio. Actualice la página y seleccione una o más tareas no eliminadas para continuar. Póngase en contacto con el servicio de asistencia si el error persiste.",
    70024: "Los servicios centralizados no están disponibles para su compromiso. Actualice la página e inténtelo de nuevo. Póngase en contacto con mesa de ayuda si el error persiste.",
    70025: "Los servicios centralizados no están disponibles actualmente para su país. Actualice la página e inténtelo de nuevo. Póngase en contacto con mesa de ayuda si el error persiste.",

    /* TaskDocumnet */
    80001: "Error al crear la asociación de documentos de tareas.",
    80002: "La solicitud debe tener al menos una tarea.",
    80003: "El ID de documento debe estar presente.",
    80004: "Se han eliminado las tareas seleccionadas. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con el servicio de asistencia.",
    80005: "El identificador de documento no es válido.",
    80006: "El usuario no tiene permisos suficientes para realizar la operación.",
    80007: "Error en la asociación del documento de tarea.",
    80008: "Después de la asociación de documentos de tareas, se produjo un error en el cambio de estado de la tarea.",
    80011: "Los documentos confidenciales no son elegibles para ser compartidos.",
    80012: "Carga de solicitud no válida o vacía.",
    80013: "Límite de tareas excedido. Seleccione 300 o menos tareas a la vez.",
    80014: "Ocurrió un error al intentar vincular el documento. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",

    /* ITApplication / SO */
    81001: "Error en la aplicación de TI.",
    81002: "Obtenga todas las Aplicaciones TI - compromiso no válido.",
    81003: "Se ha eliminado la aplicación informática seleccionada. Cierre este modal para ver la lista actualizada.",
    81004: "El nombre no debe estar vacío.",
    81005: "El nombre no debe tener más de 500 caracteres.",
    81006: "ID de tipo de estrategia no válido.",
    81007: "Id. de documento no válido.",
    81008: "No se pudo obtener la aplicación de TI por ID.",
    81009: "Clasificación no válida.",
    81010: "SCOT no válido.",
    81011: "Control no válido.",
    81012: "El ID de la aplicación de TI no debe ser nulo ni estar vacío.",
    81013: "No se encontró la aplicación de TI",
    81014: "Aplicación de TI eliminada - Proceso de TI fallido",
    81015: "Aplicación de TI - Proceso de TI - ID no debería estar vacío",
    81016: "Aplicación de TI - Proceso de TI  no valido",
    81017: "Aplicación de TI - Proceso de TI  no encontrado",
    81018: "Crear riesgo de TI - Control de TI falló",
    81019: "Organización de servicios aprobada en lugar de Application TI.",

    /* Controls */
    83001: "No se lograron obtener los controles.",
    83002: "Esta acción no se puede llevar a cabo. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    83003: "El ID de control es nulo o está vacío.",
    83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
    83005: "El ID del documento no es válido.",
    83006: "Falta el nombre del control.",
    83007: "Longitud del nombre de control no válido.",
    83008: "Solicitud no válida.",
    83009: "FrequencyId de control no válido.",
    83010: "TypeId de control no válido.",
    83011: "Aplicaciones TI de control inválidas.",
    83012: "DesignEffectivenessTypeId. de control no válido.",
    83013: "Aplicaciones de TI no válidas.",
    83014: "Solo se permiten aplicaciones de tipo SO IT, si el tipo de control es de tipo de prevención manual o de detección manual.",
    83015: "Solo ITDM puede tener seleccionadas las pruebas IPE manuales.",
    83016: "Los controles de menor riesgo no están permitidos para los compromisos con este perfil.",
    83017: "FilterSCOTs duplicados",
    83018: "El nombre del control tiene más de 500 caracteres.",
    83019: "Identificaciones de WCGW no válidas.",
    83020: "No se permiten identificaciones de WCGW duplicadas.",
    83021: "No se permiten identificadores de aplicación de IT",
    83023: "Página actual no válida.",
    83024: "Tamaño de página no válido.",
    83025: "La cadena de búsqueda no debe tener más de 100 caracteres.",
    83026: "IT app sin organización de servicios solo puede asociarse a un control de tipo ITDependentManualControl o ITApplicationControl.",
    83027: "Filtro duplicadoWCGWs.",
    83028: "Id. de control de conocimiento no válido.",

    /* ITControl */
    84001: "Error al obtener controles de TI.",
    84002: "Error al obtener el control de TI por id.",
    84003: "El identificador de control de TI es nulo o está vacío.",
    84004: "Identificador de control de TI no válido.",
    84005: "El identificador del documento no es válido.",
    84006: "Falta el nombre del control de TI.",
    84007: "Longitud de nombre de control de TI no válida.",
    84008: "ID de frecuencia de control de TI no válido.",
    84009: "ID de tipo de enfoque de control de TI no válido.",
    84010: "ID de tipo de efectividad de diseño de control de TI no válido.",
    84011: "Valor de prueba de control de TI no válido",
    84012: "Id. de tipo de eficacia operativa de control de TI no válido.",
    84013: "Falta frecuencia de control de TI.",
    84014: "Error al eliminar el control de TI.",
    84015: "La cadena de búsqueda no debe tener más de 100 caracteres.",

    /*GroupTasks*/
    85001: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85002: "La operación seleccionada no se pudo completar en este momento. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    85003: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85004: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85005: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85006: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85007: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85008: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85009: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85010: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85011: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85012: "El documento seleccionado ya se ha asignado a otra región o componente. Por lo tanto, no está disponible para la asignación. Actualice la página e inténtelo de nuevo.",
    85013: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85014: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85015: "La operación seleccionada no se pudo completar en este momento. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    85016: "El ID de compromiso debe ser mayor que cero.",
    85017: "Esta tarea ya no está disponible en este compromiso.",
    85018: "Identificador de documento no válido.",
    85019: "No tiene el nivel de confidencialidad adecuado para enviar estos documentos. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    85020: "Uno o más de los documentos que está intentando enviar ya no están disponibles para ser enviados. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    85021: "Los formularios no están disponibles para enviar al equipo primario.",
    85022: "Uno o más documentos no se pudieron enviar. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",

    /* ITRisk */
    86001: "El nombre del riesgo de TI no puede estar vacío.",
    86002: "El nombre del riesgo de TI no debe tener más de 500 caracteres.",
    86003: "Identificación de riesgo de TI no válido",
    86004: "Obtener el riesgo por llamada de identificación fallida.",
    86005: "Riesgo de TI no encontrado.",
    86006: "Riesgo de TI -Error al crear un control",
    86007: "Control TI - ID no valido",
    86008: "Riesgo de TI - Error al eliminar el control",
    86009: "Riesgo de TI - ID del control invalido",
    86010: "Error al eliminar el riesgo de TI.",


    /*Copyhub*/
    88017: "El servicio de proceso de exportación está caído: la creación de paquetes se realizó parcialmente exitosa",
    88018: "El usuario seleccionado para enviar el paquete no es válido (correo electrónico no válido, Gui o nombre completo)",
    88033: "Estatus del paquete de copia no válido para importar.",
    88042: "No tiene permiso para la exportación masiva.",
    88045: "No tiene permiso para crear la engagement de plantilla,.",
    88048: "El paquete está siendo importado actualmente por otro usuario. Inténtelo de nuevo más tarde.",
    88049: "El paquete ya no existe. Por favor, actualice la pestaña.",
    88050: "Otra copia de compromiso está en progreso en este momento.",
    88051: "El compromiso tiene demasiadas copias en progreso. Espere hasta que las copias se hayan completado antes de iniciar otra.",
    88056: "La acción no se puede completar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    88057: "Algunos documentos seleccionados contienen evidencias relacionadas en el modo de edición multiusuario activo. Por favor, registre las pruebas relacionadas para continuar. Si el error persiste, póngase en contacto con el Servicio de Soporte.",

    /* Group Scopes */
    92001: "Error al obtener  todos los alcances de grupo.",
    92002: "Error al crear una llamada de alcance de grupo.",
    92003: "Solicitud de actualización de alcance de grupo no válida.",
    92004: "Nombre del alcance no válido.",
    92005: "Identificador de alcance primario no válido.",
    92006: "El alcance principal no existe.",
    92007: "Descripción de alcance no válida.",
    92008: "La longitud del nombre del alcance del grupo supera los 100 caracteres.",
    92009: "La longitud de la descripción del alcance del grupo supera los 500 caracteres.",
    92010: "Error en la llamada para borrar alcance del grupo.",
    92011: "El sub-alcance personalizado que está editando ha sido eliminado por otro miembro del equipo. Actualiza la página y vuelve a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
    92012: "El ID de alcance especificado no es válido.",
    92013: "Este Sub-alcance personalizado se ha asignado a uno o más equipos y no se puede eliminar.",
    92014: "El sub-alcance personalizado que está intentando eliminar ya ha sido eliminado por otro miembro del equipo. Actualiza la página y vuelve a intentarlo.",
    92015: "El usuario no tiene permisos para realizar la operación.",
    92016: "El nombre del alcance ya existe en este compromiso",
    92017: "Error en la llamada a los ámbitos de grupo Get by id.",

    /* Group Sections */
    101001: "Llamada fallida Crear secciones de grupo.",
    101002: "El nombre del grupo no puede estar vacío o ser nulo.",
    101003: "La longitud del nombre de la sección del grupo supera los 100 caracteres.",
    101004: "El nombre de la sección ya existe en el compromiso",
    101005: "La llamada para editar secciones de grupo falló.",
    101006: "ID de sección no válido.",
    101007: "La sección del grupo no existe.",
    101008: "ID de proyecto no válido.",
    101009: "Sección de conocimiento del grupo no válida.",

    /* Group Documents */
    110001: "ID de proyecto no válido.",
    110002: "Estado de declaración no válido.",
    110003: "No se pudo obtener el proyecto por llamada de ID.",

    /* ClientEngagement */
    93001: "No se encontró la descripción del compromiso  del cliente.",
    93002: "La descripción del compromiso del cliente no debe tener más de 100 caracteres.",
    93003: "La solicitud del compromiso del cliente está vacía.",
    93004: "Compromiso del cliente Error al obtener llamada.",
    93005: "Error en la llamada de actualización del compromiso del cliente.",
    93006: "No se pudo actualizar el nombre para mostrar el compromiso en este momento. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",

    /*IP FIltering */
    96005: "{0} no se ha agregado a la lista de permitidos.",
    96015: "No hay ubicaciones de acceso disponibles para importar desde el compromiso de origen.",
    96016: "No hay ubicaciones de acceso disponibles para importar desde el compromiso de origen.",

    /*RBAC SchedulerRequests */
    'permissionIssueForScheduler': "No tiene permiso para solicitar servicios. Póngase en contacto con un administrador del compromiso y solicite permiso para realizar esta acción.",

    /* GroupInstructions */
    98001: "Error en las  instrucciones de grupo.",
    98002: "Uno o más de los identificadores de la sección de instrucción de conocimiento no son válidos.",
    98003: "Error al crear las instrucciones de grupo.",
    98004: "El nombre de la instrucción no puede estar vacío.",
    98005: "El nombre de la instrucción no puede exceder los 500 caracteres.",
    98006: "La descripción de la instrucción no puede estar vacía.",
    98007: "La descripción de la instrucción no puede exceder los 4.000 caracteres.",
    98008: "La instrucción debe asignarse a alcances o equipos.",
    98009: "El nombre de la instrucción ya existe en este compromiso.",
    98011: "Esta instrucción de grupo ya ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
    98012: "Esta instrucción de grupo ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
    98016: "La instrucción de grupo que está editando ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
    98017: "Esta tarea de grupo ya ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
    98018: "Esta tarea de grupo ha sido eliminada por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
    98019: "Entidad no encontrada",

    /* Group Snapshots */
    102001: "Error al crear una llamada de instantánea de instrucción de grupo.",
    102002: "Error de parámetros de solicitud no válidos.",
    102003: "Error de compromiso no válido.",
    102004: "Error en la llamada de snapshtos de grupo.",
    102005: "Error en la llamada de instantánea de grupo Get By Id.",
    102006: "Snapshot no encontrada.",
    102007: "Instantánea no válida seleccionada.",

    /* Group Links - Send link request */
    106001: "No se ha podido enviar la llamada de enlace de grupo.",
    106002: "La lista de equipos no puede estar vacía.",
    106003: "Uno o más del equipo seleccionado no es válido.",
    106004: "El mensaje de enlace del grupo en cola falló.",
    106005: "Los equipos no se pueden repetir.",
    106006: "Los tokens de concurrencia no se pueden repetir.",

    /* GroupInstructions - Send Version request */
    22019: "El equipo fue eliminado.",
    22023: "La llamada de envio de instrucciones fallo.",
    22024: "El componente al que está intentando enviar instrucciones no está disponible o ya se ha eliminado.",
    22025: "La identificación de compromiso no puede estar vacía.",
    22026: "El ID del componente no puede estar vacía.",
    22027: "Instrucción grupal encontrada sin fecha de vencimiento.",
    22028: "La instrucción de alcance aún no se publica para el componente.",
    22029: "No se publicó una nueva instrucción para el componente.",
    22030: "Esta versión de instrucciones y tareas ya ha sido aceptada por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",

    22031: "Error en la llamada a la versión de grupo.",

    /* GroupVersion */
    22032: "Las instrucciones no existen.",

    22034: "Error en la llamada a la versión del grupo por identificador.",
    22035: "El identificador del conjunto de instrucciones no puede estar vacío.",

    /* Return instruction concurrency scenario*/
    22036: "Una nueva versión de instrucciones y tareas está disponible. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    22037: "Esta versión de instrucciones y tareas ya ha sido aceptada por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    22038: "Esta versión de instrucciones y tareas ya ha sido devuelta por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",

    37018: "Esta Cuenta GL ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con Mesa de Ayuda si el error persiste.",
    37019: "La relación del documento no se puede editar. Actualice la página y vuelva a intentarlo. Póngase en contacto con el Servicio de Soporte si el error persiste.",
    37030: "Esta cuenta de GL ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con el Servicio de Soporte si el error persiste.",
    37032: "La relación del documento no se puede editar. Actualice la página y vuelva a intentarlo. Póngase en contacto con el servicio de asistencia si el error persiste.",
    37033: "La relación del documento no se puede editar. Actualice la página y vuelva a intentarlo. Póngase en contacto con el Servicio de Soporte si el error persiste.",
    37034: "La relación del documento no se puede editar. Actualice la página y vuelva a intentarlo. Póngase en contacto con el Servicio de Soporte si el error persiste.",
    37037: "Este ajuste ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con el Servicio de Soporte si el error persiste.",

    /* EngagementReports */
    111001: "Error en la llamada Obtener informe por tipo de informe.",
    113015: "El saldo de comprobación no está disponible. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    113025: "Se requiere filtrar por ID de clase de cuenta o filtrar por ID de cuenta, o se puede continuar.",
    113050: "TrialBalance o FinancialStatement no pertenece a este compromiso o podría eliminarse, no puede continuar.",

    /*Information Security */
    200001: "La acción tomada fue prohibida por EY Information Security. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",

    /*GL account concurrency scenario*/
    113043: "Esta cuenta de conciliación ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con el Servicio de Soporte si el error persiste.",
    113019: "Esta cuenta de conciliación ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con el Servicio de Soporte si el error persiste.",
    113022: "La acción no se puede completar. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de asistencia.",
    113039: "Ya hay una referencia asociada a esta cuenta de GL. Actualice la página y vuelva a intentarlo. Póngase en contacto con Servicio de Soporte si el error persiste.",
    113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
    113035: "Ya hay una referencia asociada a esta cuenta de GL. Actualice la página y vuelva a intentarlo. Póngase en contacto con Servicio de Soporte si el error persiste.",
    113020: "Esta evidencia ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con Servicio de Soporte si el error persiste.",
    113037: "Esta cuenta de GL ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con Servicio de Soporte si el error persiste.",
    40029: "Esta cuenta de GL ya no está disponible. Actualice la página y vuelva a intentarlo. Póngase en contacto con Servicio de Soporte si el error persiste.",

    /*Trial balance*/
    113060: "MultiEntity necesario para el compromiso MEST.",
    113061: "MultiEntity no es necesario para ningún compromiso MEST.",
    113057: "No se ha encontrado la hélice de compromiso.",
    113094: "El balance de prueba que se va a actualizar debe ser Planning e IstrialBalance true.",
    113095: "El balance de comprobación que se va a actualizar no debe ser Planning e IstrialBalance true cuando el tipo financiero es el balance de comprobación.",
    113069: "El alcance y la estrategia ya existen para el compromiso.",
    113009: "Identificador de saldo de prueba no válido, no se puede continuar.",
    113092: "El balance de comprobación es tanto la planificación como los estados financieros. No se puede proceder a la eliminación temporal.",
    114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
        id: 1,
        name: "Confiar"
    },
    {
        id: 2,
        name: "No confíe en"
    },
    {
        id: 3,
        name: "MP de prueba"
    }
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
        id: 1,
        value: "Actualización en curso"
    },
    {
        id: 3,
        value: "Error"
    },
    {
        id: 5,
        value: "Actualización en curso"
    },
    {
        id: 6,
        value: "Error"
    }
];

export const riskTypes = [{
        id: 1,
        name: "Riesgos significativos",
        abbrev: "SR",
        title: "Riesgo significativo"
    },
    {
        id: 2,
        name: "Riesgos de fraude",
        abbrev: "FR",
        title: "Riesgo de fraude"
    },
    {
        id: 3,
        name: "Riesgos de incorrección material",
        abbrev: "R",
        title: "ROMM/Riesgo inherente"
    }
];

export const riskTypesToolTip = [{
        id: 1,
        name: "Riesgos significativos",
        abbrev: 'SR',
        label: "Significativo",
        title: "Riesgo significativo"
    },
    {
        id: 2,
        name: "Riesgos de fraude",
        abbrev: "FR",
        label: "Fraude",
        title: "Riesgo de fraude"
    },
    {
        id: 3,
        name: "Riesgo de error material",
        abbrev: "R",
        label: "Riesgo de error material",
        title: "Riesgo de error material"
    }
];

export const risksTypes = [{
        id: 1,
        name: "Riesgos significativos",
        abbrev: "SR",
        title: "Riesgos significativos"
    },
    {
        id: 2,
        name: "Riesgos de fraude",
        abbrev: "FR",
        title: "Riesgos de fraude"
    },
    {
        id: 3,
        name: "Riesgo de error material",
        abbrev: "R",
        title: "Riesgo de error material"
    }
];

export const emptyRiskTypes = [{
        id: 1,
        label: "No se han identificado riesgos significativos"
    },
    {
        id: 2,
        label: "No se han identificado riesgos de fraude"
    },
    {
        id: 3,
        label: "No se han identificado riesgos de incorrección material"
    }
];

export const controlRiskType = [{
        id: 1,
        name: "Confiar"
    },
    {
        id: 2,
        name: "No confíe en"
    },
    {
        id: 3,
        name: "MP de prueba"
    }
];
export const inherentRiskType = [{
        id: 1,
        name: "Mas alto"
    },
    {
        id: 2,
        name: "Mas Bajo"
    }
];
export const CRAStrings = {
    Minimal: "Mínimo",
    Low: "Bajo",
    'Low +SC': "Bajo + SC",
    Moderate: "Moderado",
    High: "Alto",
    'High +SC': "Alto + SC"
};
export const priorityType = [{
        id: 1,
        name: "Bajo",
        className: 'Low',
        label: "L"
    },
    {
        id: 2,
        name: "Medio",
        className: 'Medium',
        label: "M"
    },
    {
        id: 3,
        name: "Alto",
        className: 'High',
        label: "H"
    },
    {
        id: 4,
        name: "Crítico",
        className: 'Critical',
        label: "C"
    }
];
export const reviewNoteFilterTypes = [{
        value: 0,
        label: "todo"
    },
    {
        value: 1,
        label: "Abierto"
    },
    {
        value: 2,
        label: "Resolver"
    },
    {
        value: 3,
        label: "Cerrado"
    }
];
export const reviewStatus = [{
        id: 1,
        name: "Abierto"
    },
    {
        id: 2,
        name: "Resolver"
    },
    {
        id: 3,
        name: "Cerrado"
    }
];
export const reviewNoteOpenStatusOption = [{
        value: 2,
        label: "Resolver"
    },
    {
        value: 3,
        label: "Cerrado"
    }
];
export const reviewNoteClearedStatusOption = [{
        value: 1,
        label: "Reabrir"
    },
    {
        value: 3,
        label: "Cerrar"
    }
];
export const reviewNoteBulkClearedStatusOption = [{
        value: 1,
        label: "Reabrir"
    },
    {
        value: 2,
        label: "Borrar"
    },
    {
        value: 3,
        label: "Cerrar"
    }
];
export const reviewNoteClosedStatusOption = [{
    value: 1,
    label: "Reabrir"
}];
export const signOffTypes = [{
        value: 0,
        label: "Preparador"
    },
    {
        value: 1,
        label: "Revisor"
    },
    {
        value: 2,
        label: "Ninguno"
    }
];
export const RNHNoteStatusOptions = [{
        value: 1,
        label: "Abierto"
    },
    {
        value: 2,
        label: "Cerrado"
    },
    {
        value: 3,
        label: "Resuelto"
    }
];
export const assertions = [{
        id: 1,
        assertionname: "Integridad",
        assertionabbreviation: "C",
        statementtypeid: 2,
        displayorder: 1
    },
    {
        id: 2,
        assertionname: "Existencia",
        assertionabbreviation: "E",
        statementtypeid: 2,
        displayorder: 2
    },
    {
        id: 3,
        assertionname: "Valuación",
        assertionabbreviation: "V",
        statementtypeid: 2,
        displayorder: 3
    },
    {
        id: 4,
        assertionname: "Derechos y obligaciones",
        assertionabbreviation: "R&O",
        statementtypeid: 2,
        displayorder: 4
    },
    {
        id: 5,
        assertionname: "Presentación y Divulgación",
        assertionabbreviation: "P&D",
        statementtypeid: 2,
        displayorder: 5
    },
    {
        id: 6,
        assertionname: "Integridad",
        assertionabbreviation: "C",
        statementtypeid: 1,
        displayorder: 6
    },
    {
        id: 7,
        assertionname: "Ocurrencia",
        assertionabbreviation: "O",
        statementtypeid: 1,
        displayorder: 7
    },
    {
        id: 8,
        assertionname: "Medición",
        assertionabbreviation: "M",
        statementtypeid: 1,
        displayorder: 8
    },
    {
        id: 9,
        assertionname: "Presentación y Divulgación",
        assertionabbreviation: "P&D",
        statementtypeid: 1,
        displayorder: 9
    },
    {
        id: 10,
        assertionname: "Integridad",
        assertionabbreviation: "C",
        statementtypeid: 3,
        displayorder: 10
    },
    {
        id: 11,
        assertionname: "Existencia/Ocurrencia",
        assertionabbreviation: "E/O",
        statementtypeid: 3,
        displayorder: 11
    },
    {
        id: 12,
        assertionname: "Medición/Valoración",
        assertionabbreviation: "M/V",
        statementtypeid: 3,
        displayorder: 12
    },
    {
        id: 13,
        assertionname: "Derechos y obligaciones",
        assertionabbreviation: "R&O",
        statementtypeid: 3,
        displayorder: 13
    },
    {
        id: 14,
        assertionname: "Presentación y Divulgación",
        assertionabbreviation: "P&D",
        statementtypeid: 3,
        displayorder: 14
    }
];
//Add Review Note
export const priorityTypes = [{
        value: 1,
        label: "Bajo"
    },
    {
        value: 2,
        label: "Medio"
    },
    {
        value: 3,
        label: "Alto"
    },
    {
        value: 4,
        label: "Crítico"
    }
];
/*Cog Menu*/
export const cogMenuOptions = {
    Open: "Abierto",
    'Start Co-edit mode': "Iniciar la edición multiusuario",
    'End Co-edit mode': "Edición multiusuario final",
    'Open read-only': "Abrir solo lectura",
    'View history': "Ver historial",
    CopyLink: "Copiar enlace",
    Rename: "Renombrar",
    Delete: "Eliminar",
    'Remove from task': "Eliminar de la tarea",
    Remove: "Eliminar",
    Unlink: "Desvincular",
    RelateTasks: "Relaciones tareas",
    RelateEntities: "Relacionar entidades",
    Restore: "Restaurar",
    PermanentlyDelete: "Eliminar permanentemente",
    ChangeReason: "Editar razón",
    Confidentiality: "Confidencialidad",
    SignoffRequirements: "Requisitos cierre de sesión",
    AssignRegionComponent: "Asignar a región o componente",
    UnassignRegionComponent: "Anular la asignación de la región o el componente",
    ReturnToRegionComponent: "Volver a la región o al componente",
    ClearReturnToRegionComponent: "Borrar retorno a la región o al componente",
    OverwriteForm: "Sobrescribir formulario",
    Finalize: "Finalizar documento"
};

export const pagingSvgHoverText = {
    first: "Primera página",
    previous: "Página anterior",
    next: "Próxima página",
    last: "Ultima página"
};
export const controlFrequencyType = {
    1: "Muchas veces al día",
    2: "Diario",
    3: "Semanal",
    4: "Mensual",
    5: "Trimestral",
    6: "Anualmente",
    7: "Control de aplicaciones de TI",
    8: "Otro"
};
export const itApproachType = {
    1: "Controles",
    2: "Sustantivo"
};
export const controlType = {
    1: "Aplicación de TI",
    2: "Manual dependiente de TI",
    3: "Manual preventivo",
    4: "Manual Detectivo"
};
export const aggregateITEvaluationType = {
    1: "Apoyo",
    2: "No soporte",
    3: "Soporte fS & ICFR",
    4: "Soporte solo para FS"
};
export const entityType = {
    'ENTITY3': "Cuenta",
    'ENTITY4': "SCOT",
    'ENTITY5': "ITProcess",
    'ENTITY7': "Riesgo",
    'ENTITY18': "WCGW",
    'ENTITY19': "Control",
    'ENTITY20': "ITSO Aplicación",
    'ENTITY24': "Aseveración",
    'ENTITY34': "ITControl",
    'ENTITY35': "ITRisk"
};
export const trueFalseToYesNo = {
    'true': "Sí",
    'false': "No"
}
export const trueFalseToYesOnly = {
    'true': "Sí"
}
export const yesNoLocalized = {
    'Yes': "Sí",
    'No': "No"
}
export const iTProcessEvaluationType = {
    1: "Efectivo",
    2: "Inefectivo",
    3: "confiable",
    4: "No probado"
};

export const strategyType = {
    1: "Controles",
    2: "Sustantivo",
    3: "Confiar",
    4: "No confiar"
};
export const accountType = {
    1: "Cuentas significativas",
    2: "Cuenta de riesgo limitado"
};

export const scotTypes = {
    1: "Rutina",
    2: "No Rutina",
    3: "Estimación"
};
export const taskNavigation = {
    1: "Mis tareas",
    2: "Todas las tareas",
    3: "Alcance y Estrategia",
    4: "SCOTs",
    5: "IT/SOs",
    6: "Cuentas",
    7: "Ejecución General",
    8: "Conclusión",
    9: "Resumen del equipo",
    10: "Riesgos"
};
export const subCategoty = {
    1: "Mostrar todo",
    2: "Para preparar",
    3: "Para revisar"
};
export const subCategoryType = {
    AllTasks: {
        id: 1,
        title: "Mostrar todo",
        label: "Mostrar todo"
    },
    ToPrepare: {
        id: 2,
        title: "Para preparar",
        label: "Para preparar"
    },
    ToReview: {
        id: 3,
        title: "Para revisar",
        label: "Para revisar"
    },
    Preparers: {
        id: 2,
        title: "Preparadores",
        label: "Preparadores"
    },
    Reviewers: {
        id: 3,
        title: "Revisores",
        label: "Revisores"
    }
};
/*Task Types*/
export const taskType = {
    1: "Tarea estándar",
    2: "Tarea estándar primaria",
    3: "Tarea Recorrido",
    4: "Tarea de control",
    5: "Tarea sustantiva",
    6: "Tarea de Procedimiento Sustantivo Primario",
    7: "Tarea de respuesta",
    8: "Tarea de grupo"
};

export const taskTypesForAddTask = {
    importfromknowledge: "Importar desde el conocimiento",
    custom: "Personalizado",
    account: "Cuenta",
    itsubstantive: "Procedimiento sustantivo de TI",
    scotwalkthroughtask: "Tutorial de SCOT",
    scotcontroltask: "Control de SCOT",
    itwalkthroughtask: "Tutorial de TI",
    itcontroltask: "Control de TI"
};

export const taskTypeBadge = {
    1: "OST",
    2: "PST",
    3: "Wt",
    4: "Toc",
    5: "Osp",
    6: "Psp",
    7: "Rt",
    8: "Gt",
    9: "PIC",
    10: "EQR",
    11: "PIC/EQR",
    22: "ACT",
    23: "UDP"
};
/*Task Types*/
export const taskTypeAbbreviation = {
    1: "TOC",
    2: "TOC",
    3: "TOC",
    4: "TOC",
    5: "TOC",
    6: "TOC",
    7: "RT",
    8: "RT",
    9: "RT",
    10: "RT",
    11: "RT",
    13: "OST",
    14: "PST",
    16: "OSP",
    17: "PSP",
    18: "WT",
    19: "UDP",
    20: "WT",
    22: "ACT",
    23: "GT",
    24: "GT",
    25: "GT",
    26: "OSP",
    27: "GT"
};
export const auditPhase = {
    1: "Alcance y Estrategia",
    2: "Ejecución",
    3: "Conclusión"
};
export const ProfileActionType = {
    1: "Envío de perfil - Primera vez",
    2: "Envío de perfil - RollForward",
    3: "Editar perfil",
    4: "Actualización global de contenido",
    5: "Importar PSPs",
    6: "Importar PSTs",
    7: "Actualización del contenido del formulario Canvas",
    8: "Instrucciones de Importación GA",
    9: "Añadir formulario manual",
    10: "Entrega de perfil",
    11: "Actualización obligatoria del contenido",
    12: "Sincronización de perfil de formalario de Canvas"
};

export const taskGroup = {
    1: "Perform other planning procedures",
    2: "Flujo de cuentas",
    3: "Flujo de clases significativas de transacciones (SCOTs)",
    4: "Flujo de aplicaciones de TI y organizaciones de servicio (SO)",
    5: "Flujo de evaluación del riesgo combinado (CRA)",
    6: "Flujo del plan de auditoría",
    7: "Perform wrap up procedures",
    8: "Resumen de diferencias de auditoría (SAD)",
    9: "Evaluar los resultados de la auditoría",
    10: "Perform other audit procedures",
    11: "Group Audit Structure",
    12: "Group Audit Instructions",
    13: "Tareas de grupo del equipo primario",
    14: "Tareas de grupo del equipo de componente",
    15: "Work Plan",
    16: "Accounts Flow - MEST",
    17: "Perform review procedures",
    18: "Complete preliminary engagement activities",
    19: "Establish the team",
    20: "Enable the engagement with data",
    21: "Realizar procedimientos analíticos de RA y determinar la materialidad",
    22: "Identify significant accounts - MEST",
    23: "Procedimientos adicionales para informar nuestra evaluación de riesgo",
    24: "fuentes identificadas",
    25: "Identificación de cuentas significativas",
    26: "Identificar y entender SCOTs",
    27: "Identificar y entender el proceso de TI y organizaciones de servicio",
    28: "Confirmar la estrategia y el CRA",
    29: "desarrollar procedimientos adicionales de identificación de riesgo",
    30: "Considerar el uso de auditoria interna",
    31: "Responder a la evaluación de riesgo",
    32: "Estrategia finalizada",
    33: "Procedimientos de EQR",
    34: "Diseñar procedimientos",
    35: "Evaluar y concluir sobre la evidencia de auditoria",
    36: "Emitir las comunicaciones y entregables",
    37: "Procedimientos de EQR",
    38: "Preparar y emitir el reporte de auditoria",
    39: "Finalize documentation and archive",
    40: "Probar controles de la entidad",
    41: "evaluar los datos usados en las técnicas de automatización",
    42: "ejecutar los procedimientos requeridos de fraude",
    43: "Ejecutar los procedimientos de especialistas y auditoria interna",
    44: "Evaluar los procesos de TI",
    45: "Minutes, contracts and litigation review",
    46: "Perform procedures on financial statements",
    47: "Ejecutar procedimientos de partes relacionadas, negocio en marcha y leyes y regulaciones",
    48: "Discutir las revisiones de estrategia de auditoria",
    49: "Ejecución de la conclusión",
    50: "Procedimientos de EQR",
    51: "Complete actividades de calidad de alcance y estrategia",
    52: "Perform initial audit procedures",
    53: "Perform risk assessment procedures",
    54: "Identificar organizaciones de servicios",
    55: "Digital - Grupo de tareas 5",
    56: "Identificar y comprender los procesos de TI",
    57: "Realizar procedimientos de planificación",
    58: "Estructura, instrucciones y participación del grupo",
    59: "Identifique las divulgaciones significativas",
    60: "Identifique y comprenda los procesos de generación de informes significativos",
    61: "Digital - Grupo de Tareas 11",
    62: "Digital - Grupo de tareas 12",
    63: "Digital - Grupo de tareas 13",
    64: "Digital - Grupo de tareas 14",
    65: "Digital - Grupo de tareas 15",
    66: "Digital - Grupo de tareas 16",
    67: "Digital - Grupo de tareas 17",
    68: "Complete post-interim project management activities",
    69: 'Execute substantive procedures - Governance',
    70: 'Execute substantive procedures - Strategy',
    71: 'Execute substantive procedures - Risk Management',
    72: 'Execute substantive procedures - Metrics and Targets',
    73: "Ejecutar procedimientos sustantivos - Otros",
    74: "Evaluar el trabajo de los demás",
    75: "Digital - Grupo de tareas 25",
    76: "Digital - Grupo de tareas 26",
    77: "Digital - Grupo de tareas 27",
    78: "Digital - Grupo de tareas 28",
    79: "Digital - Grupo de tareas 29",
    80: "Digital - Grupo de tareas 30",
    81: "Digital - Grupo de tareas 31",
    82: "Digital - Grupo de tareas 32",
    83: "Digital - Grupo de tareas 33",
    84: "Digital - Grupo de tareas 34",
    85: "Evaluate and conclude on review evidence",
    86: "Realizar procedimientos generales de aseguramiento",
    87: "Evaluar y concluir sobre la base de la evidencia",
    88: "Digital - Grupo de tareas 38",
    89: "Digital - Grupo de tareas 39",
    90: "Digital - Grupo de tareas 40",
    91: "Digital - Grupo de tareas 41",
    92: "Digital - Grupo de tareas 42",
    93: "Digital - Grupo de tareas 43",
    94: "Digital - Grupo de tareas 44",
    95: "Digital - Grupo de tareas 45",
    96: "Digital - Grupo de tareas 46",
    97: "Digital - Grupo de tareas 47",
    98: "Digital - Grupo de tareas 48",
    99: "Digital - Grupo de tareas 49",
    100: "Digital - Grupo de tareas 50"
};
export const AutomationHubRequestStatus = {
    Draft: "Borrador",
    Submitted: "Enviado",
    Sent: "envio en proceso",
    InProgress: "procesando",
    Failed: "Error de procesamiento",
    Completed: "Completado",
    FailedToSendToBP: "Error de procesamiento",
    QueueingFailed: "Envío fallido",
    ActionRequired: "Acción requerida"
};
export const milestonesLabels = {
    1: "Alcance",
    2: "Estrategia",
    3: "Recorridos",
    4: "Pruebas de control interina",
    5: "Pruebas sustantivas interinas",
    6: "Recorridos (procesos de fin de año)",
    7: "Pruebas de control de fin de año",
    8: "Pruebas sustantivas de fin de año",
    9: "Conclusión",
    10: "No aplicable",
    11: "Ejecución",
    12: "Actividades de calida de alcance y estrategia",
    13: "Otro alcance y estrategia",
    14: "CRA",
    15: "Evaluación de riesgos y materialidad",
    16: "Finalizar el alcance y la estrategia",
    17: "Gestión de proyectos post intermedios"
};

export const TasksFilterGroups = {
    Tasks: "Tareas",
    Assignments: "Asignaciones",
    ReviewNotes: "Notas de revisión",
    ProjectManagement: "Gestión de proyectos",
    Other: "Otros"
};

export const TasksFilterTypes = {
    TaskStatus: "Estado de la tarea",
    TaskType: "Tipo de tarea",
    AssignedTo: "Asignado a",
    OpenAssignments: "Asignaciones abiertas",
    ReviewNotesStatus: "Estado de las notas de revision",
    ReviewNotesAssignedTo: "Notas de revision asingadas a",
    ReviewNotesCreatedBy: "Notas de revision creadas por",
    TimePhase: "Fase de tiempo",
    Milestone: "Hito",
    AuditPhase: "Fase de auditoría",
    DocumentConflict: "Conflicto de documentos",
    Findings: "Resultados",
    Entity: "Entidad",
    IsBookmarked: "Descargado para trabajo fuera de línea"
};

export const quickFilterTaskStatus = [{
        value: '1',
        label: "Abierto"
    },
    {
        value: '2',
        label: "En curso"
    },
    {
        value: '3',
        label: "En revisión"
    },
    {
        value: '4',
        label: "Completado"
    }
];

export const quickFilterAssignmentStatus = [{
        value: '1',
        label: "Abierto"
    },
    {
        value: '2',
        label: "En curso"
    },
    {
        value: '3',
        label: "Cerrado"
    },
    {
        value: '4',
        label: "Sin asignar"
    }
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"Colaboración",
	// 'Control Forms',
	"Documentos",
	"Tareas",
	"Resumen de Scot",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
    'Archive Form': "Formulario de archivo",
    'Canvas Forms': "Informe de formulario Canvas",
    'Collaboration': "Colaboración",
    'Control Forms': "Informe de control",
    'Documents': "Informe de todos los documentos",
    'Tasks': "Informe Todas las tareas",
    'Team Members': "Miembros del equipo",
    'Trial Balance': "Informe de números"
};
export const projectManagement = [
	"Detalles de la colaboración",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
    'Collaboration Details': "Panel de colaboración del cliente",
    'Milestones': "Informe de Milestone",
    'Review Notes': "Informe de notas de revisión",
    'Validation Checks': "Informe de comprobaciones de validación"
};

export const taskQuickFilterOptions = [{
        id: 'taskToPreparer',
        label: "Tareas a preparar",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'tasksReadyForReview',
        label: "Tareas listas para revisión",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allAssignedTasks',
        label: "Todas las tareas asignadas",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allOverdueTasks',
        label: "Tareas atrasadas",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allTasksDueThisWeek',
        label: "Tareas que vencen esta semana",
        uiViewId: uiViews.taskSystemSuggestedFilter
    }
];

export const noDefaultFilter = {
    id: 'noDefaultFilter',
    label: "Sin filtro predeterminado"
};

export const taskTypes = [{
        id: '1',
        label: "Tarea de control"
    },
    {
        id: '2',
        label: "Tarea de control - Control"
    },
    {
        id: '3',
        label: "Tarea de control - ELC"
    },
    {
        id: '4',
        label: "Tarea de control - IT/SO"
    },
    {
        id: '5',
        label: "Tarea de control - MP"
    },
    {
        id: '6',
        label: "Tarea de control - SO"
    },
    {
        id: '7',
        label: "Tarea de respuesta"
    },
    {
        id: '8',
        label: "Tarea de respuesta a errores de flujo de efectivo"
    },
    {
        id: '9',
        label: "Tarea de respuesta a deficiencias"
    },
    {
        id: '10',
        label: "Tarea de respuesta a declaraciones erróneas"
    },
    {
        id: '11',
        label: "Tarea de respuesta a errores"
    },
    {
        id: '12',
        label: "Tarea estándar"
    },
    {
        id: '13',
        label: "Otra tarea estándar"
    },
    {
        id: '14',
        label: "Tarea estándar primaria"
    },
    {
        id: '15',
        label: "Tarea sustantiva "
    },
    {
        id: '16',
        label: "Otras tareas del procedimiento sustantivo"
    },
    {
        id: '17',
        label: "Tarea del Procedimiento Sustantivo Primario"
    },
    {
        id: '18',
        label: "Tarea de recorrido"
    },
    {
        id: '19',
        label: "Tarea de recorrido - IT/SO"
    },
    {
        id: '20',
        label: "Tarea de recorrido - SCOT"
    },
    {
        id: '21',
        label: "Para hacer"
    },
    {
        id: '22',
        label: "Tarea de conclusión de la cuenta"
    },
    {
        id: '23',
        label: "Tarea de grupo"
    },
    {
        id: '24',
        label: "Tarea de grupo primario"
    },
    {
        id: '25',
        label: "Tarea de grupo componente"
    },
    {
        id: '26',
        label: "Tarea de otros procedimientos sustantivos de  IT/SO"
    },
    {
        id: '27',
        label: "Tarea de grupo componente desvinculada"
    }
];

export const filterAssignmentType = [{
        value: '1',
        label: "Preparador"
    },
    {
        value: '2',
        label: "Revisor de detalles"
    },
    {
        value: '3',
        label: "Revisor general"
    },
    {
        value: '4',
        label: "Socio"
    },
    {
        value: '5',
        label: "EQR"
    },
    {
        value: '6',
        label: "Otro"
    }
];

export const filterTaskStatus = [{
        value: '1',
        label: "Abierto"
    },
    {
        value: '2',
        label: "En curso"
    },
    {
        value: '3',
        label: "En revisión"
    },
    {
        value: '4',
        label: "Completado"
    },
    {
        value: '5',
        label: "Sin pruebas"
    }
];

export const filterAssignmentStatus = [{
        value: '1',
        label: "Abierto"
    },
    {
        value: '2',
        label: "En progreso"
    },
    {
        value: '3',
        label: "Cerrado"
    },
    {
        value: '4',
        label: "No asignado"
    }
];

export const filterTaskType = [{
        value: '1',
        label: "Tarea de control"
    },
    {
        value: '7',
        label: "Tarea de respuesta"
    },
    {
        value: '13',
        label: "Otra tarea estándar"
    },
    {
        value: '14',
        label: "Tarea estándar primaria"
    },
    {
        value: '16',
        label: "Otra tarea de procedimiento sustantivo"
    },
    {
        value: '17',
        label: "Tarea de procedimiento sustantivo primario"
    },
    {
        value: '18',
        label: "Recorrido/Tarea UDP"
    },
    {
        value: '22',
        label: "Tarea de conclusión de cuentas"
    },
    {
        value: '999',
        label: "Se requiere firma PIC"
    },
    {
        value: '1000',
        label: "Se requiere la firma de EQR"
    }
];

export const filterTaskTypeGroupEngagement = [{
        value: '1',
        label: "Tarea de control"
    },
    {
        value: '7',
        label: "Tarea de respuesta"
    },
    {
        value: '13',
        label: "Otra tarea estándar"
    },
    {
        value: '14',
        label: "Tarea estándar primaria"
    },
    {
        value: '16',
        label: "Otra tarea de procedimiento sustantivo"
    },
    {
        value: '17',
        label: "Tarea de procedimiento sustantivo primario"
    },
    {
        value: '18',
        label: "Recorrido/ tarea UDP"
    },
    {
        value: '22',
        label: "Tarea de conclusión de cuentas"
    },
    {
        value: '23',
        label: "Tarea de grupo"
    },
    {
        value: '999',
        label: "Se requiere firma PIC"
    },
    {
        value: '1000',
        label: "Se requiere la firma de EQR"
    }
];

export const filterTaskTypeInterimEngagement = [{
        value: '14',
        label: "Tarea estándar primaria"
    },
    {
        value: '13',
        label: "Otra tarea estándar"
    },
    {
        value: '23',
        label: "Tarea de grupo"
    },
    {
        value: '999',
        label: "Se requiere firma PIC"
    },
    {
        value: '1000',
        label: "Se requiere la firma de EQR"
    }
];

export const filterMilestones = [{
        value: '1',
        label: "Alcance",
        hideFromMenu: true
    },
    {
        value: '2',
        label: "Estrategia",
        hideFromMenu: true
    },
    {
        value: '12',
        label: "Actividades de calidad de alcance y estrategia"
    },
    {
        value: '13',
        label: "Otro alcance y estrategia"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "Evaluación y materialidad de riesgos"
    },
    {
        value: '16',
        label: "Finalizar alcance y estrategia"
    },
    {
        value: '17',
        label: "Gestión de proyectos post-interino"
    },
    {
        value: '3',
        label: "Recorridos"
    },
    {
        value: '4',
        label: "Pruebas de control provisionales"
    },
    {
        value: '5',
        label: "Pruebas sustantivas provisionales"
    },
    {
        value: '6',
        label: "recorridos (procesos de fin de año)"
    },
    {
        value: '7',
        label: "Pruebas de control de fin de año"
    },
    {
        value: '8',
        label: "Pruebas sustantivas de fin de año"
    },
    {
        value: '11',
        label: "Ejecución"
    },
    {
        value: '9',
        label: "Conclusión"
    },
    {
        value: '10',
        label: "N/A"
    },
    {
        value: '0',
        label: "Sin hito"
    }
];

export const documentListMilestones = [{
        value: '1',
        label: "Alcance"
    },
    {
        value: '12',
        label: "Alcance y estrategia de gestión de proyectos"
    },
    {
        value: '13',
        label: "Otro ámbito de aplicación y estrategia"
    },
    {
        value: '2',
        label: "Estrategia"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "Evaluación del riesgo y materialidad"
    },
    {
        value: '16',
        label: "Finalizar el alcance y la estrategia"
    },
    {
        value: '17',
        label: "Gestión de proyectos post-interim"
    },
    {
        value: '3',
        label: "Recorridos"
    },
    {
        value: '4',
        label: "Pruebas de control provisionales"
    },
    {
        value: '5',
        label: "Pruebas sustantivas provisionales"
    },
    {
        value: '6',
        label: "Walkthroughs (procesos de fin de año)"
    },
    {
        value: '7',
        label: "Pruebas de control de fin de año"
    },
    {
        value: '8',
        label: "Pruebas sustantivas de fin de año"
    },
    {
        value: '11',
        label: "Ejecución"
    },
    {
        value: '9',
        label: "Conclusión"
    },
    {
        value: '10',
        label: "N/A"
    }
];

export const filterAuditPhases = [{
        value: '1',
        label: "Alcance y estrategia"
    },
    {
        value: '2',
        label: "Ejecución"
    },
    {
        value: '3',
        label: "Conclusión"
    }
];


export const filterDocListReviewNoteStatus = [{
        value: 1,
        label: "Abrir"
    },
    {
        value: 5,
        label: "Borrado"
    },
    {
        value: 2,
        label: "Cerrado"
    }
];

export const filterDocumentConflicts = [{
    value: '1',
    label: "Sí"
}, {
    value: '0',
    label: "No"
}];
export const filterDownloadedForOffline = [{
    value: '1',
    label: "Sí"
}, {
    value: '2',
    label: "No"
}];

export const missingEntityDocuments = [{
    value: 10034,
    label: "Sí"
}]


export const filterTaskFindings = [{
        value: '1',
        label: "Deficiencia"
    },
    {
        value: '2',
        label: "Error"
    }
];

export const ConfidentialityTypes = [{
        id: 1,
        Name: "Predeterminado"
    },
    {
        id: 2,
        Name: "Bajo"
    },
    {
        id: 3,
        Name: "Moderado"
    },
    {
        id: 4,
        Name: "Alto"
    },
    {
        id: 5,
        Name: "Confidencial"
    }
];

export const RoleForMember = [{
        id: 1,
        role: "Socio a cargo del compromiso (PIC)",
        roleAbbreviation: "PIC",
        displayOrder: 9
    },
    {
        id: 2,
        role: "Socio del compromiso",
        roleAbbreviation: "Socio del compromiso",
        displayOrder: 8
    },
    {
        id: 3,
        role: "Director ejecutivo",
        roleAbbreviation: "Y",
        displayOrder: 5
    },
    {
        id: 4,
        role: "Principal",
        roleAbbreviation: "Principal",
        displayOrder: 6
    },
    {
        id: 5,
        role: "Gerente senior",
        roleAbbreviation: "Sr.Gerente",
        displayOrder: 4
    },
    {
        id: 6,
        role: "Gerente",
        roleAbbreviation: "Director",
        displayOrder: 3
    },
    {
        id: 7,
        role: "Senior",
        roleAbbreviation: "Senior",
        displayOrder: 2
    },
    {
        id: 8,
        role: "Staff",
        roleAbbreviation: "Staff",
        displayOrder: 1
    },
    {
        id: 9,
        role: "Asociado",
        roleAbbreviation: "Asoc"
    },
    {
        id: 10,
        role: "Revisor de calidad del compromiso (EQR)",
        roleAbbreviation: "EQR",
        displayOrder: 10
    },
    {
        id: 11,
        role: "Otro socio",
        roleAbbreviation: "Otro socio",
        displayOrder: 7
    },
    {
        id: 12,
        role: "GDS - Personal",
        roleAbbreviation: "GDS Staff",
        displayOrder: 13
    },
    {
        id: 13,
        role: "Advisory(FAIT TAS Human Capital u otros)",
        roleAbbreviation: "ADV"
    },
    {
        id: 14,
        role: "Impuestos",
        roleAbbreviation: "Tax"
    },
    {
        id: 15,
        role: "Servicios de soporte ejecutivo",
        roleAbbreviation: "ESS"
    },
    {
        id: 16,
        role: "Abogado general",
        roleAbbreviation: "GCO",
        displayOrder: 12
    },
    {
        id: 17,
        role: "Revisor de calidad de la auditoria",
        roleAbbreviation: "AQR",
        displayOrder: 11
    },
    {
        id: 18,
        role: "Equipo componente ML",
        roleAbbreviation: "MCT"
    },
    {
        id: 19,
        role: "Supervisor del cliente",
        roleAbbreviation: "C. Supervisor'"
    },
    {
        id: 20,
        role: "Staff del cliente",
        roleAbbreviation: "C. Staff"
    },
    {
        id: 21,
        role: "Supervisor de auditoria interna",
        roleAbbreviation: "IA Supervisor"
    },
    {
        id: 22,
        role: "Staff de auditoria interna",
        roleAbbreviation: "IA Staff"
    },
    {
        id: 23,
        role: "Regulador",
        roleAbbreviation: "Regulador"
    },
    {
        id: 24,
        role: "Otros (revision de Due Diligence)",
        roleAbbreviation: "Otro"
    },
    {
        id: 25,
        role: "Oficina",
        roleAbbreviation: "Oficina"
    },
    {
        id: 26,
        role: "Area",
        roleAbbreviation: "Area"
    },
    {
        id: 27,
        role: "Industria",
        roleAbbreviation: "IND"
    },
    {
        id: 28,
        role: "National",
        roleAbbreviation: "NAT"
    },
    {
        id: 29,
        role: "Global",
        roleAbbreviation: "GBL"
    },
    {
        id: 30,
        role: "GDS - Senior",
        roleAbbreviation: "GDS Senior",
        displayOrder: 14
    },
    {
        id: 31,
        role: "GDS - Gerente",
        roleAbbreviation: "Gerente de GDS",
        displayOrder: 15
    }
];

export const SubServiceLines = [{
        subServiceLineId: 1,
        subServiceLineName: "Auditoría",
        displayOrder: 1
    },
    {
        subServiceLineId: 2,
        subServiceLineName: "FIDS",
        displayOrder: 2
    },
    {
        subServiceLineId: 9,
        subServiceLineName: "FAAS",
        displayOrder: 3
    },
    {
        subServiceLineId: 11,
        subServiceLineName: "CCaSS",
        displayOrder: 4
    },
    {
        subServiceLineId: 12,
        subServiceLineName: "BTS",
        displayOrder: 5
    },
    {
        subServiceLineId: 13,
        subServiceLineName: "Capital humano",
        displayOrder: 6
    },
    {
        subServiceLineId: 14,
        subServiceLineName: "Ley",
        displayOrder: 7
    },
    {
        subServiceLineId: 15,
        subServiceLineName: "Impuesto indirecto",
        displayOrder: 8
    },
    {
        subServiceLineId: 16,
        subServiceLineName: "GCR",
        displayOrder: 9
    },
    {
        subServiceLineId: 17,
        subServiceLineName: "Impuesto de transacción",
        displayOrder: 10
    },
    {
        subServiceLineId: 18,
        subServiceLineName: "ITS",
        displayOrder: 11
    },
    {
        subServiceLineId: 19,
        subServiceLineName: "GCO",
        displayOrder: 12
    },
    {
        subServiceLineId: 20,
        subServiceLineName: "Business Consulting",
        displayOrder: 13
    },
    {
        subServiceLineId: 21,
        subServiceLineName: "Technology Consulting",
        displayOrder: 14
    },
    {
        subServiceLineId: 22,
        subServiceLineName: "Transactions and Corporate Finance",
        displayOrder: 15
    },
    {
        subServiceLineId: 23,
        subServiceLineName: "Ey Parthenon",
        displayOrder: 16
    },
    {
        subServiceLineId: 24,
        subServiceLineName: "Otro",
        displayOrder: 17
    },
    {
        subServiceLineId: 25,
        subServiceLineName: "Riesgo tecnológico",
        displayOrder: 18
    }
];

export const SchedulerRequestRole = [{
        id: 31,
        userTypeId: 4,
        label: "Gerente de GDS"
    },
    {
        id: 31,
        userTypeId: 3,
        label: "Gestor de pedidos"
    }
];

/* Task Status */
export const TaskStatus = [{
        id: 1,
        label: "Abiertas"
    },
    {
        id: 2,
        label: "En curso"
    },
    {
        id: 3,
        label: "En revisión"
    },
    {
        id: 4,
        label: "Completa"
    },
    {
        id: 5,
        label: "Removido"
    },
    {
        id: 6,
        label: "Aprobación de PIC/EQR completa"
    }
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
        id: 1,
        label: "No enviado"
    },
    {
        id: 2,
        label: "En curso"
    },
    {
        id: 3,
        label: "Enviado"
    },
    {
        id: 4,
        label: "Regresado"
    }
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
        id: GAComponentDocumentStatus.Open,
        label: "Abierto"
    },
    {
        id: GAComponentDocumentStatus.InProgress,
        label: "Recibido"
    },
    {
        id: GAComponentDocumentStatus.Submitted,
        label: "Enviado"
    },
    {
        id: GAComponentDocumentStatus.Returned,
        label: "Volvió"
    },
    {
        id: GAComponentDocumentStatus.InReview,
        label: "Preparado"
    },
    {
        id: GAComponentDocumentStatus.Complete,
        label: "Revisado"
    },
    {
        id: GAComponentDocumentStatus.Dismissed,
        label: "Liberado"
    },
    {
        id: GAComponentDocumentStatus.RejectInTransit,
        label: "Regreso en progreso"
    },
    {
        id: GAComponentDocumentStatus.ReturnError,
        label: "Error de devolución"
    }
];
export const TeamSummaryPreparerTaskStatus = [{
        id: 1,
        label: "Abierto"
    },
    {
        id: 2,
        label: "En curso"
    },
    {
        id: 3,
        label: "Cerrado"
    }
];
export const TeamSummaryReviewerTaskStatus = [{
        id: 1,
        label: "Abierto"
    },
    {
        id: 2,
        label: "En curso"
    },
    {
        id: 3,
        label: "Cerrado"
    }
];

export const DocumentHelper = {
    401: "No se pudo completar la operación. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",
    413: "El documento supera el tamaño máximo de archivo permitido (250 mb) y no se puede cargar. Reduzca el tamaño del archivo e inténtelo de nuevo.",
    412: "Ya existe un documento con nombre en este compromiso",
    414: "El nombre supera la longitud máxima ({0} caracteres).",
    410: "Este documento se ha eliminado y, por lo tanto, no se puede abrir.",
    411: "No se permiten documentos vacíos."
};

export const reviewNoteCategories = [{
        value: reviewNoteRoutes.path.all.id,
        path: reviewNoteRoutes.path.all.path,
        label: "Todas las notas"
    },
    {
        value: reviewNoteRoutes.path.document.id,
        path: reviewNoteRoutes.path.document.path,
        label: "Notas del documento"
    },
    {
        value: reviewNoteRoutes.path.task.id,
        path: reviewNoteRoutes.path.task.path,
        label: "Notas de tareas"
    },
    {
        value: reviewNoteRoutes.path.form.id,
        path: reviewNoteRoutes.path.form.path,
        label: "Comentarios del Canvas form"
    }
];

export const reviewNoteStatus = [{
        value: '1',
        label: "Abierto"
    },
    {
        value: '2',
        label: "Resuelto"
    },
    {
        value: '3',
        label: "Cerrado"
    }
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
        id: 1,
        type: 'document',
        label: "Nota del documento"
    },
    {
        id: 2,
        type: 'task',
        label: "Nota de tarea"
    }
];

export const accountConclusionTabs = {
    details: "Detalles",
    conclusions: "Conclusiones"
};


export const rnhFilterType = [{
        id: 0,
        filterType: rnhFilterTypeQuery.annotationStatusIds,
        name: "Id de estado de la nota",
        inDropDown: false
    },
    {
        id: 1,
        filterType: rnhFilterTypeQuery.authoredBy,
        name: "Creado por",
        inDropDown: true
    },
    {
        id: 2,
        filterType: rnhFilterTypeQuery.assignedTo,
        name: "Asignado a",
        inDropDown: true
    },
    {
        id: 3,
        filterType: rnhFilterTypeQuery.priority,
        name: "Prioridad",
        inDropDown: true,
        filterOptions: [{
            id: "1",
            label: "Bajo"
        }, {
            id: "2",
            label: "Medio"
        }, {
            id: "3",
            label: "Alto"
        }, {
            id: "4",
            label: "Crítico"
        }]
    },
    {
        id: 4,
        filterType: rnhFilterTypeQuery.dueBefore,
        name: "vencido en o antes",
        inDropDown: true,
        isDateTime: true
    },
    {
        id: 5,
        filterType: rnhFilterTypeQuery.dueAfter,
        name: "Vencimiento en o después",
        inDropDown: true,
        isDateTime: true
    }
];

export const rnhSortingOptions = [{
        id: 'Number',
        label: '#'
    },
    {
        id: 'DueDate',
        label: "Vencimiento"
    },
    {
        id: 'Priority',
        label: "prioridad"
    },
    {
        id: 'Status',
        label: "Estado"
    }
];

export const userConfidentiality = [{
        id: 1,
        value: "General"
    },
    {
        id: 2,
        value: "Bajo"
    },
    {
        id: 3,
        value: "Medio"
    },
    {
        id: 4,
        value: "Alto"
    },
    {
        id: 5,
        value: "Restringido"
    },
    {
        id: 6,
        value: "Confidencial"
    }
];

export const externalUserStatus = {
    active: "Activo",
    inactive: "Inactivo"
};

export const engagementStatus = {
    1: "Activo",
    2: "Pendiente",
    3: "Rechazado",
    4: "Inactivo",
    13: "Programado - Inactivo"
};

export const copyRequestStatus = {
    0: "Expirado",
    1: "Listo",
    2: "enviado",
    3: "recibido",
    4: "Exportación en curso",
    5: "Exportación exitosa.",
    6: "Error de exportación",
    7: "Importación en curso",
    8: "Importación correcta",
    9: "Error de importación",
    10: "Negado",
    11: "Copia en curso",
    13: "borrador",
    14: "Envío en proceso",
    15: "Entrega en proceso",
    16: "Error de entrega"
}

export const copyObjectGrouptype = {
    21: "Compromiso",
    22: "Cuentas",
    23: "SCOTs",
    20: "Evidencia",
    24: "Actualización desde lo existente",
    25: "Plantilla",
    26: "Exportación a granel",
    27: "Documento externo",
    28: "Flujos de trabajo guiados",
    29: "Compromiso por Entidad"
}

export const independenceStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.overriden,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
        value: 3,
        label: labels.matteridentifiedpendingaction
    },
    {
        value: 4,
        label: labels.matterresolveddeniedaccess
    },
    {
        value: 5,
        label: labels.matterresolvedgrantedaccess
    },
    {
        value: 8,
        label: labels.override
    },
    {
        value: 1,
        label: labels.incomplete
    },
    {
        value: 2,
        label: labels.nomattersidentified
    },
    {
        value: 7,
        label: labels.restored
    },
    {
        value: 6,
        label: labels.notapplicable
    }
];

export const independenceConfirmationStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.override,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
    1: "Alcance",
    2: "Estrategia",
    3: "Recorrido",
    4: "Prueba de control interinas",
    5: "Pruebas sustantivas interinas",
    6: "Recorrido (procesos de fin de año)",
    7: "Pruebas de control de fin de año",
    8: "Pruebas sustantivas de fin de año",
    9: "Conclusión",
    10: "N / A",
    11: "Ejecución",
    12: "Actividades de calida de alcance y estrategia",
    13: "Otro alcance y estrategia",
    14: "CRA",
    15: "Evaluación de riesgos y materialidad",
    16: "Finalizar alcance y estrategia",
    17: "Gestión de proyectos post-interina"
};

export const engagementMetricsComingDueOptions = [{
        value: 1,
        label: "Mañana"
    },
    {
        value: 3,
        label: "Próximos 3 días"
    },
    {
        value: 5,
        label: "Próximos 5 días,",
        isDefault: true
    },
    {
        value: 10,
        label: "Próximos 10 días"
    },
    {
        value: 30,
        label: "Próximos 30 días,",
        isMax: true
    }
];

export const engagementMetricsWhatsNewOptions = [{
        value: 1,
        label: "Ayer"
    },
    {
        value: 3,
        label: "Los últimos 3 días"
    },
    {
        value: 5,
        label: "Últimos 5 días",
        isDefault: true
    },
    {
        value: 10,
        label: "Los últimos 10 días",
        isMax: true
    }
];

export const engagementMetricsDisplayedAttributes = {
    preparer: "Para preparar",
    forMyReview: "Para revisar",
    upcomingReview: "Próxima revisión",
    reviewNotesAssigned: "Notas para mí",
    reviewNotesAuthored: "Notas mías",
    partnerTasks: "Tareas de asociados de negocios",
    eqrTasks: "Tareas de EQR",
    timephases: "Fases de tiempo",
    groupTasks: "Agrupar tareas",
    groupDeliverables: "Entregables grupales",
    automation: "Automatización",
    requests: "Solicitudes"
};

export const quickLinks = {
    linkAccountSummary: "Resumen de cuentas",
    linkScotSummary: "Resumen de SCOT",
    linkITSummary: "Resumen de TI",
    linkCRASummary: "Resumen de la CRA",
    linkGAStructureSummary: "Resumen de estructura grupal",
    linkGAInstrcutionSummary: "Resumen de instrucciones grupales",
    linkSEM: "Matriz de evaluación sustantiva",
    linkAuditPlan: "Plan de auditoria",
    linkWorkPlan: "Plan de trabajo",
    linkITProcessEvaluation: "Evaluaciones de TI",

    linkGeneral: "General",
    linkScots: "SCOTs",
    linkITSO: "TI/SO",
    linkAccounts: "Cuentas",
    linkResponseTask: "Tareas de respuesta",
    linkWrapupEngagement: "Compromiso de cierre",
    linkArchive: "Lista de verificación de archivo"
};

export const customKeyEvents = {
    reportDate: "Fecha de reporte",
    endDatePeriodCovered: "Fecha de periodo cubierto",
    archiveDeadlineDate: "Fecha de archive "
};

export const filterReviewNoteStatus = [{
        value: filters.reviewNoteStatus.open,
        label: "Abierto"
    },
    {
        value: filters.reviewNoteStatus.cleared,
        label: "Resuelto"
    },
    {
        value: filters.reviewNoteStatus.closed,
        label: "Cerrado"
    }
];

export const filterFileExtension = [{
        value: filters.fileExtension.canvasForm,
        label: "Formulario de Canvas"
    },
    {
        value: filters.fileExtension.email,
        label: "Correo electrónico"
    },
    {
        value: filters.fileExtension.excel,
        label: "Excel"
    },
    {
        value: filters.fileExtension.paperProfile,
        label: "Perfil de papel"
    },
    {
        value: filters.fileExtension.pdf,
        label: "PDF"
    },
    {
        value: filters.fileExtension.powerPoint,
        label: 'PowerPoint'
    },
    {
        value: filters.fileExtension.smartAutomation,
		label: "Automatización inteligente"
    },
    {
        value: filters.fileExtension.visio,
        label: "Visio"
    },
    {
        value: filters.fileExtension.word,
        label: "Word"
    },
    {
        value: filters.fileExtension.zip,
        label: "Zip"
    },
    {
        value: filters.fileExtension.other,
        label: "Otro"
    }
];

export const filterDocumentContent = [{
        value: filters.documentContent.trackedChanges,
        label: "Seguimiento de los cambios"
    },
    {
        value: filters.documentContent.comments,
        label: "Comentarios"
    },
    {
        value: filters.documentContent.formulaError,
        label: "Errores de fórmula (solo archivos de Excel)"
    },
    {
        value: filters.documentContent.highlightsWordFilesOnly,
        label: "Resaltados (solo archivos de Word)"
    },
    {
        value: filters.documentContent.hiddenSheets,
        label: "Hojas ocultas"
    },
    {
        value: filters.documentContent.embeddedFiles,
        label: "Archivos incrustados"
    },
    {
        value: filters.documentContent.ProtectedFiles,
        label: "Protegido"
    },
    {
        value: filters.documentContent.DocumentContentNotAvailable,
        label: "Contenido del documento no disponible"
    },
    {
        value: filters.documentContent.DocumentsInCollaborationMode,
        label: "Documentos en modo de edición Multiusuario"
    }
];

export const filterSharedEvidence = [{
        value: filters.sharedEvidence.source,
        label: "Fuente"
    },
    {
        value: filters.sharedEvidence.target,
        label: "Objetivo"
    }
];

export const filterFindings = [{
        value: filters.findings.misstatement,
        label: "Error material"
    },
    {
        value: filters.findings.deficiency,
        label: "Deficiencia"
    }
];

export const filterSignoffRequirements = [{
        value: filters.signoffRequirements.picMandatory,
        label: "PIC Requerido"
    },
    {
        value: filters.signoffRequirements.picTeamAssigned,
        label: "Equipo PIC asignado"
    },
    {
        value: filters.signoffRequirements.eqrMandatory,
        label: "EQR requerido"
    },
    {
        value: filters.signoffRequirements.eqrTeamAssigned,
        label: "Equipo EQR designado"
    }
];

export const filterResponsiveToRisks = [{
        value: filters.responsiveToRisk.responsiveToSignificantRisk,
        label: "Riesgos significativos"
    },
    {
        value: filters.responsiveToRisk.responsiveToFraudRisk,
        label: "Riesgos de fraude"
    },
    {
        value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
        label: "Riesgos inherentes más alto"
    }
];

export const filterMissingRelatedTask = [{
        value: filters.missingRelatedTask.picSignoffRequired,
        label: "Se requiere aprobación de PIC"
    },
    {
        value: filters.missingRelatedTask.eqrSignoffRequired,
        label: "Se requiere aprobación de EQR"
    }
];

export const filterCanvasForms = [{
        value: filters.canvasForms.incompleteResponses,
        label: "Respuestas incompletas"
    },
    {
        value: filters.canvasForms.unresolvedComments,
        label: "Comentarios no resueltos"
    }
];

export const documentChangeTypes = {
    0: "No hay razon para cambios seleccionados",
    1: "No cambios administrativos",
    2: "Aceptando revisiones cuando la funcionalidad de rastrear cambios fue utilizada",
    3: "Agregar referencias de cruece adicionales a la evidencia que ya existe",
    4: "Agregar respuestas de confirmacion adicional previamente recibida por fax o email",
    5: "Cambio cosmetico",
    6: "Completar el Formulario AP y evaluación sustancial de roles",
    7: "Borrando o descartando documentacion sobrepuesta",
    8: "Preparando la carta de la entidad",
    9: "Firmar el checklist relacionado con el proceso de archivo",
    10: "Sorteando, relacionando y referenciando los documentos finales",
    11: "Cuando se ajusta a la zona horaria local, la modificación se realiza en la fecha del informe o antes (solo en América)"
};

export const documentChangeTypesOptions = [{
        value: 1,
        label: "Cambio no administrativo"
    },
    {
        value: 2,
        label: "Aceptar revisiones/comentarios cuando se utilizaron dichas funcionalidades"
    },
    {
        value: 3,
        label: "Agregar referencia adicional a la evidencia que ya existe"
    },
    {
        value: 4,
        label: "Agregar respuesta de confirmacion original previamente recibida por fax o email"
    },
    {
        value: 5,
        label: "Cambio cosmetico"
    },
    {
        value: 6,
        label: "Completar el Formulario AP y evaluación sustancial de roles"
    },
    {
        value: 7,
        label: "Eliminar o descartar documentación que no constituya evidencia de auditoría"
    },
    {
        value: 8,
        label: "Preparar o agregar documentos que no apoyen nuestra opinión"
    },
    {
        value: 9,
        label: "Firma de checklist relacionado con el proceso de archivo"
    },
    {
        value: 10,
        label: "Sorteando, relacionando y referenciado documentos finales"
    },
    {
        value: 12,
        label: "Unicamente MEST: modificacion a la evidencia relacionada con las entidades con una fecha de reporte posterior a la fecha de reporte en EY Canvas"
    },
    {
        value: 11,
        label: "Cuando se ajusta a la zona horaria local, la modificación se realiza en la fecha del informe o antes (solo en América)"
    }
];

export const FourFortyFilterTypes = [{
        id: 0,
        filterType: 'QuickFilter',
        name: "Filtros rapidos",
        hasChild: false
    },
    {
        id: 1,
        filterType: 'TaskStatus',
        name: "Status de tareas",
        hasChild: false
    },
    {
        id: 2,
        filterType: 'TaskType',
        name: "Tipo de tareas",
        hasChild: false
    },
    {
        id: 3,
        filterType: 'AssignedTo',
        name: "Asignado a",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 4,
        filterType: 'OpenAssignment',
        name: "Asignacion abierta",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 5,
        filterType: 'AssignmentsUsersEngagementRoles',
        name: "Asignacion abierta",
        hideDisplay: true,
        loadOptionsFromServer: true
    },
    {
        id: 6,
        filterType: 'ReviewNotesStatus',
        name: "Status de notas de revision",
        hasChild: false
    },
    {
        id: 7,
        filterType: 'ReviewNotesAssignedTo',
        name: "Notas de revision asignadas a",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 8,
        filterType: 'ReviewNotesCreatedBy',
        name: "Notas de revision creadas por",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 9,
        filterType: 'TimePhase',
        name: "fase de tiempo",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 10,
        filterType: 'Milestone',
        name: "Milestone",
        hasChild: false
    },
    {
        id: 11,
        filterType: 'AuditPhase',
        name: "Fase de auditoria",
        altName: "Fase del compromiso",
        hasChild: false
    },
    {
        id: 12,
        filterType: 'DocumentConflict',
        name: "Conflicto de documentos",
        hasChild: false
    },
    {
        id: 13,
        filterType: 'Findings',
        name: "Hallazgos",
        hasChild: false,
        hideForNonAudit: true
    },
    {
        id: 14,
        filterType: 'Entity',
        name: "Entidad",
        hasChild: false,
        loadOptionsFromServer: true,
        hideForNonMest: true
    },
    {
        id: 15,
        filterType: 'IsBookmarked',
        name: "Descargado o fuera de linea",
        hasChild: false
    }
];

/* Arc Timeline */
export const arcValidationGroups = [{
        id: 1,
        label: "Construir paso 29 ???"
    },
    {
        id: 2,
        label: "Construir paso 30 ???"
    },
    {
        id: 3,
        label: "SEM (Matriz de evaluación) ???"
    },
    {
        id: ArcTimelineGroups.FinalizeEvidence,
        label: "Finalizar pruebas"
    },
    {
        id: ArcTimelineGroups.CompleteRemainingTasks,
        label: "Completar tareas restantes"
    },
    {
        id: ArcTimelineGroups.ResolveValidations,
        label: "Resolver las validaciones restantes"
    },
    {
        id: 7,
        label: "Prepararse para el archivo"
    },
    {
        id: 8,
        label: "Panel de compromiso"
    },
    {
        id: 9,
        label: "Formulario de canvas (individual)"
    },
    {
        id: 10,
        label: "Formulario de canvas (Todos)"
    }
];

export const checkListTypes = [{
        id: 7,
        label: "Finalizar archivos y carpetas de copia impresa"
    },
    {
        id: 13,
        label: "Confirmar la exactitud de las fechas clave del compromiso"
    },
    {
        id: 14,
        label: "Confirmar la exactitud de los códigos de compromiso"
    },
    {
        id: 15,
        label: "Confirmar la exactitud del código de cliente"
    },
    {
        id: 10,
        label: "Desvincular este compromiso del grupo"
    },
    {
        id: 16,
        label: "Validar el tipo de informe"
    },
    {
        id: 17,
        label: "Revise los archivos temporales de los modificados después de la fecha de emision del informe"
    },
    {
        id: 18,
        label: "Revise los archivos eliminados para los modificados después de la fecha de emision del informe"
    },
    {
        id: 19,
        label: "Asegúrese de que se envíen los cambios en el perfil del comrpomiso"
    },
    {
        id: 20,
        label: "Revisar documentos protegidos"
    },
    {
        id: 95,
        label: "Designar a la persona general a cargo"
    }
];

export const arcValidationTypes = [{
        id: ArcTimeLineValidationTypes.DocumentConflict,
        label: "Resolver conflictos de documentos restantes"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
        label: "Edición multiusuario de documentos"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
        label: "Revisar documentos protegidos"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
        label: "Contenido del documento no disponible"
    },
    {
        id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
        label: "Cerrar todas las notas de revisión no resueltas"
    },
    {
        id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
        label: "Eliminar los cambios rastreados de la evidencia"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
        label: "Finalizar archivos de evidencia de Automatización Inteligente"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
        label: "Complete todos los requisitos de firma de PIC"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
        label: "Complete todos los requisitos de firma de EQR"
    },
    {
        id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
        label: "Relacionar documentos PIC con tareas PIC"
    },
    {
        id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
        label: "Relacionar documentos EQR con tareas EQR"
    },
    {
        id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
        label: "Firma en toda la evidencia"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormComment,
        label: "Resolver comentarios del formulario de Canvas"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
        label: "Evidencia compartida desvinculada"
    },
    {
        id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
        label: "Añadir evidencia para abrir tareas"
    },
    {
        id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
        label: "Verifique que todas las tareas PIC contengan documentos PIC"
    },
    {
        id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
        label: "Verifique que todas las tareas de EQR contengan documentos de EQR"
    },
    {
        id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
        label: "Relacionar la evidencia con la tarea de la entidad"
    },
    {
        id: ArcTimeLineValidationTypes.MarkTasksComplete,
        label: "Marcar tareas completas"
    },
    {
        id: ArcTimeLineValidationTypes.AccountsSummary,
        label: "Resumen de cuentas"
    },
    {
        id: ArcTimeLineValidationTypes.ScotSummary,
        label: "Resumen de SCOTs"
    },
    {
        id: ArcTimeLineValidationTypes.CraSummary,
        label: "Resumen de la CRA"
    },
    {
        id: ArcTimeLineValidationTypes.ITSummary,
        label: "Resumen de TI"
    },
    {
        id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
        label: "Confirmar la exactitud de los datos del informe de los auditores"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveForm,
        label: "Formulario de archivo completo"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveTask,
        label: "Tarea completa de archivo"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
        label: "Desvincular evidencia de grupo compartida"
    },
    {
        id: ArcTimeLineValidationTypes.AuditPlan,
        label: "Plan de auditoría"
    },
    {
        id: ArcTimeLineValidationTypes.UnassociateFinding,
        label: "Hallazgos no asociados"
    },
    {
        id: ArcTimeLineValidationTypes.IndependenceCompliance,
        label: "Cumplimiento de la independencia"
    },
    {
        id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
        label: "Finalizar las respuestas incompletas del formulario Canvas"
    },
    {
        id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
        label: "Matriz de evaluación sustantiva"
    },
    {
        id: ArcTimeLineValidationTypes.ITEvaluation,
        label: "Evaluaciones de TI"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
        label: "Documentos modificados después de la fecha de emision del informe"
    },
    {
        id: ArcTimeLineValidationTypes.DuplicateFileNames,
        label: "Renombrar archivos de evidencia con nombres de archivo duplicados"
    },
    {
        id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
        label: "Flujo de TI"
    },
    {
        id: ArcTimeLineValidationTypes.AdjustmentsModule,
        label: "Ajustes"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
        label: "Revise los formularios de Canvas sin contenido"
    },
    {
        id: ArcTimeLineValidationTypes.PersonInCharge,
        label: "Persona a cargo"
    },
    {
        id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
        label: ''
    },
    {
        id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
        label: "Revise los archivos temporales que tienen la firma del preparador y el revisor para los archivos que deben incluirse como evidencia o eliminarse"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
        label: "Revisar archivos temporales que tienen etiquetas PIC para archivos que deben incluirse en evidencia o etiquetas eliminadas"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
        label: "Revisar archivos temporales que tienen etiquetas EQR para archivos que deben incluirse en evidencia o etiquetas eliminadas"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
        label: "Revisar los archivos eliminados que tienen etiquetas PIC para los archivos que deben incluirse en la evidencia o las etiquetas eliminadas"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
        label: "Revisar los archivos eliminados que tienen etiquetas EQR para los archivos que deben incluirse en la evidencia o etiquetas eliminadas"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
        label: "Documentos relacionados con objetos que ya no están disponibles en la contratación"
    }
];

export const ArchiveErrors = {
    32204: "El compromiso tiene tarea sin evidencias.",
    32209: "Engagement tiene CanvasForm con respuestas incompletas.",
    32210: "Engagement tiene Open Review Notes.",
    32212: "El compromiso tiene una tarea incompleta.",

    32402: "El ID de archivo es null o está vacío.",
    32403: "El GUID de archivo es nulo o está vacío.",
    32404: "ARC FileStoreHost es null o está vacío.",
    32424: "Falta el código de interacción principal o no es válido.",
    32425: "La fecha de publicación del informe no puede ser una fecha futura.",
    32426: "La fecha de publicación del informe debe ser posterior a la fecha de finalización de la contratación.",
    32427: "Se debe invitar a un socio al compromiso.",
    32428: "Al ARC le faltan datos sobre el tipo de papel de trabajo.",
    32429: "Se requiere una selección en el formulario de archivo para el tipo de informe.",
    32430: "Se requiere una selección en el formulario de archivo para los informes calificados.",
    32431: "Se ha producido un error durante el proceso de archivado debido a la integración con el ARC. Póngase en contacto con el servicio de asistencia para informar de este error."
};

export const validationTypes = [{
        id: 1,
        label: "Cumplimiento de la independencia pendiente",
        altLabel: "Formulario incompleto",
        errorLabel: "Cumplimiento de la independencia pendiente"
    },
    {
        id: 2,
        label: "Versión del formulario de independencia no actualizado",
        altLabel: "Formulario obsoleto",
        errorLabel: "La versión del formulario de independencia no es actual"
    },
    {
        id: 3,
        label: "Acceso concedido por un rol no elegible",
        altLabel: "No aprobado por PPEDD'",
        errorLabel: "Acceso otorgado por rol no elegible"
    },
    {
        id: 4,
        label: "Reemplazar por rol no elegible",
        altLabel: "No reemplazado por PPEDD",
        errorLabel: "Anulación por rol no elegible"
    },
    {
        id: 5,
        label: "SCOTs no relacionados (sin cuenta)",
        errorLabel: "SCOTs no relacionados"
    },
    {
        id: 6,
        label: "Controles no relacionados (sin WCGW)",
        errorLabel: "Controles no relacionados"
    },
    {
        id: 7,
        label: "Controla la estrategia seleccionada sin WCGWs relacionados",
        errorLabel: "Estrategia de controles sin WCGW relacionados"
    },
    {
        id: 8,
        label: "Controla la estrategia seleccionada sin controles relacionados",
        errorLabel: "Estrategia de controles seleccionada sin controles relacionados"
    },
    {
        id: 9,
        label: "Controla la estrategia seleccionada sin controles relacionados seleccionados para las pruebas",
        errorLabel: "Estrategia de controles seleccionada sin controles relacionados seleccionados para las pruebas"
    },
    {
        id: 10,
        label: "Estrategia de controles seleccionada y hay un WCGW sin controles relacionados seleccionados para las pruebas",
        errorLabel: "Estrategia de controles seleccionada y hay un WCGW sin controles relacionados seleccionados para las pruebas"
    },
    {
        id: 11,
        label: "Riesgos no relacionados",
        errorLabel: "Riesgos no relacionados"
    },
    {
        id: 12,
        label: "CRA completo para esta aseveración",
        errorLabel: "CRA completa para esta aserción"
    },
    {
        id: 13,
        label: "WCGWs no relacionados",
        errorLabel: "WCGW no relacionados"
    },
    {
        id: 14,
        label: "Cuenta significativa no tiene SCOT relacionados",
        errorLabel: "La cuenta significativa no tiene SCOTs relacionados"
    },
    {
        id: 15,
        label: "Estrategia de confianza seleccionada sin WCWWs relacionados",
        errorLabel: "Confiar en la estrategia seleccionada sin WCGW relacionados"
    },
    {
        id: 16,
        label: "Estrategia de confianza seleccionada sin controles relacionados",
        errorLabel: "Estrategia de confianza seleccionada sin controles relacionados"
    },
    {
        id: 17,
        label: "Estrategia de confianza seleccionada sin controles relacionados seleccionados para las pruebas",
        errorLabel: "Confiar en la estrategia seleccionada sin controles relacionados seleccionados para las pruebas"
    },
    {
        id: 18,
        label: "Estrategia de confianza seleccionada y hay un WCGW sin controles relacionados seleccionados para las pruebas",
        errorLabel: "Estrategia de confianza seleccionada y hay un WCGW sin controles relacionados seleccionados para las pruebas"
    },
    {
        id: 19,
        label: "Aplicación de TI no relacionada/SO",
        errorLabel: "Aplicación de TI no relacionada / So"
    },
    {
        id: 20,
        label: "Control no relacionado / Procedimiento sustantivo de TI",
        errorLabel: "Procedimientos sustantivos de control/TI no relacionados"
    },
    {
        id: 21,
        label: "No hay aplicación de TI relacionada/SO",
        errorLabel: "No hay aplicación de TI / SO relacionada"
    },
    {
        id: 22,
        label: "Sin riesgos relacionados",
        errorLabel: "Sin riesgos relacionados"
    },
    {
        id: 23,
        label: "Sin controles relacionados / Procedimientos sustantivos de TI",
        errorLabel: "No hay controles relacionados / procedimientos sustantivos de TI"
    },
    {
        id: 24,
        label: "No hay controles relacionados / Procedimientos sustantivos de TI seleccionados para las pruebas",
        errorLabel: "No hay controles relacionados / procedimientos sustantivos de TI seleccionados para las pruebas"
    },
    {
        id: 25,
        label: "Existe un riesgo sin controles relacionados / Procedimientos sustantivos de TI seleccionados para las pruebas",
        errorLabel: "Existe un riesgo sin controles relacionados / procedimientos sustantivos de TI seleccionados para las pruebas"
    },
    {
        id: 26,
        label: "La Cuenta de Riesgo Limitado no tiene ninguna Tarea Sustantiva relacionada",
        errorLabel: "La cuenta de riesgo limitado no tiene ninguna tarea sustantiva relacionada"
    },
    {
        id: 27,
        label: "Ninguna tarea sustantiva está relacionada con la aseveración",
        errorLabel: "Ninguna tarea sustantiva está relacionada con la aserción"
    },
    {
        id: 28,
        label: "TOC no relacionado",
        errorLabel: "TOC no relacionado"
    },
    {
        id: 29,
        label: "Tutorial no relacionado",
        errorLabel: "Recorrido no relacionado"
    },
    {
        id: 30,
        label: "Ninguna tarea del tutorial está relacionada con el SCOT",
        errorLabel: "Ninguna tarea de recorrido está relacionada con el SCOT"
    },
    {
        id: 31,
        label: "No hay tareas de control relacionadas con un Control seleccionado para las pruebas",
        errorLabel: "Ninguna tarea de control está relacionada con un control seleccionado para las pruebas"
    },
    {
        id: 32,
        label: "Tutorial de TI/SO no relacionado",
        errorLabel: "recorrido de TI/SO no relacionado"
    },
    {
        id: 33,
        label: "IT/SO TNA no relacionados",
        errorLabel: "TOC DE TI/SO no relacionado"
    },
    {
        id: 34,
        label: "NO relacionados con IT/SO OSP",
        errorLabel: "OSP DE TI/SO no relacionado"
    },
    {
        id: 35,
        label: "El proceso IT/SO no tiene una tarea de tutorial relacionada",
        errorLabel: "El proceso IT/SO no tiene una tarea de tutorial relacionada"
    },
    {
        id: 36,
        label: "Un Control no tiene un TOC relacionado",
        errorLabel: "Un control no tiene una TDC relacionada"
    },
    {
        id: 37,
        label: "Un procedimiento sustantivo de TI no tiene un OSP relacionado",
        errorLabel: "Un procedimiento sustantivo de TI no tiene un OSP relacionado"
    },
    {
        id: 38,
        label: "Conflicto de documentos",
        errorLabel: "Conflictos no resueltos"
    },
    {
        id: 39,
        label: "Conflicto de sincronización - Evidencia compartida- No se muestra en el recuento de validación de Canvas",
        errorLabel: "Evidencia compartida - Conflicto de sincronización"
    },
    {
        id: 40,
        label: "Firma de pruebas que faltan",
        errorLabel: "Firma de todas las pruebas"
    },
    {
        id: 41,
        label: "Tareas sin evidencia",
        errorLabel: "Agregar evidencia a las tareas abiertas"
    },
    {
        id: 42,
        label: "Código de participación no válido",
        errorLabel: "Código de interacción no válido"
    },
    {
        id: 43,
        label: "Código de cliente no válido",
        errorLabel: "Código de cliente no válido"
    },
    {
        id: 44,
        label: "Nombres de archivo duplicados",
        errorLabel: "Nombres de archivo duplicados"
    },
    {
        id: 45,
        label: "Evaluación de TI inconsistente",
        errorLabel: "Evaluación incompleta del proceso de TI"
    },
    {
        id: 46,
        label: "Evaluación incompleta del proceso de TI",
        errorLabel: "Evaluación incompleta del proceso de TI"
    },
    {
        id: 47,
        label: "Evaluación agregada incompleta de TI",
        errorLabel: "Evaluación de TI agregada incompleta"
    },
    {
        id: 48,
        label: "Respuesta incompleta",
        errorLabel: "Justificación de apoyo incompleta"
    },
    {
        id: 49,
        label: "Errores no relacionados",
        errorLabel: "Declaraciones erróneas no relacionadas"
    },
    {
        id: 50,
        label: "Deficiencia no asociada",
        errorLabel: "Deficiencias no asociadas"
    },
    {
        id: 51,
        label: "WCGW sin tarea sustantiva relacionada",
        errorLabel: "WCGW sin ninguna tarea sustantiva relacionada"
    },
    {
        id: 52,
        label: "Riesgo sin WCGW relacionado",
        errorLabel: "Riesgo sin WCGW"
    },
    {
        id: 53,
        label: "Estimación de la cuenta sin índice de PSP estimado",
        errorLabel: "Cuenta estimada sin índice PSP estimado"
    },
    {
        id: 54,
        label: "Cuenta de estimación sin estimación SCOT",
        errorLabel: "Cuenta estimada sin estimación SCOT"
    },
    {
        id: 55,
        label: "Estimar SCOT sin estimación Cuenta",
        errorLabel: "Estimar SCOT sin estimación Cuenta"
    },
    {
        id: 56,
        label: "aseveración con riesgo de control de depender sin un TOC responsivo",
        errorLabel: "Aserción con riesgo de control de confianza sin un TOC receptivo"
    },
    {
        id: 57,
        label: "aseveración con riesgo de control de confianza, sin al menos un TOC receptivo asociado a un control efectivamente diseñado que no es un riesgo menor que responde al riesgo",
        errorLabel: "Aserción con riesgo de control de confianza sin al menos un TOC receptivo asociado a un control diseñado de manera efectiva que no sea de menor riesgo que responda al riesgo"
    },
    {
        id: 58,
        label: "aseveración sin una tarea sustantiva responsiva",
        errorLabel: "Afirmación sin una tarea sustantiva receptiva"
    },
    {
        id: 59,
        label: "aseveración sin un control responsivo",
        errorLabel: "Aserción sin un control responsivo"
    },
    {
        id: 60,
        label: "Comentario del formulario Canvas",
        errorLabel: "Comentario del formulario Canvas"
    },
    {
        id: 61,
        label: "Respuestas incompletas del formulario Canvas",
        errorLabel: "Respuestas incompletas del formulario Canvas"
    },
    {
        id: 62,
        label: "Notas de revisión abiertas o borradas que deben cerrarse o eliminarse",
        errorLabel: "Notas de revisión abiertas o borradas que deben cerrarse o eliminarse"
    },
    {
        id: 63,
        label: "Evidencia con control de cambios",
        errorLabel: "Evidencia con control de cambios"
    },
    {
        id: 64,
        label: "Tareas no marcadas como completadas",
        errorLabel: "Marcar tareas completadas"
    },
    {
        id: 65,
        label: "Evidencia compartida no desvinculada",
        errorLabel: "Evidencia compartida no vinculada"
    },
    {
        id: 66,
        label: "Documentos sin un tipo de modificación seleccionado",
        errorLabel: "Documentos sin un tipo de modificación seleccionado"
    },
    {
        id: 67,
        label: "Cambios no administrativos sin motivo de cambio (justificación)",
        errorLabel: "Cambios no administrativos sin motivo de cambio (justificación)"
    },
    {
        id: 68,
        label: "Modificaciones no aprobadas para cambios no administrativos por función apropiada",
        errorLabel: "Modificaciones no aprobadas para cambios no administrativos por rol apropiado"
    },
    {
        id: 69,
        label: "440 GL desaparecido revisor ejecutivo firman",
        errorLabel: "440 GL Falta la aprobación del revisor ejecutivo"
    },
    {
        id: 70,
        label: "Compromiso de grupo no desvinculado",
        errorLabel: "Desvincular este compromiso del grupo"
    },
    {
        id: 71,
        label: "Formulario de Canvas sin encabezados",
        altLabel: "Formulario de Canvas sin encabezados",
        errorLabel: "Formulario de Canvas sin encabezados"
    },
    {
        id: 72,
        label: "Falta contenido al documento de resumen de componentes de grupo",
        errorLabel: "Falta contenido al documento de resumen de componentes de grupo"
    },
    {
        id: 73,
        label: "Respuestas de formulario Canvas incompletas independientemente de la aprobación",
        errorLabel: "Formulario de lienzo incompleto"
    },
    {
        id: 74,
        label: "Cambio de perfil V2 no enviado",
        errorLabel: "Cambio de perfil no enviado"
    },
    {
        id: 75,
        label: "Archivos electrónicos de 0 bytes",
        errorLabel: "Archivos electrónicos de 0 bytes"
    },
    {
        id: 76,
        label: "Formulario de independencia editado después de la presentación",
        altLabel: "Formulario no presentado",
        errorLabel: "Formulario de independencia editado después de la presentación"
    },
    {
        id: 77,
        label: "Plantilla de independencia diferente de la individual",
        altLabel: "Plantilla de independencia diferente de la individual",
        errorLabel: "Plantilla de independencia diferente de la individual"
    },
    {
        id: 78,
        label: "Aplicación de TI (no SO) sin al menos un proceso de TI relacionado",
        errorLabel: "Aplicación de TI no relacionada"
    },
    {
        id: 79,
        label: "ITGC no tiene ITRisk relacionado o está relacionado con un ITRisk donde HasNoITGC = 1",
        errorLabel: "ITGC no relacionado"
    },
    {
        id: 80,
        label: "ITSP no tiene ITRisk relacionado",
        errorLabel: "ITSP no relacionado"
    },
    {
        id: 81,
        label: "ITProcess no tiene ninguna aplicación de TI relacionada",
        errorLabel: "Proceso de TI no relacionado"
    },
    {
        id: 82,
        label: "ITProcess sin ITRisk donde hay un ITAC o ITDM (sin excepción) relacionado a través de ITApplication",
        errorLabel: "Falta riesgo de TI"
    },
    {
        id: 83,
        label: "ITRisk (HasNoITGC = 0) no tiene ITGC relacionado",
        errorLabel: "Falta ITGC o marca que no existe ninguno"
    },
    {
        id: 84,
        label: "ITDM/ITAC sin aplicación de TI relacionada",
        errorLabel: "Control de aplicaciones/ITDM sin aplicación de TI"
    },
    {
        id: 85,
        label: "ITSP no se elimina cuando no se muestra el cuerpo correspondiente",
        errorLabel: "ITSP que debe eliminarse"
    },
    {
        id: 86,
        label: "ITGC no se elimina cuando no se muestra el cuerpo correspondiente",
        errorLabel: "ITGC que se eliminará"
    },
    {
        id: 87,
        label: "ITRisk no se elimina cuando no se muestra el cuerpo correspondiente",
        errorLabel: "Riesgo de eliminación de TI"
    },
    {
        id: 88,
        label: "ITGC con HasITControlTesting = 1 existe cuando no se muestra el cuerpo correspondiente",
        errorLabel: "ITGC con estrategia de prueba no válida"
    },
    {
        id: 89,
        label: "ITGC sin una efectividad de diseño seleccionada",
        errorLabel: "Falta la evaluación del diseño del ITGC"
    },
    {
        id: 90,
        label: "Control sin una efectividad de diseño seleccionada",
        errorLabel: "Control sin una efectividad de diseño seleccionada"
    },
    {
        id: 91,
        label: "SCOT sin aplicaciones de TI donde HasNoITApplication = 0",
        errorLabel: "SCOT no relacionado"
    },
    {
        id: 92,
        label: "Procedimientos sustantivos y pruebas de controles que responden a un riesgo significativo, pero no a la WCGW relacionada con el riesgo.",
        errorLabel: "Relación de RiskTaskRelation incoherente frente a Riesgo > relación de > tarea WCGW"
    },
    {
        id: 93,
        label: "Respuesta incoherente para los controles de prueba",
        errorLabel: "Respuesta incoherente para los controles de prueba"
    },
    {
        id: 94,
        label: "SCOT con HasNoITApplication = 0 tiene controles ITDM o App",
        errorLabel: "Falta la aplicación de TI en SCOT"
    },
    {
        id: 95,
        label: "No se ha asignado a ningún miembro del equipo la responsabilidad general",
        altLabel: "No se ha asignado a ningún miembro del equipo la responsabilidad general",
        errorLabel: "No se ha asignado a ningún miembro del equipo la responsabilidad general"
    },
    {
        id: 96,
        label: "Factores de riesgo no relacionados con un riesgo o no marcados como no ROMM",
        errorLabel: "Factores de riesgo no relacionados con un riesgo o no marcados como no ROMM"
    },
    {
        id: 97,
        label: "Risks unrelated to an Assertion",
        errorLabel: "Risks unrelated to an Assertion"
    },
    {
        id: 98,
        label: "Monto de pronóstico de base de medición incompleto",
        errorLabel: "Monto de pronóstico de base de medición incompleto"
    },
    {
        id: 99,
        label: "Justificación incompleta de la cantidad de pronóstico de la base de medición",
        errorLabel: "Justificación incompleta de la cantidad de pronóstico de la base de medición"
    },
    {
        id: 100,
        label: "Importe ajustado de la base de medición incompleta",
        errorLabel: "Importe ajustado de la base de medición incompleta"
    },
    {
        id: 101,
        label: "Materialidad de planificación incompleta",
        errorLabel: "Materialidad de planificación incompleta"
    },
    {
        id: 102,
        label: "Materialidad de planificación mayor que la cantidad máxima",
        errorLabel: "Materialidad de planificación mayor que la cantidad máxima"
    },
    {
        id: 103,
        label: "Justificación incompleta de la materialidad de la planificación",
        errorLabel: "Justificación incompleta de la materialidad de la planificación"
    },
    {
        id: 104,
        label: "Error tolerable incompleto",
        errorLabel: "Error tolerable incompleto"
    },
    {
        id: 105,
        label: "TE no está dentro del rango de valores permitidos",
        errorLabel: "TE no está dentro del rango de valores permitidos"
    },
    {
        id: 106,
        label: "Justificación de error tolerable incompleta",
        errorLabel: "Justificación de error tolerable incompleta"
    },
    {
        id: 107,
        label: "SAD incompleto",
        errorLabel: "SAD incompleto"
    },
    {
        id: 108,
        label: "TAE mayor que el máximo",
        errorLabel: "TAE mayor que el máximo"
    },
    {
        id: 109,
        label: "Justificación incompleta del SAD",
        errorLabel: "Justificación incompleta del SAD"
    },
    {
        id: 110,
        label: "Selección incompleta de PACE",
        errorLabel: "Selección incompleta de PACE"
    },
    {
        id: 111,
        label: "No hay documentos relacionados",
        errorLabel: "No hay documentos relacionados"
    },
    {
        id: 112,
        label: "Tarea PIC sin al menos una evidencia PIC relacionada",
        errorLabel: "Tarea PIC sin al menos una evidencia PIC relacionada"
    },
    {
        id: 113,
        label: "Tarea de EQR sin al menos una evidencia de EQR relacionada",
        errorLabel: "Tarea de EQR sin al menos una evidencia de EQR relacionada"
    },
    {
        id: 114,
        label: "Evidencia PIC sin al menos una tarea PIC relacionada",
        errorLabel: "Evidencia PIC sin al menos una tarea PIC relacionada"
    },
    {
        id: 115,
        label: "Evidencia de EQR sin al menos una tarea de EQR relacionada",
        errorLabel: "Evidencia de EQR sin al menos una tarea de EQR relacionada"
    },
    {
        id: 116,
        label: "Evidencia PIC sin al menos una firma de PIC",
        errorLabel: "Evidencia PIC sin al menos una firma de PIC"
    },
    {
        id: 117,
        label: "Evidencia de EQR sin al menos una firma de EQR",
        errorLabel: "Evidencia de EQR sin al menos una firma de EQR"
    },
    {
        id: 118,
        label: "La evidencia que no debe archivarse todavía está presente",
        errorLabel: "La evidencia que no debe archivarse todavía está presente"
    },
    {
        id: 119,
        label: "Archivos temporales con aprobaciones del preparador y del revisor",
        errorLabel: "Archivos temporales con aprobaciones del preparador y del revisor"
    },
    {
        id: 120,
        label: "Todos los comentarios del formulario Canvas abierto o borrado",
        errorLabel: "Todos los comentarios del formulario Canvas abierto o borrado"
    },
    {
        id: 121,
        label: "Archivos temporales que tienen un requisito PIC",
        errorLabel: "Archivos temporales que tienen un requisito PIC"
    },
    {
        id: 122,
        label: "Archivo temporal que tiene un requisito de EQR",
        errorLabel: "Archivo temporal que tiene un requisito de EQR"
    },
    {
        id: 123,
        label: "Archivos eliminados que tienen un requisito PIC",
        errorLabel: "Archivos eliminados que tienen un requisito PIC"
    },
    {
        id: 124,
        label: "Archivos eliminados que tienen un requisito de EQR",
        errorLabel: "Archivos eliminados que tienen un requisito de EQR"
    },
    {
        id: 125,
        label: "Revisar documentos protegidos",
        errorLabel: "Revisar documentos protegidos"
    },
    {
        id: 126,
        label: "Contenido del documento no disponible",
        errorLabel: "Contenido del documento no disponible"
    },
    {
        id: 127,
        label: "Cuerpo de estado de Resultados",
        errorLabel: "Cuerpo de estado de Resultados"
    },
    {
        id: 128,
        label: "Cuerpo de estado de siituación",
        errorLabel: "Cuerpo de estado de siituación"
    },
    {
        id: 129,
        label: "MultiEntidad: MultiEntidad no relacionada con todos los PSP/ACT para la(s) Cuenta(s) relacionada(s)",
        errorLabel: "MultiEntidad: MultiEntidad no relacionada con todos los PSP/ACT para la(s) Cuenta(s) relacionada(s)"
    },
    {
        id: 130,
        label: "Formulario de Cuenta sin Formulario de Evaluación de Riesgos Individuales",
        errorLabel: "Formulario de Cuenta sin Formulario de Evaluación de Riesgos Individuales"
    },
    {
        id: 131,
        label: "Estimación sin documentación estimada",
        errorLabel: "Estimación sin documentación estimada"
    },
    {
        id: 132,
        label: "Cuenta sin Formulario Analítico Individual",
        errorLabel: "Cuenta sin Formulario Analítico Individual"
    },
    {
        id: 133,
        label: "MultiEntidad sin Formulario de Perfil Individual",
        errorLabel: "MultiEntidad sin Formulario de Perfil Individual"
    },
    {
        id: 134,
        label: "Cuenta: AccountTypeID no coincide con la acción",
        errorLabel: "Cuenta: AccountTypeID no coincide con la acción"
    },
    {
        id: 135,
        label: "Cuenta: Tiene estimación que no coincide con la acción",
        errorLabel: "Cuenta: Tiene estimacion que no coincide con la acción"
    },
    {
        id: 136,
        label: "Cuenta: Account FormOption tiene riesgos relacionados que no están asociados a la cuenta",
        errorLabel: "Cuenta: Account FormOption tiene riesgos relacionados que no están asociados a la cuenta"
    },
    {
        id: 137,
        label: "Cuenta: aserción de riesgo inherente más alta sin riesgo IsHigherRisk relacionado",
        errorLabel: "Cuenta: aserción de riesgo inherente más alta sin riesgo IsHigherRisk relacionado"
    },
    {
        id: 138,
        label: "MultiEntidad - MultiEntidad sin ningún procedimiento sustantivo relacionado para la(s) Cuenta(s) relacionada(s)",
        errorLabel: "MultiEntidad - MultiEntidad sin ningún procedimiento sustantivo relacionado para la(s) Cuenta(s) relacionada(s)"
    },
    {
        id: 139,
        label: "Componente sin un formulario de participación grupal (excluyendo componentes de solo referencia)",
        errorLabel: "Componente sin un formulario de participación grupal (excluyendo componentes de solo referencia)"
    },
    {
        id: 140,
        label: "Componente (Completo/Específico) sin una Instrucción de Evaluación de Riesgos de Grupo relacionada (excluyendo los Componentes de Solo Referencia)",
        errorLabel: "Componente (Completo/Específico) sin una Instrucción de Evaluación de Riesgos de Grupo relacionada (excluyendo los Componentes de Solo Referencia)"
    },
    {
        id: 141,
        label: "MultiEntidad: cuenta sin ninguna MultiEntidad relacionada",
        errorLabel: "MultiEntidad: cuenta sin ninguna MultiEntidad relacionada"
    },
    {
        id: 142,
        label: "Document.SmartEvidenceSourceID asociado a un objeto no válido",
        errorLabel: "Document.SmartEvidenceSourceID asociado a un objeto no válido"
    },
    {
        id: 143,
        label: "Cuenta: aserción de riesgo inherente más alta sin riesgo IsHigherRisk relacionado",
        errorLabel: "Cuenta: aserción de riesgo inherente más alta sin riesgo IsHigherRisk relacionado"
    },
    {
        id: 144,
        label: "Grupo - Cuentas (ejecutadas en otros compromisos) sin un componente relacionado",
        errorLabel: "Grupo - Cuentas (ejecutadas en otros compromisos) sin un componente relacionado"
    },
    {
        id: 145,
        label: "Cuenta - Cuenta de estimación sin indice PSP",
        errorLabel: "Cuenta - Cuenta de estimación sin indice PSP"
    },
    {
        id: 146,
        label: "MultiEntidad - Cambio de perfil individual de MultiEntidad no enviado (documento individual)",
        errorLabel: "MultiEntidad - Cambio de perfil individual de MultiEntidad no enviado (documento individual)"
    },
    {
        id: 147,
        label: "MultiEntidad - Cambio de perfil individual de MultiEntidad no enviado (documento individual)",
        errorLabel: "MultiEntidad - Cambio de perfil individual de MultiEntidad no enviado (documento individual)"
    },
    {
        id: 148,
        label: "Cuenta: Propiedades de cuenta incompletas o no válidas",
        errorLabel: "Cuenta: Propiedades de cuenta incompletas o no válidas"
    },
    {
        id: 149,
        label: "Carga de documentos: faltan las firmas requeridas de PIC/EQR",
        errorLabel: "Carga de documentos: faltan las firmas requeridas de PIC/EQR"
    },
    {
        id: 150,
        label: "Carga de documentos: faltan los requisitos de firma de PIC/EQR requeridos",
        errorLabel: "Carga de documentos: faltan los requisitos de firma de PIC/EQR requeridos"
    },
    {
        id: 151,
        label: "Cuenta - Cuenta Significativa / Divulgación sin ninguna aseveración relacionada",
        errorLabel: "Cuenta - Cuenta Significativa / Divulgación sin ninguna aseveración relacionada."
    },
    {
        id: 152,
        label: "Carga de documentos: faltan firmas del preparador o del revisor",
        errorLabel: "Carga de documentos: faltan firmas del preparador o del revisor"
    },
    {
        id: 153,
        label: "Ajuste sin ninguna evidencia",
        errorLabel: "Ajuste sin ninguna evidencia"
    },
    {
        id: 154,
        label: "Estimación sin cuenta relacionada",
        errorLabel: "Estimación sin cuenta relacionada"
    },
    {
        id: 155,
        label: "Estimación de riesgo mayor/menor relacionada con la cuenta no estimada",
        errorLabel: "Estimación de riesgo mayor/menor relacionada con la cuenta no estimada"
    },
    {
        id: 156,
        label: "La respuesta de la categoría de estimación no está alineada con la designación en 'Editar estimación'",
        errorLabel: "La respuesta de la categoría de estimación no está alineada con la designación en 'Editar estimación'"
    },
    {
        id: 157,
        label: "Estimado sin SCOT válido",
        errorLabel: "Estimado sin SCOT válido"
    },
    {
        id: 158,
        label: "Account without valid estimate",
        errorLabel: "Account without valid estimate"
    },
    {
        id: 159,
        label: "Cuenta de estimación sin estimación de mayor o menor riesgo",
        errorLabel: "Cuenta de estimación sin estimación de mayor o menor riesgo"
    },
    {
        id: 160,
        label: "Estimación de SCOT sin estimación de mayor o menor riesgo",
        errorLabel: "Estimación de SCOT sin estimación de mayor o menor riesgo"
    },
    {
        id: 161,
        label: "Ajustes que no se promedian",
        errorLabel: "Ajustes que no se promedian"
    },
    {
        id: 162,
        label: "Estimación de riesgo más alta sin riesgo válido relacionado",
        errorLabel: "Estimación de riesgo más alta sin riesgo válido relacionado"
    },
    {
        id: 163,
        label: "Documento: Documento desprotegido o en proceso de desprotección para la Colaboración",
        errorLabel: "Documento: Documento desprotegido o en proceso de desprotección para la Colaboración"
    },
    {
        id: 164,
        label: "Falta de evidencia en tareas de gran alcance",
        errorLabel: "Falta de evidencia en tareas de gran alcance"
    },
    {
        id: 165,
        label: "El requisito de aprobación de EP o EQR no coincide con la respuesta",
        errorLabel: "El requisito de aprobación de EP o EQR no coincide con la respuesta"
    },
    {
        id: 166,
        label: "Riesgo significativo/de fraude relacionado con una estimación que no es un riesgo alto",
        errorLabel: "Riesgo significativo/de fraude relacionado con una estimación que no es un riesgo alto"
    }
];

export const contentType = {
    1: "Tareas estándar primarias (PST)",
    2: "Índice de procedimientos sustantivos primarios (índice PSP)",
    3: "Procedimientos sustantivos primarios",
    4: "Instrucciones de auditoría de grupo",
    5: "Formularios de Canvas requeridos por metodología",
    6: "Formularios canvas creados por los usuarios (ejemplo: formulario SCOT)",
    7: "Independencia",
    9: "Perfil",
    10: "Mapas de Canvas"
};

export const contentTypeByName = {
    'PST': "Tareas estándar primarias (PST)",
    'PSPIndex': "Indice de procedimientos sustantivos primarios (índice PSP)",
    'PSP': "Procedimientos sustantivos primarios (PCP)",
    'GAInstructions': "Instrucciones de auditoría de grupo",
    'CanvasFormKnowledge': "Formas de canvas del conocimiento",
    'CanvasFormUserAdded': "Formularios de Canvas creados por usuarios (ejemplo: formulario SCOT)",
    'IndependenceForm': "Independencia",
    'Profile': "Perfil",
    'Maps': "Mapas de Canvas"
};

export const reportTypes = {
    1: "No modificada - con párrafo de énfasis",
    2: "No modificada - sin párrafo de énfasis",
    3: "Modificada - con párrafo de énfasis",
    4: "Modificada - sin párrafo de énfasis",
    5: "Opinión adversa - con párrafo de énfasis",
    6: "Opinión adversa - sin párrafo de énfasis",
    7: "Abstención de opinión - con párrafo de énfasis",
    8: "Abstención de opinión - sin párrafo de énfasis",
    100: "No",
    101: "N/A",
    102: "Aún no seleccionado"
};

export const internalUserRoles = [{
        roleKey: 3,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Archivar compromiso",
        displayName: "Archivar compromiso",
        roleDisplayOrder: 2,
        tooltipText: "Capacidad para archivar el compromiso"
    },
    {
        roleKey: 4,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Administrar el compromiso",
        displayName: "Administrar compromiso",
        roleDisplayOrder: 1,
        tooltipText: "Capacidad para invitar a miembros internos y externos y asignar permisos a miembros internos"
    },
    {
        roleKey: 5,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Actualizar contenido",
        displayName: "Actualizar contenido",
        roleDisplayOrder: 6,
        tooltipText: "Posibilidad de editar el perfil y aceptar una actualización de contenido"
    },
    {
        roleKey: 7,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Crear solicitud de servicio",
        displayName: "Administrar solicitudes de servicio",
        roleDisplayOrder: 4,
        tooltipText: "Capacidad para crear solicitudes de servicio y marcar las solicitudes de servicio completadas"
    },
    {
        roleKey: 8,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Administrar grupo",
        displayName: "Administrar grupo",
        roleDisplayOrder: 5,
        tooltipText: "Aceptar o rechazar las instrucciones de los grupos recibidas del equipo de Primaria o Regional"
    },
    {
        roleKey: 9,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Copiar, Avanzar, Restaurar compromiso",
        displayName: "Copiar, avanzar, restaurar compromiso",
        roleDisplayOrder: 3,
        tooltipText: "Posibilidad de copiar la interacción, así como de poner al día y restaurar su archivo",
    },
    {
        roleKey: 0,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidad",
        roleNameUI: "Por defecto",
        displayName: "Ninguno (valor predeterminado)",
        roleDisplayOrder: 1,
        tooltipText: "Rol de documentos confidenciales predeterminados"
    },
    {
        roleKey: 10,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidad",
        roleNameUI: "Bajo",
        displayName: "Bajo",
        roleDisplayOrder: 8,
        tooltipText: "Rol de documentos de confidencialidad baja"
    },
    {
        roleKey: 11,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidad",
        roleNameUI: "Alto",
        displayName: "Alto",
        roleDisplayOrder: 10,
        tooltipText: "Rol de documentos de alta confidencialidad"
    },
    {
        roleKey: 12,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidad",
        roleNameUI: "Moderado",
        displayName: "Moderado",
        roleDisplayOrder: 9,
        tooltipText: "Rol de documentos de confidencialidad moderada"
    },
    // {
    // roleKey: 13,
    // sectionId:1,
    // groupDisplayOrder: 200,
    // groupName: "confidencialidad",
    // roleNameUI: "Confidencial",
    // displayName: "Confidencial",
    // roleDisplayOrder: 11,
    // tooltipText: "Rol de documentos estrictamente confidenciales"
    // },
    {
        roleKey: 14,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restricciones",
        roleNameUI: "Solo lectura",
        displayName: "Solo lectura",
        roleDisplayOrder: 12,
        tooltipText: "Esta funcionalidad solo se debe usar para conceder a los revisores de terceros esta interacción con EY Canvas. Las aprobaciones y autorizaciones apropiadas deben adquirirse de la Práctica Profesional."
    },
    {
        roleKey: 16,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restricciones",
        roleNameUI: "Solo revisión",
        displayName: "Solo revisión",
        roleDisplayOrder: 13,
        tooltipText: "La revisión solo le da a este usuario la capacidad de ver información en el compromiso de EY Canvas, cerrar sesión y usar la funcionalidad de nota de revisión. Esto debe usarse cuando otros usuarios de EY necesitan revisar este compromiso pero no pueden realizar ediciones."
    },
  {
        roleKey: 37,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restricciones",
        roleNameUI: "Solo independencia",
        displayName: "Solo independencia",
        roleDisplayOrder: 14,
        tooltipText: "La independencia solo le da a este usuario la capacidad de completar su formulario de independencia para el compromiso, pero no permitirá que el usuario acceda completamente al compromiso EY Canvas. Esto debe usarse cuando un usuario ha realizado trabajo para el compromiso, pero no necesita tener acceso a EY Canvas.",
    },
    {
        roleKey: 6,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Deshacer edición",
        displayName: "Retirar/ eliminar documentos en forma masiva",
        roleDisplayOrder: 7,
        tooltipText: "Posibilidad de revertir documentos si se realizaron cambios accidentalmente después de la fecha de publicación del informe y eliminarlos del formulario 440 EY Canvas"
    },
    {
        roleKey: 35,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Gestionar el uso compartido de la habilitación de EY Canvas FIT",
        displayName: "Administrar flujos de trabajo guiados",
        roleDisplayOrder: 14,
        tooltipText: "Posibilidad de compartir flujos de trabajo guiados entre compromisos de EY Canvas"
    },
    {
        roleKey: 36,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permisos",
        roleNameUI: "Importar datos de EY Helix",
        displayName: "Importar datos de EY Helix",
        roleDisplayOrder: 15,
        tooltipText: "Posibilidad de importar datos desde EY Helix"
    }
];

export const ValidationSubGroups = [{
        id: 9008,
        label: "Cumplimiento de la independencia"
    },
    {
        id: 9001,
        label: "Resumen de la cuenta"
    },
    {
        id: 9002,
        label: "Resumen de SCOT"
    },
    {
        id: 9004,
        label: "Resumen de TI"
    },
    {
        id: 9003,
        label: "Resumen de la CRA"
    },
    {
        id: 9005,
        label: "Plan de auditoría"
    },
    {
        id: 9011,
        label: "Matriz de evaluación sustantiva"
    },
    {
        id: 9012,
        label: "Formulario Validaciones por Canvas"
    },
    {
        id: 9009,
        label: "Evaluación de TI"
    },
    {
        id: 49,
        label: "Declaraciones erróneas no relacionadas"
    },
    {
        id: 50,
        label: "Deficiencias no relacionadas"
    },
    {
        id: 44,
        label: "Nombres de archivo duplicados"
    },
    {
        id: 38,
        label: "Conflictos no resueltos"
    },
    {
        id: 9013,
        label: "Modificaciones después de la fecha de emision del informe"
    },
    {
        id: 9014,
        label: "Flujo de TI"
    },
    {
        id: 9015,
        label: "Habilitación de EY Canvas FIT"
    },
    {
        id: 71,
        label: "Formularios sin contenido"
    },
    {
        id: 9016,
        label: 'Incomplete canvas form response'
    },
    {
        id: 9017,
        label: 'Adjustment module'
    },
];

export const engagementIndustry = {
    116: "No Específico del Sector",
    61: "Aeroespacial y Defensa – Fabricación Aeroespacial",
    112: "Aeroespacial y Defensa – Fabricación de Contratos de Defensa",
    59: "Aerolíneas – Transporte Aéreo",
    92: "Gestión de Activos – Fondos de Productos Básicos",
    57: "Gestión de Activos – Otros Fondos",
    43: "Gestión de Activos – Capital Privado / Capital Riesgo",
    85: "Gestión de Activos – Fondos Registrados / Listados",
    53: "Gestión de Activos – Productos Estructurados",
    60: "Gestión de Activos – Fondos de Cobertura No Regulados",
    10: "Gestión de Activos – Cuentas Segregadas No Reguladas",
    90: "Auditoría de Sistemas de Gestión de Cumplimiento",
    51: "Automotriz – Distribuidores y Reparaciones Automotrices",
    101: "Automoción – Fabricación Automotriz",
    5: "Automotriz – Proveedores Automotrices",
    71: "Banca y Mercados de Capitales – Bancos",
    89: "Banca y Mercados de Capitales – Distribuidores de Broker",
    27: "Banca y Mercados de Capitales – Uniones de Crédito",
    54: "Banca y Mercados de Capitales – Instituciones Financieras Diversificadas y Otras Instituciones Financieras",
    32: "Banca y Mercados de Capitales – Banca de Inversión",
    4: "Biotecnología – Biotecnología – Mercados emergentes de crecimiento",
    109: "Biotecnología – Investigación y Pruebas sanitarias",
    66: "Productos químicos – Fabricación de productos químicos",
    41: "Cleantech",
    37: "Consolidaciones",
    130: "Construcción – Ingeniería y Servicios Arquitectónicos",
    68: "Construcción – Carretera y Construcción Pesada",
    65: "Construcción – Contratistas Especializados",
    82: "Productos de consumo – Fabricación de bienes no duraderos de consumo",
    17: "Productos de Consumo – Fabricación de Alimentos y Bebidas",
    35: "Productos de Consumo – Cultivos Alimentarios, Ganadería, Pesca",
    33: "Productos de Consumo – Electrodomésticos y Fabricación Electrónica",
    75: "Productos de consumo – Otros bienes duraderos de consumo fabricación",
    39: "Productos de Consumo – Textiles y Fabricación de Ropa",
    21: "Productos Industriales Diversificados – Metales Fabricados",
    31: "Productos industriales diversificados: silvicultura, pulpa y papel",
    29: "Productos Industriales Diversificados – Fabricación de Instrumentos Industriales",
    40: "Productos Industriales Diversificados – Fabricación de Máquinas Industriales",
    26: "Productos Industriales Diversificados – Embalaje Industrial",
    42: "Productos Industriales Diversificados – Fabricación de Madera y plastico",
    105: "Productos industriales diversificados – Otros productos industriales",
    100: "Productos Industriales Diversificados – Metales Primarios",
    45: "Productos Industriales Diversificados – Impresión",
    1: "Productos Industriales Diversificados – Fabricación de Caucho y Plásticos",
    118: "Productos industriales diversificados: fabricación de piedra, arcilla y vidrio",
    76: "General",
    79: "Gobierno y Sector Público – Educación",
    78: "Gobierno y Sector Público – Gobiernos Federales, Nacionales e Internacionales",
    131: "Gobierno y Sector Público – Comisionado de Salud",
    132: "Gobierno y Sector Público – Proveedor de Salud",
    97: "Gobierno y Sector Público – Gobierno local, incluyendo los niveles estatales u otros niveles por debajo de nacionales",
    2: "Salud – Centros Médicos Académicos",
    72: "Salud – Hospitales gubernamentales",
    74: "Salud – Atención médica administrada",
    8: "Salud – Sistemas Multi Hospitalarios",
    128: "Salud – Hospitales fuera del sistema",
    94: "Salud – Otras Entidades de Atención Médica",
    73: "Salud – Grupos de Médicos",
    121: "Salud – Cuidado Post Agudo",
    58: "Salud – Hospitales Especializados",
    16: "Hospitalidad y Ocio – Juegos y Juegos de Azar",
    7: "Hospitalidad y Ocio – Hoteles, Moteles y Alojamiento",
    126: "Hospitalidad – Restaurantes / Establecimientos de comer y beber",
    84: "Niif",
    55: "Seguro – Seguro de Salud",
    111: "Seguros – Agentes de Seguros y Corredores",
    69: "Seguros – Aseguradoras de Vida",
    96: "Seguro – Otros Seguros",
    11: "Seguros – Aseguradoras de Bienes y Accidentes",
    117: "Seguro – Reaseguradores",
    23: "Ciencias de la Vida – Tecnología Médica",
    48: "Medios de comunicación y entretenimiento – Publicidad",
    14: "Medios de comunicación y entretenimiento – Difusión, Red de Cable, Video En línea",
    18: "Medios de comunicación y entretenimiento – Proveedor de cable, satélite, MVPD",
    86: "Medios de comunicación y entretenimiento – Película",
    46: "Medios de comunicación y entretenimiento : Medios y entretenimiento integrados",
    15: "Medios de comunicación y entretenimiento – Industria musical",
    25: "Medios de comunicación y entretenimiento – Otros medios y entretenimiento",
    20: "Medios de comunicación y entretenimiento – Publicidad",
    30: "Medios de comunicación y entretenimiento – Deportes",
    28: "Minería – Operaciones Mineras",
    3: "Pymes no complejas",
    120: "No con fines de lucro – Fundaciones y fideicomisos de caridad",
    107: "No para obtener beneficios – Otras organizaciones sin fines de lucro",
    70: "Petróleo y Gas – Comercio de Energía",
    22: "Petróleo y Gas – Exploración y Producción",
    67: "Petróleo y Gas – Refinación",
    113: "Otros Transportes – Transporte Local y Urbano",
    38: "Otros Transporte – Otros Transporte",
    83: "Otros Transporte – Transporte Ferroviario",
    88: "Otros Transporte – Transporte por Carretera y Almacenamiento",
    6: "Otros Transporte – Transporte acuático",
    87: "Fondos de Pensiones / Planes de Beneficios",
    95: "Farmacéutico – Fabricación de Dispositivos Médicos",
    123: "Farmacéutico – Fabricación de productos farmacéuticos y al por mayor",
    115: "Energía y Servicios Públicos – Electricidad",
    119: "Energía y Utilidades – Gas Natural",
    110: "Energía y Utilidades – Otras Utilidades",
    102: "Energía y servicios públicos – Residuos y agua",
    125: "Firmas y Servicios Profesionales – Servicios Empresariales",
    34: "Empresas y Servicios Profesionales – Otros Servicios",
    47: "Empresas y Servicios Profesionales – Servicios Personales",
    124: "Firmas y Servicios Profesionales – Firmas de Servicio Profesional",
    127: "Firmas y Servicios Profesionales – Servicios de Alquiler y Arrendamiento",
    108: "Firmas y Servicios Profesionales – Servicios de Viaje",
    49: "Bienes Raíces – Propietarios/Desarrolladores de Bienes Raíces Comerciales",
    56: "Bienes Raíces – Otros Propietarios / Desarrolladores de Bienes Raíces",
    62: "Bienes Raíces – Fideicomisos de Inversión Inmobiliaria",
    122: "Bienes Raíces – Inversores Inmobiliarios",
    12: "Bienes Raíces – Empresas de Servicios Inmobiliarios",
    91: "Bienes Raíces – Propietarios/ Desarrolladores de Bienes Raíces Residenciales",
    24: "Venta al por menor y al por mayor – Grandes Almacenes",
    93: "Venta al por menor y al por mayor – Internet Retail y pedido por correo",
    80: "Venta al por menor y al por mayor – Comerciantes masivos / Tiendas de descuento",
    9: "Venta al por menor y al por mayor – Otros minoristas especializados",
    77: "Venta al por menor y al por mayor – Tiendas de ropa y accesorios al por menor",
    114: "Venta al por menor y al por mayor: supermercados, supermercados y tiendas de conveniencia",
    36: "Venta al por menor y al por mayor – Productos duraderos al por mayor",
    64: "Venta al por menor y al por mayor – Venta al por mayor de bienes no duraderos",
    104: "Sostenibilidad",
    63: "Tecnología – Equipos de Comunicación y Redes",
    52: "Tecnología – Computadoras y Electrónica",
    138: "Tecnología – Internet y Comercio Social",
    103: "Tecnología – Servicios de TI",
    19: "Tecnología – Otra tecnología",
    98: "Tecnología – Semiconductores",
    13: "Tecnología – Software / SaaS / Apps",
    81: "Telecomunicaciones – Servicios de Comunicaciones por Cable",
    106: "Telecomunicaciones – Proveedores Integrados de Comunicaciones",
    129: "Telecomunicaciones – Proveedores de servicios de Internet",
    99: "Telecomunicaciones – Servicios de Comunicaciones Inalámbricas Móviles",
    50: "Telecomunicaciones – Otras Comunicaciones",
    44: "Telecomunicaciones – Servicios de Comunicaciones por Satélite"
};

export const rnhQuickFilterLabel = [{
        id: rnhQuickFilter.all,
        label: "Mostrar todo"
    },
    {
        id: rnhQuickFilter.assigned,
        filterType: rnhFilterTypeQuery.assignedTo,
        label: "Asignado a mí"
    },
    {
        id: rnhQuickFilter.authored,
        filterType: rnhFilterTypeQuery.authoredBy,
        label: "Autorizadas por mi"
    }
];

export const relatedItemStatus = [{
        id: 1,
        label: "Borrador"
    },
    {
        id: 2,
        label: "Sin contacto con el cliente"
    },
    {
        id: 3,
        label: "Enviado"
    },
    {
        id: 4,
        label: "Error del sistema"
    },
    {
        id: 5,
        label: "Contacto de cliente no válido"
    },
    {
        id: 6,
        label: "Respuesta pendiente"
    },
    {
        id: 7,
        label: "Recibido"
    },
    {
        id: 8,
        label: "Aceptado"
    },
    {
        id: 9,
        label: "Devuelto"
    },
    {
        id: 10,
        label: "Retirado"
    },
    {
        id: 11,
        label: "Enviar en progreso"
    },
    {
        id: 12,
        label: "Aceptar en curso"
    },
    {
        id: 13,
        label: "Retirar en curso"
    },
    {
        id: 14,
        label: "Eliminar en curso"
    },
    {
        id: 15,
        label: "Retorno en curso"
    },
    {
        id: 16,
        label: "Respuesta en curso"
    },
    {
        id: 17,
        label: "Eliminado"
    },
    {
        id: 18,
        label: "Contacto de cliente no válido devuelto"
    },
    {
        id: 19,
        label: "Recuperación en curso"
    },
    {
        id: 20,
        label: "Recuperado"
    },
    {
        id: 21,
        label: "Finalización en curso"
    },
    {
        id: 22,
        label: "Recuperación en curso"
    }
];

export const GroupDocuments = [{
        id: 33,
        label: "Group instructions sent by the primary team"
    },
    {
        id: 37,
        label: "Documentos devueltos por el equipo principal"
    }
];

export const engagementUserStatus = {
    1: "activo",
    2: "pendiente",
    3: "rechazado",
    4: "Desactivado",
    5: "Solicitud de acceso al archivo",
    6: "Rechazar el acceso al archivo",
    7: "Copiar compromiso - Inactivo",
    8: "Inactivos desvinculados",
    9: "Plantilla - Inactivo",
    10: "Roll Forward - Inactivo",
    11: "Localizado en Universo aislado",
    12: "Invitación en curso",
    13: "Programado - Inactivo"
};
export const CGTTaskSendStatus = [{
        id: 1,
        label: "No enviado"
    },
    {
        id: 2,
        label: "Documento en tránsito"
    },
    {
        id: 3,
        label: "Versión borrador enviada"
    },
    {
        id: 4,
        label: "Volvió"
    },
    {
        id: 5,
        label: "En revisión"
    },
    {
        id: 6,
        label: "íntegro"
    },
    {
        id: 7,
        label: "Rechazado"
    },
    {
        id: 8,
        label: "Rechazo en tránsito"
    },
    {
        id: 9,
        label: "Versión final enviada"
    },
    {
        id: 999,
        label: "Error al enviar"
    }
];

export const ServiceRequestStatus = [{
        id: 11,
        cssClass: 'accepted-text',
        statusLabel: "Aceptado"
    },
    {
        id: 12,
        cssClass: 'pending-text',
        statusLabel: "Enviado"
    },
    {
        id: 13,
        cssClass: 'rejected-text',
        statusLabel: "Cancelado"
    },
    {
        id: 14,
        statusLabel: "Borrador"
    },
    {
        id: 15,
        cssClass: 'completed-text',
        statusLabel: "Completado"
    },
    {
        id: 16,
        statusLabel: "Período anterior completado"
    },
    {
        id: 17,
        statusLabel: "Error de envío"
    },
    {
        id: 22,
        statusLabel: "N/A"
    },
    {
        id: 24,
        statusLabel: "Acción requerida"
    }
];

export const assignmentsSectionLabels = [{
        id: bulkAssignment.assign,
        label: "Asignaciones"
    },
    {
        id: bulkAssignment.timephase,
        label: "Fases de tiempo"
    },
    {
        id: bulkAssignment.tag,
        label: "Etiquetas"
    }
];

export const assignmentsSectionLabelsNew = [{
        id: bulkAssignment.assign,
        label: "Asignaciones"
    },
    {
        id: bulkAssignment.timephase,
        label: "Fases de tiempo"
    }
];

export const assignmentTypeLabels = [{
        id: assignmentTypes.preparer,
        label: "Preparador"
    },
    {
        id: assignmentTypes.detailReviewer,
        label: "Revisor de detalles"
    },
    {
        id: assignmentTypes.generalReviewer,
        label: "Revisor general"
    },
    {
        id: assignmentTypes.partner,
        label: "Socio"
    },
    {
        id: assignmentTypes.eqr,
        label: "EQR"
    },
    {
        id: assignmentTypes.other,
        label: "Otro"
    }
];

export const assignmentActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "Agregar"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "Eliminar"
    },
    {
        id: bulkAssignmentConstants.actionIds.replace,
        label: "Reemplazar"
    },
    {
        id: bulkAssignmentConstants.actionIds.updateDueDays,
        label: "Días de actualización pendientes"
    }
];

export const tagActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "Agregar"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "Eliminar"
    }
];

export const manageAssigmentsActionTypeLabel = [{
        id: actionTypes.edit,
        label: "Editar"
    },
    {
        id: actionTypes.delete,
        label: "Eliminar"
    }
];

export const confidentialityLevels = {
    [confidentialityTypes.DEFAULT]: "Predeterminado",
    [confidentialityTypes.LOW]: "Bajo",
    [confidentialityTypes.MODERATE]: "Moderado",
    [confidentialityTypes.HIGH]: "Alto"
};

export const milestoneTaskLabels = [{
        id: milestoneBuildTaskIds.accounts,
        label: "Tareas de flujo de cuentas"
    },
    {
        id: milestoneBuildTaskIds.scots,
        label: "Tareas de flujo de SCOT"
    },
    {
        id: milestoneBuildTaskIds.itso,
        label: "Tareas de flujo de TI/SO"
    },
    {
        id: milestoneBuildTaskIds.cra,
        label: "Tareas de flujo CRA"
    },
    {
        id: milestoneBuildTaskIds.auditPlan,
        label: "Tareas de flujo del plan de auditoría"
    },
    {
        id: milestoneBuildTaskIds.groupStructure,
        label: "Tareas de flujo de estructura de grupo"
    },
    {
        id: milestoneBuildTaskIds.groupInstructions,
        label: "Tareas de flujo de instrucciones de grupo"
    },
    {
        id: milestoneBuildTaskIds.review,
        label: "Revisar las tareas de flujo"
    }
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
    scope: "Alcance",
    teamName: "Nombre del equipo",
    groupStructure: "Estructura del grupo",
    region: "Región",
    component: "Componente"
};

export const filterSourceOfForm = [{
        value: '1',
        label: "Personalizado"
    },
    {
        value: '2',
        label: "Conocimiento"
    },
    {
        value: '3',
        label: "Independencia"
    }
];

export const independenceActions = [{
        id: independenceActionIds.createIndependenceForm,
        label: "Crear formulario de independencia"
    },
    {
        id: independenceActionIds.removeTeamMember,
        label: "Eliminar miembro del equipo"
    },
    {
        id: independenceActionIds.removeOverride,
        label: "Eliminar anulación"
    }
];


export const reviewNoteModalLabels = {
    /*Review Notes*/
    commentThread: "Hilo de notas",
    singleNoteInstructionalText: "Vea y responda al comentario seleccionado a continuación.",
    emptyNoteDetailsMessage: "Seleccione una nota para ver los detalles. Para habilitar controles masivos, utilice la tecla de control o mayús y seleccione varios comentarios de revisión. Si desea trabajar en un comentario individual, seleccione ese comentario de la lista.",
    documentReviewNotesLabel: "Notas del documento",
    addNewReviewNoteButtonText: "Nueva nota",
    noNotesAssociatedWithDocumentLabel: "Deje una nota usando las entradas a continuación. Asigne la nota a un usuario y especifique la prioridad y la fecha de vencimiento.",
    noNotesFound: "No se encontraron notas",
    noNotesAssociatedWithTaskLabel: "No hay notas {0} asociadas a la tarea.",
    allNotesLabel: "Todas las notas",
    charactersLabel: "caracteres",
    myNotesLabel: "Mis notas",
    showClearedLabel: "Mostrar completados",
    showClosedLabel: "Mostrar cerrados",
    assignedToLabel: "Asignado a",

    ofLabel: "de",
    enterNoteText: "Introducir nota",
    addNewNoteModalClose: "cerrar",
    addNewNoteModalTitleLabel: "Añadir nueva nota",
    editNoteModalTitleLabel: "Editar nota",
    deleteIconHoverText: "Borrar",
    deleteIconModalAcceptText: "Borrar",
    deleteIconModalConfirmMessage: "¿Está seguro de que desea eliminar su respuesta a este comentario?",
    deleteIconModalConfirmMessageParent: "¿Está seguro de que desea eliminar el comentario seleccionado?",
    deleteIconModalTitleLabel: "Eliminar nota",
    deleteReplyIconModalTitle: "Eliminar respuesta",
    emptyRepliesMessage: "Aún no hay respuestas.",
    replyInputPlaceholder: "Responder a esta nota",
    replyInputPlaceholderEdit: "Editar la respuesta a la nota de revisión",
    noteInputPlaceholderEdit: "Editar nota de revisión",
    replyText: "Texto de respuesta",
    editReplyModelTitle: "Edición de respuestas",
    editReplyPlaceholder: "Introducir respuesta",
    noteDueDateLabel: "Vencimiento",

    priorityLabel: "prioridad",
    dueDateLabel: "fecha de vencimiento",
    dueLabel: "Vencimiento",
    status: "Estado",
    noteModifiedDateLabel: "Modificado",
    cancelLabel: "Cancelar",
    saveLabel: "Salvar",
    clearedBy: "Completado por",
    closedBy: "Cerrado por",
    reopenedBy: "Reabierto por",
    reply: "respuesta",
    editIconHoverTextLabel: "Editar",
    required: "requerido",
    closeTitle: "cerrar",
    otherEngagementNotes: "Otras notas del compromiso",
    closeLabel: "cerrar",
    showMore: "Mostrar más",
    showLess: "Mostrar menos",
    showMoreEllipsis: "Mostrar más...",
    showLessEllipsis: "Mostrar menos...",
    noResultFound: "No se han encontrado resultados",
    engagementNameLabel: "Nombre del Compromiso:",
    taskReviewNotesLabel: "Notas de tareas",
    fromUserLabel: labels.fromUserLabel,
    toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
    packageType: "Tipo de paquete",
    categories: "Categorías",
    itemsToCopy: "Artículos para copiar",
    createPackage: "Crear paquete",
    selectPackageType: "Seleccionar tipo de paquete",
    selectPackageTypeTitle: "Seleccionar tipo de paquete",
    selectCategoriesTitle: "Seleccionar categorías",
    selectEntitiesTitle: "Seleccionar entidades",
    relateCanvasFormsTitle: "Relacionar documentos",
    relateAnObjectTitle: "Relacionar un objeto",
    step1InstructionalText: "Seleccione el tipo de paquete, asígnele el nombre y seleccione el destinatario. Garantice el cumplimiento de todas las leyes, regulaciones y políticas aplicables de EY con respecto a la privacidad de los datos, la transferencia de datos entre jurisdicciones y la protección de información confidencial antes de crear o enviar un paquete de copia.",
    packageTypes: [{
        value: 21,
        text: "Compromiso"
    }, {
        value: 20,
        text: "Evidencia"
    }, {
        value: 24,
        text: "Actualización desde lo existente"
    }, {
        value: 22,
        text: "Cuentas"
    }, {
        value: 23,
        text: "SCOTs"
    }, {
        value: 26,
        text: "Exportación a granel"
    }, {
        value: 25,
        text: "Plantilla"
    }, {
        value: 27,
        text: "Documentos externos"
    }, {
        value: 28,
        text: "Flujos de trabajo guiados"
    }, {
        value: 29,
        text: "Compromiso por Entidad"
    }],

    packageName: "Nombre del paquete",
    packageDetailsText: "Detalles del paquete",
    required: "Requerido",
    sendTo: "enviar a",
    nameOrEmail: "Nombre o correo electrónico",
    sendToName: "nombre",
    sendToEmail: "Correo electrónico",
    clearAllValues: "Borrar todos los valores",
    engagementIdErrorMessage: "No se especifica el id del Compromiso.",
    emptyCategoriesStep2Text: '...',
    insufficientPermissionsMessage: "Permisos insuficientes para crear copia del paquete. Póngase en contacto con el administrador del compromiso y solicite permiso para crear una copia del paquete.",
    CopyHubCanvasFormTooltip: "Solo para formularios de EY Canvas",
    CopyEngagementInProgress: "Solo se puede procesar una copia de Engagement a la vez.",

    //Step 3 labels
    step3Header: "Seleccionar {0} para copiar",
    selectAllText: "Seleccionar todo",
    delectAllText: "Anular la selección de todo",
    documentsSelectedText: "documentos seleccionados",
    scotsSelectedText: "SCOTs seleccionados",
    accountsSelectedText: "Cuentas seleccionadas",
    entitiesSelectedText: "Entidades seleccionadas",
    step3InstructionText: "Garantizar el cumplimiento de todas las leyes, regulaciones y políticas de EY aplicables con respecto a la privacidad de los datos, la transferencia de datos entre jurisdicciones y la protección de la información confidencial antes de crear o enviar un Paquete de datos.",
    step3InstructionTextEvidence: "Garantizar el cumplimiento de todas las leyes, regulaciones y políticas de EY aplicables con respecto a la privacidad de datos, la transferencia de datos entre jurisdicciones y la protección de la información confidencial antes de enviar datos de compromiso.",
    step3InstructionTextWarning: "EY Canvas Forms no incluirá objetos relacionados (por ejemplo, SCOTs, Controles).",
    step3InstructionTextWarningFIT: "La copia de los flujos de trabajo guiados puede incluir eventos y condiciones relevantes identificados y sus descripciones relacionadas. No incluirán otros objetos relacionados (por ejemplo, Cuentas, Riesgos).",
    availableCanvasFormsColumnName: "Documentos disponibles",
    availableFITDocuments: "Flujos de trabajo guiados disponibles",
    availableAccountsColumnName: "Cuentas disponibles",
    availableSCOTsColumnName: "SCOTs disponibles",
    availableExternalDocumentsColumnName: "Documentos externos disponibles",
    step3NoItemeSelectedError: "Seleccione al menos un elemento para continuar",
    searchPackagePlaceholder: "buscar",
    searchPackageClearHoverText: "claro",

    //step2:
    step2Header: "Seleccionar categorías para {0} paquete",
    step2AccountsHdr: "Seleccione las categorías que desea incluir en la copia del paquete. El paquete principal incluye todas las aserciones relacionadas, PSPs y OSP.",
    step2scotshdr: "Seleccione las categorías que desea incluir en copia del paquete. El paquete principal incluye todos los WCW, controles y tareas relacionados",
    step2canformhdr: "Seleccionar categorías para incluir en el paquete de copia",
    step2InstructionTextEngagementByEntity: "Seleccione las entidades que se van a incluir en el paquete de copia",
    availableEntitiesColumnName: "Entidades disponibles",
    step2HeaderEntities: "Seleccione {0} para el paquete del compromiso",
    entitiesLabel: "Entidades",

    scots: "SCOTs",
    itso: "Aplicación de TI/ Estructura so",
    evidence: "evidencia",
    realtedevidence: "Evidencia relacionada",
    signoffs: "Firmas",
    tempfiles: "Archivos temporales",
    priorperiodevidence: "Evidencia del período anterior",
    recentlydeletedfiles: "Archivos eliminados recientemente",
    historyfiles: "Historial de archivos",
    extgrp: "Grupos externos y miembros externos del equipo",
    eydocument: "Documentos de EY",
    extdoc: "Documentos externos",
    totalfilesize: "El tamaño total del archivo de todas las selecciones es",
    requestandexernaltasks: "Solicitudes y tareas externas",
    rollForwardFromExisting: "Actualización desde lo existente",
    template: "Plantilla",
    bulkExport: "Exportación a granel",

    fileSizeWaring: "Las categorías seleccionadas incluyen archivos que {0}. EY Canvas no admite copia de paquetes que superen este límite.",
    fileSizeWarningline2: "Considere la posibilidad de quitar categorías de documentos para reducir el tamaño total del archivo de copia del paquete.",
    coloredExceedLable: "supera los {0} GB",
    step2EngHdr: "Seleccione las categorías que desea incluir en el paquete de copia. El paquete básico incluye el perfil de compromiso, todos los documentos de conocimiento, las tareas estándar primarias, otras tareas estándar, las fases de tiempo; cuentas/divulgaciones, aseveraciones y sus tareas relacionadas; SCOTs, WCGWs, Controles y sus tareas relacionadas; Aplicaciones de TI / Organizaciones de servicios, Riesgos, ITGC / ITSP y tareas relacionadas. Si el compromiso de auditoría de grupo, el paquete también incluirá datos de auditoría de grupo.",
    step2EngByEntityHdr: "Seleccione las categorías que desea incluir en el paquete de copia. El paquete básico incluye el perfil de compromiso, todos los documentos de conocimiento, las tareas estándar primarias, otras tareas estándar, las fases de tiempo; cuentas/divulgaciones, afirmaciones y sus tareas relacionadas; SCOTs, WCGWs, Controles y sus tareas relacionadas; Aplicaciones de TI/Organizaciones de Servicios, Riesgos, ITGCs/ITSP y tareas relacionadas; Mapas. Si el compromiso de auditoría de grupo, el paquete también incluirá datos de auditoría de grupo.",
    step2BulkExpHdr: "Seleccione las categorías de documentos que desea exportar.",
    gb: "GB",
    step2And: "y",
    step2Files: "documento(s)",
    lessThanMinGB: "menos de 0,01 GB",
    CategoryFileSizeCount: " {0} GB y documento(s) {0}",

    cancelLabel: "Cancelar",
    showSelected: "Mostrar seleccionado",
    showSelectedDocuments: "Mostrar {0} documento(s) seleccionado(s)",
    showSelectedEntities: "Mostrar {0} entidad(es) seleccionada(s)",
    showSelectedGuidedWorflows: "Mostrar {0} flujos de trabajo guiados seleccionados",
    showSelectedAccounts: "Mostrar {0} cuenta(s) seleccionada(s)",
    showSelectedSCOTs: "Mostrar {0} SCOT(s) seleccionado(s)",
    noDataFoundLabel: "No se han encontrado datos",
    copyPackageSuccessMessage: "{0} se ha iniciado la exportación de datos.",
    copyPackageWarningLabel: "Advertencia: El paquete no se pudo enviar a los siguientes miembros debido a información no válida: {0}",
    noResultFound: "No se encontraron resultados",
    canvasForms: "Formularios de EY Canvas",
    canvasFormsInformationText: "Los formularios de EY Canvas solo se pueden exportar como archivos de evidencia y/o temporales.<br/>Seleccione una de estas opciones para habilitar la descarga de formularios de EY Canvas.",
    coEditSelectAllWarningMessage: "Algunos documentos se encuentran actualmente en modo de edición multiusuario activo y no se pueden incluir en el paquete de copia",
    coEditDocumentTooltip: "El documento está en modo de edición multiusuario activo y no se puede copiar. Por favor, registre el documento para copiarlo como parte de este paquete",
    coEditCopyWarningMessage: "{0} documentos están en modo de edición multiusuario activo dentro de la categoría o categorías {1}. Por favor, registre todos los documentos dentro de cada categoría para incluirlos como parte de este paquete"
};

export const documentTypes = [{
        id: 1,
        label: "Evidencia"
    },
    {
        id: 2,
        label: "Temporal"
    },
    {
        id: 3,
        label: "Evidencia del año anterior"
    },
    {
        id: 4,
        label: "Archivos de cliente"
    },
    {
        id: 5,
        label: "Instantánea"
    },
    {
        id: 6,
        label: "Smartform"
    },
    {
        id: 29,
        label: "Paper Profile"
    },
    {
        id: 47,
        label: "Exportación masiva de documentos"
    },
    {
        id: 48,
        label: "Canvas Form"
    },
    {
        id: 51,
        label: "Centro de automatización"
    },
    {
        id: 59,
        label: "Paquetes"
    },
    {
        id: 72,
        label: "Documento de trabajo inteligente"
    }
];

export const activityTypes = [{
        id: activityType.primaryLinkAccept,
        label: "Solicitud de enlace aceptada por {0}"
    },
    {
        id: activityType.primaryLinkReject,
        label: "Solicitud de enlace rechazada por {0}"
    },
    {
        id: activityType.primaryUnlink,
        label: "Compromiso desvinculado del grupo por {0}"
    },
    {
        id: activityType.primaryComponentUnlink,
        label: "Compromiso desvinculado del grupo por {0}"
    },
    {
        id: activityType.componentPrimaryUnlink,
        label: "Compromiso desvinculado del grupo por {0}"
    },
    {
        id: activityType.primarySendLink,
        label: "Solicitud de enlace enviada por {0} a {1}"
    },
    {
        id: activityType.documentsReceived,
        label: "Documentos recibidos por {0}"
    },
    {
        id: activityType.primarySendInstruction,
        label: "Instrucciones enviadas de {0} a {1}"
    },
    {
        id: activityType.primaryRejectInstruction,
        label: "Instrucciones devueltas por {0}"
    },
    {
        id: activityType.primaryAcceptInstruction,
        label: "Instrucciones aceptadas por {0}"
    },
    {
        id: activityType.componentReceivedInstruction,
        label: "Instrucciones recibidas"
    },
    {
        id: activityType.componentAcceptInstruction,
        label: "Instrucciones aceptadas por {0}"
    },
    {
        id: activityType.componentRejectInstruction,
        label: "Instrucciones devueltas por {0}"
    },
    {
        id: activityType.componentAcceptUpdatetInstruction,
        label: "Instrucciones aceptadas por {0}"
    },
    {
        id: activityType.componentRejectUpdateInstruction,
        label: "Instrucciones devueltas por {0}"
    },
    {
        id: activityType.primaryEvidenceReceived,
        label: "Versión recibida por {0}"
    },
    {
        id: activityType.documentVersionConflictResolved,
        label: "Conflicto resuelto por {0}"
    },
    {
        id: activityType.documentOverwrite,
        label: "Contenido del documento sobrescrito por {0}"
    },

    {
        id: activityType.primaryAssignComponent,
        label: "Documento asignado a {0}"
    },
    {
        id: activityType.componentUnassigned,
        label: "Documento sin asignar de {0}"
    },
    {
        id: activityType.clearDocumentReturnedtoComponent,
        label: "Versión finalizada por {0}"
    },
    {
        id: activityType.componentClearReturnedDocument,
        label: "Versión resuelta por {0}"
    },
    {
        id: activityType.primaryReturnEvidence,
        label: "Versión devuelta por {0}"
    },
    {
        id: activityType.componentEvidenceSent,
        label: "Versión enviada por {0}"
    },
    {
        id: activityType.componentReturnEvidence,
        label: "Versión devuelta por {0}"
    },
    {
        id: activityType.createReviewNote,
        label: "Nota abierta por {0}"
    },
    {
        id: activityType.openReviewNote,
        label: "Nota abierta por {0}"
    },
    {
        id: activityType.clearReviewNote,
        label: "Nota borrada por {0}"
    },
    {
        id: activityType.closeReviewNote,
        label: "Nota cerrada por {0}"
    },
    {
        id: activityType.reviewerSignOff,
        label: "Firmado por {0}"
    },
    {
        id: activityType.preparerSignOff,
        label: "Firmado por {0}"
    },
    {
        id: activityType.canvasSendClientRequest,
        label: labels.sent
    },
    {
        id: activityType.clientRespondToClientRequest,
        label: "Respondido"
    },
    {
        id: activityType.canvasRejectClientRequest,
        label: labels.rejected
    },
    {
        id: activityType.canvasWithdrawClientRequest,
        label: labels.WithdrawLabel
    },
    {
        id: activityType.canvasDeleteClientRequest,
        label: "Eliminado"
    },
    {
        id: activityType.canvasAcceptClientRequest,
        label: labels.accepted
    },
    {
        id: activityType.CEARecallClientRequest,
        label: "Retirado"
    },
    {
        id: activityType.canvasCompleteClientRequest,
        label: labels.completed
    }
];


export const gaLinkStatus = [{
        id: GALinkStatus.Undefined,
        label: "indefinido"
    },
    {
        id: GALinkStatus.NoPointOfContact,
        label: "Sin punto de contacto"
    },
    {
        id: GALinkStatus.Pending,
        label: "pendiente"
    },
    {
        id: GALinkStatus.Accepted,
        label: "aceptado"
    },
    {
        id: GALinkStatus.Rejected,
        label: "rechazado"
    },
    {
        id: GALinkStatus.Expired,
        label: "caducado"
    },
    {
        id: GALinkStatus.Unlinked,
        label: "Desvinculado"
    },
    {
        id: GALinkStatus.Delegated,
        label: "Delegado"
    },
    {
        id: GALinkStatus.SystemError,
        label: "Error del sistema"
    },
    {
        id: GALinkStatus.Sent,
        label: "enviado"
    },
    {
        id: GALinkStatus.InvalidPointOfContact,
        label: "Punto de contacto no válido"
    },
    {
        id: GALinkStatus.ComponentNotUsingCanvas,
        label: "Componente que no usa Canvas"
    }
];

export const gaInstructionStatus = [{
        id: 0,
        label: labels.notApplicable
    },
    {
        id: instructionStatus.notSent,
        label: "No enviado"
    },
    {
        id: instructionStatus.pending,
        label: "pendiente"
    },
    {
        id: instructionStatus.accepted,
        label: "aceptado"
    },
    {
        id: instructionStatus.rejected,
        label: "devuelto"
    },
    {
        id: instructionStatus.systemError,
        label: "Error del sistema"
    },
    {
        id: instructionStatus.expired,
        label: "caducado"
    },
    {
        id: instructionStatus.sent,
        label: "enviado"
    },
    {
        id: instructionStatus.unlinked,
        label: "Desvinculado"
    },
    {
        id: instructionStatus.queued,
        label: "Cola"
    }
];

export const gsSnapshotComparisonStatus = [{
        id: snapshotComparisonIds.noChange,
        value: "nulo"
    },
    {
        id: snapshotComparisonIds.new,
        value: "Nuevo"
    },
    {
        id: snapshotComparisonIds.added,
        value: "Añadido"
    },
    {
        id: snapshotComparisonIds.modified,
        value: "Modificado"
    },
    {
        id: snapshotComparisonIds.updated,
        value: "Actualizado"
    },
    {
        id: snapshotComparisonIds.removed,
        value: "Quitado"
    },
    {
        id: snapshotComparisonIds.itemsRemoved,
        value: "Elementos eliminados"
    },
]

export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "primario"
    },
    {
        id: GARoleTypeId.Region,
        label: "región"
    },
    {
        id: GARoleTypeId.Component,
        label: "componente"
    }
];

export const linkRequestTypes = [{
        id: linkType.sent,
        label: "enviado"
    },
    {
        id: linkType.unlinked,
        label: "Desvinculado"
    },
    {
        id: linkType.accepted,
        label: "aceptado"
    }
];

export const instructionTypes = [{
        id: instructionType.sent,
        label: "enviado"
    },
    {
        id: instructionType.rejected,
        label: "Devuelto"
    },
    {
        id: instructionType.received,
        label: "recibido"
    },
    {
        id: instructionType.accepted,
        label: "aceptado"
    }
];

export const syncStatusLabels = [{
        id: syncStatus.notSynchronized,
        label: "No sincronizado"
    },
    {
        id: syncStatus.syncInTransit,
        label: "Sincronización en tránsito"
    },
    {
        id: syncStatus.syncInProcess,
        label: "Sincronización en proceso"
    },
    {
        id: syncStatus.synchronized,
        label: "Sincronizado"
    },
    {
        id: syncStatus.deleteInTransit,
        label: "Eliminar en tránsito"
    },
    {
        id: syncStatus.deleteInProcess,
        label: "Eliminar en proceso"
    },
    {
        id: syncStatus.deleted,
        label: "borrado"
    },
    {
        id: syncStatus.noHostEngagement,
        label: "Sin participación del anfitrión"
    },
    {
        id: syncStatus.syncError,
        label: "Error de sincronización"
    }
];

export const colorOptionsLabels = {
    Red: "Rojo",
    Orange: "Naranja",
    Teal: "Verde azulado",
    Blue: "Azul",
    Purple: "Morado",
    Green: "Verde",
    Yellow: "Amarillo",
    Gray: "Gris"
};

export const todoListTimeFrameLabels = [{
        id: todoListTimeframeOptions.byDay,
        label: "Por día"
    },
    {
        id: todoListTimeframeOptions.byWeek,
        label: "Por semana"
    },
    {
        id: todoListTimeframeOptions.byMonth,
        label: "Por mes"
    },
    {
        id: todoListTimeframeOptions.all,
        label: "Todo"
    },
    {
        id: todoListTimeframeOptions.overdue,
        label: "Atrasado"
    }
];

export const clientRequestsStatusFilter = [{
        value: 'Draft',
        label: "Borrador"
    },
    {
        value: 'Pending',
        label: "Pendiente de respuesta"
    },
    {
        value: 'Received',
        label: "Recibido"
    },
    {
        value: 'Accepted',
        label: "Aceptado"
    }
];

export const clientRequestsTypeFilter = [{
        value: 'Required',
        label: "Se requiere aprobación"
    },
    {
        value: 'NotRequired',
        label: "No se requiere aprobación"
    }
];

export const clientRequestsPriorityFilter = [{
        value: 'Normal',
        label: "Normal"
    },
    {
        value: 'High',
        label: "Alto"
    },
    {
        value: 'Critical',
        label: "Crítico"
    }
];

export const clientRequestsAttachmentsFilter = [{
        value: 'Analytics',
        label: "Analítica"
    },
    {
        value: 'ExternalAttachments',
        label: "Adjuntos externos"
    },
    {
        value: 'EyAttachments',
        label: "Archivos adjuntos EY"
    },
    {
        value: 'None',
        label: "Ninguno"
    }
];

export const clientRequestsCreatedByFilter = [{
        value: 'Client',
        label: "Cliente"
    },
    {
        value: 'EY',
        label: "EY"
    }
];

export const filterTimePhase = [{
    value: -1,
    label: "Sin fase de tiempo"
}];

export const clientRequestsBooleanFilters = [{
        value: 1,
        label: "Sí"
    },
    {
        value: 0,
        label: "No"
    }
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
        value: false,
        label: "Sí"
    },
    {
        value: true,
        label: "No"
    }
]

export const controlsTestingFilters = [{
        value: 'true',
        label: "Si"
    },
    {
        value: 'false',
        label: "No"
    },
    {
        value: 'null',
        label: "No seleccionado"
    }
];

export const controlsDesignEffectivenessFilters = [{
        value: '1',
        label: "Efectivo"
    },
    {
        value: '2',
        label: "Inefectivo"
    },
    {
        value: '0',
        label: "No seleccionado"
    }
];

export const clientRequestAnnotationTabs = [{
        id: clientRequestNoteTab.comments,
        label: "Comentarios"
    },
    {
        id: clientRequestNoteTab.history,
        label: "Historia"
    }
];

export const riskTypeOptions = [{
        id: 1,
        name: "Riesgos significativos"
    },
    {
        id: 2,
        name: "Riesgos de fraude"
    },
    {
        id: 3,
        name: "Riesgo de error material"
    }
];

export const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
export const longDays = ['Domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábados'];
export const shortDays = ['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA'];
// GA Scopes
export const gaScopesResource = [{
        id: gaScopes.full,
        label: "Lleno"
    },
    {
        id: gaScopes.specific,
        label: "Específico"
    },
    {
        id: gaScopes.specificAuditProcedures,
        label: "Procedimientos de auditoría especificados"
    },
    {
        id: gaScopes.review,
        label: "Revisión"
    }
]

// GA Instructions
export const gaRecommendationTypeResource = [{
        id: gaRecommendationType.required,
        label: "Obligatorio"
    },
    {
        id: gaRecommendationType.optional,
        label: "Opcional"
    },
    {
        id: gaRecommendationType.notApplicable,
        label: "No aplicable"
    }
]

// GS Group Summary
export const gsTabsResource = [{
        id: groupSummaryTabs.assignedTeams,
        label: "Equipos asignados"
    },
    {
        id: groupSummaryTabs.instructions,
        label: "Instrucciones"
    },
    {
        id: groupSummaryTabs.tasks,
        label: "Tareas"
    }
]

export const receiveInstructionsTypeResource = {
    true: {
        title: "Nuevo",
        instructional: "un nuevo"
    },
    false: {
        title: "Actualizado",
        instructional: "un actualizado"
    }
}

export const clientRequestSystemGeneratedMessages = {
    sent: "Solicitud enviada a",
    accepted: "Solicitud aceptada",
    received: "Solicitud recibida",
    returned: "Solicitud devuelta",
    withdrawn: "Solicitud retirada",
    complete: "La solicitud fue completada por EY",
    recalled: "Solicitud retirada",
    notification_submit: "Solicitud enviada a automatización",
    notification_success: "Solicitud enviada correctamente a automatización",
    notification_error: "Se ha producido un error al enviar a la automatización. Haga clic en Enviar a automatización para volver a intentarlo.",
    restore_document: "Documento restaurado -",
    delete_document: "Documento eliminado -",
    assignedto: "Elemento reasignado a",
    editrequest: "Solicitud editada",
    prioritychange: "Solicitud de prioridad actualizada a"
};

export const externalTaskSystemGeneratedMessages = {
    sent: "Tarea externa enviada a",
    accepted: "Tarea externa aceptada",
    received: "Respuesta recibida",
    returned: "Tarea externa devuelta",
    withdrawn: "Tarea externa retirada",
    complete: "La tarea externa se completó desde EY Canvas",
    recalled: "Tarea externa retirada",
    restore_document: "Documento restaurado -",
    delete_document: "Documento eliminado -",
    assignedto: "Elemento reasignado a",
    editrequest: "Tarea externa editada",
    prioritychange: "Prioridad de tareas externas actualizada a"
};

export const ipInputLabels = [{
        id: ipInputType.ipAddress,
        label: "dirección IP"
    },
    {
        id: ipInputType.ipRange,
        label: "Rango de IP"
    },
    {
        id: ipInputType.cidrBlock,
        label: "Bloque de CIDR"
    }
];

export const ipFilterTypeLabels = {
    [ipFilterType.ipAddress]: "Dirección IP",
    [ipFilterType.ipRange]: "Rango de IP",
    [ipFilterType.cidrBlock]: "Bloque de CIDR"
};

export const gaLinkStatusObj = {
    [GALinkStatus.Undefined]: "Indefinido",
    [GALinkStatus.NoPointOfContact]: "No hay punto de contacto",
    [GALinkStatus.NotSent]: "No enviado",
    [GALinkStatus.Pending]: "Solicitud de enlace pendiente",
    [GALinkStatus.Accepted]: "Solicitud de enlace aceptada",
    [GALinkStatus.Rejected]: "Rechazado",
    [GALinkStatus.Expired]: "Caducado",
    [GALinkStatus.Unlinked]: "Desvinculado",
    [GALinkStatus.Delegated]: "Delegado",
    [GALinkStatus.SystemError]: "Error del sistema",
    [GALinkStatus.Sent]: "Enviado",
    [GALinkStatus.InvalidPointOfContact]: "Punto de contacto no válido",
    [GALinkStatus.ComponentNotUsingCanvas]: "No usará EY Canvas",
    [GALinkStatus.ComponentReferenceOnly]: "Solo referencia"
};

export const epTasksObj = [{
        value: '3',
        label: "Sin documentos firmados"
    },
    {
        value: '2',
        label: "Algunos documentos firmados"
    },
    {
        value: '1',
        label: "Todos los documentos firmados"
    }
];

export const eqrTasksObj = [{
        value: '6',
        label: "Sin documentos firmados"
    },
    {
        value: '5',
        label: "Algunos documentos firmados"
    },
    {
        value: '4',
        label: "Todos los documentos firmados"
    }
];

export const groupsFilterEntity = [{
        id: 1,
        label: "Tareas"
    },
    {
        id: 2,
        label: "Documentos"
    }
];

export const scopesFilterEntity = [{
        id: 1,
        label: "Completo"
    },
    {
        id: 2,
        label: "Específico"
    },
    {
        id: 3,
        label: "Procedimientos especificos de auditoría "
    },
    {
        id: 4,
        label: "Revisión"
    }
];

export const notesFilterLabels = [{
        id: notesFilter.allNotes,
        label: "Todas las notas"
    },
    {
        id: notesFilter.myNotes,
        label: "Mis notas"
    },
    {
        id: notesFilter.authoredByMeNotes,
        label: "Asignado a mí"
    }
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
        id: 1,
        value: labels.advancedSearchTitleCheck
    },
    {
        id: 2,
        value: labels.advancedSearchRefereceNumberCheck
    },
    {
        id: 3,
        value: labels.advancedSearchDocumentsCheck
    },
    {
        id: 4,
        value: labels.advancedSearchCommentsCheck
    }
];


export const TaskTypeLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy]
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs]
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs]
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts]
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution]
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion]
    }
];

export const TaskCategoryLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy],
        displayOrder: 1
    },
    {
        id: TaskListTypes.Risks,
        label: taskNavigation[TaskListTypes.Risks],
        displayOrder: 2
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs],
        displayOrder: 3
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs],
        displayOrder: 4
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts],
        displayOrder: 5
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution],
        displayOrder: 6
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion],
        displayOrder: 7
    },
];

export const kendoLabels = {
    alignLeft: "Justificar a la izquierda",
    alignRight: "Justificar a la derecha",
    alignCenter: "Justificar al centro",
    alignFull: "Justificar completo",
    addComment: "Agregar comentario",
    addColumnBefore: "Agregar columna izquierda",
    addColumnAfter: "Agregar columna a la derecha",
    addRowAbove: "Agregar fila arriba",
    addRowBelow: "Agregar fila a continuación",
    bulletList: "Insertar lista desordenada",
    bold: "Negrita",
    backColor: "Destacar",
    createLink: "Insertar hipervínculo",
    createTable: "Crear tabla",
    cleanFormatting: "Formato limpio",
    deleteRow: "Borrar fila",
    deleteColumn: "Eliminar columna",
    deleteTable: "Eliminar tabla",
    fontSizeInherit: "Tamaño de fuente",
    foreColor: "Color",
    format: "Formato",
    fontSize: "Tamaño de fuente",
    hyperlink: "Insertar enlace web",
    italic: "Itálico",
    indent: "Sangria",
    insertTableHint: "Crear una tabla {0} por {1}",
    'hyperlink-dialog-content-address': "Dirección web",
    "hyperlink-dialog-title": "Insertar hipervínculo",
    "hyperlink-dialog-content-title": "Título",
    "hyperlink-dialog-content-newwindow": "Abrir enlace en una nueva ventana",
    "hyperlink-dialog-cancel": "Cancelar",
    "hyperlink-dialog-insert": "Insertar",
    outdent: "Anular sangria",
    orderedList: "Insertar lista ordenada",
    print: "Impresión",
    pdf: "Exportar a PDF",
    redo: "rehacer",
    strikethrough: "Tachado",
    subscript: "Subescrito",
    superscript: "Sobrescrito",
    underline: "Subrayar",
    undo: "Deshacer"
};

export const kendoFormatOptions = [{
        text: "Párrafo",
        value: "p"
    },
    {
        text: "Encabezado 1",
        value: "h1"
    },
    {
        text: "Encabezado 2",
        value: "h2"
    },
    {
        text: "Encabezado 3",
        value: "h3"
    },
    {
        text: "Encabezado 4",
        value: "h4"
    },
    {
        text: "Encabezado 5",
        value: "h5"
    },
    {
        text: "Encabezado 6",
        value: "h6"
    }
];

export const kendoFontSize = [{
        text: '8',
        value: '8px'
    },
    {
        text: '9',
        value: '9px'
    },
    {
        text: '10',
        value: '10px'
    },
    {
        text: '11',
        value: '11px'
    },
    {
        text: '12',
        value: '12px'
    },
    {
        text: '14',
        value: '14px'
    },
    {
        text: '16',
        value: '16px'
    },
    {
        text: '18',
        value: '18px'
    },
    {
        text: '20',
        value: '20px'
    },
    {
        text: '22',
        value: '22px'
    },
    {
        text: '24',
        value: '24px'
    },
    {
        text: '26',
        value: '26px'
    },
    {
        text: '28',
        value: '28px'
    },
    {
        text: '36',
        value: '36px'
    },
    {
        text: '48',
        value: '48px'
    },
    {
        text: '72',
        value: '72px'
    }
];

export const monthsList = [
	"Enero",
	"Febrero",
	"Marzo",
	"Abril",
	"Mayo",
	"Junio",
	"Julio",
	"Agosto",
	"Septiembre",
	"Octubre",
	"Noviembre",
	"Diciembre"
];

export const pspContentStatus = {
    1: "Actualización requerida",
    2: "Actualización en progreso",
    3: "Actualizacion completa",
    4: "Error de actualización"
}

export const handOffLabels = {
    handoff: "Traspaso",
    handOffTitleTip: "Traspaso para revisión",
    markCompleteTitleTip: "Marcar completado",
    handoffModalTitle: "Traspaso al siguiente miembro del equipo",
    handoffConfirmButtonText: "Traspaso",
    return: "Devolver",
    handModalDescription: "Para firmar un archivo de pruebas, seleccione una de las opciones siguientes.",
    markCompleteTextLine1: "Entregue esta tarea al siguiente miembro del equipo.",
    markCompleteTextLine2: "Para firmar un archivo de pruebas, seleccione una de las opciones siguientes. Si tiene una asignación para esta tarea y la ha completado, seleccione <b>Sí</b> para cerrarla. Si esta tarea requiere la firma de PIC o EQR, seleccione una de las siguientes opciones.",
    closeLabel: "Cerrar",
    handoffto: "Traspaso a",
    missingToUserError: "Obligatorio",
    markCompleteConfirm: "Marcar completado",
    markCompleteModalHeaderTextPart1: "Esta tarea se marcará como completada.",
    markCompleteModalHeaderTextPart2: "Para firmar un archivo de pruebas, seleccione una de las opciones siguientes. Si tiene una asignación para esta tarea y la ha completado, seleccione <b>Sí</b> para cerrarla. Si esta tarea requiere la firma de PIC o EQR, seleccione una de las siguientes opciones.",
    signOffOnAllAs: "Firmar en todos como",
    preparer: "Preparador",
    reviewer: "Revisor",
    none: "Ninguno",
    noSignOffsByMe: "Sin firmas por mi parte",
    myPreparerSignOffs: "Mis firmas de preparador",
    myReviewerSignOffs: "Mis firmas de revisor",
    myPreparerAndReviewerSignOffs: "Mis firmas de preparador y revisor",
    preparerTitle: "Firmas del preparador",
    reviewerTitle: "Firmas de revisores",
    autoAssignmentMessage: "Este miembro del equipo no tiene una asignación. Se creará {0} asignación con una fecha de vencimiento de {1}. Para editar esta asignación {2}.",
    clickHere: "haga clic aquí",
    noTaskEvidencesHandoffModal: "No hay archivos de evidencia asociados a esta tarea.",
    // Create Assignment
    createAssignment: "Crear asignación",
    create: "Crear",
    cancelLabel: "Cancelar",
    createassignmentheader1: "El miembro del equipo seleccionado no tiene una asignación para esta tarea.",
    createassignmentheader2: "Cree una asignación aquí.",
    dueDate: "Fecha de vencimiento",
    teamMemberAssigmentLabel: "Miembro del equipo",
    daysPriorToEndDate: "Días antes de la fecha final",
    // Add Assignment
    addAssignmentTitle: "Agregar nombre de asignación",
    confirmButtonLabel: "Agregar",
    cancelButtonLabel: "Cancelar",
    assignmentTypeInstructionalText: "Seleccione un tipo de asignación e introduzca un nombre a continuación. Haga clic en <b>Agregar</b> cuando haya terminado.",
    assignmentType: "Tipo de asignación",
    required: "Obligatorio",
    clearHoverText: "Claro",
    unmarkcomplete: "Desmarcar como completo",
    markCompleteErrorMessage: "La tarea no se puede marcar como completa. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con la mesa de ayuda.",
    // Assignment Dropdown
    noResultFound: "No se encontraron resultados",
    addTaskGroupLabel: "Agregar grupo de tareas",
    addAssignmentName: "Agregar nombre de asignación",
    assignmentName: "Nombre de asignación",
    additionalSignOff: "Firmas adicionales requeridas",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    closeMyAssignment: "Cerrar mi tarea",
    filterYes: "Sí",
    filterNo: "No",
    assignmentTypeLabels: [{
            id: assignmentTypes.preparer,
            label: "Preparador"
        },
        {
            id: assignmentTypes.detailReviewer,
            label: "Revisor detallado"
        },
        {
            id: assignmentTypes.generalReviewer,
            label: "Revisor general"
        },
        {
            id: assignmentTypes.partner,
            label: "Socio"
        },
        {
            id: assignmentTypes.eqr,
            label: "EQR"
        },
        {
            id: assignmentTypes.other,
            label: "Otro"
        }
    ]
};

export const displayedOn = {
    "Account": "Cuenta",
    "SCOT": "SCOT",
    "IT/SO": "IT/SO",
    "Scope & Strategy": "Alcance y estrategia",
    "Execution": "Ejecución",
    "Conclusion": "Conclusión"
}

export const auditPlanReportLabels = {
    adc: "Objeto relacionado",
    secondaryObject: "Objeto relacionado secundario",
    taskTypeColumn: "Tipo de tarea",
    taskNamePrefix: "Prefijo de tarea",
    taskName: "Título de la tarea",
    taskNameSuffix: "Sufijo de tarea",
    taskDescription: "Descripción de la tarea",
    auditTaskStatus: "Estado de la tarea",
    rationaleForRejection: "Razón del rechazo",
    knowledgeTaskTitle: "Título de la tarea de conocimiento",
    knowledgeTaskDescription: "Descripción de la tarea de conocimiento",
    assignedTo: "Asignado a",
    engagementTagGroupName: "Grupo de etiquetas",
    engagementTagName: "Etiquetas",
    prioritized: "Priorizado",
    viewDisplayedOn: "Vista mostrada en",
    engagementPhase: "Fase de compromiso",
    milestone: "Hito",
    periodName: "Fase de tiempo",
    riskTypeAbbr: "Tipo de riesgo relacionado",
    riskName: "Nombre del riesgo relacionado",
    relatedMESTEntityName: "Entidades MEST relacionadas",
    scheduledNextWaveservices: "Servicios Centralizados",
    taskID: "ID de la tarea",
    timephaseID: "ID de la fase de tiempo",
    taskTypeID: "ID del tipo de tarea",
    timephaseTypeID: "ID de tipo de fase de tiempo"
}

export const reportingTaskAll = {
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    taskAssignedTo: labels.taskassignedto,
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    knowledge_Task_Title: "Título de la tarea de conocimiento",
    knowledge_Task_Description: "Descripción de la tarea de conocimiento",
    rejected: labels.rejected,
    rationale_for_Rejection: "Justificación del rechazo",
    audit_Phase: labels.auditPhasesLabel,
    milestonename: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    timephasestartdateinutc: "Fecha de inicio de la fase de tiempo (en UTC)",
    timephaseduedateinutc: "Fecha de vencimiento de la fase de tiempo (en UTC)",
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    lastTaskChangeDateInUTC: "Última fecha de cambio de estado de la tarea (en UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    mesT_Entity_Name: "Entidades MEST relacionadas",
    multiEntityType: "Tipo de entidad múltiple",
    taskID: "ID de la tarea",
    taskTypeID: "ID del tipo de tarea",
    taskStatusID: "ID del estado de la tarea",
    auditPhaseID: "ID de fase de auditoría",
    timephaseTypeID: "ID de hito",
    taskSourceTypeID: "Id de la fuente de la tarea",
    taskNatureTypeID: "Id de la naturaleza de la tarea",
    cgTaskID: "KnowledgeTaskID",
    knowledgeContentID: "KnowledgeContentID"
}

export const reportTaskAssignments = {
    taskNamePrefix: labels.taskPrefix,
    taskName: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    taskTypeName: labels.taskType,
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    auditPhaseName: labels.engagementPhase,
    milestones: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    PICSignoffRequired: "Se requiere aprobación de PIC",
    EQRSignoffRequired: "Se requiere aprobación de EQR",
    taskStatusName: labels.taskStatusLabel,
    taskDueDateInUTC: "Fecha de vencimiento de la tarea (en UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    completedAssignment: labels.completedAssignments,
    totalAssignment: "Asignaciones totales",
    closedTaskAssignmentPercent: "% de asignación de tareas cerradas",
    assignmentOrder: "Orden de asignación",
    firstNameVal: "Nombre del miembro del equipo de asignación de tareas",
    lastNameVal: "Apellido del miembro del equipo de asignación de tareas",
    assignmentName: labels.assignmentName,
    assignmentTypeName: labels.filterAssignmentTypeLabel,
    roleName: "Rol de usuario de compromiso",
    assignmentStatusVal: "Estado de asignación de tareas",
    dueDays: "Días de vencimiento",
    completedDateInUTC: "Fecha de finalización (en UTC)",
    assignmentDueDateInUTC: "Fecha de vencimiento de la tarea (en UTC)",
    daysCompleteBeforeDueDate: "Días restantes antes de la fecha de vencimiento de la asignación de tareas",
    daysCompleteAfterDueDate: "Días de retraso después de la fecha de vencimiento de la asignación de tareas",
    closedEarlyOrLate: "Cerrado temprano / tarde",
    closedDaysEarly: "Días cerrado temprano",
    closedDaysLate: "Días cerrado tarde",
    oldTaskName: "Título de la tarea heredada",
    oldTaskDetail: "Descripción de la tarea heredada",
    taskID: "ID de tarea",
    assignmentID: "ID de asignación",
    roleID: "ID de rol",
    userID: "ID de usuario"
}

export const reportingMultiEntityTask = {
    engagementID: "EngagementId",
    taskID: "TaskId",
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    mesT_Entity_Name: "Entidad relacionada",
    multiEntityType: "MultiEntityType",
    taskTypeID: "TaskTypeID",
    taskStatusID: "TaskStatusID"
}

export const reportingManageteamInternal = {
        firstName: labels.firstnameLabel,
        lastName: labels.lastnameLabel,
        userInitials: labels.initialsLabel,
        emailAddress: labels.editExternalEmailLabel,
        gui: "GUI",
        engagementRole: labels.engagementrole,
        hasOverallResponsability: "Tiene la responsabilidad general",
        userStatus: "Estado",
        independenceStatus: "estado de independencia",
        grantedAccess: "Acceso concedido después del archivo",
        primaryOffice: "oficina principal",
        preferredContactPhone: "Número de teléfono",
        engagementUserStatusID: "ID de estado de usuario de compromiso",
        engagementRoleID: "ID de rol de compromiso",
        independenceStatusID: "ID de estado de independencia"
    }

export const reportingManageteamExternal = {
    clientGroupName: "Nombre del grupo",
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    domain: "Dominio de usuario",
    validDomainWithinGroup: "Dominio válido dentro del grupo",
    userStatus: "Estatus de usuario",
    preferredContactPhone: "Número de teléfono preferido"
};

export const controlDesignEffectivenessType = {
    1: "Efectivo",
    2: "Inefectivo"
};

export const itAppSOSummaryReportLabels = {
    itApplicationName: "Organización de servicios/aplicaciones de TI",
    strategyTypeName: "estrategia de TI",
    typeName: "Tipo",
    itProcessName: "Proceso de TI",
    itRiskName: "Riesgo de TI",
    itControlName: "ITGC/ITSP",
    natureOfTest: "Naturaleza de la prueba",
    controlFrequencyTypeNameColumn: "Frecuencia",
    testing: "Pruebas",
    designEffectiveness: "Eficacia del diseño",
    evaluation: "Evaluación de procesos de TI"
};

export const ArchiveReportLabels = {
    engagementDescription: "Descripción del compromiso",
    archiveReportQualifiedNameSection: "Informe calificado",
    archiveReportQualifiedTypeNameSection: "Tipo  de informe calificado",
    archiveFolderDescription: "Descripción de la carpeta de archivo",
    archiveFolderTypeNameSection: "Tipo de carpeta",
    location: "Ubicación",
    archiveComments: "Comentarios de Archive",
    engagementID: "ID de compromiso",
    archiveCountryOfficeRegionID: "ID de región de la oficina de país de archivo",
    archiveReportQualifiedID: "ID Calificado del Informe de Archivo",
    archiveReportQualifiedTypeID: "ID del tipo de informe calificado de archivo"
};

export const canvasFormRelatedCommentsLabels = {
    canvasFormName: "Nombre del formulario Canvas",
    order1: "HeaderOrder",
    formHeaderName: "Encabezado",
    order2: "SectionOrder (Orden de sección)",
    order3: "BodyOrder (Orden del cuerpo)",
    formBodyResponseValue: "Respuesta",
    commentNumber: "Número de comentario",
    author: "Autor",
    assignedTo: "Asignado a",
    createDateSection: "Fecha de creación",
    commentStatusSection: "Estado",
    commentText: "Comentario",
    commentVoiceNote: "Tiene nota de voz",
    reply: "Respuesta",
    replyVoiceNote: "Tiene nota de voz"
};

export const canvasFormRelatedObjectsLabels = {
    canvasFormName: "Nombre del formulario Canvas",
    order1: "HeaderOrder",
    formHeaderName: "Encabezado",
    formHeaderID: "FormHeaderID",
    order2: "SectionOrder (Orden de sección)",
    formSectionID: "FormSectionID",
    formSectionName: "Sección",
    firstLevelEntityColumn: "Entidad de primer nivel",
    firstLevelRelatedObject: "Objeto relacionado de primer nivel",
    secondLevelEntityColumn: "Entidad de segundo nivel",
    secondLevelRelatedObject: "Objeto relacionado de segundo nivel"
};

export const canvasFormResponseLabels = {
    canvasFormName: "Nombre del formulario Canvas",
    order1: "HeaderOrder",
    formHeaderName: "Encabezado",
    knowledgeFormHeaderID: "KnowledgeID de encabezado",
    headerKnowledgeContentID: "Encabezado KnowledgeContentID",
    order2: "SectionOrder",
    formSectionName: "Sección",
    knowledgeFormSectionID: "Sección KnowledgeID",
    sectionKnowledgeContentID: "Sección KnowledgeContentID",
    order3: "BodyOrder",
    formBody: "Cuerpo",
    knowledgeFormBodyID: "Body KnowledgeID",
    bodyKnowledgeContentID: "Body KnowledgeContentID",
    formBodyResponse_Value: "Respuesta"
};

export const CanvasFormsIncompleteLabels = {
    canvasFormName: "Nombre del formulario Canvas",
    header: "Encabezado",
    headerOrder: "HeaderOrder",
    sectionOrder: "SectionOrder (Orden de sección)",
    bodyOrder: "BodyOrder (Orden del cuerpo)",
    body: "Cuerpo",
    formHeaderID: "FormHeaderID",
    formSectionID: "FormSectionID",
    formBodyID: "FormBodyID"
};

export const controlFormResponseLabels = {
    controlName: "Control",
    documentName: "Documento",
    engagementDescription: "Descripción del compromiso",
    formHeader: "Encabezado",
    headerKnowledgeDisplayOrder: "HeaderKnowledgeDisplayOrder",
    formSection: "Sección",
    sectionKnowledgeDisplayOrder: "SectionKnowledgeDisplayOrder",
    formBodyVal: "Cuerpo",
    bodyKnowledgeDisplayOrder: "BodyKnowledgeDisplayOrder",
    ControlTesting: "Tiene pruebas de control",
    controlFrequencyType: "Frecuencia de control",
    Effective: "Es efectivo",
    formBodyOptionVal: "Valor del cuerpo de la opción de formulario",
    controlType: "Tipo de control",
    controlDesignEffectivenessType: "Tipo de eficacia del diseño de control"
};

export const itProcessSummaryLabels = {
    itProcessName: "proceso de TI",
    itProcessEvaluation: "Evaluación de procesos de TI",
    itProcesSupportingRationale: "Justificación de apoyo",
    itRiskName: "Riesgo de TI",
    itControlName: "ITGCs/ITSPs",
    natureOfTest: "Naturaleza de la prueba",
    controlFrequencyTypeId: "Frecuencia",
    testing: "Pruebas",
    designEffectiveness: "Eficacia del diseño",
    operatingEffectiveness: "Efectividad operativa"
}

export const itProcessScotControlsLabels = {
    itProcessName: "Proceso de TI",
    scotName: "SCOT",
    controlName: "Control",
    controlDesignEffectivenessTypeName: "Eficacia del diseño",
    testing: "Pruebas",
    operatingEffectiveness: "Eficacia operativa",
    controlTypeName: "Tipo de control",
    isIPEManuallyTestedName: "IS IPE probado manualmente",
    itApplicationName: "Aplicación de TI",
    aggregateITEvaluationTypeName: "Evaluación de TI agregada"
};

export const scotsControlsReportLabels = {
    scotName: "SCOT",
    controlName: "Control",
    operatingEffectiveness: "Eficacia operativa",
    itApplicationName: "Aplicación de TI",
    aggregateITEvaluation: "Evaluación de TI agregada",
    supportingRationaleControlLabel: "Justificación de apoyo"
}

export const sCOTSummaryReportHeaderLabels = {
    scotName: "SCOT",
    scotTypeName: "Tipo de transacción",
    strategyTypeName: "Estrategia SCOT",
    itApplicationName: "Aplicación SCOT IT / SO",
    wcgwName: labels.wcgw,
    controlName: labels.control,
    controlFrequencyTypeName: labels.frequencyLabel,
    controlTypeName: "Tipo de control",
    testing: "Pruebas",
    operatingEffectiveness: "Eficacia operativa",
    controlITApplication: "Aplicación de control de TI / SO",
    aggregateITEvaluationTypeName: "Evaluación de TI agregada",
    supportingRationale: "Justificación de apoyo",
    scotId: "ID de SCOT",
    strategyTypeID: "ID de tipo de estrategia",
    scotTypeID: "ID de tipo SCOT",
    wcgwid: "ID de WCGW",
    controlID: "ID de control",
    controlFrequencyTypeID: "ID de tipo de frecuencia de control",
    controlTypeID: "Identificación del tipo de control",
    aggregateITEvaluationTypeID: "ID de tipo de evaluación de TI agregado"
};

export const findingsDeficiencyHeaderLabels = {
    description: "Descripción de la deficiencia",
    controls: "Controls",
    controlsIsEffective: "Eficacia operativa de los controles",
    type: "Tipo de deficiencia",
    magnitude: "Magnitud",
    responseText: "Texto de respuesta",
    remediatedAtYearEnd: "Remediado al final del año",
    mitigatingControls: "Control de compensación",
    mitigatingControlsIsEffective: "Eficacia operativa del control de compensación",
    mitigatingTasks: "Tareas de mitigación",
    foundIn: "Encontrado en el documento",
    accountsAndAssertions: "Cuentas y Aserciones",
    scoTs: "SCOTs",
    deficiencyID: "ID de deficiencia",
    controlID: "ID de control",
    mitigatedControlID: "ID de control mitigado",
    mitigatedTaskID: "ID de tarea mitigada",
    documentID: "ID del documento",
    accountID: "ID de la cuenta",
    scotID: "ID de SCOT "
};

export const findingsMisstatementHeaderLabels = {
    description: "Descripción del error",
    type: "Tipo de declaración errónea",
    trialBalance: "Balance de prueba",
    period: "Período",
    accountNumber: "Número de cuenta",
    accountName: "Nombre de la cuenta",
    accountType: "Tipo de cuenta",
    debit: "Débito",
    credit: "Crédito",
    responseText: "Texto de respuesta",
    correctedUncorrected: "Correcto / no corregido",
    mitigatingTasks: "Tareas de mitigación",
    foundInDocument: "Encontrado en el documento",
    accountsAndAssertions: "Cuentas y Aserciones",
    misstatementID: "ID de error",
    trialBalanceID: "Identificación del balance de prueba",
    misstatementAdjustmentID: "ID de ajuste de error"
};

export const findingsDeficiencyITHeaderLabels = {
    itApplicationName: "Nombre de la aplicación de TI",
    itProcessName: "Nombre del proceso de TI",
    itControlName: "Nombre de control de TI",
    itApproachTypeName: "Tipo de enfoque de TI",
    isEffective: "Eficacia del control",
    referenceNumber: "Número de referencia",
    description: "Descripción de la deficiencia",
    deficiencyMagnitudeName: "Magnitud de la deficiencia",
    deficiencyTypeName: "Tipo de deficiencia"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
    adc: "Objeto relacionado",
    secondaryObject: "Control Relacionado / Procedimiento Sustantivo",
    taskName: "Título de la tarea",
    taskDescription: "Descripción de la tarea",
    taskTypeColumn: "Tipo de tarea",
    taskStatusValue: "Estado de la tarea",
    rationaleForRejection: "Razón del rechazo",
    engagementPhase: "Fase de compromiso",
    milestone: "Hito",
    periodName: "Fase de tiempo",
    assignedTo: "Asignado a",
    engagementTagGroupName: "Grupo de etiquetas",
    engagementTagName: "Etiquetas",
    displayedOn: "Vista mostrada en",
    documentName: "Nombre del documento",
    preparersValue: "Preparadores (fecha en UTC)",
    reviewersValue: "Revisores (fecha en UTC)",
    openReviewNotes: "Abrir notas de revisión",
    closedReviewNotes: "Notas de revisión borradas",
    trackChangesValue: "Control de cambios",
    lastModifiedBy: "Ultima modificacion por",
    lastModifiedDateValue: "Últimas fechas de modificación (en UTC)",
    taskID: "ID de la tarea",
    timephaseID: "ID de fase temporal",
    taskTypeID: "ID del tipo de tarea",
    documentTypeID: "ID del tipo de documento",
    parentDocumentTypeID: "ID de tipo de documento principal",
    timePhaseTypeID: "ID de tipo de fase de tiempo"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
    sectionName: "Sección",
    gaInstructionName: "Título de la instrucción",
    gaInstructionDescription: "Descripción de la instrucción",
    documents: "Nombre del documento",
    knowledgeInstructionName: "Título de la instrucción de conocimiento",
    knowledgeInstructionDescription: "Descripción de la instrucción de conocimiento",
    gaScopeName: "Ámbitos/Subámbitos relacionados",
    componentOnly: "Alcance / Instrucción Individual",
    shortName: "Nombre de región/componente",
    cSection: "Sección personalizada",
    customInstruction: "Instrucción personalizada",
    gAinstructionID: "ID de instrucción de GA"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
    primaryEngagementID: "ID de compromiso",
    gaScopeID: "ID de alcance de GA",
    gaScopeName: "Alcance",
    gaComponentID: "ID de componente de GA",
    shortName: "Nombre del componente",
    lastPublishedDateInUTC: "Última fecha de publicación",
    lastSentDateInUTC: "Fecha del último envío",
    gaLinkStatusId: "Estado del enlace",
    gaInstructionStatusId: "Estado de la instrucción"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
    engagementID: "ID de compromiso",
    gaScopeID: "ID de alcance de GA",
    gaScopeName: "Alcance",
    gaComponentID: "ID de componente de GA",
    shortName: "Nombre del componente",
    gaLinkStatusId: "Estado del enlace",
    accountID: "ID de cuenta",
    accountName: "Nombre de la cuenta",
    accountType: "Designación de cuenta",
    activityTypeID: "Id. de tipo de actividad",
    activityTypeText: "Tipo de actividad",
    modifyDateInUTC: "Modificar fecha",
    modifyUser: "Modificar usuario",
};

export const AccountDisclosuresReportHeadeLabels = {
    engagementID: "ID de compromiso",
    accountID: "ID de cuenta",
    accountName: "Nombre de la cuenta",
    accountTypeID: "ID de tipo de cuenta",
    accountTypeId: "Designación de cuenta",
    knowledgeAssertionId: "Abreviatura de aseveración",
    inherentRiskTypeId: "Evaluación de riesgos inherentes",
    controlRiskTypeId: "Evaluación de riesgos de control",
    craValue: "CRA",
    riskID: "ID del riesgo",
    riskTypeID: "ID de tipo de riesgo",
    riskType: "Tipo de riesgo",
    riskName: "Nombre del riesgo",
    isHigherRiskValue: "Es un riesgo mayor",
};

// CRA summary
export const craSummaryReportHeaderLabels = {
    accountName: "Cuenta",
    accountTypeName: "Tipo de cuenta",
    rationale: "Razón",
    pspIndex: "índice PSP",
    conclusionStatement: "Estado de conclusión de cuenta",
    scotName: "SCOTs",
    transactionType: "Tipo de transacción",
    strategyTypeName: "estrategia SCOT",
    wcgwName: "WCGW",
    controlName: "Control",
    controlFrequencyTypeName: "Frecuencia",
    controlTypeName: "Tipo de control",
    testing: "Pruebas",
    operatingEffectiveness: "Eficacia operativa",
    itApplicationName: "Aplicación SCOT TI/ SO",
    controlITApplication: "Aplicación de control de TI/SO"
};

export const craSummaryAssertionReportHeaderLabels = {
    accountName: "Cuenta",
    accountTypeName: "Tipo de cuenta",
    rationale: "Razón",
    pspIndex: "índice PSP",
    assertionAbbreviation: "Aserción",
    riskName: "Riesgo",
    inherentRiskTypeName: "Evaluación del riesgo inherente",
    controlRiskTypeName: "Evaluación de riesgos de control",
    craValue: "CRA",
    wcgwName: "WCGW",
    controlName: "Control",
    controLFrequencyTypeName: "Frecuencia",
    controlTypeName: "Tipo de control",
    testing: "Pruebas",
    isLowerR: "Es menor riesgo",
    operatingEffectiveness: "Eficacia operativa",
    itApplicationName: "Aplicación de TI / SO"
};

export const craSummaryDataReportHeaderLabels = {
    wcgwName: "WCGW",
    controlName: "Control",
    controLFrequencyTypeName: "Frecuencia de control",
    controlTypeName: "Tipo de control",
    itApplicationName: "Aplicación IT",
    assertionName: "Aseveración",
    statementTypeName: "Tipo de instrucción",
    accountTypeName: "Tipo de cuenta",
    assertionAbbreviation: "Abreviatura de aseveración",
    inherentRiskTypeName: "Riesgo inherente",
    controlRiskTypeName: "Control de riesgo",
    craValue: "CRA",
    riskTypeAbbreviation: "Abreviatura de riesgo",
    frequency: "Frecuencia",
    accountName: "Cuenta",
    riskName: "Riesgo",
    pspIndex: "Índice PSP",
    testing: "Pruebas",
    operatingEffectiveness: "Efectividad operativa",
    isLowerRiskColumn: "Es de menor riesgo",
    scotName: "SCOT",
    controlitApplicationName: "Aplicación de Control IT",
    rationale: "Justificación",
    accountID: "ID de cuenta",
    riskID: "ID del riesgo",
    scotid: "ID de SCOT",
    wcgwid: "ID WCGW",
    controlID: "ID de Control",
    itApplicationID: "ID de aplicación IT",
    knowledgeAssertionID: "Id. de aseveración de conocimiento",
    controlTypeID: "Id. de tipo de control",
    controlFrequencyTypeID: "ID de tipo de frecuencia de control",
    accountTypeID: "ID de tipo de cuenta",
    riskTypeID: "ID de tipo de riesgo",
    inherentRiskTypeID: "ID de tipo de riesgo inherente",
    controlRiskTypeID: "ID de tipo de riesgo de control",
    statementTypeID: "ID de tipo de instrucción",
    conclusionStatement: "Estado de conclusión de la cuenta"
};

export const reportingRequestsAndTasks = {
    requestTitle: "Título de la solicitud/tarea",
    request_Description: "Descripción de la solicitud/tarea",
    type: "Tipo",
    tasks: "Título de la tarea",
    engagementTagName: "Etiquetas",
    eyAssigned: "EY usuario asignado",
    clientGroupName: "Grupo externo",
    externalAssignedUser: "Usuario asignado externo",
    periodName: "Fase de tiempo",
    dueDateInUTC: "Fecha de vencimiento (en UTC)",
    requestStatus: "Estado de solicitud/tarea",
    documentType: "Tipo de Documento",
    documentName: "Nombre del documento del año en curso",
    priorYearDocumentName: "Nombre del documento del año anterior",
    externalDocumentSignOffInUTC: "Firmas de documentos externos (en UTC)",
    clientRequestReferenceNumber: "Número de referencia de la solicitud del cliente"
};

export const reportingRequestComment = {
    requestTitle: "Título de la solicitud/tarea",
    request_Description: "Descripción de la solicitud/tarea",
    type: "Tipo",
    tasks: "Título de la tarea",
    engagementTagName: "Etiquetas",
    eyAssigned: "EY usuario asignado",
    clientGroupName: "Grupo externo",
    externalAssignedUser: "Usuario asignado externo",
    periodName: "Fase de tiempo",
    dueDateInUTC: "Fecha de vencimiento (en UTC)",
    requestStatus: "Estado de solicitud/tarea",
    externalDocumentSignOffInUTC: "Firmas de documentos externos (en UTC)",
    annotationTextData: "Comentarios",
    createDateInUTC: "Fecha de comentarios (en UTC)",
    annotationUserInitials: "Comentado por"
};

export const reportingAllDocuments = {
    documentName: "Nombre del documento",
    fileExt: "Extensión de archivo",
    canvasFormType: "Tipo de formulario Canvas",
    docType: "Tipo de Documento",
    confidentiality: "Confidencialidad",
    docFileSize: "Tamaño del archivo (KB)",
    preparers: "Preparadores (en UTC)",
    reviewers: "Revisores (en UTC)",
    relatedTask: "Tareas relacionadas",
    openReviewNote: "Abrir notas de revisión",
    clearedReviewNote: "Notas de revisión borradas",
    trackChanges: "Control de cambios",
    hiddenSheets: "Hojas ocultas",
    comments: "Comentarios",
    highlighted: "Reflejos",
    conflicted: "Conflictos",
    docModifyUser: "Ultima modificacion por",
    docModifyDateInUTC: "Última fecha de modificación (en UTC)",
    documentID: "ID del documento"
};

export const signOffDocuments = {
    documentName: "Nombre del documento",
    fileExt: "Extensión de archivo",
    canvasFormType: "Tipo de formulario Canvas",
    docType: "Tipo de Documento",
    confidentiality: "Confidencialidad",
    docFileSize: "Tamaño del archivo (KB)",
    docModifyUser: "Ultima modificacion por",
    docModifyDateInUTC: "Última fecha de modificación (en UTC)",
    signOffDate: "Fecha de firma (en UTC)",
    signedOffBy: "Firmado por",
    role: "Role",
    preparerReviewer: "Preparador / revisor"
};

export const reportingDocumentsModified = {
    documentName: "Nombre del documento",
    lastModifiedDateInUTC: "Última fecha de modificación (en UTC)",
    lastModifiedUser: "Último usuario modificado",
    reason: "Razón",
    documentChangeComment: "Razón",
    preparersInUTC: "Preparadores (en UTC)",
    reviewersInUTC: "Revisores (en UTC)",
    approver: "Aprobaciones (en UTC)"
};

export const reportingDeletedTaskReport = {
    taskNamePrefix: labels.taskPrefix,
    taskName: "Título de la tarea",
    taskNameSuffix: labels.taskSuffix,
    taskDescription: "Descripción de la tarea",
    taskTypeAbbreviation: "Tipo de tarea",
    taskSourceType: "Fuente de la tarea",
    taskNatureType: "Naturaleza de la tarea",
    last_Modified_By: "Ultima modificacion por",
    modifyDateInUTC: "Última fecha de modificación (en UTC)",
    oldTaskName: "Título de la tarea heredada",
    oldTaskDetail: "Descripción de la tarea heredada"
};

export const SEMReportHeaderLabel = {
    accountAssertion: "Cuenta/Aserción",
    craValue: "CRA",
    riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
    relatedRisks: "Riesgos relacionados",
    taskType: "Tipo de tarea",
    taskTitle: "Título de la tarea",
    taskSource: labels.source,
    taskNature: labels.nature,
    taskTypeID: "ID del tipo de tarea",
    taskSourceTypeID: "ID de tipo de fuente de tarea",
    taskNatureTypeID: "ID de tipo de naturaleza de tarea"
}

export const MilestonesReportHeaderLabels = {
    taskName: labels.repTaskTitle,
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    auditPhase: labels.auditPhasesLabel,
    periodName: labels.timephase,
    timephase: "Hito actual",
    correctTimephase: "Hito correcto"
}

export const MilestonesReportHeader = {
    milestone: "Hito",
    status: "Estado del hito",
    taskStatus: "Estado de la tarea",
    taskTitle: "Título de la tarea",
    taskTypeAbbreviationColumn: "Abreviatura del tipo de tarea",
    taskType: "Tipo de tarea",
    timePhase: "Fase de tiempo",
    assignedTo: "Asignado a",
    taskName: "Nombre de la tarea",
    task_Detail: "Detalle de la tarea",
    due_Date: "Fecha de vencimiento",
    documentName: "Nombre del documento",
    preparers: "Preparadores",
    reviewers: "Revisores",
    tagGroup: "Grupo de etiquetas",
    tags: "Etiquetas",
    engagementID: "ID de compromiso",
    taskID: "ID de tarea",
    taskTypeID: "ID de tipo de tarea",
    taskStatusID: "ID de estado de la tarea",
    timephaseID: "Id. de fase de tiempo",
    timephaseTypeID: "Id. de tipo de fase de tiempo",
    documentID: "ID del documento"
}

export const groupStructureSummaryReportHeaderLabels = {
    gaScopeName: "Descripción del alcance",
    gaScopeDescription: "Nombre de ámbito/subámbito",
    shortName: "Nombre de región/componente",
    legalName: "Nombre legal",
    gaRoleTypeName: "Rol de grupo",
    relatedRegion: "Región relacionada",
    pocText: "Punto de contacto",
    gaLinkStatusName: "Estado del enlace",
    gaInstructionStatusName: "Estado de instrucción",
    engagementID: "ID de compromiso",
    gaRoleTypeID: "GARoleTypeID",
    gaLinkStatusID: "GALinkStatusID",
    gaInstructionStatusID: "GAInstructionStatusID"
}

export const collaborationSummary = {
    clientRequestID: "Número de solicitud",
    requestTitle: "Título",
    requestType: "Tipo",
    engagementTagName: "Etiquetas",
    clientUser: "Asignado a",
    clientEmail: "correo electrónico del cliente",
    clientStatusName: "Estado",
    isOverDue: "Atrasado",
    dueDateInUTC: "Fecha de vencimiento (en UTC)",
    eySentDateInUTC: "Fecha de envío de EY (en UTC)",
    eyReceivedDateInUTC: "Fecha de recepción (en UTC)",
    deliveredLate: "Entregado tarde",
    daysLate: "Dias de retraso",
    timesReturned: "Tiempos devueltos"
}

export const collaborationActivity = {
    clientRequestID: "Número de solicitud",
    requestTitle: "Título",
    requestType: "Tipo",
    engagementTagName: "Etiquetas",
    clientUser: "Asignado a",
    clientEmail: "correo electrónico del cliente",
    clientStatusName: "Estado",
    isOverDue: "Atrasado",
    dueDateInUTC: "Fecha de vencimiento (en UTC)",
    eySentDateInUTC: "Fecha de envío de EY (en UTC)",
    eyReceivedDateInUTC: "Fecha de recepción (en UTC)",
    deliveredLate: "Entregado tarde",
    daysLate: "Dias de retraso",
    timesReturned: "Tiempos devueltos",
    activity: "Actividad",
    activityDateInUTC: "Fecha de actividad (en UTC)",
    historicalDueDateInUTC: "Fecha de vencimiento histórica (en UTC)"
}

export const groupReportHeaderLabels = {
    gaInstructionName: "Nombre de instrucción",
    gascopeTypeIDName: labels.scope,
    componentName: "Nombre del componente",
    pointOfContact: labels.pointOfContact,
    dueDateValue: "Fecha de vencimiento (en UTC)",
    overdueValue: labels.overdueLabel,
    gaStatusIdName: labels.status,
    documentName: labels.documents,
    createDateValue: "Fecha de firma (en UTC)",
    signoffBy: labels.signedOffBy,
    engagementRoleIDName: labels.role,
    isPreparerText: "Preparador / revisor",
    documentID: "ID del documento",
    gaStatusID: "ID de estado de GA",
    engagementRoleID: "ID de rol de compromiso"
}

export const wcgwSummaryHeaders = {
    wcgwName: "WCGW",
    scotName: "SCOT",
    controlName: "Controles relacionados",
    itApplications: "Aplicación de TI relacionada/SO",
    testing: "Selección de pruebas",
    isLowerR: "Es Menor Riesgo",
    controlFrequencyTypeName: "Frecuencia de control",
    controlTypeName: "Tipo de control",
    wcgwCount: "Recuento de otros WCGW relacionados"
}

export const allControlsHeaders = {
    engagementID: "ID de Compromiso",
    scotid: "ID de SCOT",
    controlID: "ID de Control",
    scotName: "Nombre de SCOT",
    controlName: "Descripción del Control",
    hasControlTesting: "Selección de pruebas",
    isLowerRisk: "Es de menor riesgo",
    controlTypeID: "Tipo de Control",
    relatedITApplicationNames: "Aplicación de IT/SO relacionada",
    responsiveToSR: "Respuesta a un Riesgo Significativo",
    IPE: "IPE"
}


export const qualityChecksHeaders = {
    itemID: "ID del artículo",
    itemName: "Nombre del artículo",
    qualityChecks: "Control de calidad",
    validationDescription: "Descripción de la validación",
    buildGroup: "Grupo de compilación",
    impactedItem: "Elemento afectado",
    type: "Tipo"
}

export const statisticsHeaders = {
    scotname: "SCOT",
    strategyTypeId: "Estrategia SCOT",
    wcgwName: "WCGW",
    controlName: "Control",
    operatingEvaluation: "Evaluación operativa",
    itApplicationName: "Aplicación de IT relacionada / SO",
    assertions: "Aseveraciones",
    controlTypeId: "Tipo de control",
    testingSelection: "Selección de pruebas",
    controlFrequencyTypeId: "Frecuencia",
    itApplications: "Aplicaciones IT",
    scotTypeId: "Tipo SCOT",
    itType: "Tipo de aplicación IT",
    isLowerR: "Es de menor riesgo",
    engagementID: "ID de compromiso",
    workspaceID: "ID de espacio de trabajo",
    scotID: "ID SCOT",
    scotTypeID: "ID tipo SCOT",
    wcgwid: "ID WCGW",
    controlID: "ID Control"
}

export const CRTAssertionCountSummaryHeaders = {
    accountName: "Cuenta",
    assertion: "Aseveración",
    controlName: "Control",
    ControlTypeName: "Tipo de control",
    ControlFrequencyTypeName: "Frecuencia",
    Testing: "Pruebas",
    OperatingEvaluation: "Evaluación operativa",
    assertionControlCount: "Conteo de control de aseveración",
    assertionAbbreviation: "Abreviatura de aseveración",
    wcgwName: "WCGW",
    engagementID: "ID de compromiso",
    workspaceID: "ID de espacio de trabajo",
    assertionID: "Id. de aseveración",
    wcgwid: "ID WCGW ",
    controlID: "ID Control "
}

export const crtlistcontrolTypeName = {
    'IT Application Control': "Control de aplicaciones de IT",
    'IT Dependent Manual Control': "Control manual dependiente de IT",
    'Manual Prevent': "Prevención manual",
    'Manual Detect': "Detección manual"
}

export const controlFrequencyNameTypes = {
    'Many times per day': "Muchas veces al día",
    'Daily': "Diario",
    'Weekly': "Semanal",
    'Monthly': "Mensual",
    'Quarterly': "Trimestral",
    'Annually': "Anualmente",
    'IT Application Control': "Control de aplicaciones de IT",
    'Other': "Otro"
};

// Folder types
export const archiveFolderTypeNameTypes = {
    'Working Papers': "Documentos de trabajo",
    'Perm File Active': "Archivo permanente activo",
    'Perm File Superseded': "Archivo permanente reemplazado",
    'Working Papers - CD/DVD': "Documentos de trabajo - CD/DVD",
    'Perm File Active - CD/DVD': "Archivo permanente activo - CD/DVD",
    'Perm File Superseded - CD/DVD': "Archivo permanente reemplazado - CD/DVD",
    'Data Storage Devices': "Dispositivos de almacenamiento de datos"
};

export const operatingEvaluationType = {
    'Effective': "Efectivo",
    'Ineffective': "Inefectivo",
    'Not Selected': "No seleccionado"
};

export const CRTSCOTCountSummaryHeaders = {
    scotname: "SCOT",
    strategyTypeName: "Estrategia SCOT",
    wcgwName: "WCGW relacionados",
    controlName: "Controles relacionados",
    operatingEvaluation: "Evaluación operativa",
    itApplicationName: "Aplicación de IT relacionada / SO",
    assertions: "Aseveraciones",
    controlTypeName: "Tipo de control",
    testing: "Selección de pruebas",
    controlFrequencyTypeName: "Frecuencia",
    itApplications: "Aplicaciones IT",
    itAppType: "Tipo de aplicación de IT",
    scotTypeName: "Tipo SCOT",
    soctisLowerRisk: "Menor control de riesgos",
    engagementID: "ID de compromiso",
    workspaceID: "ID de espacio de trabajo",
    scotID: "ID de SCOT",
    scottypeid: "ID de tipo SCOT",
    wcgwid: "ID de WCGW ",
    controlID: "ID de Control"
};

export const projectInsightCanvasFormExportHeaders = {
    EngagementID: "ID de compromiso",
    DocumentID: "ID del documento",
    ControlID: "ID de Control"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
    engagementID: "ID de compromiso",
    scotName: "SCOTName",
    strategyTypeName: "StrategyTypeName (NombreTipoEstrategia)",
    wcgwName: "WCGWName",
    controlID: "ControlID",
    controlName: "ControlName",
    controlFrequencyTypeName: "ControlFrequencyTypeName",
    controlTypeName: "ControlTypeName",
    isLowerRiskHeader: "IsLowerRisk",
    hasControlTestingHeader: "HasControlTesting",
    operativeEffectiveness: "Efectividad Operativa"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
    engagementId: "ID de compromiso",
    accountId: "ID de cuenta",
    accountName: "Nombre de la cuenta",
    accountTypeId: "ID de tipo de cuenta",
    accountDesignation: "Designación de cuenta",
    pspIndexTitle: "Índice PSP",
    knowledgeAssertion: "Abreviatura de aseveración",
    inherentRiskType: "Evaluación de riesgos inherentes",
    controlRiskType: "Evaluación de riesgos de control",
    craValue: "CRA",
    riskId: "Identificación del riesgo",
    riskTypeId: "ID de tipo de riesgo",
    riskTypeEnum: "Tipo de riesgo",
    riskName: "Nombre del riesgo",
    isHigherRiskText: "Es de mayor riesgo",
    rejectedTaskId: "ID de tarea",
    rejectedTaskName: "PSP rechazado",
    rejectedTaskRationale: "Justificación de PSP rechazada"
};

export const projectInsightControlToITApplicationHeaders = {
    engagementID: "EngagementID (Identificación de compromiso)",
    controlID: "ControlID",
    itApplicationID: "ITApplicationID",
    controlITApplication: "ControlITApplication"
};

export const projectInsightControlToAssertionHeaders = {
    engagementID: "EngagementID (Identificación de compromiso)",
    controlID: "ControlID",
    Accountname: "AccountName (Nombre de la cuenta)",
    AssertionAbbreviation: "Abreviatura de aseveración"
};

export const projectInsightRisksToWCGWsHeaders = {
    engagementId: "EngagementID (Identificación de compromiso)",
    accountName: "AccountName (Nombre de la cuenta)",
    accountId: "ID de cuenta",
    knowledgeAssertion: "Aseveración",
    CRA: "CRA",
    RelatedRisk: "RelatedRisk (Riesgo relacionado)",
    riskId: "Identificación de riesgo",
    riskType: "Tipo de riesgo",
    WCGW: "WCGW",
    wcgwId: "WCGWID",
    RelatedSCOT: "SCOT Relacionado",
    scotId: "SCOTID"
};

export const ipeControlsHeaders = {
    EngagementID: "ID de compromiso",
    DocumentID: "ID del documento"
};

export const ipeSubstantiveHeaders = {
    EngagementID: "ID de compromiso",
    DocumentID: "ID del documento"
};

export const ipeITGCHeaders = {
    EngagementID: "ID de compromiso",
    DocumentID: "ID del documento"
};

export const iTAppSOReport = {
    relatedITSO: "Aplicación de IT/SO relacionada",
    iTAppType: "Tipo de aplicación de IT",
    iTAppControl: "Control de aplicaciones de IT",
    testingSelection: "Selección de pruebas",
    relatedSCOTs: "SCOTs relacionados",
    relatedSCOTStrategy: "Estrategia SCOT relacionada",
    itdm: "ITDM",
    manualPrevent: "Prevención manual",
    manualDetect: "Detección manual",
    noRelatedControls: "No hay controles relacionados",
    controlsStatistics: "Controles por tipo",
    relatedSCOTType: "Tipo de SCOT relacionado",
    controlType: "Tipo de control",
    grandTotal: "Total",
    yes: "Sí",
    no: "No",
    notSelected: "No seleccionado",
    controls: "Controles",
    substantive: "Sustantivo",
    routine: "Rutinario",
    nonRoutine: "No rutinario",
    estimation: "Estimación"
};

export const IndependenceSummaryReport = {
    id: "ID (Identificación)",
    userName: "Nombre de usuario",
    order: "Orden",
    questionFormatted: "Pregunta",
    answer: "Respuesta",
    actionTypeID: "ID de tipo de acción",
    independenceStatusID: "ID de estado de independencia",
    EngagementUserStatusName: "Estado del usuario del compromiso",
    engagementUserStatusID: "ID de estado de usuario del compromiso",
    IndependenceStatusName: "Estado de Independencia",
    requiresExecutiveClearance: "Requiere autorización ejecutiva"
};

export const additionalInfoBasedOnValidationTypeId = {
	1: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    2: "El equipo no está utilizando la versión más actualizada del formulario 109 - Independencia de los miembros del equipo",
    3: "Un miembro del equipo cambió su rol desde un rol de PPEDD después de otorgar acceso a otro miembro del equipo con un asunto de independencia",
    4: "Un miembro del equipo cambió su rol desde un rol de PPEDD después de anular a otro miembro del equipo con un asunto de independencia",
    5: "Haga clic en el enlace de validación, identifique el SCOT que no tiene ninguna insignia de número al lado. Relacionar el SCOT con una cuenta",
	6: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    7: "Identifique el SCOT donde el recuento de WCGW relacionado está en blanco. Desplácese hasta la tarea de compilación correspondiente. Expanda el SCOT y agregue WCGW según corresponda",
    8: "Identifique el SCOT donde el recuento de controles relacionado está en blanco. Desplácese hasta la tarea de compilación correspondiente. Expanda el SCOT y agregue un control a los WCGW",
    9: "Identifique el SCOT con la validación, expanda los detalles de SCOT y verifique que al menos un control por WCGW haya seleccionado Sí para la prueba",
    10: "Identifique el SCOT con la validación, expanda los detalles de SCOT. Verifique que al menos un control por WCGW haya seleccionado Sí para la prueba",
    11: "Haga clic en el enlace de validación, identifique el Riesgo que no tiene una insignia de número al lado. Relacionar la afirmación apropiada con el riesgo",
    12: "Identifique la afirmación que carece de un riesgo inherente y/o de control. Complete el campo que falta",
    13: "Haga clic en el enlace de validación y abra el cajón Agregar WCGW. Seleccione un SCOT a la vez e identifique los WCGW que no tienen una insignia de número al lado. Relacionar el WCGW con la afirmación apropiada",
    14: "Identifique la cuenta que no tiene ninguna insignia de número junto a ella. Navegue hasta el flujo de compilación de SCOTs y relacione el SCOT con una cuenta",
    15: "Identifique la cuenta / aserción con la validación, haga clic en el botón Agregar WCGW y relacione el WCGW con la aserción",
    16: "Esta comprobación de validación verifica que todos los WCGW relacionados con una aserción con una estrategia de controles están cubiertos por un control que se probará. Identifique la aserción con la validación, haga clic en el botón Agregar WCGW y relacione el WCGW con la aserción",
    17: "Revise cada WCGW asociado a una aserción y compruebe que está cubierto por al menos un control que tiene una estrategia de prueba de Sí",
    18: "Todos los WCGW de una aserción con una estrategia Rely deben estar cubiertos por un control con un valor de prueba establecido en Sí",
    19: "Un IT/SO tiene una Estrategia de Confianza que no se elimina ni se relaciona con un Proceso IT/SO",
    20: "Un procedimiento sustantivo de IT/control de IT/IT no está relacionado con un riesgo de IT/SO",
    21: "Un cambio en la estrategia de Confiar a No Confiar después de crear el proceso de IT/SO",
    22: "Un riesgo no está relacionado con una aseveración",
    23: "Un procedimiento Sustantivo o Control de IT/SO no se encuentra relacionado a un riesgo de IT/SO",
    24: "Un procedimiento sustantivo o control de IT/SO relacionado con un riesgo de IT/SO no se selecciona para la prueba",
    25: "Un procedimiento Sustantivo o Control de IT/SO no se encuentra relacionado a un riesgo de IT/SO",
    26: "Identifique la cuenta de riesgo limitado que no tiene ninguna tarea. Agregar uno o más OSP",
    27: "Compruebe que ha importado PSP. Si no se han importado PSP, haga clic en importar PSP. Si no hay PSP para la aserción, cree un OSP",
    28: "Navegue hasta el flujo de compilación de SCOTs, abra el cajón Agregar prueba de control, identifique la tarea de TOC que no tiene ninguna insignia de número junto a ella. Relacionar la tarea de TOC con el control",
    29: "El compromiso contiene al menos una tarea de recorrido que aún no se ha asociado a un SCOT",
    30: "Un SCOT no tiene al menos una tarea de recorrido asociada",
    31: "Navegue hasta el flujo de compilación de SCOTs, abra el cajón Agregar prueba de control, identifique la tarea TOC que no tiene ninguna insignia de número junto a ella. Relacionar la tarea de TOC con el control",
    32: "Un recorrido de IT/SO no está relacionado con al menos un proceso de IT/SO",
    33: "Una prueba de control de TI/SO no está relacionada con al menos un procedimiento sustantivo/de control de TI/SO con un valor de prueba establecido en Sí",
    34: "Otro procedimiento sustantivo de IT/OS no está relacionado con al menos un procedimiento sustantivo o de control de IT/SO con un valor de prueba establecido en Sí",
    35: "Un proceso de IT/SO no tiene al menos una tarea de recorrido asociada",
    36: "Un control con un valor de prueba establecido en Sí no tiene ninguna tarea de prueba de control asociada",
    37: "Otro procedimiento sustantivo de IT/SO no está relacionado con al menos un procedimiento sustantivo o de control de IT/SO con un valor de prueba establecido en Sí",
    38: "Haga clic en el enlace de validación, en la lista Evidencia haga clic en el icono de conflicto para resolver el conflicto",
	39: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	40: 'Haga clic en el enlace de validación, desde la lista de pruebas Firma en los documentos a los que falta una firma de preparador o revisor. Solo firma los archivos que haya preparado o revisado',
	41: 'Haga clic en el enlace de validación, desde la lista de tareas filtradas revise cada tarea y asocie los archivos de evidencia apropiados',
	42: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	43: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	44: 'Haga clic en el enlace de validación, de la lista Evidencia cambie el nombre de los documentos con nombres duplicados',
	45: 'La evaluación del proceso de IT no ha sido seleccionada o es inconsistente con las evaluaciones de efectividad operativa del ITCG/ITSP',
	46: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    47: "No se ha seleccionado la evaluación de IT agregada para uno o varios de los controles de aplicación/ITDM",
    48: "El formulario Canvas tiene al menos un campo que no se ha completado",
    49: "Haga clic en el enlace de validación y luego haga clic en Agregar aserción para relacionar la aserción o la cuenta de riesgo limitado",
    50: "Tarea que no tiene ninguna aserción o cuenta de riesgo limitado asociada. Haga clic en Agregar aserción para asociar una cuenta de aserción o riesgo limitado",
    51: "Una WCGW no ha sido relacionada con una tarea sustantiva",
    52: "El compromiso tiene al menos un riesgo inherente, significativo o de fraude que no está asociado a al menos una WCGW",
    53: "Cuenta de estimación a la que le falta el índice de estimaciones de contabilidad EST. Agréguelo desde la lista de índices de PSP.",
    54: "Identifique la(s) cuenta(s) que tiene una estimación y abra la cuenta para ver si tiene una estimación SCOT relacionada con ella. Una vez que identifique la(s) cuenta(s) a la(s) que le falta(n) el SCOT estimado, deberá relacionar el SCOT estimado.",
    55: "Identifique el SCOT de estimación que no está relacionado con una cuenta de estimación. Una vez que identifique el SCOT estimado que falta en la cuenta estimada, deberá relacionar el SCOT estimado con la cuenta estimada.",
    56: "Un riesgo significativo o de fraude debe tener al menos un procedimiento sustantivo, un control y una tarea de prueba de control (si corresponde)",
    57: "Un riesgo significativo o de fraude debe tener al menos un procedimiento sustantivo, un control y una tarea de prueba de control (si corresponde)",
    58: "Haga clic en el riesgo con la validación y expanda la afirmación. Comprobar que al menos una tarea tiene seleccionada la opción Sí",
    59: "Haga clic en el riesgo con la validación y expanda la afirmación. Compruebe que al menos un control tiene seleccionado Sí. La efectividad del diseño también debe completarse para el control",
    60: "Haga clic en el enlace de validación Resolver comentarios de formulario Canvas. Abra cada formulario de Canvas y seleccione mostrar comentarios no resueltos. Todos los comentarios deben ser borrados o cerrados",
    61: "Haga clic en el enlace de validación Finalizar respuestas de formulario de Canvas incompletas. Abra cada formulario de Canvas y seleccione mostrar respuestas incompletas. Todas las preguntas del formulario de Canvas deben completarse",
    62: "Haga clic en el enlace de validación, revise los comentarios abiertos y borre o cierre todos los comentarios abiertos.",
	63: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	64: 'Haga clic en el enlace de validación, desde la lista de tareas filtradas revise cada tarea y marque las tareas abiertas como completadas',
	65: 'Haga clic en el botón desvincular todo para desvincular toda la evidencia compartida',
	66: 'El modelo 440 tiene al menos un documento sin un motivo de cambio seleccionado',
	67: 'El Formulario 440 tiene al menos un documento con una razón "no administrativa" para el cambio seleccionada que no tiene la justificación completada',
	68: 'El Formulario 440 tiene al menos un documento con una razón "no administrativa" para el cambio seleccionada que no ha sido aprobada por un gerente o superior',
	69: 'El modelo 440 no ha sido firmado ni por el socio del encargo ni por el socio responsable',
	70: 'Haga clic en el botón desvincular del grupo en la lista de verificación del archivo',
	71: 'Un formulario de Canvas no tiene encabezados ni contenido estándar',
	72: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	73: 'Haga clic en el icono de verificación de validación en el formulario Canvas para ver el número de respuestas incompletas',
	74: 'Haga clic en el enlace y envíe la versión actualizada del Engagement Profile.smt',
	75: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	76: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	77: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	78: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	79: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	80: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	81: 'Identificar los procesos de TI y relacionarlos con las aplicaciones de TI',
	82: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	83: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	84: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	85: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	86: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	87: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	88: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	89: 'La evaluación del proceso de TI no ha sido seleccionada o es inconsistente con las evaluaciones de efectividad operativa del ITCG/ITSP',
	90: 'Al control le falta una selección de la eficacia del diseño',
	91: 'Ver los SCOT y las aplicaciones informáticas relacionadas relevantes para la auditoría',
	92: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	93: 'Utilice la guía paso a paso del habilitador "Cómo documentar el flujo de TI en EY Canvas" para resolver esta validación',
	94: 'Utilice la guía paso a paso del habilitador "Cómo documentar el flujo de TI en EY Canvas" para resolver esta validación',
	95: "Un compromiso no tiene ningún miembro específico del equipo identificado como la persona a cargo en Administrar equipo",
	96: "Un factor de riesgo no está relacionado con un riesgo o no está marcado como 'No es un ROMM'",
    97: "Un riesgo no está relacionado con una aserción",
    98: "Es necesario introducir un importe en la base de previsión",
    99: "Es necesario introducir una justificación para la base de previsión",
    100: "Es necesario introducir una cantidad en la base ajustada",
    101: "No se ha seleccionado el porcentaje de materialidad de la planificación",
    102: "El porcentaje de materialidad de la planificación está fuera del rango permitido",
    103: "Es necesario introducir una justificación para el porcentaje de materialidad de planificación seleccionado",
    104: "No se ha introducido el error tolerable",
    105: "El porcentaje de error tolerable está fuera del rango permitido",
    106: "Es necesario introducir una justificación para el porcentaje de error tolerable seleccionado",
    107: "No se ha seleccionado el porcentaje de DUA",
    108: "El porcentaje de SAD está fuera del rango permitido",
    109: "Es necesario introducir una justificación para el porcentaje de DUA seleccionado",
	110: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	111: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	112: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	113: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	114: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	115: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	116: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	117: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	118: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	119: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	120: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	121: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	122: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	123: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	124: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	125: 'Los documentos protegidos no deben conservarse en los archivos de compromiso a menos que sea necesario',
	126: 'Eliminar el documento y volver a cargarlo',
	127: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	128: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	129: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	130: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    131: "Navegue hasta el formulario de listado de presupuestos y use la opción 'Crear documento' allí",
	132: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	133: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	134: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	135: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	136: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	137: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	138: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	139: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	140: 'Utilice la guía paso a paso del habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	141: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	142: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	143: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	144: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	145: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	146: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	147: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
	148: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    149: "Haga clic en el enlace de validación Finalizar respuestas de formulario de Canvas incompletas. Abra cada formulario de Canvas y verifique que todos los documentos requeridos asociados a los requisitos tengan la firma del PIC/EQR relacionada. Solo firme los archivos que haya preparado o revisado.",
    150: "Haga clic en el enlace de validación Finalizar respuestas de formulario de Canvas incompletas. Abra cada formulario de Canvas y verifique que todos los documentos requeridos asociados a los requisitos tengan el requisito de aprobación de PIC/EQR relacionado en los documentos.",
    151: "Verifique que todas las cuentas y divulgaciones significativas tengan al menos una aseveración.",
    152: "Abra cada formulario de Canvas y verifique que todos los documentos requeridos asociados a los requisitos tengan firmas de Preparador y Revisor. Solo firme los archivos que haya preparado o revisado.",
    153: 'Navegue hasta el ajuste y use la opción "Agregar evidencia" para asociar la evidencia adecuada',
    154: "Navegue hasta el documento de estimación y compruebe allí que las estimaciones de mayor o menor riesgo tienen una cuenta de estimación relacionada. Las estimaciones de riesgo muy bajo deben tener al menos una cuenta relacionada.",
    155: "Navegue hasta el documento de estimación y verifique allí las cuentas relacionadas. Sobre la base de la documentación de auditoría, desvincule la cuenta no estimativa o modifíquela a una cuenta estimativa.",
    156: "Navegue hasta el documento de estimación y verifique las respuestas allí.",
    157: "Navegue hasta el documento de estimación y verifique allí que las estimaciones de riesgo más alto / menor tengan un SCOT de estimación relacionado. Las estimaciones de riesgo muy bajo deben tener al menos un SCOT relacionado.",
    158: "Navegue hasta el documento de cuenta y verifique que haya al menos una estimación de riesgo más alta o más baja relacionada.",
    159: "Navegue hasta el documento de cuenta y verifique que haya al menos una estimación de riesgo más alta o más baja relacionada.",
    160: "Navegue hasta la hoja de prospecto de estimación para identificar los SCOT de estimación que no tienen ninguna estimación relacionada. Sobre la base de la documentación de auditoría, modificar esos SCOT para que no sean una estimación o relacionar las estimaciones con esos SCOT",
    161: "Vaya al ajuste y verifique que la suma de los asientos de débito sea igual a la suma de los asientos de crédito.",
    162: "Navegue hasta el documento de estimación y c y verifique que haya al menos un riesgo significativo o de fraude relacionado.",
    163: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    164: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    165: 'Utilice la guía paso a paso en el habilitador "Cómo borrar las comprobaciones de validación en EY Canvas" para resolver esta validación',
    166: "Navegue hasta el documento de estimación y verifique los riesgos relacionados. En función de la documentación de auditoría, desvincule el riesgo significativo/fraude o actualice la categoría de estimación a mayor riesgo."
};

export const validationChecksReportHeaderLabels = {
    validationType: "Tipo de validación",
    validationDescription: "Descripción de la validación",
    itemName: "Nombre del artículo",
    auditPhase: "Fase de auditoría",
    additionalInformation: "Información adicional",
    localization: "Localización",
    itemType: "Tipo de artículo",
    location: labels.location,
    count: "Contar",
    validationCount: "Recuento de validaciones",
    itemID: "ID del artículo",
    validationTypeID: "ID de tipo de validación",
    category: "Categoría",
    auditPhaseID: "ID de fase de auditoría",
    entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
    annotationID: "ID de anotación",
    assignToUserID: "Asignado a ID de usuario",
    assignedtoUser: labels.assignedTo,
    createUserID: "ID de autor",
    createdBy: "Autor",
    createdDate: "Creado el",
    dueDateLabel: "Fecha de vencimiento",
    relatedEvidence: "Evidencia relacionada",
    reviewNote: labels.reviewNotesLabel,
    lastModifiedBy: "Última modificación por",
    modifyUserID: "Modificado por ID de usuario",
    lastModifiedOnLabel: "Última modificación el",
    priorityType: labels.priorityLabel,
    annotationParentID: "ID de anotación principal",
    referenceNumber: "Referencia",
    relatedTasks: "Tarea relacionada",
    replies: labels.reply,
    reviewNoteStatus: labels.status,
    statusChangedByUserID: "Estado cambiado por ID de usuario",
    statusChangedBy: "Estado cambiado por",
    statusChangedDateLabel: "Estado cambiado por",
    startDateLabel: "Creado por primera vez (en UTC)",
    clearedDateLabel: "Última vez borrado (en UTC)",
    closedDateLabel: "Último cierre (en UTC)",
    documentTypeID: "Fecha de cambio de estado",
    childAnnotationID: "ID de tipo de documento"
};

export const taskDueDateCategoryIdLabels = {
    0: "Últimas semanas",
    1: "Semana actual",
    2: "La próxima semana",
    3: "Semanas futuras"
};

export const taskSummaryReportHeaderLabels = {
    engagementID: "ID de compromiso",
    taskID: "ID de tarea",
    displayedTaskName: labels.TaskName,
    taskNamePrefix: "Prefijo de tarea",
    taskNameSuffix: "Sufijo de tarea",
    dueDateColumn: labels.taskDueDateHeader,
    dueDateWeek: labels.dueLabel,
    assignmentType: labels.assignmentType,
    assignmentTypeID: "Id. de tipo de asignación",
    assignmentName: labels.assignmentName,
    assignmentStatus: labels.taskAssigmentStatusHeader,
    reviewNoteAssignedOpen: "Notas de revisión abiertas asignadas",
    reviewNoteAssignedCleared: "Notas de revisión borradas asignadas",
    reviewNoteAuthoredOpen: "Notas de revisión abiertas de autor",
    reviewNoteAuthoredCleared: "Notas de revisión autorizadas de autor",
    taskStatus: labels.taskStatusLabel,
    taskStatusID: "ID de estado de la tarea",
    taskType: labels.taskType,
    taskTypeID: "ID de tipo de tarea",
    milestone: labels.filterMilestoneLabel,
    milestoneID: "ID de hito",
    isOverdueColumn: labels.Overdue,
    timephaseName: labels.timephase,
    relatedObjectName: "Objeto relacionado",
    relatedEntityID: "ID de objeto relacionado",
    openAssignmentsOverdue: "Tareas abiertas: vencidas",
    openAssignmentsThisWeek: "Tareas abiertas-esta semana",
    openAssignmentsNextWeek: "Tareas abiertas: la próxima semana",
    openAssignmentsTotal: "Tareas abiertas-total",
    inProgressAssignmentsOverdue: "Asignaciones en curso-vencidas",
    inProgressAssignmentsThisWeek: "Tareas en curso-esta semana",
    inProgressAssignmentsNextWeek: "Tareas en curso: la próxima semana",
    inProgressAssignmentsTotal: "Asignaciones en curso-total"
};

export const crtControlSummaryReportHeaderLabels = {
    scotID: "SCOT ID",
    scotName: "SCOT",
    strategyTypeName: "Tipo de estrategia",
    wcgwID: "WCGW ID",
    wcgwName: "WCGW",
    controlID: "Control ID",
    controlName: "Control",
    operatingEvaluation: "Evaluación operativa",
    assertions: "Afirmaciones",
    controlTypeName: "Tipo de control",
    testingFormatted: "Selección de pruebas",
    scotStrategy: "Estrategia SCOT",
    itApplicationName: "Aplicación de TI relacionada / SO",
    controlFrequencyTypeName: "Frecuencia",
    scotTypeID: "ID de tipo SCOT",
    scotTypeName: "Tipo SCOT",
    itAppType: "Aplicación IT/SO",
    lowerRiskControl: "Menor control de riesgos"
};

export const trialBalanceReportHeaderLabels = {
    engagementID: "ID de compromiso",
    trialBalanceID: "ID de balance de comprobación",
    trialBalanceTypeID: "Id. de tipo de balance de comprobación",
    trialBalanceTypeName: "Nombre del tipo de balance de comprobación",
    financialStatementID: "ID de Estado financiero",
    financialStatementName: "Nombre del Estado financiero",
    financialStatementTypeID: "ID del Tipo de Informe financiero",
    financialStatementTypeName: "Nombre del tipo de informe financiero",
    financialStatementSubTypeID: "ID de Subtipo de Estado financiero",
    financialStatementSubTypeName: "Nombre del Subtipo de Estado financiero",
    analysisPeriodBalance: "Balance de fechas de análisis",
    comparativePeriodBalance: "Balance comparativo de fechas",
    analysisComparativeBalanceChange: "Análisis comparativo del cambio de equilibrio",
    analysisComparativeBalanceChangePercent: "Análisis comparativo del saldo porcentual de cambio",
    secondComparativePeriodBalance: "Segundo balance comparativo de fechas",
    analysisSecondComparativeBalanceChange: "Análisis: segundo cambio de balance comparativo",
    analysisSecondComparativeBalanceChangePercent: "Análisis segundo comparativo de cambio de saldo porcentual",
    parentFinancialStatementID: "ID del Estado financiero de la matriz",
    displayOrder: "Orden de visualización",
    eyCanvasAccountName: "Nombre de la cuenta de EY Canvas",
    relatedEntities: "Entidades vinculadas"
};

export const taskSourceTypes = {
    1: labels.internal,
    2: labels.external
};

export const taskNatureTypes = {
    1: labels.testOfDetail,
    2: labels.substantiveAnalyticalProcedure,
    3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
        value: 1,
        label: "Normal"
    },
    {
        value: 3,
        label: "Alto"
    },
    {
        value: 4,
        label: "Crítico"
    }
];

export const StatementType = [{
    id: 1,
    value: "Cuenta de resultados"
}, {
    id: 2,
    value: "Balance general"
}, {
    id: 3,
    value: "Ambos"
}];

export const AccountTypes = [{
        id: 1,
        accountTypeName: "Significativo"
    },
    {
        id: 2,
        accountTypeName: "Riesgo limitado"
    },
    {
        id: 3,
        accountTypeName: "Insignificante"
    },
    {
        id: 4,
        accountTypeName: "Otro"
    },
    {
        id: 5,
        accountTypeName: "Divulgaciones significativas"
    }
];

export const ITAppSOAttributes = [{
    id: 1,
    value: "Selección de pruebas"
}, {
    id: 2,
    value: "Aplicación de TI/SO relacionada"
}, {
    id: 3,
    value: "SCOTs relacionados"
}, {
    id: 4,
    value: "Estrategia SCOT relacionada"
}, {
    id: 5,
    value: "Tipo de SCOT relacionado"
}];

export const notesEditorLabels = {
    addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
    saveNoteButtonLabel: labels.saveLabel,
    messagePlaceholder: labels.addNewNoteModalTitle,
    messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
    messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
    messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
    addReplyButtonLabel: reviewNoteModalLabels?.reply,
    characters: labels.characters,
    of: labels.of,
    formRequired: labels.required,
    formMaxLength: labels.formMaxLength,
    toFieldLabel: labels.assignedTo,
    priorityFieldLabel: labels.rnhPriority,
    dueDateFieldLabel: labels.dueDate,
    voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
    stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
    cancelButtonLabel: labels.cancelButtonLabel,
    noResultsFound: labels.noResultsFound,
    microphoneBlockedMessage: labels.microphoneBlockedMessage,
    microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
    notInMainWindowVoice: labels.notInMainWindowVoice,
    notInMainWindowScreen: labels.notInMainWindowScreen,
    voiceNoteNotAvailable: "La nota de voz y la grabación de pantalla no están disponibles en la vista de cajón. Cambie a la vista de pantalla completa para usar estas funciones.",
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel,
    screenRecord: labels.screenRecord,
    playbackReview: labels.playbackReview,
    close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
    ...notesEditorLabels,
    closeButton: labels.reviewNotesModalClose,
    closed: labels.closed,
    open: labels.open,
    cleared: labels.cleared,
    allNotes: labels.allNotes,
    myNotes: labels.myNotes,
    assignedToMe: labels.assignedToMe,
    noNotesFound: reviewNoteModalLabels?.noNotesFound,
    noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
    assignedTo: labels.assignedTo,
    dueDate: labels.dueDate,
    edit: labels.edit,
    delete: labels.delete,
    clear: labels.clear,
    reopen: labels.reopen,
    close: labels.closeTitle,
    reply: labels.reply,
    confirm: labels.confirm,
    cancel: labels.cancelButtonLabel,
    deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
    deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
    deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
    deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
    showMore: reviewNoteModalLabels?.showMore,
    showLess: reviewNoteModalLabels?.showLess,
    view: labels.view,
    notSelected: labels.notSelectedText,
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
    close: "Cerrar",
    cancel: "Cancelar",
    repNoRecordMessage: "No se han encontrado resultados",
    edit: "Editar",
    delete: "Borrar",
    actions: "Acciones",
    show: "Mostrar",
    first: "Primera página",
    last: "Última página",
    prev: "Página anterior",
    next: "Página siguiente",

    [Entity.Account]: {
        manageEntity: "Administrar cuentas y divulgaciones",
        searchEntity: "Buscar cuentas",
        createEntity: "Cuenta nueva",
        entityName: "cuenta",
        entityNameCaps: "Cuenta",
        entityNamePlural: "Cuentas",
        placeholderText: "Cree nuevas cuentas y divulgaciones o edite y elimine las cuentas y divulgaciones existentes a continuación.",
        deleteConfirmLabel: "¿Estás seguro de que quieres eliminar esta cuenta? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.Estimate]: {
        manageEntity: "Gestionar estimación",
        searchEntity: "Presupuesto de búsqueda",
        createEntity: "Nueva estimación",
        entityName: "estimar",
        entityNameCaps: "Estimar",
        entityNamePlural: "Estimaciones",
        placeholderText: "Cree nuevos presupuestos o edite y elimine los presupuestos existentes a continuación.",
        deleteConfirmLabel: "¿Estás seguro de que quieres eliminar esta estimación? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.Risk]: {
        manageEntity: "Gestionar riesgos",
        searchEntity: "Riesgos de búsqueda",
        createEntity: "Nuevo riesgo",
        entityName: "riesgo",
        entityNameCaps: "Riesgo",
        entityNamePlural: "Riesgos",
        placeholderText: "Cree nuevos riesgos o edite y elimine los riesgos existentes a continuación.",
        deleteConfirmLabel: "¿Estás seguro de que quieres eliminar este riesgo? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.STEntity]: {
        manageEntity: "Gestionar entidades",
        searchEntity: "Buscar entidades",
        createEntity: "Nueva entidad",
        entityName: "entidad",
        entityNameCaps: "Entidad",
        entityNamePlural: "Entidades",
        placeholderText: "Cree nuevas entidades o edite y elimine las entidades existentes a continuación.",
        deleteEntity: "Eliminar entidad",
        deleteConfirmLabel: "¿Está seguro de que desea eliminar esta entidad? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.Control]: {
        manageEntity: "Gestionar controles",
        searchEntity: "Buscar Controles",
        createEntity: "Nuevo control",
        entityName: "control",
        entityNameCaps: "Control",
        entityNamePlural: "Controles",
        placeholderText: "Cree nuevos controles o edite y elimine los controles existentes a continuación.",
        deleteEntity: "Eliminar Control",
        deleteConfirmLabel: "¿Está seguro de que desea eliminar este control? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.SCOT]: {
        manageEntity: "Gestionar los SCOTs",
        searchEntity: "Buscar SCOTs",
        createEntity: "Nuevo SCOT",
        entityName: "SCOT",
        entityNameCaps: "SCOT",
        entityNamePlural: "SCOTs",
        placeholderText: "Cree nuevos SCOT o edite y elimine los SCOT existentes a continuación.",
        deleteEntity: "Eliminar SCOT",
        deleteConfirmLabel: "¿Estás seguro de que quieres eliminar este SCOT? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.ITApplication]: {
        manageEntity: "Administrar aplicaciones de TI",
        searchEntity: "Buscar",
        createEntity: "Nueva aplicación informática",
        entityName: "Aplicación informática",
        entityNameCaps: "Aplicación informática",
        entityNamePlural: "Aplicaciones informáticas",
        placeholderText: "Cree nuevas aplicaciones de TI o edite y elimine las aplicaciones de TI existentes a continuación.",
        deleteEntity: "Eliminar aplicación de TI",
        deleteConfirmLabel: "¿Está seguro de que desea eliminar esta aplicación informática? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.TaskSection]: {
        manageEntity: "Administrar grupos de tareas",
        searchEntity: "Buscar grupo de tareas",
        createEntity: "Nuevo grupo de tareas",
        entityName: "Grupo de tareas",
        entityNameCaps: "Grupo de tareas",
        entityNamePlural: "Grupos de tareas",
        placeholderText: "Cree un nuevo Grupo de tareas o edite y elimine el grupo de tareas existente a continuación.",
        deleteEntity: "Eliminar grupo de tareas",
        deleteConfirmLabel: "¿Está seguro de que desea eliminar el ajuste seleccionado? Esta acción no se puede deshacer."
    },
    [Entity.WCGW]: {
        manageEntity: "Administrar WCGWs",
        searchEntity: "Buscar WCGWs",
        createEntity: "Nuevos WCGWs",
        entityName: "WCGW",
        entityNameCaps: "WCGW",
        entityNamePlural: "WCGWs",
        placeholderText: "Cree un nuevo WCGW o edite y elimine el WCGW existente a continuación.",
        deleteEntity: "Eliminar WCGW",
        deleteConfirmLabel: "¿Estás seguro de que quieres eliminar este WCGW? Se eliminarán todas las relaciones existentes. Esta acción no se puede deshacer."
    },
    [Entity.Misstatement]: {
        manageEntity: "Gestionar ajustes",
        searchEntity: "Buscar ajustes",
        createEntity: "Nuevo ajuste",
        entityName: "ajuste",
        entityNameCaps: "Ajuste",
        entityNamePlural: "Ajustes",
        placeholderText: "Cree nuevos ajustes o edite y elimine los ajustes existentes a continuación.",
        deleteConfirmLabel: "¿Está seguro de que desea eliminar el ajuste seleccionado? Esta acción no se puede deshacer."
    },
    [Entity.AdjustmentValidation]: {
        manageEntity: "Gestione los ajustes con comprobaciones de validaciones",
        searchEntity: "Buscar",
        entityName: "Ajustes",
        entityNameCaps: "Ajustes",
        entityNamePlural: "Ajustes",
        placeholderText: "Cada ajuste debe tener relacionada al menos una evidencia y para cada ajuste la suma de los asientos de débito debe ser igual a la suma de los asientos de crédito. Los siguientes ajustes tienen uno o más problemas de validación. Haga clic en <b>'Editar'</b> para abordarlos.",
        deleteConfirmLabel: "¿Está seguro de que desea eliminar el ajuste seleccionado? Esta acción no se puede deshacer.",
        adjustmentHeader: "Ajuste",
        validationTyeHeader: "Tipo de validación",
        validationTypeAmtMissmatch: "La suma de los asientos de débito no es igual a la suma de los asientos de crédito",
        validationTypeNoEvidence: "No hay evidencia relacionada"
    },
    [Entity.SampleItem]: {
        manageEntity: "Administrar etiquetas de muestra",
        searchEntity: "Buscar etiquetas",
        createEntity: "Nueva etiqueta",
        createManageTagEntity: "Administrar grupos de etiquetas",
        entityName: "Etiqueta",
        entityNamePlural: "Etiquetas",
        entityNameForTagGroupPlural: "Grupos de etiquetas",
        placeholderText: "Cree nuevas etiquetas o edite y elimine las etiquetas existentes a continuación."
    },
    [Entity.SampleTagGroups]: {
        manageEntity: "Administrar grupos de etiquetas de muestra",
        searchEntity: "Buscar",
        createEntity: "Nuevo grupo de etiquetas",
        entityName: "Grupo de etiquetas",
        entityNameCaps: "Grupo de etiquetas",
        entityNamePlural: "Grupos de etiquetas",
        placeholderText: "Cree nuevos grupos de etiquetas de muestra o edite y elimine los grupos de etiquetas de muestra existentes a continuación.",
    }
};

export const executionType = [{
        id: 1,
        label: '',
        toolTip: '',
        value: "En este compromiso"
    },
    {
        id: 2,
        label: 'CT',
        toolTip: "Procedimientos en otro(s) compromiso(s) [solo PT]",
        value: "En otro(s) compromiso(s) [solo PT]"
    },
    {
        id: 3,
        label: 'PT/CT',
        toolTip: "Procedimientos en este y otros compromisos [solo PT]",
        value: "En este y otros enfrentamientos [solo PT]"
    }
];

export const AccountType = [{
        id: 1,
        accounttypename: "Cuenta significativa"
    },
    {
        id: 2,
        accounttypename: "Cuenta de riesgo limitado"
    },
    {
        id: 3,
        accounttypename: "Cuenta insignificante"
    },
    {
        id: 4,
        accounttypename: "Otra cuenta"
    },
    {
        id: 5,
        accounttypename: "Divulgación significativa"
    }
];

export const statementTypes = [{
        id: 1,
        name: "Cuenta de resultados"
    },
    {
        id: 2,
        name: "Balance"
    },
    {
        id: 3,
        name: "Ambos"
    }
];

export const CreateEditAccountLabels = {
    createModalDescription: "Ingrese los detalles de la nueva cuenta a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otra cuenta, seleccione '<b>{1}</b>'.",
    editModalDescription: "Edite los detalles de la cuenta a continuación y seleccione '<b>{0}</b>' para finalizar.",
    close: "Cerrar",
    cancel: "Cancelar",
    yes: "Sí",
    no: "No",
    createAccount: "Cuenta nueva",
    editAccount: "Editar cuenta",
    delete: "Borrar",
    save: "Guardar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    accountNameLabel: "Nombre de la cuenta (obligatorio)",
    accountDesignationLabel: "Designación",
    accountExecutionTypeLabel: "¿En qué compromiso de Canvas se realizarán y documentarán los procedimientos para esta cuenta?",
    accountEstimateLabel: "¿Esta cuenta se ve afectada por una estimación?",
    accountStatementTypeLabel: "Tipo de instrucción",
    pspIndexDropdownLabel: "Índice PSP (obligatorio, seleccione hasta 5)",
    removePSPIndexLabel: "Eliminar el índice de PSP",
    assertionsLabel: "Seleccionar aseveraciones relevantes",
    assertionOptions: assertions,
    executionTypeOptions: executionType,
    accountTypeOptions: AccountType,
    statementTypeOptions: statementTypes,
    confirm: "Confirmar",
    pspIndexErrorMsg: "Obligatorio",
    assertionWarningMessage: "No puede realizar cambios en las aseveraciones que tengan un riesgo significativo, o riesgo de fraude, o riesgo de error material o una estimación relacionada. Primero debe eliminar estas relaciones.",
    confirmChanges: "Confirmar cambios",
    executionTypeWarningMessage: "Los cambios que va a guardar en esta cuenta afectarán a las aseveraciones y PSP existentes, los enlaces se romperán. ¿Estás seguro de que quieres continuar? Esta acción no se puede deshacer.",
    contentUpdateToastMessage: "La actualización de contenido está disponible para {0}. Inicie la actualización de contenido desde la página de actualización de contenido.",
    assertionsRequired: "Se debe seleccionar al menos una aseveración",
    pspIndexDisabledLabel: "Seleccione hasta cinco índices de PSP. Anule la selección de una o más opciones para continuar.",
    newSignificantDisclosure: "Nueva divulgación significativa",
    noOptionsMessage: "No se han encontrado resultados",
    accountNameErrorMsg: "Obligatorio"
};

export const CreateMestLabels = {
    createModalTitle: "Nueva entidad",
    createModalDescription: "Introduce la entidad a continuación y selecciona '<b>{0}</b>' para terminar. Para crear otra entidad, selecciona '<b>{1}</b>'. Las entidades son cómo planeamos abordar la auditoría y pueden no ser entidades legales sino unidades de negocio u otras combinaciones.",
    close: "Cerrar",
    cancel: "Cancelar",
    save: "Guardar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    entityNameLabel: "Nombre de la entidad",
    entityStandardIndexLabel: "Indice estándar de la entidad",
    entityDescriptionLabel: "Descripción de la entidad (opcional)",
    entityNameErrorMsg: "Obligatorio",
    entityStandardIndexErrorMsg: "Obligatorio"
}

export const CreateEditSCOTLabels = {
    createModalTitle: "Nuevo SCOT",
    editModalTitle: "Editar SCOT",
    createModalDescription: "Ingrese los nuevos detalles de SCOT a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otro SCOT, seleccione '<b>{1}</b>'.",
    editModalDescription: "Edite los detalles de SCOT a continuación y seleccione '<b>{0}</b>' para finalizar.",
    close: "Cerrar",
    cancel: "Cancelar",
    save: "Guardar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    scotNameLabel: "Nombre SCOT (obligatorio)",
    scotStrategyLabel: "Estrategia SCOT",
    scotTypeLabel: "Tipo SCOT",
    scotTypeOptions: scotTypes,
    hasEstimateLabel: "¿Este SCOT se ve afectado por una estimación?",
    itAPPUsedLabel: "No se utilizan aplicaciones informáticas",
    routine: "Rutina",
    nonRoutine: "No rutinario",
    controls: "Controles",
    substantive: "Sustantivo",
    yes: "Sí",
    scotNameErrorMsg: "Obligatorio",
    remove: "Eliminar",
    noOptionsMessage: "No se encontraron resultados",
    wtDetailPrefix: "<p>Para todos los SCOT rutinarios y no rutinarios y los procesos de divulgación significativos, confirmamos nuestra comprensión en cada período mediante la realización de procedimientos de recorrido. Además, para las auditorías PCAOB, realizamos procedimientos de revisión de los SCOT de estimación.<br/>Para todos los SCOT cuando adoptamos una estrategia de dependencia de controles, y para los controles que abordan riesgos significativos, confirmamos que los controles relevantes se han diseñado e implementado adecuadamente. Confirmamos que nuestra decisión de adoptar una estrategia de confianza en los controles sigue siendo adecuada.<br/><br/>Concluimos que nuestra documentación describe con precisión el funcionamiento del SCOT y hemos identificado todos los WCGW apropiados, incluidos los riesgos que surgen del uso de TI, y los controles relevantes (cuando corresponda).<br/><br/> Para la estimación de SCOTs cuando utilizamos una estrategia solo sustantiva,  determinamos si nuestra interpretación de la estimación SCOT es apropiada sobre la base de nuestros procedimientos sustantivos.</p>",
	disabledTabTooltipMessage: 'Anule la selección de "No se utilizan aplicaciones de TI" para relacionar aplicaciones de TI',
    itAppLabels: {
        tabLabel: "Aplicaciones de TI",
        dropdownLabel: "Relacionar aplicaciones de TI",
        noRelatedItems: "No hay aplicaciones de TI relacionadas",
        itApplications: "Aplicaciones IT"
    },
    soLabels: {
        tabLabel: "SOs",
        dropdownLabel: "Relacionar organizaciones de servicios",
        noRelatedItems: "No hay organizaciones de servicios relacionadas",
        serviceOrganizations: "Organizaciones de servicios"
    }
};

export const CreateEditWCGWLabels = {
    wcgwName: "Nombre de WCGW (obligatorio)",
    editWCGW: "Editar WCGW",
    editTheWCGW: "Edite los detalles de WCGW a continuación y seleccione '<b>{0}</b>' para finalizar.",
    createNewWCGW: "Ingrese los nuevos detalles de WCGW a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otro WCGW, seleccione '<b>{1}</b>'.",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "New WCGW",
    editWCGWSave: "Guardar",
    editWCGWClose: "Cancelar",
    closeTitle: "Cerrar",
    wcgwNameIsRequired: "Obligatorio",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro"
};

export const controlFrequencyTypes = [{
        value: 1,
        label: "Muchas veces al día"
    },
    {
        value: 2,
        label: "Diario"
    },
    {
        value: 3,
        label: "Semanal"
    },
    {
        value: 4,
        label: "Mensual"
    },
    {
        value: 5,
        label: "Trimestral"
    },
    {
        value: 6,
        label: "Anualmente"
    },
    {
        value: 8,
        label: "Otro"
    }
];

export const controlTypes = [{
        value: 1,
        label: "Control de aplicaciones de TI"
    },
    {
        value: 2,
        label: "Control manual dependiente de TI"
    },
    {
        value: 3,
        label: "Manual Preventivo"
    },
    {
        value: 4,
        label: "Manual de Detección"
    }
];

export const CreateEditControlLabels = {
    createModalTitle: "Nuevo control",
    editModalTitle: "Editar control",
    close: "Cerrar",
    cancel: "Cancelar",
    save: "Guardar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    controlNameLabel: "Nombre del control (obligatorio)",
    frequency: "Frecuencia",
    controlType: "Tipo de control",
    frequencyTypeOptions: controlFrequencyTypes,
    controlTypeOptions: controlTypes,
    designEffectiveness: "Efectividad del diseño",
    operatingEffectiveness: "Efectividad operativa",
    testingLabel: "Prueba",
    lowerRiskLabel: "¿Es Control de riesgo menor?",
    ITDMControlSubstantiveTestingOptionLabel: "La parte automatizada de este control ITDM es solo el uso de informes generados por el sistema que se prueban sustantivamente",
    effective: "Efectivo",
    ineffective: "Inefectivo",
    yes: "Sí",
    no: "No",
    required: "Obligatorio",
    remove: "Eliminar",
    noOptionsMessage: "No se han encontrado resultados",
	disabledTabTooltipMessage: 'Seleccione "Tipo de control" como "Control de aplicaciones de TI" o "Control manual dependiente de TI" para relacionar las aplicaciones de TI',
    itAppLabels: {
        tabLabel: "Aplicaciones de TI",
        dropdownLabel: "Relacionar aplicaciones de TI",
        noRelatedItems: "No hay aplicaciones de TI relacionadas",
        itApplications: "Aplicaciones IT"
    },
    soLabels: {
        tabLabel: "SOs",
        dropdownLabel: "Relacionar organizaciones de servicios",
        noRelatedItems: "No hay organizaciones de servicios relacionadas",
        serviceOrganizations: "Organizaciones de servicios"
    },
    controlNameErrorMsg: "Obligatorio",
    createModalDescriptionLabel: "Ingrese los nuevos detalles de control a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otro control, seleccione '<b>{1}</b>'.",
    editModalDescriptionLabel: "Edite los detalles del control a continuación y seleccione '<b>{0}</b>' para finalizar.",
    wcgwLabel: "WCGW"
};

export const CreateEditITApplicationLabels = {
    close: "Cerrar",
    cancel: "Cancelar",
    yes: "Sí",
    no: "No",
    delete: "Borrar",
    save: "Guardar",
    closeTitle: "Cerrar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    iTApplicationNameLabel: "Nombre de la aplicación de TI (obligatorio)",
    iTSOApplicationNameLabel: "Nombre de la organización de servicio",
    newITApplicationLabel: "Nueva aplicación informática",
    newITSOApplicationLabel: "Nueva Organización de Servicios",
    editITApplicationLabel: "Editar aplicación de TI",
    confirm: "Confirmar",
    confirmChanges: "Confirmar cambios",
    noOptionsMessage: "No se han encontrado resultados",
    iTAppNameErrorMsg: "Obligatorio",
    iTSOAppNameErrorMsg: "Obligatorio",
    controls: "Controles",
    substantive: "Sustantivo",
    remove: "Eliminar",
    iTApplicationStrategyLabel: "Estrategia de aplicaciones de TI",
    SCOTsLabel: "Nombres de SCOTs",
    StrategyLabel: "Estrategia",
    ControlsLabel: "Nombres de control",
    ControlTypeLabel: "Tipo",
    addDescriptionLabel: "Introduzca los detalles de la nueva aplicación informática a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otra aplicación informática, seleccione '<b>{1}</b>'.",

    editDescriptionLabel: "Edite los detalles de la aplicación de TI a continuación y seleccione '<b>{0}</b>' para finalizar.",

    addSODescriptionLabel: "Introduzca los detalles de la nueva organización de servicio a continuación y seleccione '<b>Guardar y cerrar</b>' para finalizar. Para crear otra organización de servicios, seleccione '<b>Guardar y crear otra</b>'.",

    scotErrorMessage: "SCOT no puede ser ajeno a la aplicación informática, ya que hay controles relacionados.",
    SCOTsLabels: {
        tabLabel: "SCOTSs",
        dropdownLabel: "Relacionar los SCOTs",
        noRelatedItems: "No hay SCOTs relacionados"
    },
    ControlsLabels: {
        tabLabel: "Controles",
        dropdownLabel: "Controles de relación",
        noRelatedItems: "No hay controles relacionados"
    },
    strategyType: {
        1: "Controles",
        2: "Sustantivo",
        3: "Confiar",
        4: "No confiar"
    },
    controlType: {
        1: "Aplicación de TI",
        2: "Manual dependiente de TI",
        3: "Manual Preventivo",
        4: "Manual de Detección"
    }
};

export const groupComponentAccountReportHeaderLabels = {
    primaryEngagementId: "EngagementID (Identificación de compromiso)",
    gaScopeName: "Alcance",
    gaComponentId: "GAComponentID",
    shortName: "Nombre del componente",
    pocText: "Punto de contacto",
    accountId: "ID de cuenta",
    accountName: "Nombre de la cuenta",
    accountType: "Designación de cuenta",
    knowledgeAssertion: "Aserción",
    inherentRiskType: "Riesgo inherente",
    riskId: "Identificación de riesgo",
    riskType: "Tipo de riesgo",
    riskName: "Nombre del riesgo",
    isHigherRiskText: "Es de mayor riesgo"
};

export const AccountTypeIDs = {
    1: "Cuenta Significativa",
    2: "Cuenta de Riesgo Limitado",
    3: "Cuenta insignificante",
    4: "Cuenta - Otros",
    5: "Divulgación significativa"
};

export const InherentRiskTypeIDs = {
    1: "Superior",
    2: "Bajar",
    3: "Muy bajo"
};

export const riskTypeIDs = {
    1: "Riesgos significativos",
    2: "Riesgos de fraude",
    3: "Riesgos de incorrección material"
};

export const riskTypeIDsShortForm = {
    1: "SR",
    2: "FR",
    3: "ROMM"
};

export const ControlRiskTypeIDs = {
    1: "Confiar",
    2: "No confiar",
    3: "MP de prueba"
};

export const knowledgeAssertions = {
    1: "Integridad",
    2: "Existencia",
    3: "Valoración",
    4: "Derechos y obligaciones",
    5: "Presentación y divulgación",
    6: "Integridad",
    7: "Ocurrencia",
    8: "Medición",
    9: "Presentación y divulgación",
    10: "Integridad",
    11: "Existencia/Ocurrencia",
    12: "Medición/Valoración",
    13: "Derechos y obligaciones",
    14: "Presentación y divulgación"
};

export const gaInstructionStatuslabels = {
    0: "Indefinido",
    [instructionStatus.notSent]: "No enviado",
    [instructionStatus.pending]: "Pendiente",
    [instructionStatus.accepted]: "Aceptado",
    [instructionStatus.rejected]: "Devuelto",
    [instructionStatus.systemError]: "Error del sistema",
    [instructionStatus.expired]: "Caducado",
    [instructionStatus.sent]: "Enviado",
    [instructionStatus.unlinked]: "Desvinculado",
    [instructionStatus.queued]: "En espera"
};

export const financialStatementTypeLabels = {
    [financialStatementType.Asset]: "Activo",
    [financialStatementType.CurrentAsset]: "Activo corriente",
    [financialStatementType.NonCurrentAsset]: "Activo no corriente",
    [financialStatementType.Liability]: "Pasivo",
    [financialStatementType.CurrentLiability]: "Pasivo corriente",
    [financialStatementType.NonCurrentLiability]: "Pasivo no corriente",
    [financialStatementType.Equity]: "Capital",
    [financialStatementType.Revenue]: "Ingresos",
    [financialStatementType.Expense]: "Gasto",
    [financialStatementType.NonOperatingIncome]: "Ingresos/(Gastos) No Operativos",
    [financialStatementType.OtherComprehensiveIncome]: "Otros ingresos generales",
    [financialStatementType.Other]: "Otro",
    [financialStatementType.AccountType]: "Tipo de cuenta",
    [financialStatementType.AccountSubType]: "Subtipo de cuenta",
    [financialStatementType.AccountClass]: "Clase de cuenta",
    [financialStatementType.AccountSubClass]: "Subclase de cuenta",
    [financialStatementType.NetIncomeExpense]: "Neto (Ingresos) / Gastos",
    18: "GLAccount"
};

export const trialBalanceTypeLabels = {
    [trialBalanceType.Planning]: "Planificación"
};

export const createEditRiskModalLabels = {
    createModalDescription: "Ingrese los nuevos detalles de riesgo a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otro riesgo, seleccione '<b>{1}</b>'.",
    editModalDescription: "Edite los detalles de riesgo a continuación y seleccione <b>{0}</b> para finalizar.",
    close: "Cerrar",
    cancel: "Cancelar",
    createRisk: "Nuevo riesgo",
    editRisk: "Editar riesgo",
    riskType: "Tipo de riesgo (obligatorio)",

    riskTypeOptions: [{
            value: 1,
            label: "Riesgo significativo"
        },
        {
            value: 2,
            label: "Riesgo de fraude"
        },
        {
            value: 3,
            label: "Riesgo de incorrección material"
        }
    ],
    save: "Guardar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    riskNameLabel: "Nombre del riesgo (obligatorio)",
    relatedAccountsAssertionsLabel: "Cuentas y aseveraciones relacionadas (opcional)",
    relateAccounts: "Relacionar cuentas y aseveraciones (opcional)",
    assertionsLabel: "Seleccionar aseveraciones relevantes",
    riskNameErrorMsg: "Obligatorio",
    riskTypeErrorMsg: "Obligatorio",
    assertionOptions: assertions,
    removeAccountLabel: "Eliminar cuenta",
    required: "Obligatorio",
    assertionsRequired: "Se debe seleccionar al menos una aseveración"
};

export const activityTypeLabels = {
    104: "Añadido",
    105: "Eliminado"
};

export const superModalNavigationLabels = {
    identifyAccountsAndDisclosures: "Identifique las cuentas y las divulgaciones",
    identifySCOTs: "Identificar los SCOT y relacionarlos con las cuentas",
    determineSCOTStrategy: "Determinar la estrategia SCOT",
    identifyWCGWAndControls: "Identificación de WCGW y controles",
    selectControlToTest: "Seleccione controles a probar",
    identifyRisks: "Identifique los riesgos",
    relateWCGWsToAssertions: "Relacionar las WCGW con las aseveraciones",
    relateRisksToWCGWs: "Relacionar los riesgos con los WCGW",
    determineCRA: "Determine el CRA",
    timephase: "Fase de Tiempo",
    SCOTWT: "Crear WT",
    controlTOC: "Crear TOC",
    ITProcessUDP: "Crear UDP",
    ITGC_ITSP_TOC_OSP: "Crear IT TOC/OSP",
    accountPSP: "Crear PSP",
    accountOSP: "Crear OSP",
    relateWCGWTo: "Relacione WCGW con",
    relatedWCGWToTask: "Relacionar WCGW con la tarea",
    respondToSignificant_fraudRisks: "Responder a riesgos significativos/fraude",
    OST: "OST",
    accountSummary: "Resumen de la cuenta",
    SCOTSummary: "Resumen de SCOT",
    ITSummary: "Resumen de TI",
    understandITProcesses: "Comprender los procesos de TI",
    evaluateIT: "Evaluacion de IT",
    CRASummary: "Resumen del CRA",
    auditPlan: "Plan de auditoría",
    workplanSummary: "Resumen del plan de trabajo",
    buildSteps: "Pasos de compilación",
    ITApplicationsAndITProcesses: "Aplicaciones y procesos informáticos",
    workPlan: "Plan de trabajo",
    accounts: "Cuentas",
    scots: "SCOTs",
    cra: "CRA",
    openInNewTab: "Abrir en una nueva pestaña"
}

export const auditPlanITProcessLabels = {
    itProcess: "Proceso de TI",
    itProcesses: "Procesos de TI",
    tasks: "Tareas",
    sectionHeading: "Proceso de TI y tareas relacionadas con la comprensión del proceso (UDP)",
    subHeader: "Comprender el proceso de TI",
    visualDistinctMessage: "Cada proceso de TI debe tener al menos un UDP relacionado. Cree {0} o {1}.",
    addUdp: "Nuevo UDP",
    relatedUdp: "Relacionar UDP",
    toggleFilter: "Mostrar solo procesos de TI sin ningún UDP relacionado",
    noResultsFound: "No se han encontrado resultados",
    taskTitle: "Comprender y documentar el proceso de TI: {0}",
    taskDescription: "Documentar nuestra comprensión del proceso de TI. Adjunte el formulario pertinente como prueba para respaldar nuestra comprensión del proceso informático. Cuando los ITGC aparezcan en la sección Atributos de la tarea, realice procedimientos de recorrido para confirmar nuestra comprensión de los ITGC y evaluar su diseño e implementación. Adjuntar evidencia de nuestros procedimientos.",
    noRecordsAvailable: "No hay procesos de TI disponibles",
    unrelatedLabel: "Ver UDP no relacionados",
    unrelatedModalHeader: "Tareas UDP no relacionadas",
    noUnrelatedTaskPlaceholder: "No hay tareas UDP no relacionadas disponibles",
    noTaskselectedLabel: "Se debe seleccionar al menos una tarea para su eliminación",
    relateITProcessTaskTitle: "Relacionar los UDP con el proceso de TI",
    understandITProcesses: "Comprender los procesos de TI",
    unrelatedTasksMustBeAssociated: "Las tareas no relacionadas deben asociarse a un proceso de TI o eliminarse."
}

export const noEvidenceReferencedReasonsLabels = {
    immaterialReason: "Inmaterial: El saldo/actividad no cumple con el alcance de la prueba: se renuncia a realizar más investigaciones",
    strikethroughMText: "m",
    waivedReason: "Exoneracion: Monto por debajo del SAD: se exonera a una investigación adicional",
    strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
    scot: "SCOTs",
    scots: "SCOTs",
    tasks: "Tareas",
    sectionHeading: "SCOT y tareas de recorrido relacionadas",
    subHeader: "Tareas de recorridos",
    visualDistinctMessage: "Cada SCOT debe tener al menos un tutorial relacionado. Cree {0} o {1}.",
    newWT: "Nuevo WT",
    relatedWT: "Relacionar WTs",
    toggleFilter: "Mostrar solo SCOTs sin ningún WT relacionado",
    noResultsFound: "No se han encontrado resultados",
    noRecordsAvailable: "No hay SCOTs disponibles",
    relateScotTaskTitle: "Relacionar los WT con SCOT",
    taskTitle: "Recorrido: {0}",
    taskDescription: "<p>Para todos los SCOT rutinarios y no rutinarios y los procesos de divulgación significativos, confirmamos nuestra comprensión en cada período mediante la realización de procedimientos de recorrido. Además, para las auditorías PCAOB, realizamos procedimientos de revisión de los SCOT de estimación.<br/>Para todos los SCOT cuando adoptamos una estrategia de dependencia de controles, y para los controles que abordan riesgos significativos, confirmamos que los controles relevantes se han diseñado e implementado adecuadamente. Confirmamos que nuestra decisión de adoptar una estrategia de confianza en los controles sigue siendo adecuada.<br/><br/>Concluimos que nuestra documentación describe con precisión el funcionamiento del SCOT y hemos identificado todos los WCGW apropiados, incluidos los riesgos que surgen del uso de TI, y los controles relevantes (cuando corresponda).<br/><br/> Para la estimación de SCOTs cuando utilizamos una estrategia solo sustantiva,  determinamos si nuestra interpretación de la estimación SCOT es apropiada sobre la base de nuestros procedimientos sustantivos.</p>",
    unrelatedLabel: "Ver WT no relacionados",
    unrelatedModalHeader: "Tareas de WT no relacionadas",
    noUnrelatedTaskPlaceholder: "No hay tareas de WT no relacionadas disponibles",
    noTaskselectedLabel: "Se debe seleccionar al menos una tarea para su eliminación.",
    manageScots: "Gestionar los SCOTs",
    unrelatedTasksMustBeAssociated: "Las tareas no relacionadas deben asociarse a un SCOT o eliminarse."
}

export const auditPlanControlsLabels = {
    control: "Control",
    controls: "Controles seleccionados para las pruebas",
    tasks: "Tareas",
    sectionHeading: "Controles y pruebas de control relacionadas",
    subHeader: "Tareas de Prueba de control",
    visualDistinctMessage: "Cada control debe tener al menos una prueba de control relacionada. Cree {0} o {1}.",
    addToc: "Nuevo TOC",
    relatedToc: "Relacionar TDC",
    toggleFilter: "Mostrar solo controles sin ninguna TOC relacionada",
    noResultsFound: "No se han encontrado resultados",
    noRecordsAvailable: "No hay controles seleccionados para la prueba",
    unrelatedLabel: "Mostrar TOCs sin relacionar",
    unrelatedModalHeader: "Tareas TOC no relacionadas",
    noUnrelatedTaskPlaceholder: "No hay tareas TOC no relacionadas disponibles",
    noTaskselectedLabel: "Se debe seleccionar al menos una tarea para su eliminación.",
    relateControlTaskTitle: "Relacionar los TOC con el control",
    manageControl: "Administrar controles",
    taskTitleTOC: "Prueba de control: {0}",
    taskDescriptionTOC: "Diseñar la naturaleza, el momento y el alcance de nuestras pruebas de controles para obtener pruebas de auditoría suficientes y apropiadas de que el control funciona eficazmente según lo diseñado durante todo el período de confianza para prevenir o detectar y corregir errores materiales a nivel de aseveración.<br/>Concluir sobre la eficacia operativa de los controles, evaluando los resultados de nuestras pruebas de controles, incluso cuando ampliamos el tamaño de nuestra muestra y realizamos pruebas de controles compensadores.",
    manageControls: "Administrar controles",
    unrelatedTasksMustBeAssociated: "Las tareas no relacionadas deben asociarse a un control o eliminarse."
}

export const industrySelectionGroupLabels = {
    1: "Industrias seleccionadas",
    2: "Otras industrias"
}

export const knowledgeDataLabels = {
    industry: "Industria",
    showSelected: "Mostrar solo los seleccionados",
    noContent: "No hay contenido disponible en Knowledge para la industria seleccionada",
    importFromKnowledge: "Importar desde Knowledge",
    importAccounts: "Importar cuentas",
    importAccountsAndDisclosures: "Importar cuentas y divulgaciones",
    accountBuild1: "Paso 1 de la creación de la cuenta",
    import: "Importación",
    close: "Cerrar",
    cancel: "Cancelar",
    selected: "seleccionado",
    scotTitle: "SCOT build 1",
    importScots: "Importar SCOTs",
    noKnowledgeDataResult: "No hay contenido disponible para la selección",
    showOnlySelectedLabel: "Mostrar solo seleccionados",
    scot: "SCOT",
    scotDropdownLabel: "SCOT para la industria seleccionada",
    importWcgw: "Importar WCGWs",
    importFailedLabel: "Error en la importación. Intente importar de nuevo.",
    wtDetailPrefix: "<p>Para todos los SCOT rutinarios y no rutinarios y los procesos de divulgación significativos, confirmamos nuestra comprensión en cada período mediante la realización de procedimientos de recorrido. Además, para las auditorías PCAOB, realizamos procedimientos de revisión de los SCOT de estimación.<br/>Para todos los SCOT cuando adoptamos una estrategia de dependencia de controles, y para los controles que abordan riesgos significativos, confirmamos que los controles relevantes se han diseñado e implementado adecuadamente. Confirmamos que nuestra decisión de adoptar una estrategia de confianza en los controles sigue siendo adecuada.<br/><br/>Concluimos que nuestra documentación describe con precisión el funcionamiento del SCOT y hemos identificado todos los WCGW apropiados, incluidos los riesgos que surgen del uso de TI, y los controles relevantes (cuando corresponda).<br/><br/> Para la estimación de SCOTs cuando utilizamos una estrategia solo sustantiva,  determinamos si nuestra interpretación de la estimación SCOT es apropiada sobre la base de nuestros procedimientos sustantivos.</p>",
    importOSP: "Importar OSP",
    auditPlanBuild7: "Plan de Auditoría Build 7",
    account: "Cuenta",
    accountName: "Índices PSP",
    wcgwName: "WCGWs",
    selectScot: "Seleccione SCOT",
    wcgwTitle: "SCOT build 3",
    noResultFound: "No se han encontrado resultados",
    importValidationMessage: "Se requiere una selección",
    searchIconHoverLabel: "Buscar",
    scotsHeader: "SCOTs",
    controlsHeader: "Controles",
    ospsHeader: "OSPs",
    wcgw: "WCGW",
    importControls: "Controles de importación",
    accountAssertionsValidationMessage: "Faltan aseveraciones de tareas",
    accountsAndDisclosures: "Cuentas y divulgaciones",
}

export const auditPlanITControlsLabels = {
    itcontrol: "Control informático",
    itcontrols: "Controles de TI seleccionados para las pruebas",
    tasks: "Tareas",
    type: "Tipo",
    sectionHeading: "ITGC, ITSP y pruebas relacionadas de controles y tareas sustantivas",
    subHeader: "Tareas de TOC/OSP",
    visualTOCDistinctMessage: "Cada ITGC debe tener al menos una prueba de control relacionada. Cree {0} o {2}.",
    visualOSPDistinctMessage: "Cada ITSP debe tener al menos un procedimiento sustantivo relacionado. Cree {1} o {3}.",
    addTOC: "Nuevo TOC",
    addOSP: "Nuevo OSP",
    relatedTOCOSP: "Relacionar TOC/OSP",
    relatedTOC: "Relacionar TOCs",
    relatedOSP: "Relacionar OSPs",
    toggleFilter: "Mostrar solo controles de TI sin ningún TOC/OSP relacionado",
    noResultsFound: "No se han encontrado resultados",
    noRecordsAvailable: "No se seleccionaron ITGC para las pruebas",
    taskTitleTOC: "Prueba de control: {0}",
    taskDescriptionTOC: "Realizar nuestras pruebas diseñadas de ITGC para obtener evidencia de auditoría suficiente y apropiada de su efectividad operativa durante todo el período de confianza.",
    taskTitleOSP: "Otro procedimiento sustantivo: {0}",
    taskDescriptionOSP: "Personalice esta descripción de la tarea para diseñar la naturaleza, el momento y el alcance de los procedimientos sustantivos de TI para obtener evidencia de auditoría suficiente y apropiada de que los riesgos de TI se abordan de manera efectiva durante todo el período de confianza.<br>Cuando el procedimiento sustantivo de TI se realice a partir de una fecha intermedia, diseñe y realice procedimientos para obtener evidencia adicional de que los riesgos de TI se abordan durante el período cubierto por nuestros procedimientos intermedios hasta el final del período.<br>Concluimos sobre los resultados de nuestros procedimientos sustantivos en materia de TI.",
    relateITControlTaskTitle: "Relacionar los TOC/OSP con el control de TI",
    relateITControlTOCTaskTitle: "Relacionar las tablas de contenido con las ITGC",
    relateITControlOSPTaskTitle: "Relacionar los OSP con el ITSP",
    unrelatedModalHeader: "Tareas TOC/OSP no relacionadas",
    noUnrelatedTaskPlaceholder: "No hay tareas TOC/OSP no relacionadas disponibles",
    noTaskselectedLabel: "Se debe seleccionar al menos una tarea para su eliminación.",
    unrelatedLabel: "Ver TOC/OSP no relacionados",
    understandITProcesses: "Comprender los procesos de TI",
    unrelatedTasksMustBeAssociated: "Las tareas no relacionadas deben asociarse a un control de TI o eliminarse."
}

export const generalLabelsForMobile = {
    noRecordsFound: "No se han encontrado resultados dentro de esta categoría de tareas",
    taskListTitle: "Mis tareas",
    taskEvidenceTitle: "Evidencia",
    cameraPagesTitle: "Páginas",
    cameraTitle: "Cámara",
    taskDetailsTitle: "Detalles de la tarea",
    invalidPage: "No se ha encontrado ninguna página",
    combinedTaskLabel: "PIC/EQR",
    picTaskLabel: "PIC",
    eqrTaskLabel: "EQR",
    pageLabel: "Página",
    ofLabel: "de",
    noTasksAvailable: "No hay tareas disponibles",
    searchLabel: "Buscar...",
    noDescriptionAvailable: 'No description available.',
    knowledge: 'Knowledge',
    description: 'Description',
    knowledgeDescription: 'Knowledge description',
    customized: 'Customized',
    taskDetailsTitle: "Detalles de la tarea",
    unassigned: "Sin asignar",
    assignTo: "Asignado a",
    signOffLabel: "Aprobaciones",
    evidenceNoteLabel: "Notas de evidencia",
    attributeLabel: "Atributos",
    addNoteLabel: "Nueva nota",
    addCommentLabel: "Agregar comentario",
    editCommentLabel: "Comentario de actualización",
    addReplyNoteLabel: "Responder a esta nota",
    replyNoteLabel: "Respuesta",
    replyEditNoteLabel: "Editar respuesta",
    enterReplyPlaceholder: "Introduzca la respuesta",
    editNoteLabel: "Editar",
    deleteNoteLabel: "Borrar",
    reopenNoteLabel: "Reabrir",
    closeNoteLabel: "Cerrar",
    clearNoteLabel: "Borrar",
    preparerAbbrv: "P",
    reviewerAbbrv: "R",
    uploadPhoto: "Subir foto",
    noEvidenceFound: "No hay evidencia asociada a la tarea",
    noRegionComponentFound: "No se han recibido documentos del equipo regional o de componentes",
    noEvidenceMessage: "Haga clic en Cargar foto para cargar evidencias",
    noNotesFound: "No se han encontrado notas",
    noNotesStatement: "Deje una nota utilizando las entradas a continuación. Asigne la nota a un usuario y especifique la prioridad y la fecha de vencimiento.",
    regionComponentEvidence: "Evidencia de la región y los componentes",
    documentWarning: "El documento descargado será de solo lectura. Deseche el archivo cuando haya terminado.",
    preparerTitle: "Firmas del preparador",
    reviewerTitle: "Firmas de revisores",
    teamLabel: "Equipo",
    saveEvidenceTitle: "Guarde las pruebas",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
    confirmButtonLabel: "Confirmar",
    previewButton: "Vista previa",
    evidenceLable: "Nombre de la evidencia",
    mergingTitleLable: "imágenes fusionadas en PDF.",
    showErrFileExistMsg: "El nombre del archivo ya existe. Cambie el nombre del archivo.",
    showErrForNoImgExist: "No hay imágenes disponibles para la generación de PDF.",
    showErrBlankFileNameMsg: "El nombre del archivo no puede estar en blanco.",
    showIsCompletedMessage: "El archivo se ha cargado correctamente.",
    uploadingTitle: "Tratamiento",
    showErrImgContext: "useImages se debe usar dentro de un ImagesProvider",
    PagePreviewTitle: "Página",
    regionComponentEvidenceLabel: "Evidencia de la región y los componentes",
    downloadProcessLabel: "Descargar...",
    downloadCompleteLabel: "Descargar Completo",
    taskNotes: "Notas de la tarea",
    documentNotes: "Notas del documento",
    dueDateLabel: "Fecha de vencimiento",
    view: "Vista:",
    documentNotes: "Notas del documento",
    newNote: "Añadir nota",
    editNote: "Nota de edición",
    assignedTo: "Asignado a",
    priority: "Prioridad",
    select: "Escoger",
    dueDate: "Fecha de vencimiento",
    addNewNote: "Agregar una nueva nota",
    addNote: "Agregar nota",
    updateNote: "Nota de actualización",
    enterDescription: "Introduzca una descripción...",
    allnotes: "Todas las notas",
    mynotes: "Mis notas",
    assignedToMe: "Asignado a mí",
    hashValue: "#",
    showLessToggle: "Mostrar menos",
    showMoreToggle: "Mostrar más",
    delete: "Borrar",
    deleteNoteModalTitle: "Eliminar mensaje",
    deleteReplyModalTitle: "Eliminar respuesta",
    confirmDeleteNoteLabel: "¿Estás seguro de que quieres eliminar la nota seleccionada?",
    confirmDeleteReplyLabel: "¿Está seguro de que desea eliminar su respuesta a esta nota?",
    downloadInfo: "No se permite la descarga de un archivo que contenga el carácter #",
	evidenceFileValidationInfo: 'El nombre del archivo no puede incluir */ : <>\?| " Personajes',
    previewPageTitle: "Vista previa",
    redirecting: "Redirigir a la página de destino en pocos segundos...",
    redirectingToTask: "Redirigiendo a la página \'Mis tareas\' en pocos segundos...",
    errorApplyingConstraints: "Error al aplicar restricciones:",
    zoomIsNotSupported: "Zoom no es compatible con este dispositivo.",
    errorCheckingCameraCapability: "Error al comprobar las capacidades de la cámara:",
    previous: "anterior",
    next: "siguiente",
    after: "después",
    redirectingToTaskDetails: "Redireccionando a los detalles de la tarea en pocos segundos",
    mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
        value: 1,
        label: "Abrir"
    },
    {
        value: 2,
        label: "Aclarado"
    },
    {
        value: 3,
        label: "Cerrado"
    }
];

export const auditPhaseTypes = [{
        value: 1,
        label: "Alcance y estrategia"
    },
    {
        value: 2,
        label: "Ejecución"
    },
    {
        value: 3,
        label: "Conclusión"
    },
];

export const CreateEditTaskSectionLabels = {
    createModalTitle: "Nuevo grupo de tareas",
    editModalTitle: "Editar grupo de tareas",
    createModalDescription: "Ingrese los detalles del grupo de tareas a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otro grupo de tareas, seleccione '<b>{1}</b>'.",
    editModalDescription: "Edite los detalles del grupo de tareas a continuación y seleccione '<b>{0}</b>' para finalizar.",
    close: "Cerrar",
    cancel: "Cancelar",
    save: "Guardar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    taskSectionNameLabel: "Nombre del grupo de tareas (obligatorio)",
    taskSectionNameErrorMsg: "Obligatorio",
    engagementPhaseOptions: auditPhaseTypes,
    engagementPhaseLabel: "Fase de compromiso (obligatorio)",
    engagementPhaseErrorMsg: "Obligatorio",
};

export const auditPhaseLabels = {
    1: "Alcance y estrategia",
    2: "Ejecución",
    3: "Conclusión",
    4: "Realizar actividades preliminares del compromiso",
    5: "Identifique y evalúe los riesgos",
    6: "Responder a los riesgos",
    7: "Conclusión e informe"
};

export const ITApproachType = {
    1: "ITGC",
    2: "ITSP (en inglés)"
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
        id: 1,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 31,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 5,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 32,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 6,
        label: superModalNavigationLabels.determineSCOTStrategy
    },
    {
        id: 7,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 38,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 8,
        label: superModalNavigationLabels.selectControlToTest
    },
    {
        id: 2,
        label: superModalNavigationLabels.identifyRisks
    },
    {
        id: 15,
        label: superModalNavigationLabels.relateWCGWsToAssertions
    },
    {
        id: 30,
        label: superModalNavigationLabels.relateRisksToWCGWs
    },
    {
        id: 3,
        label: superModalNavigationLabels.determineCRA
    },
    {
        id: 18,
        label: superModalNavigationLabels.SCOTWT
    },
    {
        id: 19,
        label: superModalNavigationLabels.controlTOC
    },
    {
        id: 20,
        label: superModalNavigationLabels.ITProcessUDP
    },
    {
        id: 21,
        label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
    },
    {
        id: 25,
        label: superModalNavigationLabels.accountPSP
    },
    {
        id: 26,
        label: superModalNavigationLabels.accountOSP,
    },
    {
        id: 27,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 56,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 29,
        label: superModalNavigationLabels.relatedWCGWToTask
    },
    {
        id: 39,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 50,
        label: superModalNavigationLabels.OST
    }
];

export const noEvidenceReferencedReasons = [{
        id: 1,
        reason: noEvidenceReferencedReasonsLabels.immaterialReason,
        glAccountTypeId: 12,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
    },
    {
        id: 2,
        reason: noEvidenceReferencedReasonsLabels.waivedReason,
        glAccountTypeId: 13,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
    }
];


export const createEditAdjustmentLabels = {
    createModalTitle: "Nuevo ajuste",
    editModalTitle: "Editar ajuste",
    createModalDescription: "Ingrese los detalles de ajuste a continuación y seleccione '<b>{0}</b>' para finalizar. Para crear otro ajuste, seleccione '<b>{1}</b>'.",
    editModalDescription: "Edite los detalles de ajuste a continuación y seleccione '<b>{0}</b>' para finalizar. Para eliminar el ajuste, haga clic en '<b>{1}</b>'.",
    close: "Cerrar",
    cancel: "Cancelar",
    save: "Guardar",
    saveAndCloseLabel: "Guardar y cerrar",
    saveAndCreateLabel: "Guardar y crear otro",
    delete: "Eliminar",
    adjustmentNameLabel: "Índice de ajuste (obligatorio)",
    adjustmentDescriptionLabel: "Descripción del ajuste (obligatorio)",
    adjustmentDescriptionPlaceholder: "Descripción del ajuste (obligatorio)",
    required: "Obligatorio",
    editDescriptionModal: "Editar descripción de ajuste",
    descriptionRequired: "Se requiere una descripción del ajuste",
    uploadDocumentPlaceholder: "El ajuste debe guardarse antes de que pueda relacionarse con la evidencia.",
    generalLedgerAccount: "Cuentas de GL (obligatorio)",
    documentHeader: "Documentos (obligatorios)",
    addDocumentButton: "Añadir pruebas",
    glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
    adjustmentIndex: "Índice de ajuste",
    addglaccountbutton: "Agregar cuenta de GL",
    descriptionMaxLengthError: "La respuesta supera el máximo permitido.",
    glaccountTotalError: "El total de entradas de débito debe ser igual al total de las entradas de crédito",
    glaccountIdDuplicate: "Cada cuenta de GL se debe usar solo una vez en el ajuste",
    placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
    editAdjustmentDescriptionHeader: "Editar descripción de ajuste",
    editAdjustmentDescriptionSubHead: "Edite los detalles de la descripción del ajuste a continuación y seleccione \'<b>Guardar</b>\' para finalizar."
};

export const addUpdateGlAccountLabels = {
    addGLaccountTitle: "Agregar cuenta de GL",
    glaccountDescription: "Ingrese los detalles de la cuenta de GL a continuación y seleccione '<b>{0}</b>' para finalizar. Para agregar otra cuenta de GL, seleccione '<b>{1}</b>'.",
    addAndClose: "Agregar y cerrar",
    addAnother: "Agregar otro",
    accountSubClassPlaceholder: "Subclase de cuenta",
    glAccountsPlaceholder: "Seleccione la subclase de cuenta para ver las cuentas de GL disponibles.",
    glAccountListHeaderColumn: "Cuenta GL",
    amountLabel: "Cantidad (obligatoria)",
    debitCreditOptions: [{
            id: 1,
            label: "Débito"
        },
        {
            id: 2,
            label: "Crédito"
        }
    ],
    searchPlaceholder: "Buscar",
    newGlAccount: "Nueva cuenta de conciliación",
    noResultsFound: "No se han encontrado resultados",
    noRecordsPlaceholder: "No se encontraron cuentas de conciliación para la subclase de cuenta seleccionada. Seleccione una subclase diferente o haga clic en {0} para agregar una cuenta de conciliación a la subclase de cuenta seleccionada.",
    editTitleTip: "Editar cuenta de conciliación",
    removeTitleTip: "Eliminar cuenta de conciliación",
    custom: "Personalizado",
    duplicateGLAccount: "Cada cuenta de GL se debe usar solo una vez en el ajuste",
    updateModalTitle: "Actualizar cuenta de conciliación",
    updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
    accountClassLabel: "Account class",
    glAccountLabel: "GL account",
    updateLabel: "Actualizar",
    updateGlAccountModalTitle: "Actualizar cuenta de GL",
}

export const deleteGLAccountLabels = {
    deleteConfirmationModallHeader: "Eliminar cuenta de conciliación",
    deleteConfirmationModalBodyHeader: "¿Está seguro de que desea eliminar la cuenta de conciliación seleccionada? Esta acción no se puede deshacer.",
    deleteConfirmationModalAccountSubClass: "Subclase de cuenta:",
    deleteConfirmationModalAccountName: "Nombre de la cuenta:",
    deleteConfirmationModalGLAccountName: "Nombre de la cuenta de conciliación:",
    closeButtonTitle: "Cancelar",
    confirmBtnTitle: "Borrar"
}

export const glAccountListLabel = {
    accountClass: "Clase de cuenta",
    accountSubClass: "Subclase de cuenta",
    glAccount: "Cuenta de GL",
    debit: "Débito",
    credit: "Crédito",
    actions: "Acciones",
    editTitleTip: "Editar cuenta de GL",
    removeTitleTip: "Quitar la cuenta de GL"
}

export const EngagementMapLabels = {
    objectivePreviewMessage: 'Hover over a map item to preview',
    noMapAvailableMessage: "No hay mapa disponible.",
    takeContentUpdateMessage: "Realice una actualización de contenido para obtener el mapa más reciente.",
    noRecordsLabel: "No se han encontrado registros.",
    auditTopic: "Tema de auditoría",
    auditTopicPlaceholder: "Seleccione el tema que desea ver",
    numberSelected: "{0} temas seleccionados",
    refreshMapTitletip: "Haga clic aquí para iniciar la actualización del mapa del compromiso",
    mapUpdateInProgress: "Actualización en curso. La actualización puede tardar hasta diez minutos en completarse.",
    refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
    createModalTitle: "Nueva cuenta de conciliación",
    editModalTitle: "Editar cuenta de conciliación",
    createModalDescription: "Ingrese los detalles de la cuenta de conciliación a continuación y seleccione '<b>{0}</b>' para finalizar. Para agregar otra cuenta de conciliación, seleccione '<b>{1}</b>'.",
    editModalDescription: "Edite los detalles de la cuenta de conciliación a continuación y seleccione '<b>{0}</b>' para finalizar.",
    accountSubClass: "Subclase de cuenta",
    accountName: "Nombre de la cuenta (obligatorio)",
    glAccountName: "Nombre de la cuenta de conciliación (obligatorio)",
    cancelbtn: "Cancelar",
    saveAndAddbtn: "Guardar y añadir otro",
    saveAndClosebtn: "Guardar y cerrar",
    save: "Guardar",
    required: "Obligatorio",
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

    [receiveInstructionSwitcherIds.groupInstructions]: "Instrucciones de Grupo",
    [receiveInstructionSwitcherIds.groupRiskAssessment]: "Evaluación de riesgos del grupo",
    [receiveInstructionSwitcherIds.documents]: "Documentos"
};

export const misstatementEvidenceLabels = {
    placeholderText: "No hay evidencias relacionadas. Se debe asociar al menos una evidencia de apoyo. Para relacionar una evidencia, haga clic {0}.",
    addEvidenceBtn: "Añadir evidencias",
};

export const misstatementTempLabels = {
    placeholderText: "No hay documentos temporales relacionados. Para relacionar un documento temporal, haga clic en {0}.",
    addEvidenceBtn: "Agregar archivo temporal",
};

export const inherentRiskFactorTypes = [{
        id: 1,
        label: "Complejidad",
        displayOrder: 1
    },
    {
        id: 2,
        label: "Incertidumbre subjetiva",
        displayOrder: 2
    },
    {
        id: 3,
        label: "Fraude o error",
        displayOrder: 3
    },
    {
        id: 4,
        label: "Cambio",
        displayOrder: 4
    },
    {
        id: 5,
        label: "Naturaleza de la cuenta",
        displayOrder: 5
    },
    {
        id: 6,
        label: "Partes relacionadas",
        displayOrder: 6
    }
];

export const helixSettingsStepLabels = {
    title: "Definir la configuración de conexión",
    subTitle: "Seleccione la configuración de la conexión del analizador.",
    connectionNameLabel: "Nombre de la conexión",
    connectionNamePlaceholder: "Nombre de la conexión (obligatorio)",
    connetionTypesLabel: "Tipos de conexión",
    connectionTypeScopeAndStrategy: "Alcance y estrategia",
    connectionTypeFinancionStatement: "Estados Financieros",
    includeAllBusinessUnitsField: "¿Desea incluir todas las unidades de negocio?",
    yes: "Sí",
    no: "No",
    businessUnitsLabel: "Unidad(es) de negocio",
    businessUnitsPlaceholder: "Unidad(es) de negocio",
    analysisPeriodLabel: "Fecha de análisis",
    analysisPeriodPlaceholder: "Fecha de análisis",
    comparativePeriod1Label: "Fecha comparativa 1",
    comparativePeriod1Placeholder: "Fecha comparativa 1 (opcional)",
    comparativePeriod2Label: "Fecha comparativa 2",
    comparativePeriod2Placeholder: "Fecha comparativa 2 (opcional)",
    currencyTypeField: "Tipo de moneda",
    reporting: "Reportes",
    functional: "Funcional",
    currencyCodeField: "Código de moneda",
    currencyCodePlaceholder: "Código de moneda (obligatorio)",
    scopeAndStrategyLabel: "Alcance y estrategia",
    financialStatementLabel: "Estado financiero",

    required: "Obligatorio",
    comparativePeriodError: "Fecha no válida. Seleccione una fecha anterior a la fecha de análisis.",

    dataConnectionLink: 'How to manage data connections',
    helixfiscalDropDownLabel: "Fecha {0} - {1}",

    helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    businessUnitsSelectedCount: "{0} seleccionado",
    allBusinessUnitsLabel: "Todas las unidades de negocio"
};

export const importDataModalLabels = ({
    title,
    description,
    buttonLabel
}) => {
    return {
        title: title,
        description: description,
        entity: "Entidad",
        trialBalanceName: "Nombre del balance de comprobación",
        reporting: "Informes",
        functional: "Funcional",
        analysisPeriod: "Fecha de análisis",
        comparativePeriod: "Fecha comparativa",
        secondComparativePeriod: "Segunda fecha comparativa (opcional)",
        includeFinancialStatements: "Incluir estados financieros",
        carryForwardReferencesAndAdjustments: "¿Trasladar referencias y ajustes a la nueva importación?",
        import: buttonLabel,
        businessUnitSelectedCount: "{0} Unidad de negocio",
        businessUnitsSelectedCount: "{0} Unidades de negocio",
        allBusinessUnitsLabel: "Todas las unidades de negocio",
        businessUnitsPlaceholder: "Unidad(es) de negocio",
        required: "Obligatorio",
        comparativePeriodError: "Fecha no válida. Seleccione una fecha anterior a la fecha de análisis.",
        secondComparativePeriodError: "Segunda fecha comparativa mayor o igual que la fecha comparativa.",
        equalComparativePeriodError: "Las fechas no pueden ser las mismas.",
        analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
    };
};

export const AnalyzerHelixErrors = {
    400: "El proyecto EY Helix para la conexión seleccionada ya no está disponible. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, primero elimine todas las importaciones asociadas a la conexión. A continuación, haga clic en 'Desconectar analizador' en el menú más. Considere si se debe conectar otro analizador.",
    403: "No es un miembro autorizado del equipo del analizador conectado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso.",
    405: "Los análisis no están disponibles en la conexión vinculada. Vaya a EY Helix y complete los pasos de procesamiento de datos y análisis para continuar.",
    406: "El analizador EY Helix para la conexión seleccionada ya no está disponible. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, primero elimine todas las importaciones asociadas a la conexión. A continuación, haga clic en 'Desconectar analizador' en el menú más. Considere si se debe conectar otro analizador.",
    408: "El proyecto EY Helix para la conexión seleccionada ya no está disponible. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, primero elimine todas las importaciones asociadas a la conexión. A continuación, haga clic en 'Desconectar analizador' en el menú más. Considere si se debe conectar otro analizador.",
    411: "El analizador seleccionado no tiene todos los parámetros necesarios. Póngase en contacto con un administrador de EY Helix para obtener más detalles.",
    430: "El analizador seleccionado no tiene todos los parámetros necesarios. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    800: "Parece que no has accedido antes a EY Helix. Ve a EY Helix, inicia sesión y sigue las instrucciones para configurar tu cuenta.",
    801: "No es un miembro autorizado del equipo del proyecto vinculado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso.",
    901: "El proyecto EY Helix para la conexión seleccionada ya no está disponible. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, haga clic en 'Eliminar' a continuación en el menú más. Considere si se debe conectar otro analizador.",
    902: "El proyecto EY Helix para la conexión seleccionada se marca para su eliminación. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, haga clic en 'Eliminar' a continuación en el menú más. Considere si se debe conectar otro analizador.",
    903: "El proyecto EY Helix para la conexión seleccionada está marcado para almacenamiento. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, haga clic en 'Eliminar' a continuación en el menú más. Considere si se debe conectar otro analizador.",
    926: "El analizador seleccionado no está disponible en EY Helix. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    927: "Los análisis no están disponibles en el proyecto vinculado. Vaya a EY Helix y complete los pasos de procesamiento de datos y análisis para continuar.",
    928: "Analizador no válido o faltante en EY Helix. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con Servicio de Soporte.",
    929: "Se ha producido un error relacionado con el proyecto EY Helix vinculado. Los datos no se pueden importar."
};

export const validationLabels = {
    viewAdjustmentWithValidations: "Ver ajustes con validaciones {0}",
    validationTypeAmtMissmatch: "La suma de los asientos de débito no es igual a la suma de los asientos de crédito",
    validationTypeNoEvidence: "No hay evidencia relacionada"
};

export const canavsImportErrors = {
    400: "Error de importación. El proyecto EY Helix para la conexión seleccionada ya no está disponible. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, primero elimine todas las importaciones asociadas a la conexión. A continuación, haga clic en 'Desconectar analizador' en el menú más. Considere si se debe conectar otro analizador.",
    403: "Error de importación. No es un miembro autorizado del equipo del analizador conectado. Póngase en contacto con el administrador del proyecto EY Helix para obtener acceso, luego actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    405: "Error de importación. Los análisis no están disponibles en la conexión vinculada. Vaya a EY Helix y complete los pasos de procesamiento de datos y análisis para continuar. A continuación, actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    406: "Error de importación. El analizador EY Helix para la conexión seleccionada ya no está disponible. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, primero elimine todas las importaciones asociadas a la conexión. A continuación, haga clic en 'Desconectar analizador' en el menú más. Considere si se debe conectar otro analizador.",
    408: "Error de importación. El proyecto EY Helix para la conexión seleccionada ya no está disponible. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Para eliminar permanentemente la conexión, primero elimine todas las importaciones asociadas a la conexión. A continuación, haga clic en 'Desconectar analizador en el menú más. Considere si se debe conectar otro analizador.",
    411: "Error de importación. El analizador seleccionado no tiene todos los parámetros necesarios. Póngase en contacto con un administrador de EY Helix para obtener más detalles y, a continuación, actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    430: "Error de importación. El analizador seleccionado no tiene todos los parámetros necesarios. Póngase en contacto con un administrador de EY Helix para obtener más detalles. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el Servicio de Soporte.",
    113082: "El período de análisis no debe estar vacío."
};
